var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFactory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 125,
    viewBox: "0 0 151 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164881_183764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151 76.11L68.31 124.06L0 84.45L82.69 36.51L151 76.11Z",
    fill: "#CCC6BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.76 53.18L103.96 57.79L108.49 60.66L108.69 60.53V55.78L103.96 53.05L103.76 53.18ZM104.19 53.45L108.47 55.92V60.13L104.19 57.66V53.45Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.76 57.92L108.49 60.65V55.9L103.76 53.17V57.92ZM103.99 53.57L108.27 56.04V60.25L103.99 57.78V53.57Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 55.78L108.5 55.91L103.76 53.18L103.96 53.05L108.7 55.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41 57.91L104.37 57.93L104.31 57.97L104.29 57.88L104.06 56.61V56.0099L104.41 57.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75 58.11L104.72 58.13L104.65 58.17L104.64 58.08L104.06 54.94V54.33L104.75 58.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.999 58.37L104.129 53.65L104.189 53.69L104.249 53.73L105.099 58.31L104.999 58.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 58.51L105.34 58.57L104.47 53.85L104.6 53.93L105.44 58.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.789 58.71L105.689 58.77L104.819 54.05L104.939 54.12L105.789 58.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.13 58.8999L106.03 58.9699L105.16 54.2499L105.29 54.3199L106.13 58.8999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48 59.0999L106.37 59.16L105.5 54.45L105.61 54.5099L105.63 54.52L106.48 59.0999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.82 59.3L106.72 59.36L105.85 54.65L105.97 54.72L106.82 59.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.159 59.5L107.059 59.56L106.189 54.85L106.249 54.88L106.319 54.92L107.159 59.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51 59.7L107.41 59.76L106.54 55.05L106.66 55.12L107.51 59.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.849 59.9L107.749 59.96L106.879 55.24L107.009 55.32L107.849 59.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.199 60.0999L108.099 60.1599L107.229 55.4399L107.349 55.5199L108.199 60.0999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.269 58.82V59.43L107.569 55.64L107.699 55.71L108.269 58.82Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.269 57.16V57.76L107.919 55.84L107.989 55.88L108.039 55.91L108.269 57.16Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.269 59.8V59.91L107.879 59.95V59.96L107.729 59.87L108.269 59.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.269 59.36V59.47L107.249 59.59L107.089 59.5L108.269 59.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.269 58.92V59.03L106.609 59.22L106.459 59.13L108.269 58.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27 58.49V58.59L105.98 58.86L105.83 58.77L108.27 58.49Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.269 58.05V58.16L105.349 58.49L105.189 58.4L108.269 58.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27 57.61V57.72L104.72 58.13L104.56 58.04L108.27 57.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.269 57.17V57.28L104.209 57.75L104.239 57.63L108.269 57.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27 56.73V56.84L104.06 57.32V57.21L108.27 56.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27 56.29V56.4L104.06 56.89V56.77L108.27 56.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.15 55.97L104.06 56.45V56.34L107.99 55.88L108.15 55.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51 55.61L104.06 56.01V55.9L107.36 55.52L107.51 55.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.88 55.24L104.06 55.57V55.46L106.72 55.15L106.88 55.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25 54.88L104.06 55.13V55.02L106.09 54.79L106.25 54.88Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.61 54.51L104.06 54.69V54.58L105.45 54.42L105.61 54.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.98 54.15L104.06 54.25V54.14L104.82 54.05L104.98 54.15Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.35 53.78L104.06 53.81V53.7L104.19 53.69L104.35 53.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.04 55.65L108.24 60.26L112.77 63.13L112.97 63V58.25L108.24 55.52L108.04 55.65ZM108.47 55.92L112.75 58.39V62.6L108.47 60.13V55.92Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.04 60.39L112.77 63.12V58.37L108.04 55.64V60.39ZM108.27 56.04L112.55 58.51V62.72L108.27 60.25V56.04Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.98 58.25L112.78 58.38L108.04 55.65L108.24 55.52L112.98 58.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.69 60.38L108.65 60.4L108.59 60.44L108.57 60.35L108.33 59.08V58.48L108.69 60.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.03 60.58L109 60.6L108.93 60.64L108.91 60.55L108.33 57.41V56.8L109.03 60.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.27 60.84L108.41 56.12L108.47 56.16L108.53 56.19L109.38 60.78L109.27 60.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.72 60.98L109.62 61.04L108.75 56.32L108.87 56.4L109.72 60.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.06 61.17L109.96 61.24L109.1 56.52L109.22 56.59L110.06 61.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.409 61.37L110.309 61.44L109.439 56.72L109.559 56.79L110.409 61.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75 61.57L110.65 61.63L109.78 56.92L109.89 56.98L109.91 56.99L110.75 61.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.099 61.77L110.999 61.83L110.129 57.12L110.249 57.19L111.099 61.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.44 61.97L111.34 62.03L110.47 57.32L110.53 57.35L110.6 57.39L111.44 61.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.79 62.17L111.69 62.23L110.82 57.52L110.94 57.59L111.79 62.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.13 62.37L112.03 62.43L111.16 57.71L111.29 57.79L112.13 62.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.48 62.57L112.38 62.63L111.51 57.91L111.63 57.99L112.48 62.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 61.29V61.9L111.85 58.11L111.97 58.18L112.55 61.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.549 59.63V60.23L112.189 58.31L112.269 58.35L112.319 58.38L112.549 59.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 62.27V62.38L112.16 62.42L112 62.34L112.55 62.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 61.83V61.94L111.53 62.06L111.37 61.97L112.55 61.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 61.39V61.5L110.89 61.69L110.74 61.6L112.55 61.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 60.96V61.06L110.26 61.33L110.1 61.24L112.55 60.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 60.52V60.63L109.63 60.96L109.47 60.87L112.55 60.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.549 60.08V60.19L108.989 60.6L108.839 60.5L112.549 60.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.549 59.64V59.75L108.479 60.22L108.509 60.1L112.549 59.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 59.2V59.31L108.33 59.79V59.68L112.55 59.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 58.76V58.87L108.33 59.36V59.24L112.55 58.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.43 58.44L108.33 58.92V58.81L112.27 58.35L112.43 58.44Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.79 58.0801L108.33 58.48V58.37L111.63 57.9901H111.64L111.79 58.0801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.16 57.7101L108.33 58.0401V57.9301L111 57.6201L111.16 57.7101Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53 57.35L108.33 57.6V57.49L110.36 57.26H110.37L110.53 57.35Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.89 56.98L108.33 57.16V57.05L109.73 56.89L109.89 56.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.26 56.62L108.33 56.72V56.61L109.1 56.52L109.26 56.62Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.62 56.25L108.33 56.28V56.17L108.47 56.16L108.62 56.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 58.12L112.52 62.73L117.05 65.6L117.25 65.47V60.72L112.52 57.99L112.32 58.12V58.12ZM112.75 58.39L117.03 60.86V65.07L112.75 62.6V58.39V58.39Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 62.86L117.05 65.59V60.84L112.32 58.11V62.86V62.86ZM112.55 58.51L116.83 60.98V65.19L112.55 62.72V58.51Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25 60.72L117.05 60.85L112.32 58.12L112.52 57.99L117.25 60.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.96 62.8499L112.93 62.8699L112.86 62.91L112.85 62.82L112.61 61.5499V60.95L112.96 62.8499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.31 63.05L113.27 63.07L113.21 63.11L113.19 63.02L112.61 59.88V59.27L113.31 63.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.55 63.31L112.68 58.59L112.74 58.63L112.81 58.66L113.65 63.25L113.55 63.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 63.45L113.9 63.51L113.03 58.79L113.15 58.87L114 63.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.34 63.64L114.24 63.71L113.37 58.99H113.38L113.5 59.06L114.34 63.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69 63.8399L114.59 63.8999L113.72 59.1899L113.84 59.2599L114.69 63.8399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.03 64.04L114.93 64.1L114.06 59.39L114.17 59.45L114.19 59.46L115.03 64.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38 64.24L115.28 64.3L114.41 59.59L114.53 59.66L115.38 64.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72 64.44L115.62 64.5L114.75 59.79L114.8 59.82H114.81L114.87 59.86L115.72 64.44Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.06 64.64L115.96 64.7L115.09 59.99L115.22 60.06L116.06 64.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.41 64.84L116.31 64.9L115.44 60.18L115.56 60.26L116.41 64.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75 65.0399L116.65 65.0999L115.78 60.3799L115.91 60.4599L116.75 65.0399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 63.76V64.36L116.13 60.58L116.25 60.65L116.83 63.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 62.1V62.7L116.47 60.78L116.55 60.82L116.6 60.85L116.83 62.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 64.74V64.85L116.44 64.89L116.28 64.8L116.83 64.74Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 64.3V64.41L115.8 64.53L115.65 64.44L116.83 64.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 63.86V63.97L115.17 64.16L115.01 64.07L116.83 63.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 63.42V63.53L114.54 63.8L114.38 63.71L116.83 63.42Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 62.99V63.1L113.9 63.43L113.75 63.34L116.83 62.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 62.55V62.66L113.27 63.07L113.12 62.97L116.83 62.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 62.11V62.22L112.76 62.69L112.79 62.57L116.83 62.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 61.67V61.78L112.61 62.26V62.15L116.83 61.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 61.23V61.34L112.61 61.83V61.71L116.83 61.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7 60.91L112.61 61.39V61.28L116.55 60.82L116.7 60.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07 60.55L112.61 60.95V60.84L115.91 60.46L116.07 60.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.44 60.18L112.61 60.51V60.4L115.28 60.09L115.44 60.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8 59.82L112.61 60.07V59.96L114.64 59.73L114.8 59.82Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.17 59.45L112.61 59.63V59.52L114.01 59.36L114.17 59.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.54 59.09L112.61 59.19V59.08L113.37 58.99H113.38L113.54 59.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 58.72L112.61 58.75V58.64L112.74 58.63L112.9 58.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.6 60.59L116.8 65.2L121.33 68.07L121.53 67.94V63.19L116.8 60.46L116.6 60.59V60.59ZM117.03 60.86L121.31 63.33V67.54L117.03 65.07V60.86Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.6 65.33L121.33 68.06V63.31L116.6 60.58V65.33V65.33ZM116.83 60.98L121.11 63.45V67.66L116.83 65.19V60.98Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 63.19L121.33 63.32L116.6 60.59L116.8 60.46L121.53 63.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.24 65.3199L117.21 65.3399L117.14 65.3799L117.13 65.2899L116.89 64.0199V63.4199L117.24 65.3199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.59 65.5199L117.55 65.5399L117.49 65.5799L117.47 65.4899L116.89 62.3499V61.7399L117.59 65.5199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.829 65.7799L116.959 61.0599L117.019 61.0999L117.089 61.1299L117.929 65.7199L117.829 65.7799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28 65.9199L118.18 65.98L117.31 61.2599L117.43 61.34L118.28 65.9199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.619 66.11L118.519 66.18L117.649 61.46L117.769 61.53L118.619 66.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.96 66.3099L118.86 66.3699L117.99 61.6599L118.12 61.7299L118.96 66.3099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31 66.5099L119.21 66.5699L118.34 61.8599L118.45 61.9199L118.46 61.9299L119.31 66.5099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.65 66.7099L119.55 66.7699L118.68 62.0599L118.81 62.1299L119.65 66.7099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 66.9099L119.9 66.9699L119.03 62.2499L119.08 62.2899L119.15 62.3299L120 66.9099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.34 67.11L120.24 67.17L119.37 62.46L119.5 62.53L120.34 67.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.69 67.31L120.59 67.37L119.72 62.65L119.84 62.73L120.69 67.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.03 67.5099L120.93 67.5699L120.06 62.8499L120.19 62.9299L121.03 67.5099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 66.2299V66.8299L120.41 63.0499L120.53 63.1199L121.1 66.2299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 64.5699V65.1699L120.75 63.2499L120.82 63.2899H120.83L120.87 63.3199L121.1 64.5699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 67.21V67.32L120.72 67.36L120.56 67.27L121.1 67.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 66.77V66.88L120.08 67L119.93 66.91L121.1 66.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 66.33V66.44L119.45 66.63L119.29 66.54L121.1 66.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 65.89V66L118.82 66.27L118.66 66.18L121.1 65.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 65.46V65.57L118.18 65.9L118.03 65.81L121.1 65.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.099 65.02V65.13L117.549 65.54L117.399 65.44L121.099 65.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 64.58V64.69L117.04 65.16L117.07 65.04L121.1 64.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 64.14V64.25L116.89 64.73V64.62L121.1 64.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 63.7V63.81L116.89 64.3V64.18L121.1 63.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.98 63.38L116.89 63.86V63.75L120.82 63.29H120.83L120.98 63.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.35 63.02L116.89 63.42V63.31L120.19 62.93L120.35 63.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72 62.65L116.89 62.98V62.87L119.55 62.56H119.56L119.72 62.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08 62.29L116.89 62.54V62.43L118.92 62.2L119.08 62.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.45 61.92L116.89 62.1V61.99L118.29 61.83L118.45 61.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.81 61.56L116.89 61.66V61.55L117.65 61.46L117.81 61.56Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.18 61.19L116.89 61.22V61.11L117.02 61.1L117.18 61.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 63.2L121.3 67.81L125.83 70.68L126.03 70.55V65.8L121.3 63.07L121.1 63.2V63.2ZM121.53 63.47L125.81 65.94V70.15L121.53 67.68V63.47Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 67.94L125.83 70.67V65.92L121.1 63.19V67.94ZM121.33 63.59L125.61 66.06V70.27L121.33 67.8V63.59Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.04 65.8L125.84 65.93L121.1 63.2L121.3 63.07L126.04 65.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.749 67.93L121.709 67.95L121.649 67.99L121.629 67.9L121.399 66.63V66.03L121.749 67.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.089 68.13L122.059 68.15L121.989 68.19L121.979 68.1L121.399 64.96V64.35L122.089 68.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.339 68.39L121.469 63.67L121.529 63.71L121.589 63.75L122.439 68.33L122.339 68.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.78 68.53L122.68 68.59L121.81 63.87L121.94 63.95L122.78 68.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.129 68.73L123.029 68.79L122.159 64.07L122.279 64.14L123.129 68.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47 68.92L123.37 68.99L122.5 64.27L122.63 64.34L123.47 68.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.819 69.12L123.709 69.18L122.839 64.47L122.949 64.53L122.969 64.54L123.819 69.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.159 69.32L124.059 69.38L123.189 64.67L123.309 64.74L124.159 69.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.499 69.52L124.399 69.58L123.529 64.87L123.589 64.9L123.659 64.94L124.499 69.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.849 69.72L124.749 69.78L123.879 65.07L123.999 65.14L124.849 69.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.189 69.92L125.089 69.98L124.219 65.26L124.349 65.34L125.189 69.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.539 70.12L125.439 70.18L124.569 65.46L124.689 65.54L125.539 70.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 68.84V69.45L124.909 65.66L125.039 65.73L125.609 68.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 67.18V67.78L125.259 65.86L125.329 65.9L125.379 65.93L125.609 67.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 69.82V69.93L125.219 69.98L125.069 69.89L125.609 69.82Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 69.38V69.49L124.589 69.61L124.429 69.52L125.609 69.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 68.94V69.05L123.949 69.24L123.799 69.15L125.609 68.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 68.51V68.61L123.319 68.88L123.169 68.79L125.609 68.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 68.07V68.18L122.689 68.51L122.529 68.42L125.609 68.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 67.63V67.74L122.049 68.15L121.899 68.06L125.609 67.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 67.19V67.3L121.549 67.77L121.569 67.65L125.609 67.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 66.75V66.86L121.399 67.34V67.24L125.609 66.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.609 66.31V66.42L121.399 66.91V66.8L125.609 66.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.489 65.99L121.399 66.47V66.36L125.329 65.9L125.489 65.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.849 65.63L121.399 66.03V65.92L124.699 65.54L124.849 65.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.219 65.26L121.399 65.59V65.48L124.059 65.17L124.219 65.26Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.589 64.9L121.399 65.15V65.04L123.429 64.81L123.589 64.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.949 64.53L121.399 64.71V64.6L122.789 64.44L122.949 64.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 64.17L121.399 64.27V64.16L122.159 64.07L122.319 64.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.689 63.8L121.399 63.83V63.72L121.529 63.71L121.689 63.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.379 65.67L125.579 70.28L130.109 73.15L130.309 73.02V68.27L125.579 65.54L125.379 65.67V65.67ZM125.809 65.94L130.089 68.41V72.62L125.809 70.15V65.94Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.379 70.41L130.109 73.14V68.39L125.379 65.66V70.41V70.41ZM125.609 66.06L129.889 68.53V72.74L125.609 70.27V66.06V66.06Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.319 68.27L130.119 68.4L125.379 65.67L125.579 65.54L130.319 68.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.029 70.4L125.989 70.42L125.929 70.46L125.909 70.37L125.669 69.1V68.5L126.029 70.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.369 70.6L126.339 70.62L126.269 70.66L126.249 70.57L125.669 67.43V66.82L126.369 70.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.61 70.86L125.75 66.14L125.8 66.18L125.87 66.22L126.72 70.8L126.61 70.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.059 71L126.959 71.06L126.089 66.34L126.209 66.42L127.059 71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.399 71.19L127.299 71.26L126.439 66.54L126.559 66.61L127.399 71.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.749 71.39L127.649 71.46L126.779 66.74L126.899 66.81L127.749 71.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.09 71.59L127.99 71.65L127.12 66.94L127.23 67L127.25 67.01L128.09 71.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.439 71.79L128.339 71.85L127.469 67.14L127.589 67.21L128.439 71.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.78 71.99L128.68 72.05L127.81 67.34L127.87 67.37L127.94 67.41L128.78 71.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.13 72.19L129.03 72.25L128.16 67.54L128.28 67.61L129.13 72.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47 72.39L129.37 72.45L128.5 67.73L128.63 67.81L129.47 72.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.82 72.59L129.72 72.65L128.85 67.93L128.97 68.01L129.82 72.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.889 71.31V71.92L129.189 68.13L129.309 68.2L129.889 71.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.889 69.65V70.25L129.529 68.33L129.609 68.37L129.659 68.4L129.889 69.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.889 72.29V72.4L129.499 72.44V72.45L129.339 72.36L129.889 72.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.889 71.85V71.96L128.869 72.08L128.709 71.99L129.889 71.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.89 71.41V71.52L128.23 71.71L128.08 71.62L129.89 71.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.889 70.98V71.08L127.599 71.35L127.439 71.26L129.889 70.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.89 70.54V70.65L126.97 70.98L126.81 70.89L129.89 70.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.889 70.1V70.21L126.329 70.62L126.179 70.52L129.889 70.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.889 69.66V69.77L125.819 70.24L125.849 70.12L129.889 69.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.889 69.22V69.33L125.669 69.81V69.7L129.889 69.22Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.889 68.78V68.89L125.669 69.38V69.26L129.889 68.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.769 68.4601L125.669 68.9401V68.8301L129.609 68.3701L129.769 68.4601Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.129 68.1001L125.669 68.5001V68.3901L128.969 68.0101H128.979L129.129 68.1001Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.499 67.7301L125.669 68.0601V67.9501L128.339 67.6401L128.499 67.7301Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.869 67.37L125.669 67.62V67.51L127.699 67.28H127.709L127.869 67.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.229 67L125.669 67.18V67.07L127.069 66.91L127.229 67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.599 66.64L125.669 66.74V66.63L126.439 66.54L126.599 66.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.959 66.2701L125.669 66.3001V66.1901L125.799 66.1801L125.959 66.2701Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.66 68.14L129.86 72.75L134.39 75.62L134.59 75.49V70.74L129.86 68.01L129.66 68.14ZM130.09 68.41L134.37 70.88V75.09L130.09 72.62V68.41Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.66 72.88L134.39 75.61V70.86L129.66 68.13V72.88ZM129.89 68.53L134.17 71V75.21L129.89 72.74V68.53Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.59 70.74L134.39 70.87L129.66 68.14L129.86 68.01L134.59 70.74Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.3 72.87L130.27 72.89L130.2 72.93L130.19 72.84L129.95 71.57V70.97L130.3 72.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.65 73.07L130.61 73.09L130.55 73.13L130.53 73.04L129.95 69.9V69.29L130.65 73.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89 73.33L130.02 68.61L130.08 68.65L130.15 68.68L130.99 73.27L130.89 73.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34 73.47L131.24 73.53L130.37 68.81L130.49 68.89L131.34 73.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68 73.66L131.58 73.73L130.71 69.01H130.72L130.84 69.08L131.68 73.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.03 73.86L131.93 73.92L131.06 69.21L131.18 69.28L132.03 73.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.37 74.06L132.27 74.12L131.4 69.41L131.51 69.47L131.53 69.48L132.37 74.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72 74.26L132.62 74.32L131.75 69.61L131.87 69.68L132.72 74.26Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.06 74.46L132.96 74.52L132.09 69.81L132.14 69.84L132.21 69.88L133.06 74.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4 74.66L133.3 74.72L132.43 70.01L132.56 70.08L133.4 74.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.75 74.86L133.65 74.92L132.78 70.2L132.9 70.28L133.75 74.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.09 75.06L133.99 75.12L133.12 70.4L133.25 70.48L134.09 75.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 73.78V74.39L133.47 70.6L133.59 70.67L134.17 73.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 72.12V72.72L133.81 70.8L133.89 70.84L133.94 70.87L134.17 72.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 74.76V74.87L133.78 74.91L133.62 74.82L134.17 74.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 74.32V74.43L133.14 74.55L132.99 74.46L134.17 74.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 73.88V73.99L132.51 74.18L132.35 74.09L134.17 73.88Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 73.44V73.55L131.88 73.82L131.72 73.73L134.17 73.44Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 73.01V73.12L131.24 73.45L131.09 73.36L134.17 73.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 72.57V72.68L130.61 73.09L130.46 72.99L134.17 72.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 72.13V72.24L130.1 72.71L130.13 72.59L134.17 72.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 71.69V71.8L129.95 72.28V72.17L134.17 71.69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 71.25V71.36L129.95 71.85V71.73L134.17 71.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.04 70.93L129.95 71.41V71.3L133.89 70.84L134.04 70.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.41 70.57L129.95 70.97V70.86L133.25 70.48L133.41 70.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.78 70.2L129.95 70.53V70.42L132.62 70.11L132.78 70.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.14 69.84L129.95 70.09V69.98L131.98 69.75L132.14 69.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51 69.47L129.95 69.65V69.54L131.35 69.38L131.51 69.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88 69.11L129.95 69.21V69.1L130.71 69.01H130.72L130.88 69.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.24 68.74L129.95 68.77V68.66L130.08 68.65L130.24 68.74Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.939 70.61L134.139 75.22L138.669 78.09L138.869 77.96V73.21L134.139 70.48L133.939 70.61ZM134.369 70.88L138.649 73.35V77.56L134.369 75.09V70.88Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.939 75.35L138.669 78.08V73.33L133.939 70.6V75.35ZM134.169 71L138.449 73.47V77.68L134.169 75.21V71Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.869 73.21L138.669 73.34L133.939 70.61L134.139 70.48L138.869 73.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.579 75.3399L134.549 75.3599L134.479 75.3999L134.469 75.3099L134.229 74.0399V73.4399L134.579 75.3399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.929 75.5399L134.889 75.5599L134.829 75.5999L134.809 75.5099L134.229 72.3699V71.7599L134.929 75.5399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.169 75.8L134.299 71.08L134.359 71.12L134.429 71.15L135.269 75.74L135.169 75.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.619 75.94L135.519 76L134.649 71.28L134.769 71.36L135.619 75.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.959 76.13L135.859 76.2L134.989 71.48L135.109 71.55L135.959 76.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 76.3299L136.2 76.3899L135.33 71.6799L135.46 71.7499L136.3 76.3299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 76.5299L136.55 76.5899L135.68 71.8799L135.79 71.9399L135.8 71.9499L136.65 76.5299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.99 76.73L136.89 76.79L136.02 72.08L136.15 72.15L136.99 76.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.34 76.93L137.24 76.99L136.37 72.28L136.42 72.31L136.49 72.35L137.34 76.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.679 77.13L137.579 77.19L136.709 72.48L136.839 72.55L137.679 77.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.03 77.3299L137.93 77.3899L137.06 72.6699L137.18 72.7499L138.03 77.3299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.369 77.5299L138.269 77.5899L137.399 72.8699L137.529 72.9499L138.369 77.5299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44 76.2499V76.8499L137.75 73.0699L137.87 73.1399L138.44 76.2499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.439 74.59V75.19L138.089 73.27L138.159 73.31L138.209 73.34L138.439 74.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.439 77.23V77.34L138.059 77.38L137.899 77.29L138.439 77.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44 76.79V76.9L137.42 77.02L137.27 76.93L138.44 76.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.439 76.35V76.46L136.789 76.65L136.629 76.56L138.439 76.35Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44 75.91V76.02L136.16 76.29L136 76.2L138.44 75.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44 75.48V75.59L135.52 75.92L135.37 75.83L138.44 75.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.439 75.04V75.15L134.889 75.56L134.729 75.46L138.439 75.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.439 74.6V74.71L134.379 75.18L134.409 75.06L138.439 74.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.439 74.16V74.27L134.229 74.75V74.64L138.439 74.16Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.439 73.72V73.83L134.229 74.32V74.2L138.439 73.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.32 73.4L134.229 73.88V73.77L138.16 73.31L138.32 73.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.689 73.04L134.229 73.44V73.33L137.529 72.95L137.689 73.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.049 72.67L134.229 73V72.89L136.889 72.58H136.899L137.049 72.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.419 72.31L134.229 72.56V72.45L136.259 72.22L136.419 72.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.789 71.94L134.229 72.12V72.01L135.63 71.85L135.789 71.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.149 71.58L134.229 71.68V71.57L134.99 71.48L135.149 71.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52 71.21L134.229 71.24V71.13L134.359 71.12L134.52 71.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.96 53.05L99.23 55.78V60.53L99.43 60.66L103.96 57.79L104.16 53.18L103.96 53.05ZM103.73 57.66L99.45 60.13V55.92L103.73 53.45V57.66Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.16 53.18L99.4302 55.91V60.66L104.16 57.93V53.18ZM103.93 57.79L99.6502 60.26V56.05L103.93 53.58V57.79Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.23 55.78L99.43 55.91L104.16 53.18L103.96 53.05L99.23 55.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 57.91L103.55 57.93L103.62 57.97L103.64 57.88L103.87 56.61V56.0099L103.52 57.91Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.18 58.11L103.21 58.13L103.28 58.17L103.29 58.08L103.87 54.94V54.33L103.18 58.11Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.93 58.37L103.8 53.65L103.74 53.69L103.68 53.73L102.83 58.31L102.93 58.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.49 58.51L102.59 58.57L103.46 53.85L103.33 53.93L102.49 58.51Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14 58.71L102.24 58.77L103.11 54.05L102.99 54.12L102.14 58.71Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8 58.8999L101.9 58.9699L102.77 54.2499L102.64 54.3199L101.8 58.8999Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.45 59.0999L101.55 59.16L102.42 54.45L102.32 54.5099L102.3 54.52L101.45 59.0999Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.11 59.3L101.21 59.36L102.08 54.65L101.95 54.72L101.11 59.3Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.76 59.5L100.86 59.56L101.73 54.85L101.68 54.88L101.61 54.92L100.76 59.5Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 59.7L100.52 59.76L101.39 55.05L101.26 55.12L100.42 59.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.07 59.9L100.18 59.96L101.05 55.24L100.92 55.32L100.07 59.9Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.73 60.0999L99.83 60.1599L100.7 55.4399L100.58 55.5199L99.73 60.0999Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 58.82V59.43L100.36 55.64L100.23 55.71L99.6602 58.82Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 57.16V57.76L100.01 55.84L99.9402 55.88L99.8902 55.91L99.6602 57.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 59.8V59.91L100.05 59.95V59.96L100.2 59.87L99.6602 59.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 59.36V59.47L100.68 59.59L100.84 59.5L99.6602 59.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 58.92V59.03L101.31 59.22L101.47 59.13L99.6602 58.92Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 58.49V58.59L101.94 58.86L102.1 58.77L99.6602 58.49Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 58.05V58.16L102.58 58.49L102.74 58.4L99.6602 58.05Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 57.61V57.72L103.21 58.13L103.37 58.04L99.6602 57.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 57.17V57.28L103.72 57.75L103.69 57.63L99.6602 57.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 56.73V56.84L103.87 57.32V57.21L99.6602 56.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6602 56.29V56.4L103.87 56.89V56.77L99.6602 56.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7803 55.97L103.87 56.45V56.34L99.9403 55.88L99.7803 55.97Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.41 55.61L103.87 56.01V55.9L100.57 55.52L100.41 55.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.05 55.24L103.87 55.57V55.46L101.21 55.15L101.05 55.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.68 54.88L103.87 55.13V55.02L101.84 54.79L101.68 54.88Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32 54.51L103.87 54.69V54.58L102.48 54.42H102.47L102.32 54.51Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.95 54.15L103.87 54.25V54.14L103.11 54.05L102.95 54.15Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58 53.78L103.87 53.81V53.7L103.74 53.69L103.58 53.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6895 55.52L94.9595 58.25V63L95.1595 63.13L99.6895 60.26L99.8895 55.65L99.6895 55.52ZM99.4595 60.13L95.1795 62.6V58.39L99.4595 55.92V60.13Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8897 55.65L95.1597 58.38V63.13L99.8897 60.4V55.65ZM99.6597 60.26L95.3797 62.73V58.52L99.6597 56.05V60.26Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9497 58.25L95.1497 58.38L99.8897 55.65L99.6897 55.52L94.9497 58.25Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2397 60.38L99.2797 60.4L99.3397 60.44L99.3597 60.35L99.5897 59.08V58.48L99.2397 60.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8999 60.58L98.9299 60.6L98.9999 60.64L99.0199 60.55L99.5899 57.41V56.8L98.8999 60.58Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6498 60.84L99.5198 56.12L99.4598 56.16L99.3998 56.19L98.5498 60.78L98.6498 60.84Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.21 60.98L98.31 61.04L99.18 56.32L99.05 56.4L98.21 60.98Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8701 61.17L97.9601 61.24L98.8301 56.52L98.7101 56.59L97.8701 61.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.52 61.37L97.62 61.44L98.49 56.72L98.36 56.79L97.52 61.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1797 61.57L97.2797 61.63L98.1497 56.92L98.0397 56.98L98.0197 56.99L97.1797 61.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8301 61.77L96.9301 61.83L97.8001 57.12L97.6801 57.19L96.8301 61.77Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4897 61.97L96.5897 62.03L97.4597 57.32L97.3997 57.35L97.3298 57.39L96.4897 61.97Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1396 62.17L96.2396 62.23L97.1096 57.52L96.9896 57.59L96.1396 62.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7998 62.37L95.8998 62.43L96.7698 57.71L96.6398 57.79L95.7998 62.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4497 62.57L95.5497 62.63L96.4197 57.91L96.2997 57.99L95.4497 62.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 61.29V61.9L96.0799 58.11L95.9499 58.18L95.3799 61.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 59.63V60.23L95.7299 58.31L95.6599 58.35L95.6099 58.38L95.3799 59.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 62.27V62.38L95.7699 62.42L95.9199 62.34L95.3799 62.27Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 61.83V61.94L96.3999 62.06L96.5599 61.97L95.3799 61.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 61.39V61.5L97.0399 61.69L97.1899 61.6L95.3799 61.39Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 60.96V61.06L97.6699 61.33L97.8299 61.24L95.3799 60.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 60.52V60.63L98.2999 60.96L98.4599 60.87L95.3799 60.52Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 60.08V60.19L98.9399 60.6L99.0899 60.5L95.3799 60.08Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 59.64V59.75L99.4499 60.22L99.4199 60.1L95.3799 59.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 59.2V59.31L99.5899 59.79V59.68L95.3799 59.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3799 58.76V58.87L99.5899 59.36V59.24L95.3799 58.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5 58.44L99.59 58.92V58.81L95.66 58.35L95.5 58.44Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1396 58.0801L99.5896 58.48V58.37L96.2997 57.9901H96.2896L96.1396 58.0801Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.77 57.7101L99.59 58.0401V57.9301L96.93 57.6201L96.77 57.7101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3999 57.35L99.5899 57.6V57.49L97.5599 57.26L97.3999 57.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.04 56.98L99.59 57.16V57.05L98.2 56.89L98.04 56.98Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6699 56.62L99.5899 56.72V56.61L98.8299 56.52L98.6699 56.62Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2998 56.25L99.5898 56.28V56.17L99.4598 56.16L99.2998 56.25Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4097 57.99L90.6797 60.72V65.47L90.8797 65.6L95.4097 62.73L95.6097 58.12L95.4097 57.99V57.99ZM95.1797 62.6L90.8997 65.07V60.86L95.1797 58.39V62.6V62.6Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6099 58.12L90.8799 60.85V65.6L95.6099 62.87V58.12ZM95.3799 62.73L91.0999 65.2V60.99L95.3799 58.52V62.73V62.73Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6797 60.72L90.8697 60.85L95.6097 58.12L95.4097 57.99L90.6797 60.72Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9697 62.8499L94.9997 62.8699L95.0597 62.91L95.0797 62.82L95.3197 61.5499V60.95L94.9697 62.8499Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6196 63.05L94.6496 63.07L94.7196 63.11L94.7396 63.02L95.3196 59.88V59.27L94.6196 63.05Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3798 63.31L95.2498 58.59L95.1898 58.63L95.1198 58.66L94.2798 63.25L94.3798 63.31Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9297 63.45L94.0297 63.51L94.8997 58.79L94.7797 58.87L93.9297 63.45Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5898 63.64L93.6898 63.71L94.5598 58.99H94.5499L94.4298 59.06L93.5898 63.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2397 63.8399L93.3397 63.8999L94.2097 59.1899L94.0897 59.2599L93.2397 63.8399Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8994 64.04L92.9994 64.1L93.8694 59.39L93.7594 59.45L93.7394 59.46L92.8994 64.04Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5498 64.24L92.6498 64.3L93.5198 59.59L93.3998 59.66L92.5498 64.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2095 64.44L92.3095 64.5L93.1795 59.79L93.1295 59.82H93.1195L93.0495 59.86L92.2095 64.44Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8594 64.64L91.9594 64.7L92.8294 59.99L92.7094 60.06L91.8594 64.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5195 64.84L91.6195 64.9L92.4895 60.18L92.3595 60.26L91.5195 64.84Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1694 65.0399L91.2694 65.0999L92.1394 60.3799L92.0194 60.4599L91.1694 65.0399Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 63.76V64.36L91.7996 60.58L91.6796 60.65L91.0996 63.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 62.1V62.7L91.4596 60.78L91.3796 60.82L91.3296 60.85L91.0996 62.1Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 64.74V64.85L91.4896 64.89L91.6496 64.8L91.0996 64.74Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 64.3V64.41L92.1196 64.53L92.2796 64.44L91.0996 64.3Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 63.86V63.97L92.7596 64.16L92.9096 64.07L91.0996 63.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 63.42V63.53L93.3896 63.8L93.5496 63.71L91.0996 63.42Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 62.99V63.1L94.0196 63.43L94.1796 63.34L91.0996 62.99Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 62.55V62.66L94.6596 63.07L94.8096 62.97L91.0996 62.55Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 62.11V62.22L95.1696 62.69L95.1396 62.57L91.0996 62.11Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 61.67V61.78L95.3196 62.26V62.15L91.0996 61.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 61.23V61.34L95.3196 61.83V61.71L91.0996 61.23Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2197 60.91L95.3197 61.39V61.28L91.3797 60.82L91.2197 60.91Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8594 60.55L95.3194 60.95V60.84L92.0194 60.46L91.8594 60.55Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4897 60.18L95.3197 60.51V60.4L92.6497 60.09L92.4897 60.18Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1294 59.82L95.3194 60.07V59.96L93.2894 59.73H93.2794L93.1294 59.82Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7598 59.45L95.3198 59.63V59.52L93.9198 59.36L93.7598 59.45Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3896 59.09L95.3196 59.19V59.08L94.5596 58.99H94.5497L94.3896 59.09Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0298 58.72L95.3198 58.75V58.64L95.1898 58.63L95.0298 58.72Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1299 60.46L86.3999 63.19V67.94L86.5999 68.07L91.1299 65.2L91.3299 60.59L91.1299 60.46V60.46ZM90.8999 65.07L86.6199 67.54V63.33L90.8999 60.86V65.07Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3301 60.59L86.6001 63.32V68.07L91.3301 65.34V60.59V60.59ZM91.1001 65.2L86.8201 67.67V63.46L91.1001 60.99V65.2Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3999 63.19L86.5999 63.32L91.3299 60.59L91.1299 60.46L86.3999 63.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6899 65.3199L90.7199 65.3399L90.7899 65.3799L90.7999 65.2899L91.0399 64.0199V63.4199L90.6899 65.3199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3398 65.5199L90.3798 65.5399L90.4398 65.5799L90.4598 65.4899L91.0398 62.3499V61.7399L90.3398 65.5199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1 65.7799L90.97 61.0599L90.91 61.0999L90.84 61.1299L90 65.7199L90.1 65.7799Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6499 65.9199L89.7499 65.98L90.6199 61.2599L90.4999 61.34L89.6499 65.9199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3101 66.11L89.4101 66.18L90.2801 61.46L90.1501 61.53L89.3101 66.11Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9697 66.3099L89.0597 66.3699L89.9297 61.6599L89.8097 61.7299L88.9697 66.3099Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6196 66.5099L88.7196 66.5699L89.5896 61.8599L89.4796 61.9199L89.4596 61.9299L88.6196 66.5099Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2798 66.7099L88.3698 66.7699L89.2398 62.0599L89.1198 62.1299L88.2798 66.7099Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9297 66.9099L88.0297 66.9699L88.8997 62.2499L88.8497 62.2899L88.7797 62.3299L87.9297 66.9099Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5898 67.11L87.6898 67.17L88.5598 62.46L88.4298 62.53L87.5898 67.11Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2397 67.31L87.3397 67.37L88.2097 62.65L88.0897 62.73L87.2397 67.31Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8999 67.5099L86.9999 67.5699L87.8699 62.8499L87.7399 62.9299L86.8999 67.5099Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 66.2299V66.8299L87.5198 63.0499L87.3998 63.1199L86.8198 66.2299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 64.5699V65.1699L87.1798 63.2499L87.1098 63.2899H87.0998L87.0498 63.3199L86.8198 64.5699Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 67.21V67.32L87.2098 67.36L87.3698 67.27L86.8198 67.21Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 66.77V66.88L87.8498 67L87.9998 66.91L86.8198 66.77Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 66.33V66.44L88.4798 66.63L88.6398 66.54L86.8198 66.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 65.89V66L89.1098 66.27L89.2698 66.18L86.8198 65.89Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 65.46V65.57L89.7498 65.9L89.8998 65.81L86.8198 65.46Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 65.02V65.13L90.3798 65.54L90.5298 65.44L86.8198 65.02Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 64.58V64.69L90.8898 65.16L90.8598 65.04L86.8198 64.58Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 64.14V64.25L91.0398 64.73V64.62L86.8198 64.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8198 63.7V63.81L91.0398 64.3V64.18L86.8198 63.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9497 63.38L91.0397 63.86V63.75L87.1097 63.29H87.0997L86.9497 63.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5796 63.02L91.0396 63.42V63.31L87.7396 62.93L87.5796 63.02Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.21 62.65L91.04 62.98V62.87L88.37 62.56L88.21 62.65Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8496 62.29L91.0396 62.54V62.43L89.0096 62.2L88.8496 62.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.48 61.92L91.04 62.1V61.99L89.64 61.83L89.48 61.92Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1196 61.56L91.0396 61.66V61.55L90.2796 61.46L90.1196 61.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.75 61.19L91.04 61.22V61.11L90.91 61.1L90.75 61.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6201 63.07L81.8901 65.8V70.55L82.0901 70.68L86.6201 67.81L86.8201 63.2L86.6201 63.07V63.07ZM86.3901 67.68L82.1101 70.15V65.94L86.3901 63.47V67.68Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8203 63.2L82.0903 65.93V70.68L86.8203 67.95V63.2ZM86.5903 67.81L82.3103 70.28V66.07L86.5903 63.6V67.81Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8901 65.8L82.0901 65.93L86.8201 63.2L86.6201 63.07L81.8901 65.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1802 67.93L86.2202 67.95L86.2802 67.99L86.3002 67.9L86.5302 66.63V66.03L86.1802 67.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8403 68.13L85.8703 68.15L85.9403 68.19L85.9503 68.1L86.5303 64.96V64.35L85.8403 68.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5902 68.39L86.4602 63.67L86.4002 63.71L86.3402 63.75L85.4902 68.33L85.5902 68.39Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1504 68.53L85.2504 68.59L86.1204 63.87L85.9904 63.95L85.1504 68.53Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8003 68.73L84.9003 68.79L85.7703 64.07L85.6503 64.14L84.8003 68.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4604 68.92L84.5604 68.99L85.4305 64.27L85.3005 64.34L84.4604 68.92Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1104 69.12L84.2104 69.18L85.0804 64.47L84.9804 64.53L84.9604 64.54L84.1104 69.12Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7705 69.32L83.8705 69.38L84.7405 64.67L84.6105 64.74L83.7705 69.32Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4302 69.52L83.5202 69.58L84.3902 64.87L84.3402 64.9L84.2702 64.94L83.4302 69.52Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0801 69.72L83.1801 69.78L84.0501 65.07L83.9201 65.14L83.0801 69.72Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7402 69.92L82.8402 69.98L83.7102 65.26L83.5802 65.34L82.7402 69.92Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3901 70.12L82.4901 70.18L83.3601 65.46L83.2401 65.54L82.3901 70.12Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 68.85V69.45L83.0203 65.66L82.8903 65.73L82.3203 68.85Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 67.18V67.78L82.6703 65.86L82.6003 65.9L82.5503 65.93L82.3203 67.18Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 69.82V69.93L82.7103 69.98L82.8603 69.89L82.3203 69.82Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 69.38V69.49L83.3403 69.61L83.5003 69.52L82.3203 69.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 68.94V69.05L83.9703 69.24L84.1303 69.15L82.3203 68.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 68.51V68.62L84.6103 68.88L84.7603 68.79L82.3203 68.51Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 68.07V68.18L85.2403 68.51L85.4003 68.42L82.3203 68.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 67.63V67.74L85.8703 68.15L86.0303 68.06L82.3203 67.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 67.19V67.3L86.3803 67.77L86.3503 67.65L82.3203 67.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 66.75V66.86L86.5303 67.34V67.24L82.3203 66.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 66.31V66.42L86.5303 66.91V66.8L82.3203 66.31Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4404 65.99L86.5304 66.47V66.36L82.6004 65.9L82.4404 65.99Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0703 65.63L86.5303 66.03V65.92L83.2303 65.54L83.0703 65.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7104 65.26L86.5304 65.59V65.48L83.8705 65.17L83.7104 65.26Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 64.9L86.5303 65.15V65.04L84.5003 64.81L84.3403 64.9Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9805 64.53L86.5305 64.71V64.6L85.1405 64.44H85.1305L84.9805 64.53Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6104 64.17L86.5303 64.27V64.16L85.7703 64.07L85.6104 64.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2402 63.8L86.5302 63.83V63.72L86.4002 63.71L86.2402 63.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3496 65.54L77.6196 68.27V73.02L77.8196 73.15L82.3496 70.28L82.5496 65.67L82.3496 65.54ZM82.1196 70.15L77.8396 72.62V68.41L82.1196 65.94V70.15Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5498 65.67L77.8198 68.4V73.15L82.5498 70.42V65.67ZM82.3198 70.28L78.0398 72.75V68.54L82.3198 66.07V70.28Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6099 68.27L77.8099 68.4L82.5499 65.67L82.3499 65.54L77.6099 68.27Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8999 70.4L81.9399 70.42L81.9999 70.46L82.0199 70.37L82.2499 69.1V68.5L81.8999 70.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5601 70.6L81.5901 70.62L81.6601 70.66L81.6801 70.57L82.2501 67.43V66.82L81.5601 70.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.31 70.86L82.18 66.14L82.12 66.18L82.06 66.22L81.21 70.8L81.31 70.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8701 71L80.9701 71.06L81.8401 66.34L81.7201 66.42L80.8701 71Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5303 71.2L80.6203 71.26L81.4903 66.54L81.3703 66.61L80.5303 71.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1802 71.39L80.2802 71.46L81.1502 66.74L81.0302 66.81L80.1802 71.39Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8398 71.59L79.9398 71.65L80.8098 66.94L80.6998 67L80.6798 67.01L79.8398 71.59Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4902 71.79L79.5902 71.85L80.4602 67.14L80.3402 67.21L79.4902 71.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1499 71.99L79.2499 72.05L80.1199 67.34L80.0599 67.37L79.9899 67.41L79.1499 71.99Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7998 72.19L78.8998 72.25L79.7698 67.54L79.6498 67.61L78.7998 72.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.46 72.39L78.56 72.45L79.43 67.73L79.3 67.81L78.46 72.39Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1099 72.59L78.2099 72.65L79.0799 67.93L78.9599 68.01L78.1099 72.59Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 71.31V71.92L78.74 68.13L78.61 68.2L78.04 71.31Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 69.65V70.25L78.39 68.33L78.32 68.37L78.27 68.4L78.04 69.65Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 72.29V72.4L78.43 72.45L78.58 72.36L78.04 72.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 71.85V71.96L79.06 72.08L79.22 71.99L78.04 71.85Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 71.41V71.52L79.7 71.71L79.85 71.62L78.04 71.41Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 70.98V71.09L80.33 71.35L80.49 71.26L78.04 70.98Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 70.54V70.65L80.96 70.98L81.12 70.89L78.04 70.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 70.1V70.21L81.6 70.62L81.75 70.53L78.04 70.1Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 69.66V69.77L82.11 70.24L82.08 70.12L78.04 69.66Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 69.22V69.33L82.25 69.81V69.71L78.04 69.22Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04 68.78V68.89L82.25 69.38V69.27L78.04 68.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1602 68.4601L82.2502 68.9401V68.8301L78.3202 68.3701L78.1602 68.4601Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7998 68.1001L82.2498 68.5001V68.3901L78.9598 68.0101H78.9498L78.7998 68.1001Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4302 67.7301L82.2502 68.0601V67.9501L79.5902 67.6401L79.4302 67.7301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0601 67.37L82.2501 67.62V67.51L80.2201 67.28L80.0601 67.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7002 67L82.2502 67.18V67.07L80.8602 66.91L80.7002 67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3301 66.64L82.2501 66.74V66.63L81.4901 66.54L81.3301 66.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9702 66.2701L82.2502 66.3001V66.1901L82.1202 66.1801L81.9702 66.2701Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0698 68.01L73.3398 70.74V75.49L73.5398 75.62L78.0698 72.75L78.2698 68.14L78.0698 68.01ZM77.8398 72.62L73.5598 75.09V70.88L77.8398 68.41V72.62Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.27 68.14L73.54 70.87V75.62L78.27 72.89V68.14ZM78.04 72.75L73.76 75.22V71.01L78.04 68.54V72.75Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3398 70.74L73.5398 70.87L78.2698 68.14L78.0698 68.01L73.3398 70.74Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6299 72.87L77.6599 72.89L77.7299 72.93L77.7399 72.84L77.9799 71.57V70.97L77.6299 72.87Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2798 73.07L77.3098 73.09L77.3798 73.13L77.3998 73.04L77.9798 69.9V69.29L77.2798 73.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0399 73.33L77.9099 68.61L77.8499 68.65L77.7799 68.69L76.9399 73.27L77.0399 73.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5898 73.47L76.6898 73.53L77.5598 68.81L77.4398 68.89L76.5898 73.47Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.25 73.67L76.35 73.73L77.22 69.01H77.21L77.09 69.08L76.25 73.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8999 73.86L75.9999 73.93L76.8699 69.21L76.7499 69.28L75.8999 73.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5596 74.06L75.6596 74.12L76.5296 69.41L76.4196 69.47L76.3996 69.48L75.5596 74.06Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.21 74.26L75.31 74.32L76.18 69.61L76.06 69.68L75.21 74.26Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8696 74.46L74.9696 74.52L75.8396 69.81L75.7896 69.84H75.7796L75.7096 69.88L74.8696 74.46Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5298 74.66L74.6198 74.72L75.4898 70.01L75.3698 70.08L74.5298 74.66Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1797 74.86L74.2797 74.92L75.1497 70.2L75.0197 70.28L74.1797 74.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8398 75.06L73.9298 75.12L74.7999 70.4L74.6798 70.48L73.8398 75.06Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 73.78V74.39L74.4598 70.6L74.3398 70.67L73.7598 73.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 72.12V72.72L74.1198 70.8L74.0398 70.84L73.9898 70.87L73.7598 72.12Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 74.76V74.87L74.1498 74.92L74.3098 74.83L73.7598 74.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 74.32V74.43L74.7798 74.55L74.9398 74.46L73.7598 74.32Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 73.88V73.99L75.4198 74.18L75.5698 74.09L73.7598 73.88Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 73.45V73.55L76.0498 73.82L76.2098 73.73L73.7598 73.45Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 73.01V73.12L76.6798 73.45L76.8398 73.36L73.7598 73.01Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 72.57V72.68L77.3198 73.09L77.4698 72.99L73.7598 72.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 72.13V72.24L77.8298 72.71L77.7998 72.59L73.7598 72.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 71.69V71.8L77.9798 72.28V72.18L73.7598 71.69Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 71.25V71.36L77.9798 71.85V71.73L73.7598 71.25Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8799 70.93L77.9799 71.41V71.3L74.0399 70.84L73.8799 70.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5195 70.57L77.9795 70.97V70.86L74.6795 70.48L74.5195 70.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1499 70.2L77.9799 70.53V70.42L75.3099 70.11L75.1499 70.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7896 69.84L77.9796 70.09V69.98L75.9495 69.75H75.9396L75.7896 69.84Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4199 69.47L77.9799 69.65V69.54L76.5799 69.38L76.4199 69.47Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0498 69.11L77.9798 69.21V69.1L77.2198 69.01H77.2098L77.0498 69.11Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6899 68.74L77.9799 68.77V68.66L77.8499 68.65L77.6899 68.74Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7901 70.48L69.0601 73.21V77.96L69.2601 78.09L73.7901 75.22L73.9901 70.61L73.7901 70.48ZM73.5601 75.09L69.2801 77.56V73.35L73.5601 70.88V75.09Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9902 70.61L69.2603 73.34V78.09L73.9902 75.36V70.61ZM73.7603 75.22L69.4803 77.69V73.48L73.7603 71.01V75.22Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0601 73.21L69.2601 73.34L73.9901 70.61L73.7901 70.48L69.0601 73.21Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3501 75.3399L73.3801 75.3599L73.4501 75.3999L73.4601 75.3099L73.7001 74.0399V73.4399L73.3501 75.3399Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 75.5399L73.04 75.5599L73.1 75.5999L73.12 75.5099L73.7 72.3699V71.7599L73 75.5399Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7602 75.8L73.6301 71.08L73.5702 71.12L73.5002 71.16L72.6602 75.74L72.7602 75.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3101 75.94L72.4101 76L73.2801 71.28L73.1601 71.36L72.3101 75.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9702 76.13L72.0702 76.2L72.9402 71.48L72.8202 71.55L71.9702 76.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6299 76.3299L71.7199 76.3999L72.5999 71.6799L72.4699 71.7499L71.6299 76.3299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2798 76.5299L71.3798 76.5899L72.2498 71.8799L72.1398 71.9399L72.1298 71.9499L71.2798 76.5299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9399 76.73L71.0299 76.79L71.9099 72.08L71.7799 72.15L70.9399 76.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5898 76.93L70.6898 76.99L71.5598 72.28L71.5098 72.31L71.4398 72.35L70.5898 76.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25 77.13L70.35 77.19L71.22 72.48L71.09 72.55L70.25 77.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8999 77.3299L69.9999 77.3899L70.8699 72.6699L70.7499 72.7499L69.8999 77.3299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5601 77.5299L69.6601 77.5899L70.5301 72.8699L70.4001 72.9499L69.5601 77.5299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 76.2499V76.8599L70.18 73.0699L70.06 73.1399L69.48 76.2499Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 74.59V75.19L69.84 73.27L69.77 73.31H69.76L69.71 73.34L69.48 74.59Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 77.23V77.34L69.87 77.38L70.03 77.3L69.48 77.23Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 76.79V76.9L70.51 77.02L70.66 76.93L69.48 76.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 76.35V76.46L71.14 76.65L71.3 76.56L69.48 76.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 75.92V76.02L71.77 76.29L71.93 76.2L69.48 75.92Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 75.48V75.59L72.41 75.92L72.56 75.83L69.48 75.48Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 75.04V75.15L73.04 75.56L73.19 75.46L69.48 75.04Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 74.6V74.71L73.55 75.18L73.52 75.06L69.48 74.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 74.16V74.27L73.7 74.75V74.64L69.48 74.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48 73.72V73.83L73.7 74.32V74.2L69.48 73.72Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6099 73.4L73.6999 73.88V73.77L69.7699 73.31H69.7599L69.6099 73.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2397 73.04L73.6997 73.44V73.33L70.3997 72.95L70.2397 73.04Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8701 72.67L73.7001 73V72.89L71.0301 72.58L70.8701 72.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5098 72.31L73.6998 72.56V72.45L71.6698 72.22L71.5098 72.31Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1401 71.94L73.7001 72.12V72.01L72.3001 71.85L72.1401 71.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7798 71.58L73.6998 71.68V71.57L72.9398 71.48L72.7798 71.58Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4102 71.21L73.7001 71.24V71.13L73.5702 71.12L73.4102 71.21Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2901 73.08L64.5601 75.81V80.56L64.7601 80.69L69.2901 77.82L69.4901 73.21L69.2901 73.08ZM69.0601 77.69L64.7801 80.16V75.95L69.0601 73.48V77.69Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4902 73.21L64.7603 75.94V80.69L69.4902 77.96V73.21ZM69.2603 77.82L64.9803 80.29V76.08L69.2603 73.61V77.82Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5601 75.81L64.7601 75.94L69.4901 73.21L69.2901 73.08L64.5601 75.81Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8501 77.94L68.8801 77.96L68.9501 78L68.9701 77.91L69.2001 76.64V76.04L68.8501 77.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5103 78.14L68.5403 78.16L68.6103 78.2L68.6203 78.11L69.2002 74.97V74.36L68.5103 78.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2602 78.4L69.1301 73.68L69.0702 73.72L69.0102 73.76L68.1602 78.34L68.2602 78.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8203 78.54L67.9203 78.6L68.7903 73.88L68.6603 73.96L67.8203 78.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4702 78.73L67.5702 78.8L68.4402 74.08L68.3202 74.15L67.4702 78.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1304 78.93L67.2304 79L68.1004 74.28L67.9704 74.35L67.1304 78.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7803 79.13L66.8803 79.19L67.7503 74.48L67.6503 74.54H67.6403L67.6303 74.55L66.7803 79.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4404 79.33L66.5404 79.39L67.4104 74.68L67.2804 74.75L66.4404 79.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0903 79.53L66.1903 79.59L67.0603 74.88L67.0103 74.91L66.9403 74.95L66.0903 79.53Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.75 79.73L65.85 79.79L66.72 75.08L66.59 75.15L65.75 79.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4004 79.93L65.5104 79.99L66.3804 75.27L66.2504 75.35L65.4004 79.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0601 80.13L65.1601 80.19L66.0301 75.47L65.9101 75.55L65.0601 80.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 78.85V79.46L65.6902 75.67L65.5602 75.74L64.9902 78.85Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 77.19V77.79L65.3402 75.87L65.2702 75.91L65.2202 75.94L64.9902 77.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 79.83V79.94L65.3702 79.98L65.3802 79.99L65.5302 79.9L64.9902 79.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 79.39V79.5L66.0102 79.62L66.1702 79.53L64.9902 79.39Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 78.95V79.06L66.6402 79.25L66.8002 79.16L64.9902 78.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 78.52V78.62L67.2702 78.89L67.4302 78.8L64.9902 78.52Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 78.08V78.19L67.9102 78.52L68.0702 78.43L64.9902 78.08Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 77.64V77.75L68.5402 78.16L68.7002 78.06L64.9902 77.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 77.2V77.31L69.0502 77.78L69.0202 77.66L64.9902 77.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 76.76V76.87L69.2002 77.35V77.25L64.9902 76.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9902 76.32V76.43L69.2002 76.92V76.8L64.9902 76.32Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1104 76L69.2003 76.48V76.37L65.2703 75.91L65.1104 76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7402 75.64L69.2002 76.04V75.93L65.9002 75.55L65.7402 75.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3804 75.2701L69.2004 75.6001V75.4901L66.5404 75.1801L66.3804 75.2701Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0103 74.91L69.2002 75.16V75.05L67.1702 74.82L67.0103 74.91Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6504 74.54L69.2004 74.72V74.61L67.8104 74.45H67.8004L67.6504 74.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2803 74.18L69.2003 74.28V74.17L68.4403 74.08L68.2803 74.18Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9102 73.81L69.2001 73.84V73.73L69.0702 73.72L68.9102 73.81Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0195 75.55L60.2896 78.28V83.03L60.4896 83.16L65.0195 80.29L65.2196 75.68L65.0195 75.55ZM64.7896 80.16L60.5095 82.63V78.42L64.7896 75.95V80.16Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2197 75.6801L60.4897 78.4101V83.1601L65.2197 80.4301V75.6801ZM64.9897 80.2901L60.7097 82.7601V78.5501L64.9897 76.0801V80.2901Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2798 78.28L60.4798 78.41L65.2198 75.68L65.0198 75.55L60.2798 78.28Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 80.41L64.6098 80.43L64.6698 80.47L64.6898 80.38L64.9198 79.11V78.51L64.5698 80.41Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.23 80.61L64.26 80.63L64.33 80.67L64.35 80.58L64.92 77.44V76.83L64.23 80.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9799 80.87L64.8499 76.15L64.7899 76.19L64.7299 76.22L63.8799 80.81L63.9799 80.87Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.54 81.01L63.64 81.07L64.51 76.35L64.38 76.43L63.54 81.01Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2002 81.2L63.2902 81.27L64.1602 76.55L64.0402 76.62L63.2002 81.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8501 81.4L62.9501 81.47L63.8201 76.75L63.6901 76.82L62.8501 81.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 81.6L62.61 81.66L63.48 76.95L63.37 77.01L63.35 77.02L62.5 81.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1602 81.8L62.2602 81.86L63.1302 77.15L63.0102 77.22L62.1602 81.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8198 82L61.9198 82.06L62.7898 77.35L62.7298 77.38L62.6598 77.42L61.8198 82Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4697 82.2L61.5697 82.26L62.4397 77.55L62.3197 77.62L61.4697 82.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1299 82.4L61.2299 82.46L62.0999 77.74L61.9699 77.82L61.1299 82.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7798 82.6L60.8798 82.66L61.7498 77.94L61.6298 78.02L60.7798 82.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 81.32V81.92L61.41 78.14L61.28 78.21L60.71 81.32Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 79.66V80.26L61.06 78.34L60.99 78.38L60.94 78.41L60.71 79.66Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 82.3V82.41L61.1 82.45L61.25 82.36L60.71 82.3Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 81.86V81.97L61.73 82.09L61.89 82L60.71 81.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 81.42V81.53L62.37 81.72L62.52 81.63L60.71 81.42Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 80.9901V81.09L63 81.3601L63.16 81.2701L60.71 80.9901Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 80.55V80.66L63.63 80.99L63.79 80.9L60.71 80.55Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 80.11V80.22L64.27 80.63L64.42 80.53L60.71 80.11Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 79.67V79.78L64.78 80.25L64.75 80.13L60.71 79.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 79.23V79.34L64.92 79.82V79.71L60.71 79.23Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71 78.79V78.9L64.92 79.39V79.27L60.71 78.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8301 78.4701L64.9201 78.9501V78.8401L60.9901 78.3801L60.8301 78.4701Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4697 78.1101L64.9197 78.5101V78.4001L61.6197 78.0201L61.4697 78.1101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1001 77.7401L64.9201 78.0701V77.9601L62.2601 77.6501L62.1001 77.7401Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.73 77.38L64.92 77.63V77.52L62.89 77.29L62.73 77.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3701 77.01L64.9201 77.19V77.08L63.5301 76.92L63.3701 77.01Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 76.65L64.92 76.75V76.64L64.16 76.55L64 76.65Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6299 76.2801L64.9199 76.3101V76.2001L64.7899 76.1901L64.6299 76.2801Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7398 78.02L56.0098 80.75V85.5L56.2098 85.63L60.7398 82.76L60.9398 78.15L60.7398 78.02V78.02ZM60.5098 82.63L56.2298 85.1V80.89L60.5098 78.42V82.63Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.94 78.15L56.21 80.88V85.63L60.94 82.9V78.15ZM60.71 82.76L56.43 85.23V81.02L60.71 78.55V82.76Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 80.75L56.2 80.88L60.94 78.15L60.74 78.02L56 80.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3003 82.88L60.3303 82.9L60.3903 82.94L60.4103 82.85L60.6503 81.58V80.98L60.3003 82.88Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9502 83.08L59.9802 83.1L60.0502 83.14L60.0702 83.05L60.6502 79.91V79.3L59.9502 83.08Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7104 83.34L60.5704 78.62L60.5204 78.66L60.4504 78.69L59.6104 83.28L59.7104 83.34Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2603 83.48L59.3603 83.54L60.2303 78.82L60.1103 78.9L59.2603 83.48Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9204 83.67L59.0204 83.74L59.8804 79.02L59.7604 79.09L58.9204 83.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5703 83.87L58.6703 83.93L59.5403 79.22L59.4203 79.29L58.5703 83.87Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.23 84.07L58.33 84.13L59.2 79.42L59.09 79.48L59.07 79.49L58.23 84.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8804 84.27L57.9804 84.33L58.8504 79.62L58.7304 79.69L57.8804 84.27Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.54 84.47L57.64 84.53L58.51 79.82L58.46 79.85H58.45L58.38 79.89L57.54 84.47Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1899 84.67L57.2899 84.73L58.1599 80.02L58.0399 80.09L57.1899 84.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8501 84.87L56.9501 84.93L57.8201 80.21L57.6901 80.29L56.8501 84.87Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 85.07L56.6 85.13L57.47 80.41L57.35 80.49L56.5 85.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 83.79V84.39L57.1302 80.61L57.0102 80.68L56.4302 83.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 82.13V82.73L56.7902 80.81L56.7102 80.85L56.6602 80.88L56.4302 82.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 84.77V84.88L56.8202 84.92L56.9802 84.83L56.4302 84.77Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 84.33V84.44L57.4502 84.56L57.6102 84.47L56.4302 84.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 83.89V84L58.0902 84.19L58.2402 84.1L56.4302 83.89Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 83.46V83.56L58.7202 83.83L58.8802 83.74L56.4302 83.46Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 83.02V83.13L59.3502 83.46L59.5102 83.37L56.4302 83.02Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 82.58V82.69L59.9902 83.1L60.1402 83L56.4302 82.58Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 82.14V82.25L60.5002 82.72L60.4702 82.6L56.4302 82.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 81.7V81.81L60.6502 82.29V82.18L56.4302 81.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 81.26V81.37L60.6502 81.86V81.74L56.4302 81.26Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5503 80.94L60.6503 81.42V81.31L56.7103 80.85L56.5503 80.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1899 80.5801L60.6499 80.9801V80.8701L57.3499 80.4901L57.1899 80.5801Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8203 80.2101L60.6503 80.5401V80.4301L57.9803 80.1201L57.8203 80.2101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46 79.85L60.65 80.1V79.99L58.62 79.76H58.61L58.46 79.85Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0903 79.48L60.6503 79.66V79.55L59.2503 79.39L59.0903 79.48Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7202 79.12L60.6502 79.22V79.11L59.8802 79.02L59.7202 79.12Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3604 78.75L60.6504 78.78V78.67L60.5204 78.66L60.3604 78.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.46 80.49L51.73 83.22V87.97L51.93 88.1L56.46 85.23L56.66 80.62L56.46 80.49V80.49ZM56.23 85.1L51.95 87.57V83.36L56.23 80.89V85.1Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6602 80.62L51.9302 83.35V88.1L56.6602 85.37V80.62ZM56.4302 85.23L52.1502 87.7V83.49L56.4302 81.02V85.23Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.73 83.22L51.93 83.35L56.66 80.62L56.46 80.49L51.73 83.22Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.02 85.35L56.05 85.37L56.12 85.41L56.13 85.32L56.37 84.05V83.45L56.02 85.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6699 85.55L55.7099 85.57L55.7699 85.61L55.7899 85.52L56.3699 82.38V81.77L55.6699 85.55Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4301 85.81L56.3001 81.09L56.2401 81.13L56.1701 81.16L55.3301 85.75L55.4301 85.81Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.98 85.95L55.08 86.01L55.95 81.29L55.83 81.37L54.98 85.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6401 86.14L54.7401 86.21L55.6101 81.49L55.4801 81.56L54.6401 86.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.29 86.3399L54.39 86.3999L55.26 81.6899L55.14 81.7599L54.29 86.3399Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9497 86.54L54.0497 86.6L54.9197 81.89L54.8097 81.95L54.7897 81.96L53.9497 86.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6001 86.74L53.7001 86.8L54.5701 82.09L54.4501 82.16L53.6001 86.74Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2598 86.94L53.3598 87L54.2298 82.28L54.1798 82.32L54.1098 82.36L53.2598 86.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9199 87.14L53.0199 87.2L53.8899 82.49L53.7599 82.56L52.9199 87.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5698 87.34L52.6698 87.4L53.5398 82.68L53.4198 82.76L52.5698 87.34Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.23 87.5399L52.33 87.5999L53.2 82.8799L53.07 82.9599L52.23 87.5399Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 86.26V86.86L52.8499 83.08L52.7299 83.15L52.1499 86.26Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 84.6V85.2L52.5099 83.28L52.4399 83.32H52.4299L52.3799 83.35L52.1499 84.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 87.24V87.35L52.5399 87.39L52.6999 87.3L52.1499 87.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 86.8V86.91L53.1799 87.03L53.3299 86.94L52.1499 86.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 86.36V86.47L53.8099 86.66L53.9699 86.57L52.1499 86.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 85.92V86.03L54.4399 86.3L54.5999 86.21L52.1499 85.92Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 85.49V85.6L55.0799 85.93L55.2299 85.84L52.1499 85.49Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 85.05V85.16L55.7099 85.57L55.8599 85.47L52.1499 85.05Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 84.61V84.72L56.2199 85.19L56.1899 85.07L52.1499 84.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 84.17V84.28L56.3699 84.76V84.65L52.1499 84.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1499 83.73V83.84L56.3699 84.33V84.21L52.1499 83.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2798 83.41L56.3698 83.89V83.78L52.4398 83.32H52.4298L52.2798 83.41Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9097 83.05L56.3697 83.45V83.34L53.0697 82.96L52.9097 83.05Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.54 82.68L56.37 83.01V82.9L53.7 82.59L53.54 82.68Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1797 82.32L56.3697 82.57V82.46L54.3397 82.23L54.1797 82.32Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8101 81.95L56.3701 82.13V82.02L54.9701 81.86L54.8101 81.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4399 81.59L56.3699 81.69V81.58L55.6099 81.49L55.4399 81.59Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0801 81.22L56.3701 81.25V81.14L56.2401 81.13L56.0801 81.22Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9502 83.1L47.2202 85.83V90.58L47.4202 90.71L51.9502 87.84L52.1502 83.23L51.9502 83.1ZM51.7202 87.71L47.4402 90.18V85.97L51.7202 83.5V87.71Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1504 83.23L47.4204 85.96V90.71L52.1504 87.98V83.23V83.23ZM51.9204 87.84L47.6404 90.31V86.1L51.9204 83.63V87.84Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2202 85.83L47.4202 85.96L52.1502 83.23L51.9502 83.1L47.2202 85.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5103 87.9599L51.5403 87.9799L51.6103 88.0199L51.6303 87.9299L51.8603 86.6599V86.0599L51.5103 87.9599Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1704 88.16L51.2004 88.1799L51.2704 88.2199L51.2804 88.1299L51.8604 84.9899V84.3799L51.1704 88.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9203 88.42L51.7903 83.7L51.7303 83.74L51.6703 83.78L50.8203 88.36L50.9203 88.42Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4805 88.56L50.5805 88.62L51.4505 83.9L51.3205 83.98L50.4805 88.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1304 88.75L50.2304 88.82L51.1004 84.1L50.9804 84.17L50.1304 88.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7905 88.9499L49.8905 89.0199L50.7605 84.2999L50.6305 84.3699L49.7905 88.9499Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4404 89.1499L49.5404 89.2099L50.4104 84.4999L50.3104 84.5599L50.2904 84.5699L49.4404 89.1499Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1006 89.35L49.2006 89.41L50.0706 84.7L49.9406 84.77L49.1006 89.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7505 89.55L48.8505 89.61L49.7205 84.9L49.6705 84.93L49.6005 84.97L48.7505 89.55Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4102 89.75L48.5102 89.81L49.3802 85.1L49.2502 85.17L48.4102 89.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0605 89.95L48.1705 90.01L49.0405 85.29L48.9105 85.37L48.0605 89.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7202 90.1499L47.8202 90.2099L48.6902 85.4899L48.5702 85.5699L47.7202 90.1499Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 88.8699V89.4799L48.3504 85.6899L48.2204 85.7599L47.6504 88.8699Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 87.21V87.81L48.0004 85.89L47.9304 85.93L47.8804 85.96L47.6504 87.21Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 89.85V89.96L48.0404 90V90.01L48.1904 89.92L47.6504 89.85Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 89.41V89.52L48.6704 89.64L48.8304 89.55L47.6504 89.41Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 88.97V89.08L49.3004 89.27L49.4604 89.18L47.6504 88.97Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 88.54V88.64L49.9304 88.91L50.0904 88.82L47.6504 88.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 88.1V88.21L50.5704 88.54L50.7304 88.45L47.6504 88.1Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 87.66V87.77L51.2004 88.18L51.3604 88.08L47.6504 87.66Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 87.22V87.33L51.7104 87.8L51.6804 87.68L47.6504 87.22Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 86.78V86.89L51.8604 87.37V87.26L47.6504 86.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6504 86.34V86.45L51.8604 86.94V86.82L47.6504 86.34Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7705 86.02L51.8605 86.5V86.39L47.9305 85.93L47.7705 86.02Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4004 85.66L51.8604 86.06V85.95L48.5604 85.57L48.4004 85.66Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0405 85.29L51.8605 85.62V85.51L49.2005 85.2L49.0405 85.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6704 84.93L51.8604 85.18V85.07L49.8304 84.84L49.6704 84.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3105 84.56L51.8605 84.74V84.63L50.4705 84.47H50.4605L50.3105 84.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9404 84.2L51.8604 84.3V84.19L51.1004 84.1L50.9404 84.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5703 83.83L51.8603 83.86V83.75L51.7303 83.74L51.5703 83.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6797 85.5699L42.9497 88.2999V93.0499L43.1497 93.1799L47.6797 90.3099L47.8797 85.6999L47.6797 85.5699V85.5699ZM47.4497 90.1799L43.1697 92.6499V88.4399L47.4497 85.9699V90.1799Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8799 85.7L43.1499 88.43V93.18L47.8799 90.45V85.7V85.7ZM47.6499 90.31L43.3699 92.78V88.57L47.6499 86.1V90.31Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9399 88.2999L43.1399 88.4299L47.8799 85.6999L47.6799 85.5699L42.9399 88.2999Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.23 90.4299L47.27 90.4499L47.33 90.4899L47.35 90.3999L47.58 89.1299V88.5299L47.23 90.4299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8901 90.6299L46.9201 90.6499L46.9901 90.6899L47.0101 90.5999L47.5801 87.4599V86.8499L46.8901 90.6299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.64 90.8899L47.51 86.1699L47.45 86.2099L47.39 86.2399L46.54 90.8299L46.64 90.8899Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2002 91.0299L46.3002 91.0899L47.1702 86.3699L47.0402 86.4499L46.2002 91.0299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8604 91.2199L45.9504 91.2899L46.8204 86.5699L46.7004 86.6399L45.8604 91.2199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5103 91.4199L45.6103 91.4799L46.4803 86.7699L46.3503 86.8399L45.5103 91.4199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1699 91.6199L45.2699 91.6799L46.1399 86.9699L46.0299 87.0299L46.0099 87.0399L45.1699 91.6199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8203 91.8199L44.9203 91.8799L45.7903 87.1699L45.6703 87.2399L44.8203 91.8199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.48 92.0199L44.58 92.0799L45.45 87.3699L45.39 87.3999L45.32 87.4399L44.48 92.0199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1299 92.2199L44.2299 92.2799L45.0999 87.5699L44.9799 87.6399L44.1299 92.2199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.79 92.4199L43.89 92.4799L44.76 87.7599L44.63 87.8399L43.79 92.4199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4399 92.6199L43.5399 92.6799L44.4099 87.9599L44.2899 88.0399L43.4399 92.6199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 91.3399V91.9499L44.0701 88.1599L43.9401 88.2299L43.3701 91.3399Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 89.6799V90.2799L43.7201 88.3599L43.6501 88.3999L43.6001 88.4299L43.3701 89.6799Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 92.3199V92.4299L43.7601 92.4699L43.9101 92.3899L43.3701 92.3199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 91.8799V91.9899L44.3901 92.1099L44.5501 92.0199L43.3701 91.8799Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 91.4399V91.5499L45.0301 91.7399L45.1801 91.6499L43.3701 91.4399Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 91.0099V91.1099L45.6601 91.3799L45.8201 91.2899L43.3701 91.0099Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 90.5699V90.6799L46.2901 91.0099L46.4501 90.9199L43.3701 90.5699Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 90.1299V90.2399L46.9301 90.6499L47.0801 90.5499L43.3701 90.1299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 89.6899V89.7999L47.4401 90.2699L47.4101 90.1499L43.3701 89.6899Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 89.2499V89.3599L47.5801 89.8399V89.7299L43.3701 89.2499Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3701 88.8099V88.9199L47.5801 89.4099V89.2899L43.3701 88.8099Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4902 88.49L47.5802 88.97V88.86L43.6502 88.4L43.4902 88.49Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1299 88.13L47.5799 88.53V88.42L44.2899 88.04H44.2799L44.1299 88.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7603 87.76L47.5803 88.09V87.98L44.9203 87.67L44.7603 87.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3901 87.3999L47.5801 87.6499V87.5399L45.5501 87.3099L45.3901 87.3999Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0303 87.0299L47.5803 87.2099V87.0999L46.1903 86.9399L46.0303 87.0299Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6602 86.6699L47.5802 86.7699V86.66L46.8202 86.5699L46.6602 86.6699Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.29 86.3L47.58 86.33V86.22L47.45 86.21L47.29 86.3Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3999 88.04L38.6699 90.77V95.52L38.8699 95.65L43.3999 92.78L43.5999 88.17L43.3999 88.04V88.04ZM43.1699 92.65L38.8899 95.12V90.91L43.1699 88.44V92.65Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6001 88.17L38.8701 90.9V95.65L43.6001 92.92V88.17V88.17ZM43.3701 92.78L39.0901 95.25V91.04L43.3701 88.57V92.78Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6602 90.77L38.8602 90.9L43.6002 88.17L43.4002 88.04L38.6602 90.77Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9604 92.8999L42.9905 92.9199L43.0504 92.9599L43.0704 92.8699L43.3105 91.5999V90.9999L42.9604 92.8999Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6104 93.0999L42.6404 93.1199L42.7104 93.16L42.7304 93.0699L43.3104 89.9299V89.3199L42.6104 93.0999Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3705 93.36L43.2405 88.64L43.1805 88.68L43.1105 88.71L42.2705 93.3L42.3705 93.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9204 93.5L42.0204 93.56L42.8904 88.84L42.7704 88.92L41.9204 93.5Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5806 93.69L41.6806 93.76L42.5506 89.04H42.5406L42.4206 89.11L41.5806 93.69Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2305 93.8899L41.3305 93.9499L42.2005 89.2399L42.0805 89.3099L41.2305 93.8899Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8901 94.0899L40.9901 94.1499L41.8601 89.4399L41.7501 89.4999L41.7301 89.5099L40.8901 94.0899Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5405 94.29L40.6405 94.35L41.5105 89.64L41.3905 89.71L40.5405 94.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2002 94.49L40.3002 94.55L41.1702 89.84L41.1202 89.87H41.1102L41.0402 89.91L40.2002 94.49Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8501 94.69L39.9501 94.75L40.8201 90.04L40.7001 90.11L39.8501 94.69Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5103 94.89L39.6103 94.95L40.4803 90.23L40.3503 90.31L39.5103 94.89Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1602 95.0899L39.2602 95.1499L40.1302 90.4299L40.0102 90.5099L39.1602 95.0899Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 93.8099V94.41L39.7903 90.6299L39.6703 90.6999L39.0903 93.8099Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 92.15V92.75L39.4503 90.83L39.3703 90.87L39.3203 90.9L39.0903 92.15Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 94.79V94.9L39.4803 94.94L39.6403 94.85L39.0903 94.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 94.35V94.46L40.1103 94.58L40.2703 94.49L39.0903 94.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 93.91V94.02L40.7503 94.21L40.9003 94.12L39.0903 93.91Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 93.47V93.58L41.3803 93.85L41.5403 93.76L39.0903 93.47Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 93.04V93.15L42.0103 93.48L42.1703 93.39L39.0903 93.04Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 92.6V92.71L42.6503 93.12L42.8003 93.02L39.0903 92.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 92.16V92.27L43.1603 92.74L43.1303 92.62L39.0903 92.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 91.72V91.83L43.3103 92.31V92.2L39.0903 91.72Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0903 91.28V91.39L43.3103 91.88V91.76L39.0903 91.28Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2104 90.96L43.3105 91.44V91.33L39.3704 90.87L39.2104 90.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8501 90.6L43.3101 91V90.89L40.0101 90.51L39.8501 90.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4805 90.23L43.3105 90.56V90.45L40.6405 90.14L40.4805 90.23Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1201 89.87L43.3101 90.12V90.01L41.2801 89.78H41.2701L41.1201 89.87Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7505 89.5L43.3105 89.68V89.57L41.9105 89.41L41.7505 89.5Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3804 89.14L43.3104 89.24V89.13L42.5504 89.04H42.5404L42.3804 89.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0205 88.77L43.3105 88.8V88.69L43.1805 88.68L43.0205 88.77Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1201 90.51L34.3901 93.24V97.99L34.5901 98.12L39.1201 95.25L39.3201 90.64L39.1201 90.51V90.51ZM38.8901 95.12L34.6101 97.59V93.38L38.8901 90.91V95.12Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3203 90.64L34.5903 93.37V98.12L39.3203 95.39V90.64V90.64ZM39.0903 95.25L34.8103 97.72V93.51L39.0903 91.04V95.25Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3901 93.24L34.5901 93.37L39.3201 90.64L39.1201 90.51L34.3901 93.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6802 95.37L38.7102 95.39L38.7802 95.43L38.7902 95.34L39.0302 94.07V93.47L38.6802 95.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3301 95.57L38.3701 95.59L38.4301 95.63L38.4501 95.54L39.0301 92.4V91.79L38.3301 95.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0902 95.83L38.9602 91.11L38.9002 91.15L38.8302 91.18L37.9902 95.77L38.0902 95.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6401 95.97L37.7401 96.03L38.6101 91.31L38.4901 91.39L37.6401 95.97Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3003 96.16L37.4003 96.23L38.2703 91.51L38.1403 91.58L37.3003 96.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9502 96.36L37.0502 96.42L37.9202 91.71L37.8002 91.78L36.9502 96.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6099 96.56L36.7099 96.62L37.5799 91.91L37.4699 91.97L37.4499 91.98L36.6099 96.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2603 96.76L36.3603 96.82L37.2303 92.11L37.1103 92.18L36.2603 96.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9199 96.96L36.0199 97.02L36.8899 92.3L36.8399 92.34L36.7699 92.38L35.9199 96.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5801 97.16L35.6801 97.22L36.5501 92.51L36.4201 92.58L35.5801 97.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.23 97.36L35.33 97.42L36.2 92.7L36.08 92.78L35.23 97.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8901 97.56L34.9901 97.62L35.8601 92.9L35.7301 92.98L34.8901 97.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 96.28V96.88L35.5101 93.1L35.3901 93.17L34.8101 96.28Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 94.62V95.22L35.1701 93.3L35.1001 93.34H35.0901L35.0401 93.37L34.8101 94.62Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 97.26V97.37L35.2001 97.41L35.3601 97.32L34.8101 97.26Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 96.82V96.93L35.8401 97.05L35.9901 96.96L34.8101 96.82Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 96.38V96.49L36.4701 96.68L36.6301 96.59L34.8101 96.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 95.94V96.05L37.1001 96.32L37.2601 96.23L34.8101 95.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 95.51V95.62L37.7401 95.95L37.8901 95.86L34.8101 95.51Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 95.07V95.18L38.3701 95.59L38.5201 95.49L34.8101 95.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 94.63V94.74L38.8801 95.21L38.8501 95.09L34.8101 94.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 94.19V94.3L39.0301 94.78V94.67L34.8101 94.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8101 93.75V93.86L39.0301 94.34V94.23L34.8101 93.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9399 93.43L39.0299 93.91V93.8L35.0999 93.34H35.0899L34.9399 93.43Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5698 93.07L39.0298 93.47V93.36L35.7298 92.98L35.5698 93.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2002 92.7L39.0302 93.03V92.92L36.3602 92.61L36.2002 92.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8398 92.34L39.0298 92.59V92.48L36.9998 92.25L36.8398 92.34Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4702 91.97L39.0302 92.15V92.04L37.6302 91.88L37.4702 91.97Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1001 91.61L39.0301 91.71V91.6L38.2701 91.51L38.1001 91.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7402 91.24L39.0302 91.27V91.16L38.9002 91.15L38.7402 91.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.09 29.58L31.81 28.32C31.87 28.32 41.04 26.28 52.69 19.72C62.89 13.99 72.41 4.89997 72.84 4.47997L74.89 3.40997L74.76 3.15997L72.66 4.25997C72.56 4.34997 62.9 13.65 52.55 19.48C40.94 26.01 31.81 28.04 31.71 28.06L28.96 29.33L29.08 29.59L29.09 29.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1998 28.92L30.9198 27.66C30.9798 27.66 40.1498 25.62 51.7998 19.06C61.9898 13.33 71.5098 4.24 71.9498 3.82L73.9998 2.75L73.8698 2.5L71.7698 3.6C71.6698 3.69 62.0098 12.99 51.6598 18.82C40.0498 25.35 30.9198 27.38 30.8198 27.4L28.0698 28.67L28.1898 28.93L28.1998 28.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5199 39.48L28.2399 38.22C28.2999 38.22 37.4699 36.18 49.1299 29.62C59.3099 23.9 68.2599 15.22 68.6999 14.79L71.6499 13.3L71.5199 13.05L68.5099 14.58C68.4199 14.67 59.3399 23.56 48.9899 29.38C37.3799 35.91 28.2499 37.94 28.1499 37.96L25.3999 39.23L25.5199 39.49V39.48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1291 42.37L78.0791 44.13V47.19L78.2091 47.27L81.1291 45.42L81.2591 42.45L81.1291 42.37ZM80.9791 45.34L78.2191 46.93V44.21L80.9791 42.62V45.34Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.259 42.45L78.209 44.21V47.27L81.259 45.51V42.45ZM81.109 45.42L78.349 47.01V44.29L81.109 42.7V45.42Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0791 44.13L78.2091 44.22L81.2591 42.45L81.1291 42.37L78.0791 44.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8394 45.5L80.8594 45.52L80.9094 45.54L80.9194 45.49L81.0694 44.66V44.28L80.8394 45.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6191 45.63L80.6391 45.64L80.6891 45.67L80.6991 45.61L81.0691 43.59V43.2L80.6191 45.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4589 45.8L81.0189 42.76L80.9889 42.78L80.9389 42.81L80.3989 45.76L80.4589 45.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1792 45.89L80.2392 45.93L80.7992 42.89L80.7192 42.94L80.1792 45.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9492 46.02L80.0192 46.06L80.5792 43.02L80.4992 43.06L79.9492 46.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.729 46.14L79.799 46.18L80.359 43.14L80.279 43.19L79.729 46.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5093 46.27L79.5793 46.31L80.1393 43.27L80.0693 43.31L80.0593 43.32L79.5093 46.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2891 46.4L79.3491 46.44L79.9091 43.4L79.8291 43.45L79.2891 46.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0693 46.53L79.1293 46.57L79.6893 43.53L79.6593 43.55L79.6093 43.57L79.0693 46.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 46.66L78.9094 46.7L79.4694 43.66L79.3894 43.71L78.8394 46.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6191 46.79L78.6891 46.83L79.2491 43.78L79.1691 43.83L78.6191 46.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3989 46.91L78.4589 46.95L79.0189 43.91L78.9389 43.96L78.3989 46.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 46.09V46.48L78.7991 44.04L78.7191 44.09L78.3491 46.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 45.02V45.41L78.5791 44.17L78.5291 44.2L78.4991 44.22L78.3491 45.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 46.72V46.79L78.5991 46.82L78.6991 46.76L78.3491 46.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 46.4399V46.5099L79.0091 46.5899L79.1091 46.5299L78.3491 46.4399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 46.16V46.23L79.4191 46.35L79.5191 46.29L78.3491 46.16Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 45.87V45.95L79.8291 46.12L79.9291 46.06L78.3491 45.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 45.59V45.66L80.2391 45.88L80.3391 45.82L78.3491 45.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 45.31V45.38L80.6491 45.64L80.7391 45.58L78.3491 45.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 45.03V45.1L80.9691 45.4L80.9491 45.33L78.3491 45.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 44.74V44.81L81.0691 45.13V45.06L78.3491 44.74Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3491 44.46V44.53L81.0691 44.84V44.77L78.3491 44.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4292 44.2599L81.0692 44.56V44.49L78.5292 44.2L78.4292 44.2599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 44.02L81.0694 44.28V44.21L78.9394 43.96L78.8394 44.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.249 43.78L81.069 43.99V43.92L79.349 43.73L79.249 43.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6592 43.55L81.0692 43.71V43.64L79.7592 43.49L79.6592 43.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0693 43.31L81.0693 43.43V43.36L80.1693 43.25L80.0693 43.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4692 43.08L81.0692 43.15V43.07L80.5792 43.02L80.4692 43.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8789 42.84L81.0689 42.86V42.79L80.9889 42.78L80.8789 42.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3693 43.96L75.3193 45.72V48.78L75.4493 48.86L78.3693 47.01L78.4993 44.04L78.3693 43.96ZM78.2193 46.93L75.4593 48.52V45.8L78.2193 44.21V46.93Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4992 44.05L75.4492 45.8101V48.87L78.4992 47.1101V44.05ZM78.3492 47.0201L75.5892 48.6101V45.89L78.3492 44.3V47.0201Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3193 45.72L75.4493 45.81L78.4993 44.05L78.3693 43.96L75.3193 45.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0894 47.1001L78.1094 47.1101L78.1494 47.1401L78.1594 47.0801L78.3094 46.2601V45.8701L78.0894 47.1001Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8594 47.22L77.8794 47.24L77.9294 47.26L77.9394 47.2L78.3094 45.18V44.79L77.8594 47.22Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7092 47.39L78.2692 44.35L78.2292 44.37L78.1892 44.4L77.6392 47.35L77.7092 47.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4194 47.48L77.4794 47.52L78.0394 44.48L77.9594 44.53L77.4194 47.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1992 47.61L77.2592 47.65L77.8192 44.61L77.7392 44.65L77.1992 47.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9692 47.7401L77.0392 47.78L77.5992 44.7401L77.5192 44.78L76.9692 47.7401Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7495 47.8601L76.8195 47.9101L77.3795 44.8701L77.3095 44.9001L77.2995 44.9101L76.7495 47.8601Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5293 47.9901L76.5893 48.03L77.1593 44.9901L77.0793 45.0401L76.5293 47.9901Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3096 48.1201L76.3696 48.1601L76.9296 45.1201L76.8996 45.1401L76.8496 45.1701L76.3096 48.1201Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0894 48.2501L76.1494 48.2901L76.7094 45.2501L76.6294 45.3001L76.0894 48.2501Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8594 48.3801L75.9294 48.4201L76.4894 45.3801L76.4094 45.4201L75.8594 48.3801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6392 48.51L75.7092 48.55L76.2692 45.51L76.1892 45.55L75.6392 48.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 47.6901V48.0701L76.0394 45.6301L75.9594 45.6801L75.5894 47.6901Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 46.61V47L75.8194 45.76L75.7794 45.79H75.7694L75.7394 45.81L75.5894 46.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 48.32V48.39L75.8394 48.41L75.9494 48.36L75.5894 48.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 48.03V48.1L76.2494 48.18L76.3494 48.12L75.5894 48.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 47.75V47.82L76.6594 47.94L76.7594 47.89L75.5894 47.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 47.47V47.54L77.0694 47.71L77.1694 47.65L75.5894 47.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 47.18V47.26L77.4794 47.47L77.5794 47.41L75.5894 47.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 46.9V46.97L77.8894 47.24L77.9894 47.18L75.5894 46.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 46.62V46.69L78.2194 46.99L78.1994 46.92L75.5894 46.62Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 46.33V46.4L78.3094 46.72V46.65L75.5894 46.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5894 46.05V46.12L78.3094 46.44V46.36L75.5894 46.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6694 45.85L78.3094 46.15V46.08L75.7794 45.79H75.7694L75.6694 45.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0796 45.61L78.3096 45.87V45.8L76.1796 45.55L76.0796 45.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4893 45.38L78.3093 45.59V45.52L76.5893 45.32L76.4893 45.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8994 45.14L78.3094 45.3V45.23L76.9994 45.08L76.8994 45.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3096 44.9L78.3096 45.02V44.95L77.4096 44.85L77.3096 44.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7192 44.67L78.3092 44.74V44.67L77.8192 44.61L77.7192 44.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1191 44.43L78.3091 44.45V44.38L78.2291 44.37L78.1191 44.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6091 45.55L72.5591 47.31V50.37L72.6891 50.45L75.6091 48.6L75.7391 45.63L75.6091 45.55ZM75.4591 48.52L72.6991 50.11V47.39L75.4591 45.8V48.52Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.739 45.64L72.689 47.4V50.46L75.739 48.7V45.64ZM75.589 48.61L72.829 50.2V47.48L75.589 45.89V48.61Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5591 47.32L72.6891 47.4L75.7391 45.64L75.6091 45.55L72.5591 47.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3291 48.69L75.3491 48.7L75.3891 48.73L75.3991 48.67L75.5491 47.85V47.46L75.3291 48.69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0986 48.82L75.1286 48.83L75.1686 48.86L75.1786 48.8L75.5486 46.77V46.38L75.0986 48.82Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9489 48.99V48.98L75.5089 45.95L75.4689 45.97L75.4289 45.99L74.8789 48.94L74.9489 48.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6587 49.07L74.7187 49.11L75.2887 46.07L75.2087 46.12L74.6587 49.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.439 49.2L74.499 49.24L75.059 46.2L74.979 46.25L74.439 49.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2188 49.33L74.2787 49.37L74.8387 46.33L74.7588 46.38L74.2188 49.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9888 49.46L74.0588 49.5L74.6188 46.46L74.5488 46.5H74.5388L73.9888 49.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.769 49.59L73.839 49.63L74.399 46.59L74.319 46.63L73.769 49.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5488 49.71L73.6088 49.75L74.1788 46.71L74.1388 46.73L74.0888 46.76L73.5488 49.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3291 49.84L73.3891 49.88L73.9491 46.84L73.8691 46.89L73.3291 49.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1089 49.97L73.1689 50.01L73.7289 46.97L73.6489 47.02L73.1089 49.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8789 50.1L72.9489 50.14L73.5089 47.1L73.4289 47.15L72.8789 50.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 49.28V49.67L73.2889 47.23L73.2089 47.27L72.8389 49.28Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 48.2V48.59L73.0589 47.36L73.0189 47.38L72.9789 47.4L72.8389 48.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 49.91V49.98L73.0889 50.01L73.1889 49.95L72.8389 49.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 49.6299V49.6999L73.4989 49.7699L73.5989 49.7099L72.8389 49.6299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 49.34V49.41L73.8989 49.54L73.9989 49.48L72.8389 49.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 49.06V49.13L74.3089 49.3L74.4089 49.24L72.8389 49.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 48.78V48.85L74.7189 49.06L74.8189 49.01L72.8389 48.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 48.49V48.56L75.1289 48.83L75.2289 48.77L72.8389 48.49Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 48.21V48.28L75.4589 48.58L75.4389 48.51L72.8389 48.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 47.93V48L75.5489 48.31V48.24L72.8389 47.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 47.64V47.72L75.5489 48.03V47.96L72.8389 47.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9189 47.4399L75.549 47.7499V47.6699L73.0189 47.3799L72.9189 47.4399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3188 47.2L75.5489 47.46V47.39L73.4288 47.15L73.3188 47.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.729 46.97L75.549 47.18V47.11L73.839 46.91H73.829L73.729 46.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1387 46.73L75.5487 46.9V46.82L74.2387 46.67L74.1387 46.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5488 46.4999L75.5488 46.6099V46.5399L74.6488 46.4399L74.5488 46.4999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.959 46.2599L75.549 46.33V46.2599L75.059 46.2L74.959 46.2599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3687 46.03L75.5487 46.05V45.98L75.4687 45.97L75.3687 46.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8493 47.15L69.7993 48.91V51.97L69.9293 52.05L72.8493 50.2L72.9793 47.23L72.8493 47.15ZM72.6993 50.12L69.9393 51.71V48.99L72.6993 47.4V50.12Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9792 47.23L69.9292 48.99V52.05L72.9792 50.29V47.23ZM72.8292 50.2L70.0692 51.79V49.07L72.8292 47.48V50.2Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7993 48.91L69.9293 48.99L72.9793 47.23L72.8493 47.15L69.7993 48.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5693 50.2801L72.5893 50.2901L72.6293 50.3201L72.6393 50.2601L72.7993 49.4401V49.0601L72.5693 50.2801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3491 50.41L72.3691 50.42L72.4091 50.45L72.4191 50.39L72.7991 48.37V47.97L72.3491 50.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1891 50.58L72.7491 47.54L72.7091 47.56L72.6691 47.58L72.1191 50.54L72.1891 50.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8989 50.67L71.9689 50.7L72.5289 47.67L72.4489 47.71L71.8989 50.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6792 50.7901L71.7392 50.8301L72.2992 47.8L72.2292 47.84L71.6792 50.7901Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.459 50.92L71.519 50.96L72.079 47.92L71.999 47.97L71.459 50.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2393 51.05L71.2993 51.09L71.8593 48.05L71.7893 48.09L71.7793 48.1L71.2393 51.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0093 51.1801L71.0793 51.2201L71.6393 48.1801L71.5593 48.2201L71.0093 51.1801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7891 51.3101L70.8591 51.3501L71.4191 48.3101L71.3791 48.3301L71.3391 48.3501L70.7891 51.3101Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5693 51.4301L70.6293 51.4701L71.1893 48.4301L71.1093 48.4801L70.5693 51.4301Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3491 51.5601L70.4091 51.6001L70.9691 48.5601L70.8891 48.6101L70.3491 51.5601Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1191 51.6901L70.1891 51.7301L70.7491 48.6901L70.6691 48.7401L70.1191 51.6901Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 50.8701V51.2601L70.5291 48.8201L70.4491 48.8701L70.0791 50.8701Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 49.8V50.18L70.3091 48.95L70.2591 48.98L70.2291 48.99L70.0791 49.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 51.5V51.57L70.3291 51.6L70.4291 51.54L70.0791 51.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 51.22V51.29L70.7391 51.36L70.8391 51.31L70.0791 51.22Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 50.93V51.01L71.1491 51.13L71.2491 51.07L70.0791 50.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 50.65V50.72L71.5491 50.89L71.6491 50.83L70.0791 50.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 50.37V50.44L71.9591 50.66L72.0591 50.6L70.0791 50.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 50.09V50.16L72.3691 50.42L72.4691 50.36L70.0791 50.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 49.8V49.87L72.6991 50.18L72.6791 50.1L70.0791 49.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 49.52V49.59L72.7991 49.9V49.83L70.0791 49.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0791 49.24V49.31L72.7991 49.62V49.55L70.0791 49.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1592 49.03L72.7992 49.34V49.27L70.2592 48.98L70.1592 49.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5693 48.8L72.7993 49.06V48.98L70.6693 48.74L70.5693 48.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9692 48.56L72.7992 48.77V48.7L71.0792 48.5L70.9692 48.56Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3789 48.33L72.7989 48.49V48.42L71.4889 48.27L71.3789 48.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7891 48.09L72.7991 48.21V48.13L71.8891 48.03L71.7891 48.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1992 47.85L72.7992 47.92V47.85L72.2992 47.8L72.1992 47.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6089 47.62L72.7989 47.64V47.57L72.7089 47.56L72.6089 47.62Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9995 42.45L81.1295 45.42L84.0495 47.27L84.1795 47.19V44.13L81.1295 42.37L80.9995 42.45ZM81.2795 42.62L84.0395 44.21V46.93L81.2795 45.34V42.62Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9995 45.51L84.0495 47.27V44.21L80.9995 42.45V45.51ZM81.1495 42.71L83.9095 44.3V47.02L81.1495 45.43V42.71Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1795 44.13L84.0495 44.22L80.9995 42.45L81.1295 42.37L84.1795 44.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4095 45.5L81.3895 45.52L81.3494 45.54L81.3394 45.49L81.1895 44.66V44.28L81.4095 45.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6395 45.63L81.6195 45.64L81.5695 45.67L81.5594 45.61L81.1895 43.59V43.2L81.6395 45.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7895 45.8L81.2295 42.76L81.2695 42.78L81.3095 42.81L81.8595 45.76L81.7895 45.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0795 45.89L82.0195 45.93L81.4595 42.89L81.5395 42.94L82.0795 45.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2997 46.02L82.2397 46.06L81.6797 43.02L81.7597 43.06L82.2997 46.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5294 46.14L82.4594 46.18L81.8994 43.14L81.9794 43.19L82.5294 46.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7496 46.27L82.6796 46.31L82.1196 43.27L82.1896 43.31L82.1996 43.32L82.7496 46.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9694 46.4L82.9094 46.44L82.3394 43.4L82.4194 43.45L82.9694 46.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1893 46.53L83.1293 46.57L82.5693 43.53L82.5993 43.55L82.6493 43.57L83.1893 46.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4096 46.66L83.3495 46.7L82.7896 43.66L82.8696 43.71L83.4096 46.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6393 46.79L83.5693 46.83L83.0093 43.78L83.0893 43.83L83.6393 46.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8595 46.91L83.7895 46.95L83.2295 43.91L83.3095 43.96L83.8595 46.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9095 46.09V46.48L83.4595 44.04L83.5395 44.09L83.9095 46.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9097 45.02V45.41L83.6797 44.17L83.7197 44.2H83.7297L83.7597 44.22L83.9097 45.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9093 46.72V46.79L83.6593 46.82H83.6493L83.5493 46.76L83.9093 46.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9094 46.4399V46.5099L83.2494 46.5899L83.1494 46.5299L83.9094 46.4399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9093 46.16V46.23L82.8393 46.35L82.7393 46.29L83.9093 46.16Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9096 45.87V45.95L82.4296 46.12L82.3296 46.06L83.9096 45.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9094 45.59V45.66L82.0194 45.88L81.9194 45.82L83.9094 45.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9093 45.31V45.38L81.6093 45.64L81.5093 45.58L83.9093 45.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9093 45.03V45.1L81.2793 45.4L81.2993 45.33L83.9093 45.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9095 44.74V44.81L81.1895 45.13V45.06L83.9095 44.74Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9095 44.46V44.53L81.1895 44.84V44.77L83.9095 44.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8295 44.2599L81.1895 44.56V44.49L83.7195 44.2H83.7295L83.8295 44.2599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4194 44.02L81.1895 44.28V44.21L83.3195 43.96L83.4194 44.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0095 43.78L81.1895 43.99V43.92L82.9095 43.73L83.0095 43.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5994 43.55L81.1895 43.71V43.64L82.4995 43.49L82.5994 43.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1895 43.31L81.1895 43.43V43.36L82.0894 43.25L82.1895 43.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7794 43.08L81.1895 43.15V43.07L81.6795 43.02L81.7794 43.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3794 42.84L81.1895 42.86V42.79L81.2694 42.78L81.3794 42.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7593 44.05L83.8893 47.02L86.8093 48.87L86.9393 48.79V45.73L83.8893 43.97L83.7593 44.05ZM84.0393 44.22L86.7993 45.81V48.53L84.0393 46.94V44.22Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7593 47.1L86.8093 48.86V45.8L83.7593 44.04V47.1ZM83.9093 44.3L86.6693 45.89V48.61L83.9093 47.02V44.3Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9393 45.72L86.8093 45.81L83.7593 44.05L83.8893 43.96L86.9393 45.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1692 47.1001L84.1492 47.1101L84.1092 47.1401L84.0992 47.0801L83.9492 46.2601V45.8701L84.1692 47.1001Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3992 47.22L84.3692 47.24L84.3292 47.26L84.3192 47.2L83.9492 45.18V44.79L84.3992 47.22Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5493 47.39L83.9893 44.35L84.0293 44.37L84.0693 44.4L84.6193 47.35L84.5493 47.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.839 47.48L84.779 47.52L84.209 44.48L84.289 44.53L84.839 47.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0594 47.61L84.9995 47.65L84.4395 44.61L84.5194 44.65L85.0594 47.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2792 47.7401L85.2192 47.78L84.6592 44.7401L84.7392 44.78L85.2792 47.7401Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5094 47.8601L85.4394 47.9101L84.8794 44.8701L84.9494 44.9001L84.9594 44.9101L85.5094 47.8601Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7291 47.9901L85.6591 48.03L85.0991 44.9901L85.1791 45.0401L85.7291 47.9901Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9493 48.1201L85.8893 48.1601L85.3193 45.1201L85.3593 45.1401L85.3993 45.1701L85.9493 48.1201Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1693 48.2501L86.1093 48.2901L85.5493 45.2501L85.6293 45.3001L86.1693 48.2501Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.389 48.3801L86.329 48.4201L85.769 45.3801L85.849 45.4201L86.389 48.3801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6193 48.51L86.5493 48.55L85.9893 45.51L86.0693 45.55L86.6193 48.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.659 47.6901V48.0701L86.209 45.6301L86.289 45.6801L86.659 47.6901Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6595 46.61V47L86.4395 45.76L86.4795 45.79L86.5194 45.81L86.6595 46.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6591 48.32V48.39L86.4091 48.41L86.3091 48.36L86.6591 48.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6594 48.03V48.1L85.9994 48.18L85.8994 48.12L86.6594 48.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.659 47.75V47.82L85.599 47.94L85.499 47.89L86.659 47.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6594 47.47V47.54L85.1894 47.71L85.0894 47.65L86.6594 47.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6592 47.18V47.26L84.7792 47.47L84.6792 47.41L86.6592 47.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.659 46.9V46.97L84.369 47.24L84.269 47.18L86.659 46.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6591 46.62V46.69L84.0391 46.99L84.0591 46.92L86.6591 46.62Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6592 46.33V46.4L83.9492 46.72V46.65L86.6592 46.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6592 46.05V46.12L83.9492 46.44V46.36L86.6592 46.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5792 45.85L83.9492 46.15V46.08L86.4792 45.79L86.5792 45.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1792 45.61L83.9492 45.87V45.8L86.0692 45.55L86.1792 45.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7692 45.38L83.9492 45.59V45.52L85.6592 45.32H85.6692L85.7692 45.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3592 45.14L83.9492 45.3V45.23L85.2592 45.08L85.3592 45.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9492 44.9L83.9492 45.02V44.95L84.8492 44.85L84.9492 44.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5392 44.67L83.9492 44.74V44.67L84.4392 44.61L84.5392 44.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1292 44.43L83.9492 44.45V44.38L84.0292 44.37L84.1292 44.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5195 45.64L86.6495 48.61L89.5695 50.46L89.6995 50.38V47.32L86.6495 45.56L86.5195 45.64ZM86.7995 45.81L89.5595 47.4V50.12L86.7995 48.53V45.81Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5195 48.7L89.5695 50.46V47.4L86.5195 45.64V48.7ZM86.6695 45.9L89.4295 47.49V50.21L86.6695 48.62V45.9Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6995 47.32L89.5695 47.4L86.5195 45.64L86.6495 45.55L89.6995 47.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9297 48.69L86.9097 48.7L86.8697 48.73L86.8597 48.67L86.6997 47.85V47.46L86.9297 48.69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1497 48.82L87.1297 48.83L87.0897 48.86L87.0797 48.8L86.6997 46.77V46.38L87.1497 48.82Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3095 48.99V48.98L86.7495 45.95L86.7895 45.97L86.8295 45.99L87.3795 48.94L87.3095 48.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5997 49.07L87.5297 49.11L86.9697 46.07L87.0497 46.12L87.5997 49.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8197 49.2L87.7597 49.24L87.1997 46.2L87.2697 46.25L87.8197 49.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0399 49.33L87.9799 49.37L87.4199 46.33L87.4999 46.38L88.0399 49.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2597 49.46L88.1996 49.5L87.6396 46.46L87.7096 46.5H87.7197L88.2597 49.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4899 49.59L88.4199 49.63L87.8599 46.59L87.9399 46.63L88.4899 49.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7096 49.71L88.6396 49.75L88.0796 46.71L88.1196 46.73L88.1596 46.76L88.7096 49.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9298 49.84L88.8698 49.88L88.2998 46.84L88.3898 46.89L88.9298 49.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1498 49.97L89.0898 50.01L88.5298 46.97L88.6098 47.02L89.1498 49.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3695 50.1L89.3095 50.14L88.7495 47.1L88.8295 47.15L89.3695 50.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4197 49.28V49.67L88.9697 47.23L89.0497 47.27L89.4197 49.28Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4199 48.2V48.59L89.1899 47.36L89.2399 47.38L89.2699 47.4L89.4199 48.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4198 49.91V49.98L89.1698 50.01L89.0698 49.95L89.4198 49.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4197 49.6299V49.6999L88.7597 49.7699L88.6597 49.7099L89.4197 49.6299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4195 49.34V49.41L88.3495 49.54L88.2495 49.48L89.4195 49.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4198 49.06V49.13L87.9498 49.3L87.8398 49.24L89.4198 49.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4199 48.78V48.85L87.5399 49.06L87.4399 49.01L89.4199 48.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4198 48.49V48.56L87.1298 48.83L87.0298 48.77L89.4198 48.49Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4198 48.21V48.28L86.7998 48.58L86.8198 48.51L89.4198 48.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4197 47.93V48L86.6997 48.31V48.24L89.4197 47.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4197 47.64V47.72L86.6997 48.03V47.96L89.4197 47.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3397 47.4399L86.6997 47.7499V47.6699L89.2397 47.3799L89.3397 47.4399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9297 47.2L86.6997 47.46V47.39L88.8297 47.15L88.9297 47.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5297 46.97L86.6997 47.18V47.11L88.4197 46.91L88.5297 46.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1197 46.73L86.6997 46.9V46.82L88.0097 46.67L88.1197 46.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7097 46.4999L86.6997 46.6099V46.5399L87.6097 46.4399L87.7097 46.4999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2997 46.2599L86.6997 46.33V46.2599L87.1997 46.2L87.2997 46.2599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8897 46.03L86.6997 46.05V45.98L86.7897 45.97L86.8897 46.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2695 47.23L89.3995 50.2L92.3195 52.05L92.4495 51.97V48.91L89.3995 47.15L89.2695 47.23ZM89.5495 47.4L92.3095 48.99V51.71L89.5495 50.12V47.4Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2695 50.29L92.3195 52.05V48.99L89.2695 47.23V50.29ZM89.4195 47.49L92.1795 49.08V51.8L89.4195 50.21V47.49Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4595 48.91L92.3295 48.99L89.2695 47.23L89.3995 47.15L92.4595 48.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6895 50.2801L89.6695 50.2901L89.6195 50.3201L89.6095 50.2601L89.4595 49.4401V49.0601L89.6895 50.2801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9095 50.41L89.8895 50.42L89.8495 50.45L89.8395 50.39L89.4595 48.37V47.97L89.9095 50.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0693 50.58L89.5093 47.54L89.5493 47.56L89.5893 47.58L90.1293 50.54L90.0693 50.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3595 50.67L90.2895 50.7L89.7295 47.67L89.8095 47.71L90.3595 50.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5797 50.7901L90.5097 50.8301L89.9497 47.8L90.0297 47.84L90.5797 50.7901Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7994 50.92L90.7394 50.96L90.1694 47.92L90.2594 47.97L90.7994 50.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0194 51.05L90.9594 51.09L90.3994 48.05L90.4694 48.09L90.4794 48.1L91.0194 51.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2396 51.1801L91.1796 51.2201L90.6196 48.1801L90.6996 48.2201L91.2396 51.1801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4694 51.3101L91.3994 51.3501L90.8394 48.3101L90.8794 48.3301L90.9194 48.3501L91.4694 51.3101Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6896 51.4301L91.6196 51.4701L91.0596 48.4301L91.1396 48.4801L91.6896 51.4301Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9093 51.5601L91.8493 51.6001L91.2793 48.5601L91.3693 48.6101L91.9093 51.5601Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1293 51.6901L92.0693 51.7301L91.5093 48.6901L91.5893 48.7401L92.1293 51.6901Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1795 50.8701V51.2601L91.7295 48.8201L91.8095 48.8701L92.1795 50.8701Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1797 49.8V50.18L91.9497 48.95L91.9997 48.98L92.0297 48.99L92.1797 49.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1796 51.5V51.57L91.9296 51.6L91.8296 51.54L92.1796 51.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1794 51.22V51.29L91.5194 51.36L91.4194 51.31L92.1794 51.22Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1793 50.93V51.01L91.1093 51.13L91.0093 51.07L92.1793 50.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1796 50.65V50.72L90.7096 50.89L90.5996 50.83L92.1796 50.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1795 50.37V50.44L90.2995 50.66L90.1895 50.6L92.1795 50.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1796 50.09V50.16L89.8895 50.42L89.7896 50.36L92.1796 50.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1796 49.8V49.87L89.5596 50.18L89.5796 50.1L92.1796 49.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1795 49.52V49.59L89.4595 49.9V49.83L92.1795 49.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1795 49.24V49.31L89.4595 49.62V49.55L92.1795 49.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0995 49.03L89.4595 49.34V49.27L91.9995 48.98L92.0995 49.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6895 48.8L89.4595 49.06V48.98L91.5895 48.74L91.6895 48.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2795 48.56L89.4595 48.77V48.7L91.1795 48.5L91.2795 48.56Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8795 48.33L89.4595 48.49V48.42L90.7695 48.27L90.8795 48.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4695 48.09L89.4595 48.21V48.13L90.3595 48.03L90.4695 48.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0595 47.85L89.4595 47.92V47.85L89.9495 47.8L90.0595 47.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6495 47.62L89.4595 47.64V47.57L89.5495 47.56L89.6495 47.62Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7994 15.61L70.2394 15.35V13.97L69.7894 14.22L69.3594 15.35L69.7994 15.61Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7994 15.61L69.3594 15.35V13.97L69.7894 14.22L69.7994 15.61Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2394 13.97L69.7994 13.71L69.3594 13.97L69.7894 14.22L70.2394 13.97Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4398 14.82L68.8797 14.56V13.18L68.4297 13.43L67.9897 14.56L68.4398 14.82Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4398 14.82L67.9897 14.56V13.18L68.4297 13.43L68.4398 14.82Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8797 13.18L68.4398 12.92L67.9897 13.18L68.4297 13.43L68.8797 13.18Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5594 14.44L72.9994 14.18V12.79L72.5494 13.04L72.1094 14.18L72.5594 14.44Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5594 14.44L72.1094 14.18V12.79L72.5494 13.04L72.5594 14.44Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9994 12.79L72.5594 12.54L72.1094 12.79L72.5494 13.04L72.9994 12.79Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1895 13.65L71.6295 13.39V12L71.1895 12.26L70.7495 13.39L71.1895 13.65Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1895 13.65L70.7495 13.39V12L71.1895 12.26V13.65Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6295 12L71.1895 11.75L70.7495 12L71.1895 12.26L71.6295 12Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8893 4.59999L73.1993 4.41999V3.42999L72.8793 3.60999L72.5693 4.41999L72.8893 4.59999Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8893 4.59999L72.5693 4.41999V3.42999L72.8793 3.60999L72.8893 4.59999Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1993 3.43L72.8893 3.25L72.5693 3.43L72.8793 3.61L73.1993 3.43Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9196 4.04L72.2296 3.86V2.87L71.9096 3.05L71.5996 3.86L71.9196 4.04Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9196 4.04L71.5996 3.86V2.87L71.9096 3.05L71.9196 4.04Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2296 2.87L71.9196 2.69L71.5996 2.87L71.9096 3.05L72.2296 2.87Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8498 3.75998L75.1598 3.57998V2.59998L74.8398 2.76998L74.5298 3.57998L74.8498 3.75998Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8498 3.75998L74.5298 3.57998V2.59998L74.8398 2.76998L74.8498 3.75998Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1598 2.59997L74.8498 2.40997L74.5298 2.59997L74.8398 2.76997L75.1598 2.59997Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8796 3.19997L74.1896 3.01997V2.02997L73.8696 2.20997L73.5596 3.01997L73.8796 3.19997Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8796 3.19997L73.5596 3.01997V2.02997L73.8696 2.20997L73.8796 3.19997Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1896 2.02998L73.8796 1.84998L73.5596 2.02998L73.8696 2.20998L74.1896 2.02998Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8594 54.31L75.5894 51.22V50.42L86.7594 50.1V50.9L80.8594 54.31Z",
    fill: "#6C7178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8594 53.51L75.5894 50.42L81.3994 47.06L86.7594 50.1L80.8594 53.51Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9995 49.35L80.4995 49.07V17.32L80.9995 17.6L81.4895 49.07L80.9995 49.35Z",
    fill: "#95A2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9995 49.35L81.4895 49.07V17.32L80.9995 17.6V49.35Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4995 17.32L80.9995 17.03L81.4895 17.32L80.9995 17.6L80.4995 17.32Z",
    fill: "#8491B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1196 18.68L78.6096 18.4L78.7996 18.51L78.3096 18.79L78.1196 18.68Z",
    fill: "#8491B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9394 27L80.6894 26.85L78.3594 28.19L78.6194 28.63L80.9394 27.29V27Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9398 27V27.29L78.6198 28.63L78.4897 28.41L80.9398 27Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9394 31.55L80.6894 31.4L78.3594 32.74L78.6194 33.18L80.9394 31.84V31.55Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 28.4L78.6895 28.35L80.4995 31.49L80.7195 31.68L79.1294 28.4H78.8394Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 28.4L78.9994 28.18L80.9394 31.55L80.7194 31.68L78.8394 28.4Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5994 37.43L78.3794 37.3L79.4994 34.42L80.5594 31.75L80.7594 31.85L79.5994 34.9C79.5994 34.9 79.5994 34.88 79.5894 34.87L78.5994 37.41V37.43Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9394 36.1L80.6894 35.95L78.3594 37.29L78.6194 37.73L80.9394 36.39V36.1Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9393 31.84L80.6193 32.03L78.5693 37.24L78.7893 37.37L80.9393 31.84Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9398 31.55V31.84L78.6198 33.18L78.4897 32.96L80.9398 31.55Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9394 40.65L80.6894 40.5L78.3594 41.84L78.6194 42.28L80.9394 40.94V40.65Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5994 46.53L78.3794 46.4L79.4994 43.52L80.5594 40.85L80.7594 40.95L79.5994 44C79.5994 44 79.5994 43.98 79.5894 43.97L78.5994 46.51V46.53Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9394 45.2L80.6894 45.05L78.3594 46.39L78.6194 46.84L80.9394 45.5V45.2Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7794 48.78L80.5194 48.64L78.1694 49.99L78.5894 50.34L80.7794 49.08V48.78Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9395 48.69V48.98L78.5895 50.34L78.4595 50.12L80.9395 48.69Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 46.6L78.6895 46.55L80.4995 48.63L80.7195 48.82L79.0994 46.6H78.8394Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 46.6L78.9994 46.38L80.9394 48.69L80.7194 48.82L78.8394 46.6Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9398 45.2V45.5L78.6198 46.84L78.4897 46.61L80.9398 45.2Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9393 40.94L80.6193 41.13L78.5693 46.34L78.7893 46.47L80.9393 40.94Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9398 40.65V40.94L78.6198 42.28L78.4897 42.06L80.9398 40.65Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 37.5L78.6895 37.45L80.4995 40.6L80.7195 40.78L79.0994 37.5H78.8394Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9398 36.1V36.39L78.6198 37.73L78.4897 37.51L80.9398 36.1Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 37.5L78.9994 37.28L80.9394 40.65L80.7194 40.78L78.8394 37.5Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9394 17.91L80.6894 17.76L78.3594 19.1L78.6194 19.55L80.9394 18.21V17.91Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5994 23.79L78.3794 23.66L79.4994 20.78L80.5594 18.11L80.7594 18.21L79.5994 21.26C79.5994 21.26 79.5994 21.24 79.5894 21.23L78.5994 23.77V23.79Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9394 22.46L80.6894 22.31L78.3594 23.65L78.6194 24.1L80.9394 22.76V22.46Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9393 18.21L80.6193 18.39L78.5693 23.6L78.7893 23.73L80.9393 18.21Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9398 17.91V18.21L78.6198 19.55L78.4897 19.32L80.9398 17.91Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 23.86L78.6895 23.81L80.4995 26.96L80.7195 27.14L79.0994 23.86H78.8394Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9398 22.46V22.76L78.6198 24.1L78.4897 23.87L80.9398 22.46Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8394 23.86L78.9994 23.64L80.9394 27.01L80.7194 27.14L78.8394 23.86Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9394 17.61L80.6894 17.46L78.3594 18.8L78.6194 19.24L80.9394 17.9V17.61Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9398 17.61V17.9L78.6198 19.24L78.4897 19.02L80.9398 17.61Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2896 50.69L78.0996 50.59L78.1196 18.68L78.3096 18.79L78.7896 50.41L78.2896 50.69Z",
    fill: "#929FBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2896 50.69L78.7896 50.41L78.7996 18.5L78.3095 18.79L78.2896 50.69Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3193 49.48L81.8093 49.19V17.44L81.3093 17.72L80.8193 49.19L81.3193 49.48Z",
    fill: "#99A6C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3193 49.48L80.8193 49.19V17.44L81.3093 17.72L81.3193 49.48Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8093 17.44L81.3193 17.16L80.8193 17.44L81.3093 17.72L81.8093 17.44Z",
    fill: "#7E8BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1895 18.81L83.6995 18.52L83.5195 18.64L83.9995 18.92L84.1895 18.81Z",
    fill: "#7E8BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 27.12L81.6296 26.98L83.9496 28.32L83.6896 28.76L81.3696 27.42V27.12Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 27.12V27.42L83.6896 28.76L83.8196 28.54L81.3696 27.12Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 31.68L81.6296 31.53L83.9496 32.87L83.6896 33.31L81.3696 31.97V31.68Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4694 28.53L83.6194 28.47L81.8094 31.62L81.5894 31.8L83.1794 28.53H83.4694Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4696 28.53L83.3096 28.31L81.3696 31.68L81.5896 31.8L83.4696 28.53Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7093 37.55L83.9293 37.42L82.8093 34.54L81.7493 31.87L81.5493 31.97L82.7093 35.02C82.7093 35.02 82.7093 35 82.7193 34.99L83.7093 37.53V37.55Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 36.23L81.6296 36.08L83.9496 37.42L83.6896 37.86L81.3696 36.52V36.23Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 31.97L81.6896 32.15L83.7396 37.37L83.5196 37.5L81.3696 31.97Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 31.68V31.97L83.6896 33.31L83.8196 33.09L81.3696 31.68Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 40.78L81.6296 40.63L83.9496 41.97L83.6896 42.41L81.3696 41.07V40.78Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7093 46.66L83.9293 46.53L82.8093 43.65L81.7493 40.98L81.5493 41.08L82.7093 44.13C82.7093 44.13 82.7093 44.11 82.7193 44.1L83.7093 46.64V46.66Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 45.33L81.6296 45.18L83.9496 46.52L83.6896 46.96L81.3696 45.62V45.33Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5298 48.91L81.7898 48.76L83.8198 49.93L83.7198 50.46L81.5298 49.2V48.91Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 48.81V49.11L83.7196 50.46L83.8496 50.24L81.3696 48.81Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4694 46.73L83.6194 46.67L81.8094 48.76L81.5894 48.94L83.2194 46.73H83.4694Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4696 46.73L83.3096 46.51L81.3696 48.81L81.5896 48.94L83.4696 46.73Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 45.33V45.62L83.6896 46.96L83.8196 46.74L81.3696 45.33Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 41.07L81.6896 41.25L83.7396 46.47L83.5196 46.6L81.3696 41.07Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 40.78V41.07L83.6896 42.41L83.8196 42.19L81.3696 40.78Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4694 37.63L83.6194 37.57L81.8094 40.72L81.5894 40.9L83.2194 37.63H83.4694Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 36.23V36.52L83.6896 37.86L83.8196 37.64L81.3696 36.23Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4696 37.63L83.3096 37.41L81.3696 40.78L81.5896 40.9L83.4696 37.63Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 18.04L81.6296 17.89L83.9496 19.23L83.6896 19.67L81.3696 18.33V18.04Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7093 23.92L83.9293 23.79L82.8093 20.91L81.7493 18.24L81.5493 18.34L82.7093 21.39C82.7093 21.39 82.7093 21.37 82.7193 21.36L83.7093 23.9V23.92Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 22.59L81.6296 22.44L83.9496 23.78L83.6896 24.22L81.3696 22.88V22.59Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 18.33L81.6896 18.51L83.7396 23.73L83.5196 23.86L81.3696 18.33Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 18.04V18.33L83.6896 19.67L83.8196 19.45L81.3696 18.04Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4694 23.99L83.6194 23.94L81.8094 27.08L81.5894 27.27L83.2194 23.99H83.4694Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 22.59V22.88L83.6896 24.22L83.8196 24L81.3696 22.59Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4696 23.99L83.3096 23.77L81.3696 27.14L81.5896 27.27L83.4696 23.99Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 17.74L81.6296 17.59L83.9496 18.93L83.6896 19.37L81.3696 18.03V17.74Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 17.74V18.03L83.6896 19.37L83.8196 19.15L81.3696 17.74Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9898 50.82L83.5298 50.53L83.5098 18.63L83.9998 18.92L83.9898 50.82Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7495 51L83.2495 50.71V18.96L83.7495 19.24L84.2395 50.71L83.7495 51Z",
    fill: "#C7D3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7495 51L84.2395 50.71V18.96L83.7495 19.24V51Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2495 18.96L83.7495 18.68L84.2395 18.96L83.7495 19.24L83.2495 18.96Z",
    fill: "#B4C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8696 20.33L81.3596 20.04L81.5496 20.16L81.0596 20.44L80.8696 20.33Z",
    fill: "#B4C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6894 28.64L83.4394 28.5L81.1094 29.84L81.3694 30.28L83.6894 28.94V28.64Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6898 28.64V28.94L81.3698 30.28L81.2397 30.06L83.6898 28.64Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6894 33.19L83.4394 33.05L81.1094 34.39L81.3694 34.83L83.6894 33.49V33.19Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5894 30.05L81.4395 29.99L83.2495 33.14L83.4695 33.32L81.8794 30.05H81.5894Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5894 30.05L81.7494 29.83L83.6894 33.19L83.4694 33.32L81.5894 30.05Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3494 39.07L81.1294 38.94L82.2494 36.06L83.3094 33.39L83.5094 33.49L82.3494 36.54C82.3494 36.54 82.3494 36.52 82.3394 36.51L81.3494 39.05V39.07Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6894 37.74L83.4394 37.6L81.1094 38.94L81.3694 39.38L83.6894 38.04V37.74Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6893 33.49L83.3693 33.67L81.3193 38.89L81.5393 39.01L83.6893 33.49Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6898 33.19V33.49L81.3698 34.83L81.2397 34.61L83.6898 33.19Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6894 42.29L83.4394 42.15L81.1094 43.49L81.3694 43.93L83.6894 42.59V42.29Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3494 48.17L81.1294 48.04L82.2494 45.16L83.3094 42.49L83.5094 42.59L82.3494 45.64C82.3494 45.64 82.3494 45.62 82.3394 45.61L81.3494 48.15V48.17Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6894 46.85L83.4394 46.7L81.1094 48.04L81.3694 48.48L83.6894 47.14V46.85Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5294 50.43L83.2694 50.28L80.9194 51.63L81.3394 51.98L83.5294 50.72V50.43Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6895 50.33V50.63L81.3395 51.98L81.2095 51.76L83.6895 50.33Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5894 48.25L81.4395 48.19L83.2495 50.28L83.4695 50.46L81.8494 48.25H81.5894Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5894 48.25L81.7494 48.03L83.6894 50.33L83.4694 50.46L81.5894 48.25Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6898 46.85V47.14L81.3698 48.48L81.2397 48.26L83.6898 46.85Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6893 42.59L83.3693 42.77L81.3193 47.99L81.5393 48.11L83.6893 42.59Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6898 42.29V42.59L81.3698 43.93L81.2397 43.71L83.6898 42.29Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5894 39.15L81.4395 39.09L83.2495 42.24L83.4695 42.42L81.8494 39.15H81.5894Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6898 37.74V38.04L81.3698 39.38L81.2397 39.16L83.6898 37.74Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5894 39.15L81.7494 38.93L83.6894 42.29L83.4694 42.42L81.5894 39.15Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6894 19.56L83.4394 19.41L81.1094 20.75L81.3694 21.19L83.6894 19.85V19.56Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3494 25.43L81.1294 25.3L82.2494 22.42L83.3094 19.75L83.5094 19.85L82.3494 22.9C82.3494 22.9 82.3494 22.88 82.3394 22.87L81.3494 25.41V25.43Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6894 24.11L83.4394 23.96L81.1094 25.3L81.3694 25.74L83.6894 24.4V24.11Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6893 19.85L83.3693 20.03L81.3193 25.25L81.5393 25.37L83.6893 19.85Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6898 19.56V19.85L81.3698 21.19L81.2397 20.97L83.6898 19.56Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5894 25.51L81.4395 25.45L83.2495 28.6L83.4695 28.78L81.8494 25.51H81.5894Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6898 24.11V24.4L81.3698 25.74L81.2397 25.52L83.6898 24.11Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5894 25.51L81.7494 25.29L83.6894 28.66L83.4694 28.78L81.5894 25.51Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6894 19.25L83.4394 19.11L81.1094 20.45L81.3694 20.89L83.6894 19.55V19.25Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6898 19.25V19.55L81.3698 20.89L81.2397 20.67L83.6898 19.25Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0396 52.34L80.8496 52.23L80.8696 20.33L81.0596 20.44L81.5396 52.05L81.0396 52.34Z",
    fill: "#C3D0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0396 52.34L81.5396 52.05L81.5496 20.15L81.0595 20.44L81.0396 52.34Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3694 51L78.8594 50.71L78.8694 18.96L78.3694 19.24L77.8794 50.71L78.3694 51Z",
    fill: "#CAD6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3694 51L77.8794 50.71V18.96L78.3694 19.24V51Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8694 18.96L78.3694 18.68L77.8794 18.96L78.3694 19.24L78.8694 18.96Z",
    fill: "#B0BDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2493 20.33L80.7493 20.04L80.5693 20.16L81.0593 20.44L81.2493 20.33Z",
    fill: "#B0BDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 28.64L78.6797 28.5L80.9997 29.84L80.7497 30.28L78.4297 28.94V28.64Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 28.64V28.94L80.7497 30.28L80.8797 30.06L78.4297 28.64Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 33.19L78.6797 33.05L80.9997 34.39L80.7497 34.83L78.4297 33.49V33.19Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5294 30.05L80.6794 29.99L78.8694 33.14L78.6494 33.32L80.2294 30.05H80.5294Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5297 30.05L80.3697 29.83L78.4297 33.19L78.6497 33.32L80.5297 30.05Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7694 39.07L80.9894 38.94L79.8694 36.06L78.8094 33.39L78.6094 33.49L79.7694 36.54C79.7694 36.54 79.7694 36.52 79.7794 36.51L80.7694 39.05V39.07Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 37.74L78.6797 37.6L80.9997 38.94L80.7497 39.38L78.4297 38.04V37.74Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 33.49L78.7397 33.67L80.7897 38.89L80.5697 39.01L78.4297 33.49Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 33.19V33.49L80.7497 34.83L80.8797 34.61L78.4297 33.19Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 42.29L78.6797 42.15L80.9997 43.49L80.7497 43.93L78.4297 42.59V42.29Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7694 48.17L80.9894 48.04L79.8694 45.16L78.8094 42.49L78.6094 42.59L79.7694 45.64C79.7694 45.64 79.7694 45.62 79.7794 45.61L80.7694 48.15V48.17Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 46.85L78.6797 46.7L80.9997 48.04L80.7497 48.48L78.4297 47.14V46.85Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5894 50.43L78.8394 50.28L80.8794 51.45L80.7794 51.98L78.5894 50.72V50.43Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 50.33V50.63L80.7797 51.98L80.9097 51.76L78.4297 50.33Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5294 48.25L80.6794 48.19L78.8694 50.28L78.6494 50.46L80.2694 48.25H80.5294Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5297 48.25L80.3697 48.03L78.4297 50.33L78.6497 50.46L80.5297 48.25Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 46.85V47.14L80.7497 48.48L80.8797 48.26L78.4297 46.85Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 42.59L78.7397 42.77L80.7897 47.99L80.5697 48.11L78.4297 42.59Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 42.29V42.59L80.7497 43.93L80.8797 43.71L78.4297 42.29Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5294 39.15L80.6794 39.09L78.8694 42.24L78.6494 42.42L80.2694 39.15H80.5294Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 37.74V38.04L80.7497 39.38L80.8797 39.16L78.4297 37.74Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5297 39.15L80.3697 38.93L78.4297 42.29L78.6497 42.42L80.5297 39.15Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 19.56L78.6797 19.41L80.9997 20.75L80.7497 21.19L78.4297 19.85V19.56Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7694 25.43L80.9894 25.3L79.8694 22.42L78.8094 19.75L78.6094 19.85L79.7694 22.9C79.7694 22.9 79.7694 22.88 79.7794 22.87L80.7694 25.41V25.43Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 24.11L78.6797 23.96L80.9997 25.3L80.7497 25.74L78.4297 24.4V24.11Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 19.85L78.7397 20.03L80.7897 25.25L80.5697 25.37L78.4297 19.85Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 19.56V19.85L80.7497 21.19L80.8797 20.97L78.4297 19.56Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5294 25.51L80.6794 25.45L78.8694 28.6L78.6494 28.78L80.2694 25.51H80.5294Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 24.11V24.4L80.7497 25.74L80.8797 25.52L78.4297 24.11Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5297 25.51L80.3697 25.29L78.4297 28.66L78.6497 28.78L80.5297 25.51Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 19.25L78.6797 19.11L80.9997 20.45L80.7497 20.89L78.4297 19.55V19.25Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4297 19.25V19.55L80.7497 20.89L80.8797 20.67L78.4297 19.25Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0393 52.34L80.5793 52.05L80.5693 20.15L81.0593 20.44L81.0393 52.34Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2594 51.76L48.9794 50.5C49.0394 50.5 58.2094 48.46 69.8594 41.9C80.0394 36.18 88.9894 27.5 89.4294 27.07L92.3794 25.58L92.2494 25.33L89.2394 26.86C89.1494 26.95 80.0694 35.84 69.7194 41.66C58.1094 48.19 48.9794 50.22 48.8794 50.24L46.1294 51.51L46.2494 51.77L46.2594 51.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3697 51.1L48.0897 49.84C48.1497 49.84 57.3197 47.8 68.9697 41.24C79.1497 35.52 88.0997 26.84 88.5397 26.41L91.4897 24.92L91.3597 24.67L88.3497 26.2C88.2597 26.29 79.1797 35.18 68.8297 41C57.2197 47.53 48.0897 49.56 47.9897 49.58L45.2397 50.85L45.3597 51.11L45.3697 51.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7996 27.21L90.2396 26.96V25.57L89.7896 25.82L89.3496 26.96L89.7996 27.21Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7996 27.21L89.3496 26.96V25.57L89.7896 25.82L89.7996 27.21Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4297 26.42L88.8698 26.17V24.78L88.4297 25.03L87.9897 26.17L88.4297 26.42Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4297 26.42L87.9897 26.17V24.78L88.4297 25.03V26.42Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5494 26.04L92.9894 25.78V24.4L92.5394 24.65L92.1094 25.78L92.5494 26.04Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5494 26.04L92.1094 25.78V24.4L92.5394 24.65L92.5494 26.04Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1898 25.25L91.6297 24.99V23.61L91.1797 23.86L90.7397 24.99L91.1898 25.25Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1898 25.25L90.7397 24.99V23.61L91.1797 23.86L91.1898 25.25Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9097 11.1L70.5197 10.75L93.4697 24L92.8697 24.36L69.9797 11.85L69.9097 11.1Z",
    fill: "#E6FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9097 11.1V11.8L92.8697 25.04V24.36L69.9097 11.1Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4696 24V24.7L92.8696 25.04V24.36L93.4696 24Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 24.28L93.1898 24.1L90.9697 19.2L90.7397 19.34L92.5597 24.1L92.8797 24.28Z",
    fill: "#EDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.09 21.51L88.4 21.33V18.06H87.78L87.77 21.33L88.09 21.51Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.09 21.51L87.77 21.33L87.78 18.06H88.09V21.51Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1099 18.2299L88.3799 18.0699L90.7399 21.0099L92.2299 22.8999L92.6699 23.9099L90.1499 20.8199C90.1499 20.8199 90.1699 20.8199 90.1899 20.8199L88.1099 18.2299V18.2299Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5798 24.11V23.66L88.3198 18.31L88.0498 18.47L92.5798 24.11Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6098 21.24L87.9198 21.06V17.79H87.2998V21.06L87.6098 21.24Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7998 18.47L83.1097 18.29V15.02H82.4897V18.29L82.7998 18.47Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.02 12.41L78.29 12.25L80.65 15.19L82.82 17.94L82.59 18.09L80.07 15C80.07 15 80.09 15 80.11 15L78.03 12.41H78.02Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9897 15.69L78.2997 15.51V12.24H77.6797V15.51L77.9897 15.69Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1796 12.68L73.4896 12.51V9.88995L72.8696 10.13V12.51L73.1796 12.68Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4597 10.6499C71.5697 10.6499 71.6797 10.6299 71.7597 10.5699L73.1897 12.3899L72.9597 12.5399L71.4497 10.6799C71.4497 10.6799 71.4497 10.6599 71.4497 10.6499H71.4597Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4598 10.65C71.4598 10.65 71.5298 10.65 71.5598 10.65L72.8698 12.29V12.74L71.3198 10.81C71.3898 10.78 71.4398 10.72 71.4598 10.65Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1796 12.9199L72.8696 12.7399V10.1299H73.1796V12.9199Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4899 11.37L70.1099 11.14L73.7999 9.53998V10.24L70.4899 11.37Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7897 12.61L77.9397 12.49L73.5097 12.48L73.1797 12.6L77.6297 12.89L77.7897 12.61Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7897 12.61L77.9297 12.91L73.1797 12.92V12.6L77.7897 12.61Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9897 15.69L77.6797 15.51V12.24H77.9897V15.69Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49 18.29V17.84L78.23 12.49L77.96 12.65L82.49 18.29Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7998 18.47L82.4897 18.29V15.02H82.7998V18.47Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4098 18.17L87.5598 18.04L83.1298 18.03L82.7998 18.16L87.2498 18.44L87.4098 18.17Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6098 21.24L87.2998 21.06V17.79H87.6098V21.24Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4098 18.17L87.5398 18.47H82.7998V18.16L87.4098 18.17Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 24.28L92.5597 24.1L90.7397 20.03V19.34L92.8797 24.28Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 9.53997L74.0298 9.40997L90.9698 19.2L90.7398 19.34L73.7998 10.24V9.53997Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 9.53998V10.24L90.7398 20.03V19.34L73.7998 9.53998Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0299 9.40997L73.7999 9.53997L70.1099 11.14L70.4999 10.93L74.0299 9.40997Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5298 21.2L90.7398 19.89V19.48L88.5298 20.78V21.2Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5297 20.78L90.7397 19.48L90.4397 19.3L88.2197 20.6L88.5297 20.78Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7798 19.02L86.9998 17.71V17.3L84.7798 18.6V19.02Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7797 18.6L86.9997 17.3L86.6897 17.12L84.4697 18.42L84.7797 18.6Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1997 17.5199L84.4197 16.2199V15.7999L82.1997 17.1099V17.5199Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1996 17.1099L84.4196 15.7999L84.1096 15.6299L81.8896 16.9299L82.1996 17.1099Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6196 16.0299L81.8396 14.7299V14.3099L79.6196 15.6199V16.0299Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6196 15.6199L81.8396 14.3099L81.5296 14.1299L79.3096 15.4399L79.6196 15.6199Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0498 14.5399L79.2598 13.2299V12.8199L77.0498 14.1199V14.5399Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0498 14.12L79.2598 12.82L78.9497 12.64L76.7397 13.95L77.0498 14.12Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4697 13.0499L76.6897 11.7399V11.3199L74.4697 12.6299V13.0499Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4697 12.63L76.6897 11.32L76.3797 11.15L74.1597 12.45L74.4697 12.63Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8896 11.55L74.1096 10.25V9.82996L71.8896 11.14V11.55Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8896 11.14L74.1096 9.82996L73.7996 9.64996L71.5796 10.96L71.8896 11.14Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5396 12.4699L68.1395 12.1299L91.0895 25.3699L90.4895 25.7299L67.5396 13.1699V12.4699Z",
    fill: "#E6FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5396 12.47V13.17L90.4895 26.42V25.73L67.5396 12.47Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0897 25.3699V26.0699L90.4897 26.4199V25.7299L91.0897 25.3699Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4994 25.6499L90.8094 25.4699L88.5994 20.5699L88.3594 20.7099L90.1894 25.4699L90.4994 25.6499Z",
    fill: "#EDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7094 22.88L86.0194 22.7V19.43H85.3994V22.7L85.7094 22.88Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7094 22.88L85.3994 22.7V19.43H85.7094V22.88Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7295 19.5999L85.9995 19.4399L88.3595 22.3799L89.8495 24.2699L90.2895 25.2799L87.7695 22.1899C87.7695 22.1899 87.7895 22.1899 87.8095 22.1899L85.7295 19.5999V19.5999Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2097 25.48V25.03L85.9497 19.68L85.6797 19.84L90.2097 25.48Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2294 22.62L85.5394 22.44L85.5494 19.16H84.9194V22.44L85.2294 22.62Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4194 19.84L80.7394 19.66V16.39H80.1094V19.66L80.4194 19.84Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6396 13.78L75.9097 13.62L78.2696 16.56L80.4397 19.31L80.2096 19.46L77.6897 16.37C77.6897 16.37 77.7097 16.37 77.7297 16.37L75.6497 13.78H75.6396Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6193 17.06L75.9293 16.88V13.61H75.3093L75.2993 16.88L75.6193 17.06Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8095 14.06L71.1195 13.88V11.27L70.4995 11.5V13.88L70.8095 14.06Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0793 12.0199C69.1893 12.0199 69.2993 11.9999 69.3793 11.9399L70.8093 13.7599L70.5793 13.9099L69.0693 12.0499C69.0693 12.0499 69.0693 12.0299 69.0693 12.0199H69.0793Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0897 12.02C69.0897 12.02 69.1597 12.02 69.1897 12.02L70.4997 13.66V14.11L68.9497 12.18C69.0197 12.15 69.0697 12.09 69.0897 12.02Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8095 14.2899L70.4995 14.1099V11.4999H70.8095V14.2899Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1195 12.74L67.7295 12.52L71.4295 10.91V11.61L68.1195 12.74Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4196 13.99L75.5596 13.86L71.1296 13.85L70.8096 13.98L75.2596 14.26L75.4196 13.99Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4196 13.99L75.5496 14.29H70.8096V13.98L75.4196 13.99Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6193 17.06L75.2993 16.88L75.3093 13.61H75.6193V17.06Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1094 19.66V19.21L75.8494 13.86L75.5894 14.02L80.1094 19.66Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4194 19.84L80.1094 19.66V16.39H80.4294L80.4194 19.84Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0294 19.54L85.1794 19.42L80.7494 19.41L80.4194 19.53L84.8794 19.81L85.0294 19.54Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2294 22.62L84.9194 22.44V19.16H85.2294V22.62Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0294 19.54L85.1694 19.84H80.4194V19.53L85.0294 19.54Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4994 25.65L90.1894 25.47L88.3694 21.4L88.3594 20.71L90.4994 25.65Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4297 10.91L71.6597 10.78L88.5997 20.57L88.3597 20.71L71.4297 11.61V10.91Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4297 10.91V11.61L88.3697 21.4L88.3597 20.71L71.4297 10.91Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6595 10.78L71.4295 10.91L67.7295 12.52L68.1195 12.3L71.6595 10.78Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0099 13.94L80.6099 13.71V5.75L81.0099 5.97L81.4099 13.71L81.0099 13.94Z",
    fill: "#95A2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0098 13.94L81.4098 13.71V5.75L81.0098 5.97V13.94Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6099 5.75002L81.0099 5.52002L81.4099 5.75002L81.0099 5.97002L80.6099 5.75002Z",
    fill: "#8491B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6899 6.85L79.0899 6.62L79.2299 6.71L78.8399 6.94L78.6899 6.85Z",
    fill: "#8491B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9596 6.13001L80.7597 6.01001L78.8896 7.09001L79.0896 7.45001L80.9596 6.37001V6.13001Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0799 10.87L78.8999 10.77L79.7999 8.45005L80.6599 6.30005L80.8199 6.38005L79.8799 8.84005C79.8799 8.84005 79.8799 8.83005 79.8699 8.82005L79.0699 10.87H79.0799Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9596 9.79999L80.7597 9.67999L78.8896 10.76L79.0896 11.12L80.9596 10.04V9.79999Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9598 6.37L80.7098 6.52L79.0498 10.72L79.2298 10.82L80.9598 6.37Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9597 6.13V6.37L79.0897 7.45L78.9897 7.27L80.9597 6.13Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9596 13.47L80.7597 13.35L78.8896 14.43L79.0896 14.79L80.9596 13.71V13.47Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9597 13.47V13.71L79.0897 14.79L78.9897 14.61L80.9597 13.47Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2699 10.93L79.1499 10.89L80.6099 13.42L80.7899 13.57L79.4799 10.93H79.2699Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9597 9.80005V10.04L79.0897 11.12L78.9897 10.94L80.9597 9.80005Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2695 10.93L79.3995 10.75L80.9595 13.47L80.7895 13.57L79.2695 10.93Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8297 15.02L78.6797 14.94L78.6897 6.85004L78.8397 6.94004L79.2297 14.79L78.8297 15.02Z",
    fill: "#929FBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8296 15.02L79.2296 14.79L79.2396 6.71002L78.8396 6.94002L78.8296 15.02Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2696 14.04L81.6596 13.81V5.84998L81.2596 6.07998L80.8696 13.81L81.2696 14.04Z",
    fill: "#99A6C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2696 14.04L80.8696 13.81V5.84998L81.2596 6.07998L81.2696 14.04Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6596 5.85L81.2696 5.62L80.8696 5.85L81.2596 6.08L81.6596 5.85Z",
    fill: "#7E8BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5895 6.94997L83.1896 6.71997L83.0396 6.80997L83.4296 7.03997L83.5895 6.94997Z",
    fill: "#7E8BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3096 6.23005L81.5196 6.11005L83.3896 7.19005L83.1796 7.55005L81.3096 6.47005V6.23005Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2 10.97L83.38 10.87L82.48 8.55002L81.62 6.40002L81.46 6.48002L82.4 8.94002C82.4 8.94002 82.4 8.93002 82.41 8.92002L83.21 10.97H83.2Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3096 9.90003L81.5196 9.78003L83.3896 10.86L83.1796 11.22L81.3096 10.14V9.90003Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3096 6.47003L81.5696 6.62003L83.2196 10.82L83.0396 10.92L81.3096 6.47003Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3096 6.23004V6.47004L83.1796 7.55004L83.2896 7.37004L81.3096 6.23004Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3096 13.57L81.5196 13.45L83.3896 14.53L83.1796 14.89L81.3096 13.81V13.57Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3096 13.57V13.81L83.1796 14.89L83.2896 14.71L81.3096 13.57Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0098 11.03L83.1198 10.99L81.6697 13.53L81.4897 13.67L82.7998 11.03H83.0098Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3096 9.90002V10.14L83.1796 11.22L83.2896 11.04L81.3096 9.90002Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0096 11.03L82.8796 10.86L81.3096 13.57L81.4896 13.67L83.0096 11.03Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4198 15.12L83.0498 14.89L83.0298 6.81L83.4298 7.04L83.4198 15.12Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2296 15.27L82.8296 15.04V7.07001L83.2296 7.30001L83.6196 15.04L83.2296 15.27Z",
    fill: "#C7D3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2295 15.27L83.6195 15.04V7.07001L83.2295 7.30001V15.27Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8296 7.07003L83.2296 6.84003L83.6196 7.07003L83.2296 7.30003L82.8296 7.07003Z",
    fill: "#B4C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9097 8.18001L81.2997 7.95001L81.4497 8.04001L81.0597 8.26001L80.9097 8.18001Z",
    fill: "#B4C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1796 7.46003L82.9796 7.34003L81.0996 8.42003L81.3096 8.77003L83.1796 7.69003V7.46003Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2899 12.2L81.1099 12.1L82.0099 9.78L82.8699 7.63L83.0299 7.71L82.0899 10.17C82.0899 10.17 82.0899 10.16 82.0799 10.15L81.2799 12.2H81.2899Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1796 11.13L82.9796 11.01L81.0996 12.09L81.3096 12.44L83.1796 11.36V11.13Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1795 7.69L82.9295 7.84L81.2695 12.05L81.4495 12.15L83.1795 7.69Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.18 7.46002V7.69002L81.31 8.77002L81.21 8.60002L83.18 7.46002Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1796 14.79L82.9796 14.68L81.0996 15.76L81.3096 16.11L83.1796 15.03V14.79Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.18 14.79V15.03L81.31 16.11L81.21 15.93L83.18 14.79Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4896 12.26L81.3696 12.21L82.8296 14.75L82.9996 14.9L81.6896 12.26H81.4896Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.18 11.13V11.36L81.31 12.44L81.21 12.27L83.18 11.13Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4897 12.26L81.6097 12.08L83.1797 14.79L82.9997 14.9L81.4897 12.26Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0497 16.35L80.8896 16.26L80.9097 8.17999L81.0596 8.25999L81.4397 16.12L81.0497 16.35Z",
    fill: "#C3D0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0498 16.35L81.4398 16.12L81.4598 8.03003L81.0598 8.26003L81.0498 16.35Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8897 15.27L79.2897 15.04V7.07001L78.8897 7.30001L78.4897 15.04L78.8897 15.27Z",
    fill: "#CAD6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8897 15.27L78.4897 15.04V7.07001L78.8897 7.30001V15.27Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2897 7.07003L78.8897 6.84003L78.4897 7.07003L78.8897 7.30003L79.2897 7.07003Z",
    fill: "#B0BDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2099 8.18001L80.8099 7.95001L80.6699 8.04001L81.0599 8.26001L81.2099 8.18001Z",
    fill: "#B0BDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9399 7.46003L79.1399 7.34003L81.0099 8.42003L80.8099 8.77003L78.9399 7.69003V7.46003Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8196 12.2L80.9996 12.1L80.0996 9.78L79.2396 7.63L79.0796 7.71L80.0196 10.17V10.15L80.8296 12.2H80.8196Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9399 11.13L79.1399 11.01L81.0099 12.09L80.8099 12.44L78.9399 11.36V11.13Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9399 7.69L79.1899 7.84L80.8499 12.05L80.6699 12.15L78.9399 7.69Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9399 7.46002V7.69002L80.8099 8.77002L80.9099 8.60002L78.9399 7.46002Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9399 14.79L79.1399 14.68L81.0099 15.76L80.8099 16.11L78.9399 15.03V14.79Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9399 14.79V15.03L80.8099 16.11L80.9099 15.93L78.9399 14.79Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6299 12.26L80.7499 12.21L79.2899 14.75L79.1099 14.9L80.4199 12.26H80.6299Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9399 11.13V11.36L80.8099 12.44L80.9099 12.27L78.9399 11.13Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6299 12.26L80.4999 12.08L78.9399 14.79L79.1099 14.9L80.6299 12.26Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0497 16.35L80.6697 16.12L80.6597 8.03003L81.0597 8.26003L81.0497 16.35Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2997 37.76L46.0197 36.5C46.0797 36.5 55.2597 34.46 66.9097 27.9C77.0997 22.17 86.6197 13.08 87.0597 12.66L89.1097 11.59L88.9797 11.34L86.8797 12.44C86.7797 12.53 77.1197 21.83 66.7697 27.66C55.1597 34.19 46.0197 36.22 45.9297 36.24L43.1797 37.51L43.2997 37.77V37.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4095 37.1L45.1296 35.84C45.1896 35.84 54.3595 33.8 66.0195 27.24C76.2095 21.51 85.7395 12.42 86.1695 12L88.2196 10.93L88.0895 10.68L85.9895 11.78C85.8895 11.87 76.2295 21.17 65.8795 27C54.2695 33.53 45.1396 35.56 45.0396 35.58L42.2896 36.85L42.4095 37.11V37.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1096 12.85L87.4195 12.67V11.68L87.1096 11.86L86.7896 12.67L87.1096 12.85Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1096 12.85L86.7896 12.67V11.68L87.1096 11.86V12.85Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4195 11.68L87.1096 11.5L86.7896 11.68L87.1096 11.86L87.4195 11.68Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1396 12.29L86.4496 12.11V11.12L86.1396 11.3L85.8296 12.11L86.1396 12.29Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1396 12.29L85.8296 12.11V11.12L86.1396 11.3V12.29Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4496 11.12L86.1396 10.94L85.8296 11.12L86.1396 11.3L86.4496 11.12Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0695 12.02L89.3795 11.83V10.85L89.0695 11.03L88.7495 11.83L89.0695 12.02Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0695 12.02L88.7495 11.83V10.85L89.0695 11.03V12.02Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3795 10.85L89.0695 10.67L88.7495 10.85L89.0695 11.03L89.3795 10.85Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0998 11.46L88.4098 11.27V10.29L88.0998 10.47L87.7798 11.27L88.0998 11.46Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0998 11.46L87.7798 11.27V10.29L88.0998 10.47V11.46Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4098 10.29L88.0998 10.1L87.7798 10.29L88.0998 10.47L88.4098 10.29Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7197 1.24999L73.1597 0.98999L90.0297 10.73L89.5897 10.99L72.7697 1.78999L72.7197 1.24999Z",
    fill: "#E6FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7197 1.25V1.76L89.5897 11.5V10.99L72.7197 1.25Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0298 10.73V11.24L89.5898 11.5V10.99L90.0298 10.73Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5998 10.93L89.8298 10.8L88.1998 7.20001L88.0298 7.30001L89.3698 10.8L89.5998 10.93Z",
    fill: "#EDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0801 8.89998L86.3101 8.76999V6.35999H85.8501V8.76999L86.0801 8.89998Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0801 8.89998L85.8501 8.76999V6.35999H86.0801V8.89998Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1001 6.48L86.3001 6.37L88.0401 8.52999L89.1401 9.92L89.4701 10.66L87.6201 8.39C87.6201 8.39 87.6401 8.39 87.6501 8.39L86.1201 6.48H86.1001Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3798 10.81V10.48L86.2498 6.54999L86.0498 6.65999L89.3798 10.81Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73 8.69998L85.96 8.56998V6.16998H85.5V8.56998L85.73 8.69998Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.19 6.66L82.42 6.53V4.12H81.96V6.53L82.19 6.66Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6699 2.20998L78.8699 2.09998L80.6099 4.25998L82.1999 6.27998L82.0299 6.38998L80.1799 4.11998C80.1799 4.11998 80.1999 4.11998 80.2099 4.11998L78.6799 2.20998H78.6699Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6597 4.62002L78.8897 4.49002V2.08002H78.4297V4.49002L78.6597 4.62002Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1197 2.40999L75.3496 2.27999V0.359985L74.8896 0.529985V2.27999L75.1197 2.40999Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8498 0.919985C73.9298 0.919985 74.0098 0.899985 74.0698 0.859985L75.1199 2.19999L74.9498 2.30999L73.8398 0.949985V0.929985L73.8498 0.919985Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86 0.909973C73.86 0.909973 73.91 0.909973 73.93 0.909973L74.89 2.11997V2.44997L73.75 1.02997C73.75 1.02997 73.84 0.969973 73.85 0.919973L73.86 0.909973Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1197 2.58003L74.8896 2.45003V0.530029H75.1197V2.58003Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1399 1.43998L72.8599 1.27998L75.5799 0.0999756V0.609976L73.1399 1.43998Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5096 2.36001L78.6196 2.27001L75.3596 2.26001L75.1196 2.35001L78.3896 2.56001L78.5096 2.36001Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5096 2.35998L78.6096 2.57998H75.1196V2.34998L78.5096 2.35998Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6597 4.62002L78.4297 4.49002V2.08002H78.6597V4.62002Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9599 6.53002V6.20002L78.8299 2.27002L78.6299 2.38002L81.9599 6.53002Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.19 6.66L81.96 6.53V4.12H82.19V6.66Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5799 6.44003L85.6899 6.35003L82.4299 6.34003L82.1899 6.43003L85.4599 6.64003L85.5799 6.44003Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73 8.69998L85.5 8.56998V6.16998H85.73V8.69998Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5799 6.43999L85.6799 6.65999H82.1899V6.42999L85.5799 6.43999Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5998 10.93L89.3698 10.8L88.0298 7.80999V7.29999L89.5998 10.93Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5801 0.1L75.7501 0L88.2001 7.2L88.0301 7.3L75.5801 0.61V0.1Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5801 0.0999756V0.609976L88.0301 7.80998V7.29998L75.5801 0.0999756Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7499 0L75.5799 0.1L72.8599 1.28L73.1499 1.12L75.7499 0Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4004 8.67002L88.0304 7.71002V7.40002L86.4004 8.36002V8.67002Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4002 8.36002L88.0302 7.40002L87.8102 7.27002L86.1802 8.23002L86.4002 8.36002Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6499 7.06999L85.2799 6.10999V5.79999L83.6499 6.75999V7.06999Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6499 6.75998L85.2799 5.79998L85.0499 5.66998L83.4199 6.62998L83.6499 6.75998Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75 5.97001L83.38 5.01001V4.70001L81.75 5.66001V5.97001Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75 5.66001L83.38 4.70001L83.16 4.57001L81.52 5.53001L81.75 5.66001Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8599 4.86999L81.4899 3.90999V3.60999L79.8599 4.56999V4.86999Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8599 4.56997L81.4899 3.60997L81.2599 3.46997L79.6299 4.42997L79.8599 4.56997Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.96 3.77001L79.59 2.81001V2.51001L77.96 3.47001V3.77001Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.96 3.47L79.59 2.51L79.36 2.38L77.73 3.34L77.96 3.47Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0698 2.67997L77.6998 1.71997V1.40997L76.0698 2.36997V2.67997Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0698 2.36997L77.6998 1.40997L77.4698 1.27997L75.8398 2.23997L76.0698 2.36997Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1699 1.58L75.7999 0.619998V0.309998L74.1699 1.27V1.58Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1699 1.26999L75.7999 0.309993L75.5699 0.179993L73.9399 1.13999L74.1699 1.26999Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9697 2.25L71.4097 2L88.2897 11.74L87.8397 12L70.9697 2.77V2.25Z",
    fill: "#E6FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9697 2.25V2.77L87.8397 12.5V12L70.9697 2.25Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2898 11.74V12.25L87.8398 12.5V12L88.2898 11.74Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8498 11.94L88.0798 11.81L86.4498 8.21002L86.2798 8.31002L87.6198 11.81L87.8498 11.94Z",
    fill: "#EDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3301 9.91L84.5601 9.77999V7.37H84.1001V9.77999L84.3301 9.91Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3301 9.91L84.1001 9.77999V7.37H84.3301V9.91Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3501 7.49L84.5501 7.38L86.2901 9.54L87.3901 10.93L87.7201 11.67L85.8701 9.4C85.8701 9.4 85.8901 9.4 85.9001 9.4L84.3701 7.49H84.3501Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6401 11.82V11.49L84.5101 7.56L84.3101 7.67L87.6401 11.82Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.98 9.70998L84.21 9.57998V7.16998H83.75V9.57998L83.98 9.70998Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4497 7.67L80.6697 7.54V5.13H80.2197V7.54L80.4497 7.67Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9297 3.21004L77.1297 3.10004L78.8697 5.26004L80.4597 7.28004L80.2897 7.39004L78.4397 5.12004C78.4397 5.12004 78.4597 5.12004 78.4697 5.12004L76.9397 3.21004H76.9297Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9097 5.63003L77.1397 5.50003V3.09003H76.6797V5.50003L76.9097 5.63003Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3699 3.42L73.5999 3.29V1.37L73.1499 1.54V3.29L73.3699 3.42Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1101 1.91999C72.1901 1.91999 72.2701 1.89999 72.3301 1.85999L73.3801 3.19999L73.2101 3.30999L72.1001 1.94999V1.92999L72.1101 1.91999Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.11 1.91998C72.11 1.91998 72.16 1.91998 72.18 1.91998L73.14 3.12998V3.45998L72 2.03998C72 2.03998 72.09 1.97998 72.1 1.92998L72.11 1.91998Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3699 3.59004L73.1499 3.46004V1.54004H73.3799L73.3699 3.59004Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3999 2.44999L71.1099 2.28999L73.8299 1.10999V1.61999L71.3999 2.44999Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7596 3.37002L76.8696 3.28002L73.6196 3.27002L73.3696 3.36002L76.6496 3.57002L76.7596 3.37002Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7596 3.36999L76.8596 3.58999H73.3696V3.35999L76.7596 3.36999Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9097 5.63003L76.6797 5.50003V3.09003H76.9097V5.63003Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2197 7.54003V7.21003L77.0896 3.28003L76.8896 3.39003L80.2197 7.54003Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4497 7.67L80.2197 7.54V5.13H80.4497V7.67Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8297 7.45004L83.9397 7.36004L80.6897 7.35004L80.4497 7.44004L83.7197 7.65004L83.8297 7.45004Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.98 9.70998L83.75 9.57998V7.16998H83.98V9.70998Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8297 7.45L83.9297 7.67H80.4497V7.44L83.8297 7.45Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8498 11.94L87.6198 11.81L86.2898 8.82L86.2798 8.31L87.8498 11.94Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8301 1.11001L74.0001 1.01001L86.4501 8.21001L86.2801 8.31001L73.8301 1.62001V1.11001Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8301 1.10999V1.61999L86.2901 8.81998L86.2801 8.30999L73.8301 1.10999Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9999 1.01001L73.8299 1.11001L71.1099 2.29001L71.3999 2.13001L73.9999 1.01001Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8594 53.51V54.31L86.7594 50.9V50.1L80.8594 53.51Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7993 48.91L69.9293 51.88L72.8493 53.73L72.9793 53.65V50.59L69.9293 48.83L69.7993 48.91ZM70.0793 49.08L72.8393 50.67V53.39L70.0793 51.8V49.08Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7993 51.97L72.8493 53.73V50.67L69.7993 48.91V51.97ZM69.9493 49.17L72.7093 50.76V53.48L69.9493 51.89V49.17Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9793 50.59L72.8493 50.67L69.7993 48.91L69.9293 48.82L72.9793 50.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2193 51.96L70.1993 51.97L70.1493 52L70.1393 51.94L69.9893 51.12V50.73L70.2193 51.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4393 52.09L70.4193 52.1L70.3693 52.13L70.3593 52.07L69.9893 50.05V49.65L70.4393 52.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5991 52.26L70.0391 49.22L70.0791 49.24L70.1191 49.26L70.6591 52.22L70.5991 52.26Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8793 52.34L70.8193 52.38L70.2593 49.34L70.3393 49.39L70.8793 52.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1095 52.47L71.0395 52.51L70.4795 49.47L70.5595 49.52L71.1095 52.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3292 52.6L71.2592 52.64L70.6992 49.6L70.7792 49.65L71.3292 52.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5494 52.73L71.4894 52.77L70.9194 49.73L70.9894 49.77H71.0094L71.5494 52.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7694 52.86L71.7094 52.9L71.1494 49.86L71.2294 49.9L71.7694 52.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9891 52.98L71.9291 53.03L71.3691 49.98L71.3991 50L71.4491 50.03L71.9891 52.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2194 53.11L72.1494 53.15L71.5894 50.11L71.6694 50.16L72.2194 53.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4391 53.2401L72.3691 53.28L71.8091 50.2401L71.8891 50.2901L72.4391 53.2401Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6591 53.3701L72.5991 53.4101L72.0391 50.3701L72.1191 50.4201L72.6591 53.3701Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7093 52.55V52.94L72.2593 50.5L72.3393 50.54L72.7093 52.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7095 51.47V51.86L72.4795 50.63L72.5295 50.65L72.5595 50.67L72.7095 51.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7094 53.18V53.25L72.4594 53.28L72.3594 53.22L72.7094 53.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7092 52.9V52.97L72.0492 53.04L71.9492 52.98L72.7092 52.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7091 52.61V52.68L71.6391 52.81L71.5391 52.75L72.7091 52.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7094 52.33V52.4L71.2294 52.57L71.1294 52.51L72.7094 52.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7092 52.05V52.12L70.8192 52.34L70.7192 52.28L72.7092 52.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7093 51.76V51.83L70.4193 52.1L70.3193 52.04L72.7093 51.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7094 51.48V51.55L70.0894 51.85L70.1094 51.78L72.7094 51.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7093 51.2V51.27L69.9893 51.58V51.51L72.7093 51.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7093 50.91V50.99L69.9893 51.3V51.23L72.7093 50.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6293 50.71L69.9893 51.02V50.95L72.5293 50.65L72.6293 50.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2193 50.48L69.9893 50.73V50.66L72.1193 50.42L72.2193 50.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8093 50.24L69.9893 50.45V50.38L71.7093 50.18L71.8093 50.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3993 50L69.9893 50.17V50.1L71.2993 49.95L71.3993 50Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9893 49.77L69.9893 49.88V49.81L70.8893 49.71L70.9893 49.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5893 49.53L69.9893 49.6V49.53L70.4793 49.47L70.5893 49.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1793 49.3L69.9893 49.32V49.25L70.0793 49.24L70.1793 49.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5591 50.5L72.6891 53.47L75.6091 55.32L75.7391 55.24V52.18L72.6891 50.42L72.5591 50.5ZM72.8391 50.67L75.5991 52.26V54.98L72.8391 53.39V50.67Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5591 53.56L75.6091 55.32V52.26L72.5591 50.5V53.56ZM72.7091 50.76L75.4691 52.35V55.07L72.7091 53.48V50.76Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7391 52.18L75.6091 52.26L72.5591 50.5L72.6891 50.42L75.7391 52.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.979 53.55L72.949 53.56L72.909 53.59L72.899 53.53L72.749 52.71V52.33L72.979 53.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.199 53.68L73.179 53.69L73.129 53.72L73.119 53.66L72.749 51.64V51.25L73.199 53.68Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3591 53.85L72.7891 50.81L72.8291 50.83L72.8691 50.85L73.4191 53.81L73.3591 53.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.639 53.94L73.579 53.98L73.019 50.94L73.099 50.98L73.639 53.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8593 54.06L73.7993 54.1L73.2393 51.07L73.3193 51.11L73.8593 54.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.089 54.19L74.019 54.23L73.459 51.19L73.539 51.24L74.089 54.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3092 54.32L74.2392 54.36L73.6792 51.32L73.7492 51.36L73.7592 51.37L74.3092 54.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5292 54.45L74.4692 54.49L73.9092 51.45L73.9892 51.5L74.5292 54.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7489 54.58L74.6889 54.62L74.1289 51.58L74.1589 51.6L74.2089 51.62L74.7489 54.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9691 54.71L74.9091 54.74L74.3491 51.71L74.4291 51.75L74.9691 54.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1988 54.83L75.1288 54.87L74.5688 51.83L74.6488 51.88L75.1988 54.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4191 54.96L75.3591 55L74.7891 51.96L74.8691 52.01L75.4191 54.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.469 54.14V54.53L75.019 52.09L75.099 52.14L75.469 54.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4693 53.07V53.45L75.2393 52.22L75.2793 52.25H75.2893L75.3193 52.26L75.4693 53.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4691 54.77V54.84L75.2191 54.87L75.1191 54.81L75.4691 54.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.469 54.4899V54.5599L74.809 54.6299L74.709 54.5799L75.469 54.4899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4688 54.21V54.28L74.3988 54.4L74.2988 54.34L75.4688 54.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4692 53.9199V53.9899L73.9892 54.1599L73.8892 54.0999L75.4692 53.9199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.469 53.64V53.71L73.579 53.93L73.479 53.87L75.469 53.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4688 53.36V53.43L73.1688 53.69L73.0688 53.63L75.4688 53.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4689 53.0699V53.1399L72.8389 53.4499L72.8589 53.3699L75.4689 53.0699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.469 52.79V52.86L72.749 53.17V53.1L75.469 52.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.469 52.5099V52.58L72.749 52.8899V52.82L75.469 52.5099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.389 52.2999L72.749 52.6099V52.5399L75.279 52.2499H75.289L75.389 52.2999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.979 52.07L72.749 52.33V52.25L74.879 52.0099L74.979 52.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.569 51.83L72.749 52.04V51.97L74.469 51.77L74.569 51.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.159 51.6L72.749 51.76V51.69L74.059 51.54L74.159 51.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.749 51.3599L72.749 51.4799V51.4099L73.649 51.2999L73.749 51.3599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.339 51.1199L72.749 51.1899V51.1199L73.239 51.0699L73.339 51.1199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.939 50.89L72.749 50.91V50.84L72.829 50.83L72.939 50.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3193 52.09L75.4493 55.06L78.3693 56.91L78.4993 56.83V53.77L75.4493 52.01L75.3193 52.09ZM75.5993 52.26L78.3593 53.85V56.57L75.5993 54.98V52.26Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3193 55.15L78.3693 56.91V53.85L75.3193 52.09V55.15ZM75.4693 52.35L78.2293 53.94V56.66L75.4693 55.07V52.35Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4993 53.77L78.3693 53.86L75.3193 52.09L75.4493 52.01L78.4993 53.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7293 55.14L75.7093 55.16L75.6693 55.18L75.6593 55.13L75.5093 54.3V53.92L75.7293 55.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9593 55.27L75.9293 55.28L75.8893 55.31L75.8793 55.25L75.5093 53.23V52.84L75.9593 55.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1093 55.44L75.5493 52.4L75.5893 52.42L75.6293 52.45L76.1793 55.4L76.1093 55.44Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.399 55.53L76.339 55.57L75.769 52.53L75.849 52.58L76.399 55.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6195 55.66L76.5595 55.7L75.9995 52.66L76.0795 52.7L76.6195 55.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8392 55.79L76.7792 55.82L76.2192 52.78L76.2992 52.83L76.8392 55.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0695 55.91L76.9995 55.95L76.4395 52.91L76.5095 52.95L76.5194 52.96L77.0695 55.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2892 56.04L77.2192 56.08L76.6592 53.04L76.7392 53.09L77.2892 56.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5092 56.17L77.4492 56.21L76.8892 53.17L76.9192 53.19L76.9692 53.21L77.5092 56.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7294 56.3L77.6694 56.34L77.1094 53.3L77.1894 53.35L77.7294 56.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9591 56.43L77.8891 56.47L77.3291 53.42L77.4091 53.47L77.9591 56.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1793 56.55L78.1093 56.59L77.5493 53.55L77.6293 53.6L78.1793 56.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.219 55.7301V56.1201L77.769 53.6801L77.849 53.7301L78.219 55.7301Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2195 54.66V55.05L77.9995 53.81L78.0395 53.84L78.0795 53.86L78.2195 54.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2191 56.36V56.43L77.9691 56.46L77.8691 56.4L78.2191 56.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2195 56.08V56.15L77.5595 56.23L77.4595 56.17L78.2195 56.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2191 55.8V55.87L77.1591 55.99L77.0591 55.93L78.2191 55.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2194 55.52V55.59L76.7494 55.76L76.6494 55.7L78.2194 55.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2193 55.23V55.3L76.3393 55.52L76.2393 55.46L78.2193 55.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2191 54.95V55.02L75.9291 55.28L75.8291 55.22L78.2191 54.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2191 54.67V54.74L75.5991 55.04L75.6191 54.97L78.2191 54.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2193 54.38V54.45L75.5093 54.77V54.7L78.2193 54.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2193 54.1V54.17L75.5093 54.48V54.41L78.2193 54.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1493 53.9L75.5093 54.2V54.13L78.0393 53.84L78.1493 53.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7393 53.66L75.5093 53.92V53.85L77.6293 53.6H77.6393L77.7393 53.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3293 53.42L75.5093 53.63V53.56L77.2193 53.37H77.2293L77.3293 53.42Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9193 53.19L75.5093 53.35V53.28L76.8193 53.13L76.9193 53.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5093 52.95L75.5093 53.07V53L76.4093 52.89L76.5093 52.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0993 52.72L75.5093 52.79V52.71L75.9993 52.66L76.0993 52.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6893 52.48L75.5093 52.5V52.43L75.5893 52.42L75.6893 52.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0791 53.69L78.2091 56.66L81.1291 58.51L81.2591 58.43V55.37L78.2091 53.61L78.0791 53.69ZM78.3591 53.86L81.1191 55.45V58.17L78.3591 56.58V53.86Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0791 56.74L81.1291 58.5V55.44L78.0791 53.68V56.74ZM78.2291 53.94L80.9891 55.53V58.25L78.2291 56.66V53.94Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2591 55.36L81.1291 55.45L78.0791 53.69L78.2091 53.6L81.2591 55.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.489 56.74L78.469 56.75L78.429 56.78L78.419 56.72L78.269 55.9V55.51L78.489 56.74Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.709 56.86L78.689 56.88L78.649 56.9L78.639 56.85L78.269 54.82V54.43L78.709 56.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8691 57.03L78.3091 53.99L78.3491 54.01L78.3891 54.04L78.9391 56.99L78.8691 57.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1588 57.12L79.0888 57.16L78.5288 54.12L78.6088 54.17L79.1588 57.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3793 57.25L79.3193 57.29L78.7593 54.25L78.8393 54.3L79.3793 57.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.599 57.38L79.539 57.42L78.979 54.38L79.059 54.42L79.599 57.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8292 57.5L79.7592 57.55L79.1992 54.51L79.2692 54.54L79.2792 54.55L79.8292 57.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.049 57.63L79.979 57.67L79.4189 54.63L79.4989 54.68L80.049 57.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2692 57.76L80.1992 57.8L79.6392 54.76L79.6792 54.78L79.7192 54.81L80.2692 57.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4891 57.89L80.4291 57.93L79.8691 54.89L79.9491 54.94L80.4891 57.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7089 58.02L80.6489 58.06L80.0889 55.02L80.1689 55.06L80.7089 58.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9391 58.15L80.8691 58.19L80.3091 55.15L80.3891 55.19L80.9391 58.15Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9788 57.33V57.71L80.5288 55.27L80.6088 55.32L80.9788 57.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.979 56.25V56.64L80.749 55.4L80.799 55.43L80.829 55.45L80.979 56.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9789 57.96V58.03L80.7289 58.06L80.6289 58L80.9789 57.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9792 57.6699V57.7399L80.3192 57.8199L80.2192 57.7599L80.9792 57.6699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9791 57.39V57.46L79.9091 57.58L79.8091 57.53L80.9791 57.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9792 57.1099V57.1799L79.5092 57.3499L79.4092 57.2899L80.9792 57.1099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.979 56.8199V56.8999L79.099 57.1099L78.999 57.0499L80.979 56.8199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9789 56.54V56.61L78.6889 56.88L78.5889 56.82L80.9789 56.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9789 56.2599V56.33L78.3589 56.63L78.3789 56.56L80.9789 56.2599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.979 55.97V56.05L78.269 56.36V56.29L80.979 55.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.979 55.6899V55.7599L78.269 56.0799V55.9999L80.979 55.6899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.899 55.4899L78.269 55.7899V55.7199L80.799 55.4299L80.899 55.4899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.489 55.2499L78.269 55.5099V55.4399L80.389 55.1899L80.489 55.2499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.089 55.02L78.269 55.23V55.16L79.979 54.96L80.089 55.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.679 54.78L78.269 54.94V54.87L79.569 54.72H79.579L79.679 54.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.269 54.5399L78.269 54.6599V54.5899L79.169 54.4899L79.269 54.5399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.859 54.3099L78.269 54.3799V54.3099L78.759 54.2499L78.859 54.3099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.449 54.07L78.269 54.0999V54.02L78.349 54.0099L78.449 54.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3293 48.82L89.2793 50.58V53.64L89.4093 53.72L92.3293 51.87L92.4593 48.9L92.3293 48.82ZM92.1793 51.79L89.4193 53.38V50.66L92.1793 49.07V51.79Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4597 48.91L89.4097 50.67V53.73L92.4597 51.97V48.91ZM92.3097 51.88L89.5497 53.47V50.75L92.3097 49.16V51.88Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2695 50.59L89.3995 50.67L92.4595 48.91L92.3295 48.82L89.2695 50.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0396 51.96L92.0595 51.97L92.0995 52L92.1196 51.94L92.2695 51.12V50.73L92.0396 51.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8193 52.09L91.8393 52.1L91.8793 52.13L91.8893 52.07L92.2693 50.05V49.65L91.8193 52.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6591 52.26L92.2191 49.22L92.1791 49.24L92.1391 49.26L91.5991 52.22L91.6591 52.26Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3691 52.34L91.4391 52.38L91.9991 49.34L91.9191 49.39L91.3691 52.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1494 52.47L91.2194 52.51L91.7794 49.47L91.6994 49.52L91.1494 52.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9292 52.6L90.9892 52.64L91.5592 49.6L91.4692 49.65L90.9292 52.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7095 52.73L90.7695 52.77L91.3295 49.73L91.2595 49.77H91.2495L90.7095 52.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4893 52.86L90.5493 52.9L91.1093 49.86L91.0293 49.9L90.4893 52.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2593 52.98L90.3293 53.03L90.8893 49.98L90.8493 50L90.8093 50.03L90.2593 52.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0396 53.11L90.1096 53.15L90.6695 50.11L90.5895 50.16L90.0396 53.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8193 53.2401L89.8793 53.28L90.4493 50.2401L90.3593 50.2901L89.8193 53.2401Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5991 53.3701L89.6591 53.4101L90.2191 50.3701L90.1391 50.4201L89.5991 53.3701Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 52.55V52.94L89.9993 50.5L89.9193 50.54L89.5493 52.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 51.47V51.86L89.7793 50.63L89.7293 50.65L89.6993 50.67L89.5493 51.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 53.18V53.25L89.7993 53.28L89.8993 53.22L89.5493 53.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 52.9V52.97L90.2093 53.04L90.3093 52.98L89.5493 52.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 52.61V52.68L90.6193 52.81L90.7193 52.75L89.5493 52.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 52.33V52.4L91.0193 52.57L91.1293 52.51L89.5493 52.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 52.05V52.12L91.4293 52.34L91.5393 52.28L89.5493 52.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 51.76V51.83L91.8393 52.1L91.9393 52.04L89.5493 51.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 51.48V51.55L92.1693 51.85L92.1493 51.78L89.5493 51.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 51.2V51.27L92.2693 51.58V51.51L89.5493 51.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5493 50.91V50.99L92.2693 51.3V51.23L89.5493 50.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6294 50.71L92.2694 51.02V50.95L89.7294 50.65L89.6294 50.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0396 50.48L92.2695 50.73V50.66L90.1395 50.42L90.0396 50.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4492 50.24L92.2692 50.45V50.38L90.5492 50.18L90.4492 50.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8491 50L92.2691 50.17V50.1L90.9591 49.95L90.8491 50Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2593 49.77L92.2693 49.88V49.81L91.3693 49.71L91.2593 49.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6694 49.53L92.2694 49.6V49.53L91.7794 49.47L91.6694 49.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0791 49.3L92.2691 49.32V49.25L92.1791 49.24L92.0791 49.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5695 50.42L86.5195 52.18V55.24L86.6495 55.32L89.5695 53.47L89.6995 50.5L89.5695 50.42ZM89.4195 53.39L86.6595 54.98V52.26L89.4195 50.67V53.39Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6994 50.5L86.6494 52.26V55.32L89.6994 53.56V50.5ZM89.5494 53.47L86.7894 55.06V52.34L89.5494 50.75V53.47Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5195 52.18L86.6495 52.26L89.6995 50.5L89.5695 50.42L86.5195 52.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2798 53.55L89.2998 53.56L89.3498 53.59L89.3598 53.53L89.5098 52.71V52.33L89.2798 53.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0596 53.68L89.0796 53.69L89.1196 53.72L89.1396 53.66L89.5096 51.64V51.25L89.0596 53.68Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8994 53.85L89.4594 50.81L89.4194 50.83L89.3794 50.85L88.8394 53.81L88.8994 53.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6196 53.94L88.6796 53.98L89.2396 50.94L89.1596 50.98L88.6196 53.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3896 54.06L88.4596 54.1L89.0196 51.07L88.9397 51.11L88.3896 54.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1694 54.19L88.2394 54.23L88.7994 51.19L88.7194 51.24L88.1694 54.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9497 54.32L88.0097 54.36L88.5797 51.32L88.5097 51.36L88.4897 51.37L87.9497 54.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7295 54.45L87.7895 54.49L88.3495 51.45L88.2695 51.5L87.7295 54.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5098 54.58L87.5698 54.62L88.1298 51.58L88.0998 51.6L88.0498 51.62L87.5098 54.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2798 54.71L87.3498 54.74L87.9098 51.71L87.8298 51.75L87.2798 54.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0596 54.83L87.1296 54.87L87.6896 51.83L87.6096 51.88L87.0596 54.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8394 54.96L86.8994 55L87.4594 51.96L87.3794 52.01L86.8394 54.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 54.14V54.53L87.2395 52.09L87.1596 52.14L86.7896 54.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 53.07V53.45L87.0195 52.22L86.9696 52.25L86.9396 52.26L86.7896 53.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 54.77V54.84L87.0396 54.87L87.1395 54.81L86.7896 54.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 54.4899V54.5599L87.4495 54.6299L87.5496 54.5799L86.7896 54.4899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 54.21V54.28L87.8596 54.4L87.9595 54.34L86.7896 54.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 53.9199V53.9899L88.2695 54.1599L88.3696 54.0999L86.7896 53.9199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 53.64V53.71L88.6796 53.93L88.7795 53.87L86.7896 53.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 53.36V53.43L89.0796 53.69L89.1796 53.63L86.7896 53.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 53.0699V53.1399L89.4096 53.4499L89.3895 53.3699L86.7896 53.0699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 52.79V52.86L89.5096 53.17V53.1L86.7896 52.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7896 52.5099V52.58L89.5096 52.8899V52.82L86.7896 52.5099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8696 52.2999L89.5096 52.6099V52.5399L86.9696 52.2499L86.8696 52.2999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2798 52.07L89.5098 52.33V52.25L87.3798 52.0099L87.2798 52.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6895 51.83L89.5095 52.04V51.97L87.7895 51.77L87.6895 51.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0996 51.6L89.5096 51.76V51.69L88.1996 51.54L88.0996 51.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5098 51.3599L89.5098 51.4799V51.4099L88.6098 51.2999L88.5098 51.3599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9097 51.1199L89.5097 51.1899V51.1199L89.0197 51.0699L88.9097 51.1199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3193 50.89L89.5093 50.91V50.84L89.4193 50.83L89.3193 50.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8093 52.01L83.7593 53.77V56.83L83.8893 56.91L86.8093 55.06L86.9393 52.09L86.8093 52.01ZM86.6593 54.98L83.8993 56.57V53.85L86.6593 52.26V54.98Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9392 52.09L83.8892 53.85V56.91L86.9392 55.15V52.09ZM86.7892 55.06L84.0292 56.65V53.93L86.7892 52.34V55.06Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7593 53.77L83.8893 53.86L86.9393 52.09L86.8093 52.01L83.7593 53.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5195 55.14L86.5495 55.16L86.5895 55.18L86.5995 55.13L86.7495 54.3V53.92L86.5195 55.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2993 55.27L86.3193 55.28L86.3693 55.31L86.3793 55.25L86.7493 53.23V52.84L86.2993 55.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1391 55.44L86.6991 52.4L86.6691 52.42L86.6191 52.45L86.0791 55.4L86.1391 55.44Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8594 55.53L85.9194 55.57L86.4794 52.53L86.3994 52.58L85.8594 55.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6392 55.66L85.6992 55.7L86.2592 52.66L86.1792 52.7L85.6392 55.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4092 55.79L85.4792 55.82L86.0392 52.78L85.9592 52.83L85.4092 55.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1895 55.91L85.2595 55.95L85.8195 52.91L85.7495 52.95L85.7394 52.96L85.1895 55.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9692 56.04L85.0292 56.08L85.5892 53.04L85.5092 53.09L84.9692 56.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7495 56.17L84.8095 56.21L85.3695 53.17L85.3395 53.19L85.2895 53.21L84.7495 56.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5293 56.3L84.5893 56.34L85.1493 53.3L85.0693 53.35L84.5293 56.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2993 56.43L84.3693 56.47L84.9293 53.42L84.8493 53.47L84.2993 56.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0791 56.55L84.1391 56.59L84.7091 53.55L84.6291 53.6L84.0791 56.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 55.7301V56.1201L84.4793 53.6801L84.3993 53.7301L84.0293 55.7301Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 54.66V55.05L84.2593 53.81L84.2093 53.84L84.1793 53.86L84.0293 54.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 56.36V56.43L84.2793 56.46L84.3793 56.4L84.0293 56.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 56.08V56.15L84.6893 56.23L84.7893 56.17L84.0293 56.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 55.8V55.87L85.0993 55.99L85.1993 55.93L84.0293 55.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 55.52V55.59L85.5093 55.76L85.6093 55.7L84.0293 55.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 55.23V55.3L85.9193 55.52L86.0193 55.46L84.0293 55.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 54.95V55.02L86.3293 55.28L86.4293 55.22L84.0293 54.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 54.67V54.74L86.6493 55.04L86.6393 54.97L84.0293 54.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 54.38V54.45L86.7493 54.77V54.7L84.0293 54.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0293 54.1V54.17L86.7493 54.48V54.41L84.0293 54.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1094 53.9L86.7494 54.2V54.13L84.2094 53.84L84.1094 53.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5195 53.66L86.7495 53.92V53.85L84.6195 53.6L84.5195 53.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9292 53.42L86.7492 53.63V53.56L85.0292 53.37L84.9292 53.42Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3394 53.19L86.7494 53.35V53.28L85.4394 53.13L85.3394 53.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7495 52.95L86.7495 53.07V53L85.8495 52.89L85.7495 52.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1592 52.72L86.7492 52.79V52.71L86.2592 52.66L86.1592 52.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5591 52.48L86.7491 52.5V52.43L86.6691 52.42L86.5591 52.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0495 53.6L80.9995 55.36V58.42L81.1295 58.5L84.0495 56.65L84.1795 53.68L84.0495 53.6ZM83.8995 56.57L81.1395 58.16V55.44L83.8995 53.85V56.57Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1794 53.69L81.1294 55.45V58.51L84.1794 56.75V53.69ZM84.0294 56.66L81.2694 58.25V55.53L84.0294 53.94V56.66Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9995 55.36L81.1295 55.45L84.1795 53.69L84.0495 53.6L80.9995 55.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7695 56.74L83.7895 56.75L83.8295 56.78L83.8395 56.72L83.9895 55.9V55.51L83.7695 56.74Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5391 56.86L83.5691 56.88L83.6091 56.9L83.6191 56.85L83.9891 54.82V54.43L83.5391 56.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3893 57.03L83.9493 53.99L83.9093 54.01L83.8693 54.04L83.3193 56.99L83.3893 57.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0991 57.12L83.1591 57.16L83.7191 54.12L83.6391 54.17L83.0991 57.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8794 57.25L82.9394 57.29L83.4994 54.25L83.4194 54.3L82.8794 57.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6592 57.38L82.7192 57.42L83.2792 54.38L83.1992 54.42L82.6592 57.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4292 57.5L82.4992 57.55L83.0592 54.51L82.9892 54.54L82.9792 54.55L82.4292 57.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2095 57.63L82.2695 57.67L82.8395 54.63L82.7595 54.68L82.2095 57.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9893 57.76L82.0493 57.8L82.6093 54.76L82.5793 54.78L82.5293 54.81L81.9893 57.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7695 57.89L81.8295 57.93L82.3895 54.89L82.3095 54.94L81.7695 57.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5391 58.02L81.6091 58.06L82.1691 55.02L82.0891 55.06L81.5391 58.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3193 58.15L81.3893 58.19L81.9493 55.15L81.8693 55.19L81.3193 58.15Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 57.33V57.71L81.7293 55.27L81.6493 55.32L81.2793 57.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 56.25V56.64L81.4993 55.4L81.4593 55.43L81.4193 55.45L81.2793 56.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 57.96V58.03L81.5193 58.06H81.5293L81.6293 58L81.2793 57.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 57.6699V57.7399L81.9293 57.8199L82.0393 57.7599L81.2793 57.6699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 57.39V57.46L82.3393 57.58L82.4393 57.53L81.2793 57.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 57.1099V57.1799L82.7493 57.3499L82.8493 57.2899L81.2793 57.1099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 56.8199V56.8999L83.1593 57.1099L83.2593 57.0499L81.2793 56.8199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 56.54V56.61L83.5693 56.88L83.6693 56.82L81.2793 56.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 56.2599V56.33L83.8993 56.63L83.8793 56.56L81.2793 56.2599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 55.97V56.05L83.9893 56.36V56.29L81.2793 55.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2793 55.6899V55.7599L83.9893 56.0799V55.9999L81.2793 55.6899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3491 55.4899L83.9891 55.7899V55.7199L81.4591 55.4299L81.3491 55.4899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7593 55.2499L83.9893 55.5099V55.4399L81.8693 55.1899H81.8593L81.7593 55.2499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1694 55.02L83.9894 55.23V55.16L82.2694 54.96L82.1694 55.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5791 54.78L83.9891 54.94V54.87L82.6791 54.72L82.5791 54.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9893 54.5399L83.9893 54.6599V54.5899L83.0893 54.4899L82.9893 54.5399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3994 54.3099L83.9894 54.3799V54.3099L83.4994 54.2499L83.3994 54.3099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8091 54.07L83.9891 54.0999V54.02L83.9091 54.0099L83.8091 54.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8693 67.59L33.8193 69.35V72.41L33.9493 72.49L36.8693 70.64L36.9993 67.67L36.8693 67.59V67.59ZM36.7193 70.56L33.9593 72.15V69.43L36.7193 67.84V70.56Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9992 67.67L33.9492 69.43V72.49L36.9992 70.73V67.67ZM36.8492 70.64L34.0892 72.23V69.51L36.8492 67.92V70.64Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8193 69.35L33.9393 69.43L36.9993 67.67L36.8693 67.59L33.8193 69.35Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5796 70.72L36.5996 70.73L36.6496 70.76L36.6596 70.7L36.8096 69.88V69.5L36.5796 70.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3594 70.85L36.3794 70.86L36.4194 70.89L36.4394 70.83L36.8094 68.81V68.41L36.3594 70.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1992 71.02L36.7592 67.98L36.7192 68L36.6792 68.02L36.1392 70.98L36.1992 71.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9194 71.11L35.9794 71.14L36.5394 68.11L36.4594 68.15L35.9194 71.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6895 71.23L35.7595 71.27L36.3195 68.24L36.2395 68.28L35.6895 71.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4692 71.36L35.5392 71.4L36.0992 68.36L36.0192 68.41L35.4692 71.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2495 71.49L35.3095 71.53L35.8795 68.49L35.8095 68.53H35.7995L35.7895 68.54L35.2495 71.49Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0293 71.62L35.0893 71.66L35.6493 68.62L35.5693 68.66L35.0293 71.62Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8096 71.75L34.8696 71.79L35.4296 68.75L35.3996 68.77H35.3896L35.3496 68.79L34.8096 71.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5796 71.87L34.6496 71.91L35.2096 68.87L35.1296 68.92L34.5796 71.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3594 72L34.4294 72.04L34.9894 69L34.9094 69.05L34.3594 72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1392 72.13L34.1992 72.17L34.7592 69.13L34.6792 69.18L34.1392 72.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 71.31V71.7L34.5394 69.26L34.4594 69.31L34.0894 71.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 70.24V70.62L34.3194 69.39L34.2694 69.42L34.2394 69.43L34.0894 70.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 71.94V72.01L34.3394 72.04L34.4394 71.98L34.0894 71.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 71.66V71.73L34.7494 71.8L34.8494 71.75L34.0894 71.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 71.37V71.45L35.1594 71.57L35.2594 71.51L34.0894 71.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 71.09V71.16L35.5694 71.33L35.6694 71.27L34.0894 71.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 70.81V70.88L35.9794 71.1L36.0794 71.04L34.0894 70.81Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 70.53V70.6L36.3794 70.86L36.4794 70.8L34.0894 70.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 70.24V70.31L36.7094 70.62L36.6894 70.54L34.0894 70.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 69.96V70.03L36.8094 70.34V70.27L34.0894 69.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0894 69.68V69.75L36.8094 70.06V69.99L34.0894 69.68Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1694 69.47L36.8094 69.78V69.71L34.2694 69.42L34.1694 69.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5796 69.24L36.8096 69.5V69.42L34.6796 69.18L34.5796 69.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9893 69L36.8093 69.21V69.14L35.0893 68.94L34.9893 69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3994 68.77L36.8094 68.93V68.86L35.4994 68.71L35.3994 68.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8096 68.53L36.8096 68.65V68.57L35.9096 68.47L35.8096 68.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2095 68.29L36.8095 68.36V68.29L36.3195 68.24L36.2095 68.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6191 68.06L36.8091 68.08V68.01L36.7191 68L36.6191 68.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1096 69.18L31.0596 70.94V74L31.1896 74.08L34.1096 72.23L34.2396 69.26L34.1096 69.18V69.18ZM33.9596 72.15L31.1996 73.74V71.02L33.9596 69.43V72.15Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2395 69.26L31.1895 71.02V74.08L34.2395 72.32V69.26ZM34.0895 72.23L31.3295 73.82V71.1L34.0895 69.51V72.23Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0596 70.94L31.1896 71.03L34.2396 69.26L34.1096 69.18L31.0596 70.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8198 72.31L33.8498 72.33L33.8898 72.35L33.8998 72.29L34.0498 71.47V71.09L33.8198 72.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5996 72.44L33.6196 72.45L33.6696 72.48L33.6796 72.42L34.0496 70.4V70.01L33.5996 72.44Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4394 72.61L33.9994 69.57L33.9694 69.59L33.9194 69.62L33.3794 72.57L33.4394 72.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1597 72.7L33.2197 72.74L33.7797 69.7L33.6997 69.74L33.1597 72.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9395 72.83L32.9995 72.87L33.5595 69.83L33.4795 69.87L32.9395 72.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7095 72.95L32.7795 72.99L33.3395 69.95L33.2595 70L32.7095 72.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4897 73.08L32.5597 73.12L33.1197 70.08L33.0497 70.12L33.0397 70.13L32.4897 73.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2695 73.21L32.3295 73.25L32.8895 70.21L32.8095 70.26L32.2695 73.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0498 73.34L32.1098 73.38L32.6698 70.34L32.6398 70.36L32.5898 70.38L32.0498 73.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8296 73.47L31.8896 73.51L32.4496 70.47L32.3696 70.51L31.8296 73.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5996 73.6L31.6696 73.63L32.2296 70.59L32.1496 70.64L31.5996 73.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3794 73.72L31.4394 73.76L32.0094 70.72L31.9294 70.77L31.3794 73.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 72.9V73.29L31.7796 70.85L31.6996 70.9L31.3296 72.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 71.83V72.22L31.5596 70.98L31.5096 71.01L31.4796 71.03L31.3296 71.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 73.53V73.6L31.5796 73.63L31.6796 73.57L31.3296 73.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 73.25V73.32L31.9896 73.4L32.0896 73.34L31.3296 73.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 72.97V73.04L32.3996 73.16L32.4996 73.1L31.3296 72.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 72.68V72.75L32.8096 72.93L32.9096 72.87L31.3296 72.68Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 72.4V72.47L33.2196 72.69L33.3196 72.63L31.3296 72.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 72.12V72.19L33.6296 72.45L33.7196 72.39L31.3296 72.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 71.84V71.91L33.9496 72.21L33.9396 72.14L31.3296 71.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 71.55V71.62L34.0496 71.94V71.87L31.3296 71.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3296 71.27V71.34L34.0496 71.65V71.58L31.3296 71.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4097 71.0699L34.0497 71.3699V71.2999L31.5097 71.0099L31.4097 71.0699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8198 70.83L34.0498 71.09V71.02L31.9198 70.77L31.8198 70.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2295 70.59L34.0495 70.8V70.73L32.3295 70.54L32.2295 70.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6396 70.36L34.0496 70.52V70.45L32.7397 70.3L32.6396 70.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0498 70.1199L34.0498 70.2399V70.1699L33.1498 70.0599L33.0498 70.1199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4595 69.89L34.0495 69.95V69.88L33.5595 69.83L33.4595 69.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8594 69.65L34.0494 69.67V69.6L33.9694 69.59L33.8594 69.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3493 70.77L28.2993 72.53V75.59L28.4293 75.67L31.3493 73.82L31.4793 70.85L31.3493 70.77V70.77ZM31.1993 73.74L28.4393 75.33V72.61L31.1993 71.02V73.74Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4792 70.85L28.4292 72.61V75.67L31.4792 73.91V70.85ZM31.3292 73.82L28.5692 75.41V72.69L31.3292 71.1V73.82V73.82Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2993 72.53L28.4293 72.62L31.4793 70.85L31.3493 70.77L28.2993 72.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0693 73.91L31.0893 73.92L31.1293 73.95L31.1393 73.89L31.2893 73.07V72.68L31.0693 73.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8389 74.03L30.8689 74.05L30.9089 74.07L30.9189 74.01L31.2889 71.99V71.6L30.8389 74.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6891 74.2L31.2491 71.16L31.2091 71.18L31.1691 71.21L30.6191 74.16L30.6891 74.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3989 74.29L30.4589 74.33L31.0189 71.29L30.9389 71.34L30.3989 74.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1792 74.42L30.2392 74.46L30.7992 71.42L30.7192 71.46L30.1792 74.42Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.959 74.55L30.019 74.59L30.579 71.55L30.499 71.59L29.959 74.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.729 74.67L29.799 74.71L30.359 71.67L30.289 71.71L30.279 71.72L29.729 74.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5093 74.8L29.5693 74.84L30.1393 71.8L30.0593 71.85L29.5093 74.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2891 74.93L29.3491 74.97L29.9091 71.93L29.8791 71.95L29.8291 71.98L29.2891 74.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0693 75.0599L29.1293 75.0999L29.6893 72.0599L29.6093 72.1099L29.0693 75.0599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8389 75.1899L28.9089 75.2299L29.4689 72.1899L29.3889 72.2299L28.8389 75.1899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6191 75.3199L28.6891 75.3599L29.2491 72.3199L29.1691 72.3599L28.6191 75.3199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 74.4999V74.8799L29.0291 72.4399L28.9491 72.4899L28.5791 74.4999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 73.4199V73.8099L28.7991 72.5699L28.7591 72.5999L28.7191 72.6199L28.5791 73.4199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 75.1299V75.1999L28.8191 75.2199H28.8291L28.9291 75.1699L28.5791 75.1299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 74.8399V74.9099L29.2291 74.9899L29.3291 74.9299L28.5791 74.8399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 74.5599V74.6299L29.6391 74.7499L29.7391 74.6899L28.5791 74.5599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 74.2799V74.3499L30.0491 74.5199L30.1491 74.4599L28.5791 74.2799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 73.9899V74.0599L30.4591 74.2799L30.5591 74.2199L28.5791 73.9899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 73.71V73.78L30.8691 74.05L30.9691 73.99L28.5791 73.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 73.4299V73.4999L31.1991 73.7999L31.1791 73.7299L28.5791 73.4299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 73.14V73.21L31.2891 73.53V73.46L28.5791 73.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 72.8599V72.9299L31.2891 73.2499V73.1699L28.5791 72.8599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6489 72.6599L31.2889 72.9599V72.8899L28.7589 72.5999L28.6489 72.6599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0591 72.4199L31.2891 72.6799V72.6099L29.1591 72.3599L29.0591 72.4199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4692 72.1899L31.2892 72.3999V72.3299L29.5692 72.1299L29.4692 72.1899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8789 71.95L31.2889 72.11V72.04L29.9789 71.89L29.8789 71.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2891 71.7099L31.2891 71.8299V71.7599L30.3891 71.6599L30.2891 71.7099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6992 71.4799L31.2892 71.5499V71.4799L30.7992 71.4199L30.6992 71.4799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1089 71.2399L31.2889 71.2599V71.1899L31.2089 71.1799L31.1089 71.2399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5896 72.36L25.5396 74.12V77.18L25.6695 77.26L28.5896 75.41L28.7195 72.44L28.5896 72.36V72.36ZM28.4396 75.33L25.6796 76.92V74.2L28.4396 72.61V75.33V75.33Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7194 72.45L25.6694 74.21V77.27L28.7194 75.51V72.45ZM28.5694 75.42L25.8094 77.01V74.29L28.5694 72.7V75.42Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5396 74.13L25.6695 74.21L28.7195 72.45L28.5896 72.36L25.5396 74.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3096 75.5L28.3296 75.51L28.3696 75.54L28.3796 75.48L28.5296 74.66V74.27L28.3096 75.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0791 75.63L28.1091 75.64L28.1491 75.67L28.1591 75.61L28.5291 73.58V73.19L28.0791 75.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9294 75.79L28.4894 72.75L28.4494 72.78L28.4094 72.8L27.8594 75.75L27.9294 75.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6392 75.88L27.6992 75.92L28.2692 72.88L28.1892 72.93L27.6392 75.88Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4194 76.01L27.4794 76.05L28.0394 73.01L27.9594 73.06L27.4194 76.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1992 76.14L27.2592 76.18L27.8192 73.14L27.7392 73.19L27.1992 76.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9692 76.27L27.0392 76.31L27.5992 73.27L27.5292 73.31H27.5192L26.9692 76.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7495 76.39L26.8195 76.44L27.3795 73.4L27.2995 73.44L26.7495 76.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5293 76.52L26.5893 76.56L27.1593 73.52L27.1193 73.54L27.0793 73.57L26.5293 76.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3096 76.65L26.3696 76.69L26.9296 73.65L26.8496 73.7L26.3096 76.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0894 76.78L26.1494 76.82L26.7094 73.78L26.6294 73.83L26.0894 76.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8594 76.91L25.9294 76.95L26.4894 73.91L26.4094 73.96L25.8594 76.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 76.09V76.48L26.2693 74.04L26.1893 74.08L25.8193 76.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 75.01V75.4L26.0493 74.17L25.9993 74.19L25.9693 74.21L25.8193 75.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 76.72V76.79L26.0693 76.82L26.1693 76.76L25.8193 76.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 76.43V76.51L26.4793 76.58L26.5793 76.52L25.8193 76.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 76.15V76.22L26.8793 76.34L26.9793 76.29L25.8193 76.15Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 75.87V75.94L27.2893 76.11L27.3893 76.05L25.8193 75.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 75.59V75.66L27.6993 75.87L27.7993 75.81L25.8193 75.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 75.3V75.37L28.1093 75.64L28.2093 75.58L25.8193 75.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 75.02V75.09L28.4393 75.39L28.4193 75.32L25.8193 75.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 74.74V74.81L28.5293 75.12V75.05L25.8193 74.74Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8193 74.45V74.52L28.5293 74.84V74.77L25.8193 74.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8994 74.2499L28.5294 74.5599V74.4799L25.9994 74.1899L25.8994 74.2499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 74.01L28.5293 74.27V74.2L26.4093 73.96L26.2993 74.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7095 73.78L28.5295 73.99V73.92L26.8195 73.72L26.7095 73.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1191 73.54L28.5291 73.71V73.63L27.2291 73.48H27.2191L27.1191 73.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5293 73.31L28.5293 73.42V73.35L27.6293 73.25L27.5293 73.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9395 73.0699L28.5295 73.1399V73.0699L28.0395 73.0099L27.9395 73.0699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3491 72.84L28.5291 72.86V72.79L28.4491 72.78L28.3491 72.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7397 67.67L36.8697 70.64L39.7897 72.49L39.9197 72.41V69.35L36.8697 67.59L36.7397 67.67V67.67ZM37.0197 67.84L39.7797 69.43V72.15L37.0197 70.56V67.84Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7397 70.73L39.7897 72.49V69.43L36.7397 67.67V70.73ZM36.8897 67.93L39.6497 69.52V72.24L36.8897 70.65V67.93Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9197 69.35L39.7897 69.43L36.7397 67.67L36.8697 67.59L39.9197 69.35Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1497 70.72L37.1297 70.73L37.0897 70.76L37.0797 70.7L36.9297 69.88V69.5L37.1497 70.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3797 70.85L37.3497 70.86L37.3097 70.89L37.2997 70.83L36.9297 68.81V68.41L37.3797 70.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5297 71.02L36.9697 67.98L37.0097 68L37.0497 68.02L37.5997 70.98L37.5297 71.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8195 71.11L37.7595 71.14L37.1895 68.11L37.2695 68.15L37.8195 71.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0399 71.23L37.9799 71.27L37.4199 68.24L37.4999 68.28L38.0399 71.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2596 71.36L38.1996 71.4L37.6396 68.36L37.7197 68.41L38.2596 71.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4899 71.49L38.4199 71.53L37.8599 68.49L37.9299 68.53L37.9399 68.54L38.4899 71.49Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7096 71.62L38.6396 71.66L38.0796 68.62L38.1596 68.66L38.7096 71.62Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9296 71.75L38.8696 71.79L38.3096 68.75L38.3396 68.77L38.3896 68.79L38.9296 71.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1498 71.87L39.0898 71.91L38.5298 68.87L38.6098 68.92L39.1498 71.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3795 72L39.3095 72.04L38.7495 69L38.8295 69.05L39.3795 72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5997 72.13L39.5297 72.17L38.9697 69.13L39.0497 69.18L39.5997 72.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6395 71.31V71.7L39.1895 69.26L39.2695 69.31L39.6395 71.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6399 70.24V70.62L39.4199 69.39L39.4599 69.42L39.4999 69.43L39.6399 70.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6395 71.94V72.01L39.3895 72.04L39.2896 71.98L39.6395 71.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6399 71.66V71.73L38.9899 71.8L38.8799 71.75L39.6399 71.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6395 71.37V71.45L38.5795 71.57L38.4795 71.51L39.6395 71.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6398 71.09V71.16L38.1698 71.33L38.0698 71.27L39.6398 71.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6397 70.81V70.88L37.7597 71.1L37.6597 71.04L39.6397 70.81Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6395 70.53V70.6L37.3495 70.86L37.2495 70.8L39.6395 70.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6395 70.24V70.31L37.0195 70.62L37.0395 70.54L39.6395 70.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6397 69.96V70.03L36.9297 70.34V70.27L39.6397 69.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6397 69.68V69.75L36.9297 70.06V69.99L39.6397 69.68Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5697 69.47L36.9297 69.78V69.71L39.4597 69.42L39.5697 69.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1597 69.24L36.9297 69.5V69.42L39.0497 69.18H39.0597L39.1597 69.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7497 69L36.9297 69.21V69.14L38.6397 68.94H38.6497L38.7497 69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3397 68.77L36.9297 68.93V68.86L38.2397 68.71L38.3397 68.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9297 68.53L36.9297 68.65V68.57L37.8297 68.47L37.9297 68.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5197 68.29L36.9297 68.36V68.29L37.4197 68.24L37.5197 68.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1097 68.06L36.9297 68.08V68.01L37.0097 68L37.1097 68.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4995 69.26L39.6295 72.23L42.5495 74.08L42.6795 74V70.94L39.6295 69.18L39.4995 69.26V69.26ZM39.7795 69.43L42.5395 71.02V73.74L39.7795 72.15V69.43Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4995 72.32L42.5495 74.08V71.02L39.4995 69.26V72.32ZM39.6495 69.52L42.4095 71.11V73.83L39.6495 72.24V69.52Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6795 70.94L42.5495 71.03L39.4995 69.26L39.6295 69.18L42.6795 70.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9095 72.31L39.8895 72.33L39.8495 72.35L39.8395 72.29L39.6895 71.47V71.09L39.9095 72.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1295 72.44L40.1095 72.45L40.0695 72.48L40.0595 72.42L39.6895 70.4V70.01L40.1295 72.44Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2895 72.61L39.7295 69.57L39.7695 69.59L39.8095 69.62L40.3595 72.57L40.2895 72.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5792 72.7L40.5092 72.74L39.9492 69.7L40.0292 69.74L40.5792 72.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7997 72.83L40.7397 72.87L40.1797 69.83L40.2597 69.87L40.7997 72.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0194 72.95L40.9594 72.99L40.3994 69.95L40.4794 70L41.0194 72.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2496 73.08L41.1796 73.12L40.6196 70.08L40.6896 70.12L40.6996 70.13L41.2496 73.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4694 73.21L41.3994 73.25L40.8394 70.21L40.9194 70.26L41.4694 73.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6896 73.34L41.6196 73.38L41.0596 70.34L41.0996 70.36L41.1396 70.38L41.6896 73.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9095 73.47L41.8495 73.51L41.2896 70.47L41.3695 70.51L41.9095 73.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1293 73.6L42.0693 73.63L41.5093 70.59L41.5893 70.64L42.1293 73.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3595 73.72L42.2895 73.76L41.7295 70.72L41.8095 70.77L42.3595 73.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3992 72.9V73.29L41.9492 70.85L42.0292 70.9L42.3992 72.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3994 71.83V72.22L42.1694 70.98L42.2194 71.01L42.2494 71.03L42.3994 71.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3993 73.53V73.6L42.1493 73.63L42.0493 73.57L42.3993 73.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3997 73.25V73.32L41.7397 73.4L41.6396 73.34L42.3997 73.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3995 72.97V73.04L41.3295 73.16L41.2295 73.1L42.3995 72.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3996 72.68V72.75L40.9296 72.93L40.8296 72.87L42.3996 72.68Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3994 72.4V72.47L40.5194 72.69L40.4194 72.63L42.3994 72.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3993 72.12V72.19L40.1093 72.45L40.0093 72.39L42.3993 72.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3993 71.84V71.91L39.7793 72.21L39.7993 72.14L42.3993 71.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3995 71.55V71.62L39.6895 71.94V71.87L42.3995 71.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3995 71.27V71.34L39.6895 71.65V71.58L42.3995 71.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3195 71.0699L39.6895 71.3699V71.2999L42.2195 71.0099L42.3195 71.0699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9095 70.83L39.6895 71.09V71.02L41.8095 70.77L41.9095 70.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5095 70.59L39.6895 70.8V70.73L41.3995 70.54L41.5095 70.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0995 70.36L39.6895 70.52V70.45L40.9895 70.3H40.9995L41.0995 70.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6895 70.1199L39.6895 70.2399V70.1699L40.5895 70.0599L40.6895 70.1199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2795 69.89L39.6895 69.95V69.88L40.1795 69.83L40.2795 69.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8695 69.65L39.6895 69.67V69.6L39.7695 69.59L39.8695 69.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2598 70.85L42.3898 73.82L45.3098 75.67L45.4398 75.59V72.53L42.3898 70.77L42.2598 70.85V70.85ZM42.5398 71.02L45.2998 72.61V75.33L42.5398 73.74V71.02Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2598 73.91L45.3098 75.67V72.61L42.2598 70.85V73.91ZM42.4098 71.11L45.1698 72.7V75.42L42.4098 73.83V71.11Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4398 72.53L45.3098 72.62L42.2598 70.85L42.3798 70.77L45.4398 72.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6699 73.91L42.6499 73.92L42.6099 73.95L42.5999 73.89L42.4399 73.07V72.68L42.6699 73.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8899 74.03L42.8699 74.05L42.8299 74.07L42.8199 74.01L42.4399 71.99V71.6L42.8899 74.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0497 74.2L42.4897 71.16L42.5297 71.18L42.5697 71.21L43.1097 74.16L43.0497 74.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.34 74.29L43.27 74.33L42.71 71.29L42.79 71.34L43.34 74.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5602 74.42L43.4902 74.46L42.9302 71.42H42.9402L43.0102 71.46L43.5602 74.42Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7802 74.55L43.7202 74.59L43.1602 71.55L43.2402 71.59L43.7802 74.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9999 74.67L43.9399 74.71L43.3799 71.67L43.4499 71.71L43.4599 71.72L43.9999 74.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2301 74.8L44.1601 74.84L43.6001 71.8L43.6801 71.85L44.2301 74.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4498 74.93L44.3798 74.97L43.8198 71.93L43.8598 71.95L43.8998 71.98L44.4498 74.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.67 75.0599L44.6 75.0999L44.04 72.0599L44.12 72.1099L44.67 75.0599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.89 75.1899L44.83 75.2299L44.27 72.1899L44.35 72.2299L44.89 75.1899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1097 75.3199L45.0497 75.3599L44.4897 72.3199L44.5697 72.3599L45.1097 75.3199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.16 74.4999V74.8799L44.71 72.4399L44.79 72.4899L45.16 74.4999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1602 73.4199V73.8099L44.9302 72.5699L44.9802 72.5999L45.0102 72.6199L45.1602 73.4199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1601 75.1299V75.1999L44.9101 75.2199L44.8101 75.1699L45.1601 75.1299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1599 74.8399V74.9099L44.4999 74.9899L44.3999 74.9299L45.1599 74.8399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1597 74.5599V74.6299L44.0897 74.7499L43.9897 74.6899L45.1597 74.5599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1601 74.2799V74.3499L43.6901 74.5199L43.5801 74.4599L45.1601 74.2799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1602 73.9899V74.0599L43.2802 74.2799L43.1802 74.2199L45.1602 73.9899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.16 73.71V73.78L42.87 74.05L42.77 73.99L45.16 73.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.16 73.4299V73.4999L42.54 73.7999L42.56 73.7299L45.16 73.4299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1599 73.14V73.21L42.4399 73.53V73.46L45.1599 73.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1599 72.8599V72.9299L42.4399 73.2499V73.1699L45.1599 72.8599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0799 72.6599L42.4399 72.9599V72.8899L44.9799 72.5999L45.0799 72.6599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6699 72.4199L42.4399 72.6799V72.6099L44.5699 72.3599L44.6699 72.4199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2599 72.1899L42.4399 72.3999V72.3299L44.1599 72.1299L44.2599 72.1899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8599 71.95L42.4399 72.11V72.04L43.7499 71.89L43.8599 71.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4499 71.7099L42.4399 71.8299V71.7599L43.3399 71.6599L43.4499 71.7099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0399 71.4799L42.4399 71.5499V71.4799L42.9299 71.4199H42.9399L43.0399 71.4799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6299 71.2399L42.4399 71.2599V71.1899L42.5299 71.1799L42.6299 71.2399Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0098 72.45L45.1398 75.42L48.0598 77.27L48.1898 77.19V74.13L45.1398 72.37L45.0098 72.45V72.45ZM45.2898 72.62L48.0498 74.21V76.93L45.2898 75.34V72.62Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0098 75.51L48.0598 77.27V74.21L45.0098 72.45V75.51ZM45.1598 72.71L47.9198 74.3V77.02L45.1598 75.43V72.71Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1898 74.13L48.0698 74.21L45.0098 72.45L45.1398 72.36L48.1898 74.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4297 75.5L45.4097 75.51L45.3597 75.54L45.3497 75.48L45.1997 74.66V74.27L45.4297 75.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6497 75.63L45.6297 75.64L45.5897 75.67L45.5797 75.61L45.1997 73.58V73.19L45.6497 75.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8095 75.79L45.2495 72.75L45.2895 72.78L45.3295 72.8L45.8695 75.75L45.8095 75.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0897 75.88L46.0297 75.92L45.4697 72.88L45.5497 72.93L46.0897 75.88Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3199 76.01L46.2499 76.05L45.6899 73.01L45.7699 73.06L46.3199 76.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5397 76.14L46.4697 76.18L45.9097 73.14L45.9897 73.19L46.5397 76.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7596 76.27L46.6996 76.31L46.1396 73.27L46.1996 73.31H46.2096H46.2197L46.7596 76.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9799 76.39L46.9199 76.44L46.3599 73.4L46.4399 73.44L46.9799 76.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2096 76.52L47.1396 76.56L46.5796 73.52L46.6096 73.54H46.6196L46.6596 73.57L47.2096 76.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4298 76.65L47.3598 76.69L46.7998 73.65L46.8798 73.7L47.4298 76.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6495 76.78L47.5795 76.82L47.0195 73.78L47.0995 73.83L47.6495 76.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8695 76.91L47.8095 76.95L47.2495 73.91L47.3295 73.96L47.8695 76.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9197 76.09V76.48L47.4697 74.04L47.5497 74.08L47.9197 76.09Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9199 75.01V75.4L47.6899 74.17L47.7399 74.19L47.7699 74.21L47.9199 75.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9198 76.72V76.79L47.6698 76.82L47.5698 76.76L47.9198 76.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9197 76.43V76.51L47.2597 76.58L47.1597 76.52L47.9197 76.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9195 76.15V76.22L46.8495 76.34L46.7495 76.29L47.9195 76.15Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9198 75.87V75.94L46.4398 76.11L46.3398 76.05L47.9198 75.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9197 75.59V75.66L46.0297 75.87L45.9297 75.81L47.9197 75.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9198 75.3V75.37L45.6298 75.64L45.5298 75.58L47.9198 75.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9198 75.02V75.09L45.2998 75.39L45.3198 75.32L47.9198 75.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9197 74.74V74.81L45.1997 75.12V75.05L47.9197 74.74Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9197 74.45V74.52L45.1997 74.84V74.77L47.9197 74.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8397 74.2499L45.1997 74.5599V74.4799L47.7397 74.1899L47.8397 74.2499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4297 74.01L45.1997 74.27V74.2L47.3297 73.96L47.4297 74.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0197 73.78L45.1997 73.99V73.92L46.9197 73.72L47.0197 73.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6097 73.54L45.1997 73.71V73.63L46.5097 73.48L46.6097 73.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1997 73.31L45.1997 73.42V73.35L46.0997 73.25L46.1997 73.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7997 73.0699L45.1997 73.1399V73.0699L45.6897 73.0099L45.7997 73.0699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3897 72.84L45.1997 72.86V72.79L45.2897 72.78L45.3897 72.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5396 40.83L25.9796 40.57V39.18L25.5296 39.43L25.0996 40.57L25.5396 40.83Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5396 40.83L25.0996 40.57V39.18L25.5296 39.43L25.5396 40.83Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9796 39.18L25.5396 38.93L25.0996 39.18L25.5296 39.43L25.9796 39.18Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.18 40.04L24.62 39.78V38.39L24.17 38.65L23.73 39.78L24.18 40.04Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.18 40.04L23.73 39.78V38.39L24.17 38.65L24.18 40.04Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.62 38.39L24.18 38.14L23.73 38.39L24.17 38.65L24.62 38.39Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2896 39.65L28.7396 39.4V38.01L28.2896 38.26L27.8496 39.4L28.2896 39.65Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2896 39.65L27.8496 39.4V38.01L28.2896 38.26V39.65Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7396 38.01L28.2896 37.75L27.8496 38.01L28.2896 38.26L28.7396 38.01Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9297 38.86L27.3697 38.61V37.22L26.9297 37.47L26.4897 38.61L26.9297 38.86Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9297 38.86L26.4897 38.61V37.22L26.9297 37.47V38.86Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3697 37.22L26.9297 36.96L26.4897 37.22L26.9297 37.47L27.3697 37.22Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6296 29.82L28.9396 29.63V28.65L28.6196 28.83L28.3096 29.63L28.6296 29.82Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6296 29.82L28.3096 29.63V28.65L28.6196 28.83L28.6296 29.82Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9396 28.65L28.6296 28.47L28.3096 28.65L28.6196 28.83L28.9396 28.65Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6598 29.25L27.9698 29.07V28.09L27.6498 28.27L27.3398 29.07L27.6598 29.25Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6598 29.25L27.3398 29.07V28.09L27.6498 28.27L27.6598 29.25Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9698 28.09L27.6598 27.9L27.3398 28.09L27.6498 28.27L27.9698 28.09Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.59 28.9799L30.9 28.7999V27.8099L30.58 27.9899L30.27 28.7999L30.59 28.9799Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.59 28.9799L30.27 28.7999V27.8099L30.58 27.9899L30.59 28.9799Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9 27.8099L30.59 27.6299L30.27 27.8099L30.58 27.9899L30.9 27.8099Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6198 28.4199L29.9298 28.2399V27.2499L29.6098 27.4299L29.2998 28.2399L29.6198 28.4199Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6198 28.4199L29.2998 28.2399V27.2499L29.6098 27.4299L29.6198 28.4199Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9298 27.2499L29.6198 27.0699L29.2998 27.2499L29.6098 27.4299L29.9298 27.2499Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5996 79.5299L31.3296 76.4299V75.6299L42.4996 75.3199V76.1199L36.5996 79.5299Z",
    fill: "#6C7178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5996 78.73L31.3296 75.63L37.1396 72.28L42.4996 75.32L36.5996 78.73Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7397 74.57L36.2397 74.29V42.53L36.7397 42.81L37.2297 74.29L36.7397 74.57Z",
    fill: "#95A2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7397 74.57L37.2297 74.29V42.53L36.7397 42.81V74.57Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2397 42.53L36.7297 42.25L37.2297 42.53L36.7397 42.81L36.2397 42.53Z",
    fill: "#8491B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8599 43.9L34.3499 43.61L34.5299 43.73L34.0499 44.01L33.8599 43.9Z",
    fill: "#8491B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 52.2199L36.4296 52.0699L34.0996 53.4099L34.3596 53.8499L36.6796 52.5099V52.2199Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 52.22V52.51L34.36 53.85L34.23 53.63L36.68 52.22Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 56.77L36.4296 56.62L34.0996 57.96L34.3596 58.4L36.6796 57.06V56.77Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5797 53.62L34.4297 53.56L36.2397 56.71L36.4597 56.89L34.8697 53.62H34.5797Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5796 53.62L34.7396 53.4L36.6796 56.77L36.4596 56.89L34.5796 53.62Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3396 62.65L34.1196 62.52L35.2396 59.64L36.2996 56.97L36.4996 57.07L35.3396 60.12C35.3396 60.12 35.3396 60.1 35.3296 60.09L34.3396 62.63V62.65Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 61.32L36.4296 61.17L34.0996 62.51L34.3596 62.95L36.6796 61.61V61.32Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 57.06L36.3596 57.24L34.3096 62.46L34.5296 62.59L36.6796 57.06Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 56.77V57.06L34.36 58.4L34.23 58.18L36.68 56.77Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 65.87L36.4296 65.72L34.0996 67.06L34.3596 67.5L36.6796 66.16V65.87Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3396 71.7499L34.1196 71.6199L35.2396 68.7399L36.2996 66.0699L36.4996 66.1699L35.3396 69.2199C35.3396 69.2199 35.3396 69.1999 35.3296 69.1899L34.3396 71.7299V71.7499Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 70.42L36.4296 70.27L34.0996 71.61L34.3596 72.05L36.6796 70.71V70.42Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5197 74L36.2597 73.85L33.9097 75.21L34.3297 75.55L36.5197 74.29V74Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6797 73.91V74.2L34.3297 75.55L34.1997 75.33L36.6797 73.91Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5797 71.82L34.4297 71.77L36.2397 73.85L36.4597 74.03L34.8397 71.82H34.5797Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5796 71.82L34.7396 71.6L36.6796 73.91L36.4596 74.03L34.5796 71.82Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 70.42V70.71L34.36 72.05L34.23 71.83L36.68 70.42Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 66.16L36.3596 66.35L34.3096 71.56L34.5296 71.69L36.6796 66.16Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 65.87V66.16L34.36 67.5L34.23 67.28L36.68 65.87Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5797 62.72L34.4297 62.66L36.2397 65.81L36.4597 65.99L34.8397 62.72H34.5797Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 61.3199V61.6099L34.36 62.9499L34.23 62.7299L36.68 61.3199Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5796 62.72L34.7396 62.5L36.6796 65.87L36.4596 65.99L34.5796 62.72Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 43.13L36.4296 42.98L34.0996 44.32L34.3596 44.76L36.6796 43.42V43.13Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3396 49.01L34.1196 48.88L35.2396 46L36.2996 43.33L36.4996 43.43L35.3396 46.48C35.3396 46.48 35.3396 46.46 35.3296 46.45L34.3396 48.99V49.01Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 47.68L36.4296 47.53L34.0996 48.87L34.3596 49.31L36.6796 47.97V47.68Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 43.42L36.3596 43.61L34.3096 48.82L34.5296 48.95L36.6796 43.42Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 43.1299V43.4199L34.36 44.7599L34.23 44.5399L36.68 43.1299Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5797 49.08L34.4297 49.03L36.2397 52.17L36.4597 52.36L34.8397 49.08H34.5797Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 47.68V47.97L34.36 49.31L34.23 49.09L36.68 47.68Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5796 49.08L34.7396 48.86L36.6796 52.23L36.4596 52.36L34.5796 49.08Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6796 42.83L36.4296 42.68L34.0996 44.02L34.3596 44.46L36.6796 43.12V42.83Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 42.83V43.12L34.36 44.46L34.23 44.24L36.68 42.83Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0298 75.91L33.8398 75.8L33.8598 43.9L34.0498 44.01L34.5298 75.63L34.0298 75.91Z",
    fill: "#929FBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0298 75.91L34.5298 75.63L34.5398 43.72L34.0498 44.01L34.0298 75.91Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0496 74.7L37.5496 74.41V42.66L37.0496 42.94L36.5596 74.41L37.0496 74.7Z",
    fill: "#99A6C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0496 74.7L36.5596 74.41V42.66L37.0496 42.94V74.7Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5496 42.66L37.0496 42.37L36.5596 42.66L37.0496 42.94L37.5496 42.66Z",
    fill: "#7E8BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9295 44.03L39.4395 43.74L39.2495 43.86L39.7395 44.14L39.9295 44.03Z",
    fill: "#7E8BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 52.34L37.3599 52.2L39.6899 53.5299L39.4299 53.9799L37.1099 52.6399V52.34Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 52.34V52.64L39.4299 53.98L39.5599 53.76L37.1099 52.34Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 56.89L37.3599 56.75L39.6899 58.09L39.4299 58.53L37.1099 57.19V56.89Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2096 53.7399L39.3596 53.6899L37.5496 56.8399L37.3296 57.0199L38.9196 53.7399H39.2096Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2099 53.74L39.0499 53.53L37.1099 56.89L37.3299 57.02L39.2099 53.74Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4496 62.77L39.6695 62.64L38.5495 59.76L37.4896 57.09L37.2896 57.19L38.4496 60.24C38.4496 60.24 38.4495 60.22 38.4595 60.21L39.4496 62.75V62.77Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 61.44L37.3599 61.3L39.6899 62.64L39.4299 63.08L37.1099 61.74V61.44Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 57.1899L37.4299 57.3699L39.4799 62.5799L39.2599 62.7099L37.1099 57.1899Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 56.89V57.19L39.4299 58.53L39.5599 58.31L37.1099 56.89Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 65.99L37.3599 65.85L39.6899 67.19L39.4299 67.63L37.1099 66.29V65.99Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4496 71.8699L39.6695 71.7399L38.5495 68.8599L37.4896 66.1899L37.2896 66.2899L38.4496 69.3399C38.4496 69.3399 38.4495 69.3199 38.4595 69.3099L39.4496 71.8499V71.8699Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 70.54L37.3599 70.4L39.6899 71.74L39.4299 72.18L37.1099 70.84V70.54Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.27 74.13L37.53 73.98L39.56 75.15L39.46 75.68L37.27 74.42V74.13Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 74.03V74.33L39.4599 75.68L39.5899 75.46L37.1099 74.03Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2096 71.95L39.3596 71.89L37.5496 73.98L37.3296 74.16L38.9496 71.95H39.2096Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2099 71.95L39.0499 71.73L37.1099 74.03L37.3299 74.16L39.2099 71.95Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 70.54V70.84L39.4299 72.18L39.5599 71.96L37.1099 70.54Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 66.29L37.4299 66.47L39.4799 71.69L39.2599 71.81L37.1099 66.29Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 65.99V66.29L39.4299 67.63L39.5599 67.41L37.1099 65.99Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2096 62.85L39.3596 62.79L37.5496 65.94L37.3296 66.12L38.9496 62.85H39.2096Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 61.4399V61.7399L39.4299 63.0799L39.5599 62.8599L37.1099 61.4399Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2099 62.85L39.0499 62.63L37.1099 65.99L37.3299 66.12L39.2099 62.85Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 43.25L37.3599 43.11L39.6899 44.45L39.4299 44.89L37.1099 43.55V43.25Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4496 49.13L39.6695 49L38.5495 46.1199L37.4896 43.45L37.2896 43.5499L38.4496 46.5999C38.4496 46.5999 38.4495 46.58 38.4595 46.57L39.4496 49.11V49.13Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 47.8L37.3599 47.66L39.6899 49L39.4299 49.44L37.1099 48.1V47.8Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 43.55L37.4299 43.73L39.4799 48.95L39.2599 49.07L37.1099 43.55Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 43.25V43.55L39.4299 44.89L39.5599 44.67L37.1099 43.25Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2096 49.21L39.3596 49.15L37.5496 52.3L37.3296 52.48L38.9496 49.21H39.2096Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 47.8V48.1L39.4299 49.44L39.5599 49.22L37.1099 47.8Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2099 49.21L39.0499 48.99L37.1099 52.36L37.3299 52.48L39.2099 49.21Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 42.95L37.3599 42.81L39.6899 44.15L39.4299 44.59L37.1099 43.25V42.95Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1099 42.95V43.25L39.4299 44.59L39.5599 44.3699L37.1099 42.95Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.73 76.04L39.26 75.75L39.25 43.85L39.74 44.14L39.73 76.04Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4897 76.2099L38.9897 75.9299V44.1799L39.4897 44.4599L39.9797 75.9299L39.4897 76.2099Z",
    fill: "#C7D3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4897 76.2099L39.9797 75.9299V44.1799L39.4897 44.4599V76.2099Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9897 44.18L39.4897 43.89L39.9797 44.18L39.4897 44.46L38.9897 44.18Z",
    fill: "#B4C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6099 45.54L37.0999 45.2599L37.2899 45.3699L36.7999 45.65L36.6099 45.54Z",
    fill: "#B4C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 53.86L39.1796 53.71L36.8496 55.05L37.1096 55.49L39.4296 54.15V53.86Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43 53.86V54.15L37.11 55.49L36.98 55.27L39.43 53.86Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 58.41L39.1796 58.2599L36.8496 59.5999L37.1096 60.0499L39.4296 58.7099V58.41Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3297 55.26L37.1797 55.21L38.9897 58.36L39.2097 58.54L37.6197 55.26H37.3297Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3296 55.26L37.4896 55.04L39.4296 58.41L39.2096 58.54L37.3296 55.26Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0896 64.29L36.8696 64.16L37.9896 61.28L39.0496 58.61L39.2496 58.71L38.0896 61.76C38.0896 61.76 38.0896 61.74 38.0796 61.73L37.0896 64.27V64.29Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 62.96L39.1796 62.81L36.8496 64.15L37.1096 64.6L39.4296 63.26V62.96Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 58.71L39.1096 58.89L37.0596 64.1L37.2796 64.23L39.4296 58.71Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43 58.41V58.71L37.11 60.05L36.98 59.82L39.43 58.41Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 67.51L39.1796 67.36L36.8496 68.7L37.1096 69.15L39.4296 67.81V67.51Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0896 73.39L36.8696 73.26L37.9896 70.38L39.0496 67.71L39.2496 67.81L38.0896 70.86C38.0896 70.86 38.0896 70.84 38.0796 70.83L37.0896 73.37V73.39Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 72.06L39.1796 71.92L36.8496 73.26L37.1096 73.7L39.4296 72.36V72.06Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2697 75.64L39.0097 75.5L36.6597 76.85L37.0797 77.2L39.2697 75.94V75.64Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4297 75.55V75.84L37.0797 77.2L36.9497 76.98L39.4297 75.55Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3297 73.46L37.1797 73.41L38.9897 75.5L39.2097 75.68L37.5897 73.46H37.3297Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3296 73.46L37.4896 73.25L39.4296 75.55L39.2096 75.68L37.3296 73.46Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43 72.0599V72.3599L37.11 73.6999L36.98 73.4799L39.43 72.0599Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 67.8099L39.1096 67.9899L37.0596 73.1999L37.2796 73.3299L39.4296 67.8099Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43 67.5099V67.8099L37.11 69.1499L36.98 68.9299L39.43 67.5099Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3297 64.3599L37.1797 64.3099L38.9897 67.4599L39.2097 67.6399L37.5897 64.3599H37.3297Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43 62.96V63.26L37.11 64.6L36.98 64.38L39.43 62.96Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3296 64.36L37.4896 64.14L39.4296 67.51L39.2096 67.64L37.3296 64.36Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 44.7699L39.1796 44.6299L36.8496 45.9699L37.1096 46.4099L39.4296 45.0699V44.7699Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0896 50.65L36.8696 50.52L37.9896 47.64L39.0496 44.97L39.2496 45.07L38.0896 48.12C38.0896 48.12 38.0896 48.1 38.0796 48.09L37.0896 50.63V50.65Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 49.32L39.1796 49.18L36.8496 50.52L37.1096 50.96L39.4296 49.62V49.32Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 45.0699L39.1096 45.2499L37.0596 50.4599L37.2796 50.5899L39.4296 45.0699Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43 44.77V45.07L37.11 46.41L36.98 46.19L39.43 44.77Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3297 50.73L37.1797 50.67L38.9897 53.82L39.2097 54L37.5897 50.73H37.3297Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43 49.3199V49.6199L37.11 50.9599L36.98 50.7399L39.43 49.3199Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3296 50.7299L37.4896 50.5099L39.4296 53.8699L39.2096 54L37.3296 50.7299Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4296 44.4699L39.1796 44.3199L36.8496 45.6599L37.1096 46.1099L39.4296 44.7699V44.4699Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.43 44.47V44.77L37.11 46.11L36.98 45.89L39.43 44.47Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7798 77.55L36.5898 77.45L36.6098 45.54L36.7998 45.65L37.2798 77.27L36.7798 77.55Z",
    fill: "#C3D0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7798 77.55L37.2798 77.27L37.2898 45.37L36.7998 45.65L36.7798 77.55Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1096 76.2099L34.5996 75.9299V44.1799L34.0996 44.4599L33.6196 75.9299L34.1096 76.2099Z",
    fill: "#CAD6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1096 76.2099L33.6196 75.9299V44.1799L34.0996 44.4599L34.1096 76.2099Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5996 44.18L34.1096 43.89L33.6196 44.18L34.0996 44.46L34.5996 44.18Z",
    fill: "#B0BDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9896 45.54L36.4896 45.2599L36.3096 45.3699L36.7996 45.65L36.9896 45.54Z",
    fill: "#B0BDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 53.86L34.4199 53.71L36.7399 55.05L36.4899 55.49L34.1699 54.15V53.86Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 53.86V54.15L36.4899 55.49L36.6199 55.27L34.1699 53.86Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 58.41L34.4199 58.2599L36.7399 59.5999L36.4899 60.0499L34.1699 58.7099V58.41Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2696 55.26L36.4096 55.21L34.6096 58.36L34.3896 58.54L35.9697 55.26H36.2696Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2699 55.26L36.1099 55.04L34.1699 58.41L34.3899 58.54L36.2699 55.26Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5096 64.29L36.7296 64.16L35.6096 61.28L34.5496 58.61L34.3496 58.71L35.5096 61.76C35.5096 61.76 35.5096 61.74 35.5196 61.73L36.5096 64.27V64.29Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 62.96L34.4199 62.81L36.7399 64.15L36.4899 64.6L34.1699 63.26V62.96Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 58.71L34.4799 58.89L36.5299 64.1L36.3099 64.23L34.1699 58.71Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 58.41V58.71L36.4899 60.05L36.6199 59.82L34.1699 58.41Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 67.51L34.4199 67.36L36.7399 68.7L36.4899 69.15L34.1699 67.81V67.51Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5096 73.39L36.7296 73.26L35.6096 70.38L34.5496 67.71L34.3496 67.81L35.5096 70.86C35.5096 70.86 35.5096 70.84 35.5196 70.83L36.5096 73.37V73.39Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 72.06L34.4199 71.92L36.7399 73.26L36.4899 73.7L34.1699 72.36V72.06Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3296 75.64L34.5796 75.5L36.6196 76.67L36.5196 77.2L34.3296 75.94V75.64Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 75.55V75.84L36.5199 77.2L36.6499 76.98L34.1699 75.55Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2696 73.46L36.4096 73.41L34.6096 75.5L34.3896 75.68L36.0096 73.46H36.2696Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2699 73.46L36.1099 73.25L34.1699 75.55L34.3899 75.68L36.2699 73.46Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 72.0599V72.3599L36.4899 73.6999L36.6199 73.4799L34.1699 72.0599Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 67.8099L34.4799 67.9899L36.5299 73.1999L36.3099 73.3299L34.1699 67.8099Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 67.5099V67.8099L36.4899 69.1499L36.6199 68.9299L34.1699 67.5099Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2696 64.3599L36.4096 64.3099L34.6096 67.4599L34.3896 67.6399L36.0096 64.3599H36.2696Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 62.96V63.26L36.4899 64.6L36.6199 64.38L34.1699 62.96Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2699 64.36L36.1099 64.14L34.1699 67.51L34.3899 67.64L36.2699 64.36Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 44.7699L34.4199 44.6299L36.7399 45.9699L36.4899 46.4099L34.1699 45.0699V44.7699Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5096 50.65L36.7296 50.52L35.6096 47.64L34.5496 44.97L34.3496 45.07L35.5096 48.12C35.5096 48.12 35.5096 48.1 35.5196 48.09L36.5096 50.63V50.65Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 49.32L34.4199 49.18L36.7399 50.52L36.4899 50.96L34.1699 49.62V49.32Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 45.0699L34.4799 45.2499L36.5299 50.4599L36.3099 50.5899L34.1699 45.0699Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 44.77V45.07L36.4899 46.41L36.6199 46.19L34.1699 44.77Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2696 50.73L36.4096 50.67L34.6096 53.82L34.3896 54L36.0096 50.73H36.2696Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 49.3199V49.6199L36.4899 50.9599L36.6199 50.7399L34.1699 49.3199Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2699 50.7299L36.1099 50.5099L34.1699 53.8699L34.3899 54L36.2699 50.7299Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 44.4699L34.4199 44.3199L36.7399 45.6599L36.4899 46.1099L34.1699 44.7699V44.4699Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1699 44.47V44.77L36.4899 46.11L36.6199 45.89L34.1699 44.47Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7798 77.55L36.3198 77.27L36.2998 45.37L36.7998 45.65L36.7798 77.55Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5298 52.43L45.9798 52.17V50.79L45.5298 51.04L45.0898 52.17L45.5298 52.43Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5298 52.43L45.0898 52.17V50.79L45.5298 51.04V52.43Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.17 51.64L44.61 51.38V50L44.17 50.25L43.73 51.38L44.17 51.64Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.17 51.64L43.73 51.38V50L44.17 50.25V51.64Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2896 51.26L48.7296 51V49.61L48.2796 49.86L47.8496 51L48.2896 51.26Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2896 51.26L47.8496 51V49.61L48.2796 49.86L48.2896 51.26Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.93 50.4699L47.37 50.2099V48.8199L46.92 49.0799L46.48 50.2099L46.93 50.4699Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.93 50.4699L46.48 50.2099V48.8199L46.92 49.0799L46.93 50.4699Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6499 36.32L26.2499 35.97L49.2099 49.22L48.5999 49.57L25.7199 37.06L25.6499 36.32Z",
    fill: "#E6FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6499 36.3199V37.0099L48.5999 50.2599V49.5699L25.6499 36.3199Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2101 49.22V49.91L48.6001 50.26V49.57L49.2101 49.22Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.61 49.49L48.93 49.31L46.71 44.42L46.48 44.55L48.3 49.31L48.61 49.49Z",
    fill: "#EDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8203 46.73L44.1403 46.55V43.28H43.5103V46.55L43.8203 46.73Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8203 46.73L43.5103 46.55V43.28H43.8303L43.8203 46.73Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8501 43.44L44.1201 43.28L46.4801 46.22L47.9701 48.11L48.4101 49.12L45.8901 46.03C45.8901 46.03 45.9101 46.03 45.9301 46.03L43.8501 43.44Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.32 49.33V48.88L44.06 43.53L43.79 43.68L48.32 49.33Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.35 46.46L43.66 46.28V43.01H43.04V46.28L43.35 46.46Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.54 43.68L38.85 43.51V40.23H38.23V43.51L38.54 43.68Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7603 37.62L34.0303 37.46L36.3903 40.4L38.5603 43.15L38.3303 43.3L35.8103 40.21C35.8103 40.21 35.8303 40.21 35.8503 40.21L33.7703 37.62H33.7603Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7299 40.91L34.0399 40.73V37.46H33.4199V40.73L33.7299 40.91Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9199 37.9L29.2299 37.72V35.11L28.6099 35.34V37.72L28.9199 37.9Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1999 35.87C27.3099 35.87 27.4199 35.85 27.4999 35.79L28.9299 37.61L28.6999 37.76L27.1899 35.9C27.1899 35.9 27.1899 35.88 27.1899 35.87H27.1999Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2001 35.87C27.2001 35.87 27.2701 35.87 27.3001 35.87L28.6101 37.51V37.96L27.0601 36.03C27.1301 36 27.1801 35.94 27.2001 35.87V35.87Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9199 38.13L28.6099 37.95V35.34H28.9199V38.13Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2301 36.59L25.8501 36.36L29.5401 34.76V35.45L26.2301 36.59Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5299 37.83L33.6799 37.71L29.2499 37.7L28.9199 37.82L33.3699 38.1L33.5299 37.83Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5299 37.83L33.6699 38.13H28.9199V37.82L33.5299 37.83Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7299 40.91L33.4199 40.73V37.46H33.7299V40.91Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2302 43.51V43.06L33.9702 37.71L33.7002 37.86L38.2302 43.51Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.54 43.68L38.23 43.51V40.23H38.54V43.68Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.15 43.38L43.3 43.26L38.87 43.25L38.54 43.37L42.99 43.66L43.15 43.38Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.35 46.46L43.04 46.28V43.01H43.35V46.46Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.15 43.38L43.28 43.68H38.54V43.37L43.15 43.38Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.61 49.49L48.3 49.31L46.48 45.25V44.55L48.61 49.49Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.54 34.76L29.77 34.62L46.71 44.42L46.48 44.55L29.54 35.45V34.76Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.54 34.76V35.45L46.48 45.25V44.55L29.54 34.76Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7701 34.62L29.5401 34.76L25.8501 36.36L26.2301 36.15L29.7701 34.62Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.27 46.41L46.48 45.11V44.69L44.27 46V46.41Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.27 46L46.48 44.69L46.18 44.52L43.96 45.82L44.27 46Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.52 44.2299L42.74 42.93V42.5099L40.52 43.82V44.2299Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.52 43.82L42.74 42.51L42.43 42.34L40.21 43.64L40.52 43.82Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9399 42.74L40.1599 41.44V41.02L37.9399 42.33V42.74Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9399 42.33L40.1599 41.02L39.8499 40.84L37.6299 42.15L37.9399 42.33Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3599 41.25L37.5799 39.94V39.53L35.3599 40.83V41.25Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3598 40.83L37.5798 39.53L37.2698 39.35L35.0498 40.66L35.3598 40.83Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7798 39.76L34.9998 38.45V38.03L32.7798 39.34V39.76Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.78 39.34L35 38.03L34.69 37.86L32.48 39.16L32.78 39.34Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.21 38.26L32.42 36.96V36.54L30.21 37.85V38.26Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2099 37.85L32.4199 36.54L32.1199 36.36L29.8999 37.67L30.2099 37.85Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6299 36.77L29.8499 35.46V35.05L27.6299 36.35V36.77Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6298 36.35L29.8498 35.05L29.5398 34.87L27.3198 36.18L27.6298 36.35Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2798 37.69L23.8798 37.34L46.8298 50.59L46.2298 50.95L23.2798 38.39V37.69Z",
    fill: "#E6FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2798 37.6899V38.3899L46.2298 51.6299V50.9499L23.2798 37.6899Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.83 50.59V51.28L46.23 51.63V50.95L46.83 50.59Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2396 50.87L46.5496 50.69L44.3396 45.79L44.0996 45.92L45.9296 50.69L46.2396 50.87Z",
    fill: "#EDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4496 48.1L41.7596 47.92V44.65H41.1396V47.92L41.4496 48.1Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4496 48.1L41.1396 47.92V44.65H41.4496V48.1Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4697 44.81L41.7397 44.65L44.0997 47.59L45.5897 49.48L46.0297 50.49L43.5097 47.4C43.5097 47.4 43.5297 47.4 43.5497 47.4L41.4697 44.81Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9499 50.7V50.25L41.6899 44.9L41.4199 45.06L45.9499 50.7Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9697 47.83L41.2797 47.65V44.38H40.6597V47.65L40.9697 47.83Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1596 45.06L36.4696 44.88L36.4796 41.61H35.8496V44.88L36.1596 45.06Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3799 38.99L31.6499 38.83L34.0099 41.77L36.1799 44.52L35.9499 44.67L33.4299 41.58C33.4299 41.58 33.4499 41.58 33.4699 41.58L31.3899 38.99H31.3799Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3496 42.28L31.6695 42.1V38.83H31.0396V42.1L31.3496 42.28Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5495 39.27L26.8595 39.09V36.48L26.2395 36.71L26.2295 39.09L26.5495 39.27Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8196 37.24C24.9296 37.24 25.0396 37.22 25.1196 37.16L26.5496 38.98L26.3196 39.13L24.8096 37.27C24.8096 37.27 24.8096 37.25 24.8096 37.24H24.8196Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8197 37.24C24.8197 37.24 24.8897 37.24 24.9197 37.24L26.2297 38.88V39.33L24.6797 37.4C24.7497 37.37 24.7997 37.31 24.8197 37.24V37.24Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5495 39.5L26.2295 39.32L26.2395 36.71H26.5495V39.5Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8597 37.96L23.4697 37.73L27.1697 36.13V36.83L23.8597 37.96Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1598 39.2L31.2998 39.08L26.8698 39.07L26.5498 39.19L30.9998 39.48L31.1598 39.2Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1598 39.2L31.2898 39.5H26.5498V39.19L31.1598 39.2Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3496 42.28L31.0396 42.1V38.83H31.3596L31.3496 42.28Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8498 44.88V44.43L31.5898 39.08L31.3198 39.24L35.8498 44.88Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1596 45.06L35.8496 44.88V41.61H36.1596V45.06Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7697 44.76L40.9197 44.63L36.4897 44.62L36.1597 44.75L40.6197 45.03L40.7697 44.76Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9697 47.83L40.6597 47.65V44.38H40.9697V47.83Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7697 44.76L40.9097 45.06H36.1597V44.75L40.7697 44.76Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2396 50.87L45.9296 50.69L44.1096 46.62L44.0996 45.92L46.2396 50.87Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1699 36.13L27.3999 36L44.3399 45.79L44.0999 45.92L27.1699 36.83V36.13Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1699 36.13V36.83L44.1099 46.62L44.0999 45.92L27.1699 36.13Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3997 36L27.1697 36.13L23.4697 37.73L23.8597 37.52L27.3997 36Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7501 39.16L36.3501 38.93V30.96L36.7501 31.19L37.1501 38.93L36.7501 39.16Z",
    fill: "#95A2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 39.16L37.15 38.93L37.14 30.96L36.75 31.19V39.16Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3501 30.96L36.7501 30.74L37.1401 30.96L36.7501 31.19L36.3501 30.96Z",
    fill: "#8491B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4302 32.07L34.8302 31.84L34.9702 31.93L34.5802 32.16L34.4302 32.07Z",
    fill: "#8491B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7001 31.35L36.5001 31.23L34.6201 32.31L34.8301 32.67L36.7001 31.59V31.35Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8099 36.09L34.6299 35.99L35.5299 33.67L36.3899 31.52L36.5499 31.6L35.6099 34.06V34.04L34.7999 36.09H34.8099Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7001 35.02L36.5001 34.9L34.6201 35.98L34.8301 36.33L36.7001 35.25V35.02Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7 31.59L36.45 31.73L34.79 35.94L34.97 36.04L36.7 31.59Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7 31.35V31.59L34.83 32.67L34.73 32.49L36.7 31.35Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7001 38.69L36.5001 38.57L34.6201 39.65L34.8301 40L36.7001 38.92V38.69Z",
    fill: "#A3AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7 38.69V38.92L34.83 40L34.73 39.83L36.7 38.69Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0101 36.15L34.8901 36.1L36.3501 38.64L36.5301 38.79L35.2201 36.15H35.0101Z",
    fill: "#7683A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7 35.02V35.25L34.83 36.33L34.73 36.16L36.7 35.02Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0098 36.15L35.1398 35.97L36.6998 38.69L36.5298 38.79L35.0098 36.15Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5702 40.24L34.4102 40.15L34.4302 32.07L34.5802 32.16L34.9702 40.01L34.5702 40.24Z",
    fill: "#929FBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5698 40.24L34.9698 40.01L34.9798 31.92L34.5798 32.16L34.5698 40.24Z",
    fill: "#94A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9999 39.2599L37.3999 39.0299V31.0699L36.9999 31.2899L36.6099 39.0299L36.9999 39.2599Z",
    fill: "#99A6C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9999 39.2599L36.6099 39.0299V31.0699L36.9999 31.2899V39.2599Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 31.07L37.0099 30.84L36.6099 31.07L36.9999 31.29L37.3999 31.07Z",
    fill: "#7E8BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3198 32.1699L38.9298 31.9399L38.7798 32.0299L39.1698 32.2599L39.3198 32.1699Z",
    fill: "#7E8BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 31.45L37.2498 31.33L39.1298 32.41L38.9198 32.77L37.0498 31.69V31.45Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9402 36.19L39.1202 36.09L38.2202 33.77L37.3602 31.62L37.2002 31.7L38.1402 34.16C38.1402 34.16 38.1402 34.15 38.1502 34.14L38.9502 36.19H38.9402Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 35.12L37.2498 35L39.1298 36.08L38.9198 36.44L37.0498 35.36V35.12Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 31.69L37.2998 31.83L38.9598 36.04L38.7798 36.14L37.0498 31.69Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 31.45V31.69L38.9198 32.77L39.0198 32.59L37.0498 31.45Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 38.79L37.2498 38.67L39.1298 39.75L38.9198 40.11L37.0498 39.02V38.79Z",
    fill: "#A7B3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 38.79V39.02L38.9198 40.11L39.0198 39.93L37.0498 38.79Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.74 36.25L38.86 36.21L37.41 38.74L37.23 38.89L38.54 36.25H38.74Z",
    fill: "#667291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 35.12V35.36L38.9198 36.44L39.0198 36.26L37.0498 35.12Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7398 36.25L38.6198 36.07L37.0498 38.79L37.2298 38.89L38.7398 36.25Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.16 40.34L38.79 40.11L38.77 32.02L39.17 32.26L39.16 40.34Z",
    fill: "#93A0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9703 40.49L38.5703 40.26V32.29L38.9703 32.52L39.3603 40.26L38.9703 40.49Z",
    fill: "#C7D3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9702 40.49L39.3602 40.26V32.29L38.9702 32.52V40.49Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5703 32.29L38.9603 32.06L39.3603 32.29L38.9703 32.52L38.5703 32.29Z",
    fill: "#B4C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6401 33.39L37.0401 33.16L37.1901 33.25L36.8001 33.48L36.6401 33.39Z",
    fill: "#B4C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9198 32.67L38.7098 32.56L36.8398 33.64L37.0498 33.99L38.9198 32.91V32.67Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0301 37.41L36.8501 37.31L37.7501 34.99L38.6101 32.84L38.7701 32.92L37.8301 35.38V35.36L37.0201 37.41H37.0301Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9198 36.34L38.7098 36.22L36.8398 37.3L37.0498 37.66L38.9198 36.58V36.34Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9198 32.91L38.6598 33.06L37.0098 37.26L37.1898 37.37L38.9198 32.91Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9199 32.67V32.91L37.0499 33.99L36.9399 33.81L38.9199 32.67Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9198 40.01L38.7098 39.89L36.8398 40.97L37.0498 41.33L38.9198 40.25V40.01Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9199 40.01V40.25L37.0499 41.33L36.9399 41.15L38.9199 40.01Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2299 37.47L37.1099 37.43L38.5599 39.97L38.7399 40.11L37.4299 37.47H37.2299Z",
    fill: "#B3C0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9199 36.34V36.58L37.0499 37.66L36.9399 37.48L38.9199 36.34Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.23 37.47L37.35 37.3L38.92 40.01L38.74 40.11L37.23 37.47Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7799 41.57L36.6299 41.48L36.6399 33.39L36.7999 33.48L37.1799 41.34L36.7799 41.57Z",
    fill: "#C3D0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7798 41.57L37.1798 41.34L37.1998 33.25L36.7998 33.48L36.7798 41.57Z",
    fill: "#C1CEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.63 40.49L35.03 40.26V32.29L34.63 32.52L34.23 40.26L34.63 40.49Z",
    fill: "#CAD6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.63 40.49L34.23 40.26V32.29L34.63 32.52V40.49Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.03 32.29L34.63 32.06L34.23 32.29L34.63 32.52L35.03 32.29Z",
    fill: "#B0BDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9499 33.39L36.5499 33.16L36.3999 33.25L36.7999 33.48L36.9499 33.39Z",
    fill: "#B0BDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802 32.67L34.8802 32.56L36.7502 33.64L36.5502 33.99L34.6802 32.91V32.67Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5598 37.41L36.7398 37.31L35.8398 34.99L34.9798 32.84L34.8198 32.92L35.7598 35.38C35.7598 35.38 35.7598 35.37 35.7698 35.36L36.5698 37.41H36.5598Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802 36.34L34.8802 36.22L36.7502 37.3L36.5502 37.66L34.6802 36.58V36.34Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802 32.91L34.9302 33.06L36.5802 37.26L36.4102 37.37L34.6802 32.91Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802 32.67V32.91L36.5502 33.99L36.6502 33.81L34.6802 32.67Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802 40.01L34.8802 39.89L36.7502 40.97L36.5502 41.33L34.6802 40.25V40.01Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802 40.01V40.25L36.5502 41.33L36.6502 41.15L34.6802 40.01Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3701 37.47L36.4901 37.43L35.0301 39.97L34.8501 40.11L36.1601 37.47H36.3701Z",
    fill: "#A2AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802 36.34V36.58L36.5502 37.66L36.6502 37.48L34.6802 36.34Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3702 37.47L36.2402 37.3L34.6802 40.01L34.8502 40.11L36.3702 37.47Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7799 41.57L36.4099 41.34L36.3999 33.25L36.7999 33.48L36.7799 41.57Z",
    fill: "#C5D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8498 38.07L43.1598 37.89V36.9L42.8398 37.08L42.5298 37.89L42.8498 38.07Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8498 38.07L42.5298 37.89V36.9L42.8398 37.08L42.8498 38.07Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1598 36.9L42.8498 36.72L42.5298 36.9L42.8398 37.08L43.1598 36.9Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8796 37.51L42.1896 37.32V36.34L41.8696 36.52L41.5596 37.32L41.8796 37.51Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8796 37.51L41.5596 37.32V36.34L41.8696 36.52L41.8796 37.51Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1896 36.34L41.8796 36.16L41.5596 36.34L41.8696 36.52L42.1896 36.34Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8097 37.2299L45.1197 37.0499V36.0699L44.7997 36.2399L44.4897 37.0499L44.8097 37.2299Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8097 37.2299L44.4897 37.0499V36.0699L44.7997 36.2399L44.8097 37.2299Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1197 36.0699L44.8097 35.8799L44.4897 36.0699L44.7997 36.2399L45.1197 36.0699Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.84 36.6699L44.15 36.4899V35.4999L43.83 35.6799L43.52 36.4899L43.84 36.6699Z",
    fill: "#C7BCA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.84 36.6699L43.52 36.4899V35.4999L43.83 35.6799L43.84 36.6699Z",
    fill: "#968162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15 35.4999L43.84 35.3199L43.52 35.4999L43.83 35.6799L44.15 35.4999Z",
    fill: "#8F7B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.46 26.46L28.9 26.21L45.77 35.95L45.33 36.21L28.51 27.01L28.46 26.46Z",
    fill: "#E6FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.46 26.46V26.97L45.33 36.71V36.21L28.46 26.46Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7701 35.95V36.4599L45.3301 36.7099V36.2099L45.7701 35.95Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.34 36.15L45.57 36.02L43.94 32.42L43.77 32.52L45.11 36.02L45.34 36.15Z",
    fill: "#EDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8203 34.12L42.0403 33.98L42.0503 31.58H41.5903V33.98L41.8203 34.12Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8203 34.12L41.5903 33.98V31.58H41.8203V34.12Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8301 31.7L42.0301 31.59L43.7701 33.75L44.8701 35.14L45.2001 35.88L43.3501 33.61C43.3501 33.61 43.3701 33.61 43.3801 33.61L41.8501 31.7H41.8301Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.12 36.0299V35.6999L41.99 31.7599L41.79 31.8799L45.12 36.0299Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4702 33.9199L41.6902 33.7899L41.7002 31.3799H41.2402V33.7899L41.4702 33.9199Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9302 31.88L38.1602 31.75V29.34H37.7002V31.75L37.9302 31.88Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 27.42L34.6102 27.31L36.3502 29.47L37.9402 31.49L37.7702 31.6L35.9202 29.33C35.9202 29.33 35.9402 29.33 35.9502 29.33L34.4202 27.42H34.4102Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3999 29.84L34.6199 29.71V27.3H34.1699V29.71L34.3999 29.84Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8599 27.63L31.0899 27.5V25.58L30.6299 25.75V27.5L30.8599 27.63Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5901 26.1299C29.6701 26.1299 29.7501 26.1099 29.8101 26.0699L30.8601 27.4099L30.6901 27.5199L29.5801 26.1599V26.1399L29.5901 26.1299Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.59 26.1299C29.59 26.1299 29.64 26.1299 29.66 26.1299L30.62 27.3399V27.6699L29.48 26.2499C29.48 26.2499 29.57 26.1899 29.58 26.1399L29.59 26.1299Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8599 27.8L30.6299 27.66V25.75H30.8599V27.8Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8801 26.6599L28.6001 26.4899L31.3201 25.3199V25.8299L28.8801 26.6599Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2499 27.58L34.3599 27.49L31.0999 27.48L30.8599 27.57L34.1299 27.78L34.2499 27.58Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2499 27.5799L34.3499 27.7999H30.8599V27.5699L34.2499 27.5799Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3999 29.84L34.1699 29.71V27.3H34.3999V29.84Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7001 31.75V31.42L34.5701 27.49L34.3701 27.6L37.7001 31.75Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9302 31.88L37.7002 31.75V29.34H37.9302V31.88Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3202 31.66L41.4302 31.57L38.1702 31.56L37.9302 31.65L41.2002 31.86L41.3202 31.66Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4702 33.9199L41.2402 33.7899V31.3799H41.4702V33.9199Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3202 31.66L41.4202 31.88H37.9302V31.65L41.3202 31.66Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.34 36.15L45.11 36.02L43.77 33.03V32.52L45.34 36.15Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3203 25.32L31.4803 25.22L43.9403 32.42L43.7703 32.52L31.3203 25.83V25.32Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3203 25.3199V25.8299L43.7703 33.0299V32.5199L31.3203 25.3199Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4801 25.22L31.3201 25.32L28.6001 26.49L28.8801 26.34L31.4801 25.22Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1401 33.89L43.7701 32.93V32.62L42.1401 33.58V33.89Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1402 33.58L43.7702 32.62L43.5402 32.49L41.9102 33.45L42.1402 33.58Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3901 32.28L41.0201 31.32V31.02L39.3901 31.98V32.28Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3902 31.98L41.0202 31.02L40.7902 30.89L39.1602 31.85L39.3902 31.98Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4902 31.19L39.1202 30.23V29.92L37.4902 30.88V31.19Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4903 30.88L39.1203 29.92L38.8903 29.79L37.2603 30.75L37.4903 30.88Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6001 30.0899L37.2301 29.1299V28.8199L35.6001 29.7799V30.0899Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6001 29.7799L37.2301 28.8199L37.0001 28.6899L35.3701 29.6499L35.6001 29.7799Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7002 28.99L35.3302 28.03V27.72L33.7002 28.68V28.99Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7002 28.68L35.3302 27.72L35.1002 27.59L33.4702 28.55L33.7002 28.68Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8003 27.8899L33.4403 26.9299V26.6299L31.8003 27.5899V27.8899Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8001 27.5899L33.4401 26.6299L33.2101 26.4999L31.5801 27.4599L31.8001 27.5899Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9102 26.79L31.5402 25.83V25.53L29.9102 26.49V26.79Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9102 26.49L31.5402 25.53L31.3102 25.4L29.6802 26.36L29.9102 26.49Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.71 27.47L27.15 27.22L44.03 36.95L43.58 37.22L26.71 27.98V27.47Z",
    fill: "#E6FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.71 27.47V27.98L43.58 37.72V37.22L26.71 27.47Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0301 36.95V37.47L43.5801 37.72V37.22L44.0301 36.95Z",
    fill: "#B2C3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.59 37.16L43.82 37.03L42.19 33.43L42.02 33.52L43.36 37.03L43.59 37.16Z",
    fill: "#EDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0703 35.12L40.3003 34.99V32.59H39.8403V34.99L40.0703 35.12Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0703 35.12L39.8403 34.99V32.59H40.0703V35.12Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0903 32.71L40.2903 32.6L42.0303 34.76L43.1303 36.15L43.4603 36.89L41.6103 34.62C41.6103 34.62 41.6303 34.62 41.6403 34.62L40.1103 32.71H40.0903Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3803 37.03V36.71L40.2403 32.77L40.0503 32.89L43.3803 37.03Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7202 34.93L39.9502 34.8V32.39H39.4902V34.8L39.7202 34.93Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.18 32.89L36.41 32.76V30.35H35.96V32.76L36.18 32.89Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6699 28.43L32.8699 28.32L34.6099 30.48L36.1999 32.5L36.0299 32.61L34.1799 30.34C34.1799 30.34 34.1999 30.34 34.2099 30.34L32.6799 28.43H32.6699Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6499 30.85L32.8799 30.71V28.31H32.4199V30.71L32.6499 30.85Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1099 28.64L29.3399 28.5V26.58L28.8899 26.75L28.8799 28.5L29.1099 28.64Z",
    fill: "#CAD7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8503 27.14C27.9303 27.14 28.0103 27.12 28.0703 27.08L29.1203 28.42L28.9503 28.53L27.8403 27.17C27.8403 27.17 27.8403 27.16 27.8403 27.15L27.8503 27.14Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8502 27.14C27.8502 27.14 27.9002 27.14 27.9202 27.14L28.8802 28.35V28.68L27.7402 27.26C27.7402 27.26 27.8302 27.2 27.8402 27.15L27.8502 27.14Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1099 28.8L28.8799 28.67L28.8899 26.75H29.1099V28.8Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1401 27.67L26.8501 27.5L29.5701 26.32V26.84L27.1401 27.67Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 28.58L32.6099 28.49H29.3499L29.1099 28.58L32.3899 28.78L32.4999 28.58Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 28.58L32.5999 28.8H29.1099V28.58H32.4999Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6499 30.85L32.4199 30.71V28.31H32.6499V30.85Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9599 32.76L35.9499 32.43L32.8199 28.49L32.6299 28.61L35.9599 32.76Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.18 32.89L35.96 32.76V30.35H36.18V32.89Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5702 32.67L39.6802 32.58L36.4202 32.57L36.1802 32.66L39.4602 32.87L39.5702 32.67Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7202 34.93L39.4902 34.8V32.39H39.7202V34.93Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5702 32.67L39.6702 32.89H36.1802V32.66L39.5702 32.67Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.59 37.16L43.36 37.03L42.02 34.04V33.52L43.59 37.16Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5703 26.32L29.7403 26.23L42.1903 33.43L42.0203 33.52L29.5703 26.84V26.32Z",
    fill: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5703 26.32V26.84L42.0203 34.04V33.52L29.5703 26.32Z",
    fill: "#C2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7401 26.23L29.5701 26.32L26.8501 27.5L27.1401 27.34L29.7401 26.23Z",
    fill: "#A5B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5996 78.7299V79.5299L42.4996 76.1199V75.3199L36.5996 78.7299Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5396 74.13L25.6695 77.1L28.5896 78.95L28.7195 78.87V75.81L25.6695 74.05L25.5396 74.13V74.13ZM25.8195 74.3L28.5795 75.89V78.61L25.8195 77.02V74.3Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5396 77.18L28.5896 78.94V75.88L25.5396 74.12V77.18ZM25.6896 74.38L28.4496 75.97V78.69L25.6896 77.1V74.38Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7195 75.8L28.5896 75.89L25.5396 74.13L25.6695 74.04L28.7195 75.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9595 77.18L25.9295 77.19L25.8895 77.22L25.8795 77.16L25.7295 76.34V75.95L25.9595 77.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1795 77.3L26.1595 77.32L26.1095 77.34L26.0995 77.29L25.7295 75.26V74.87L26.1795 77.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3393 77.47L25.7793 74.43L25.8093 74.45L25.8593 74.48L26.3993 77.43L26.3393 77.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6195 77.56L26.5595 77.6L25.9995 74.56L26.0795 74.61L26.6195 77.56Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8397 77.69L26.7797 77.73L26.2197 74.69L26.2997 74.74L26.8397 77.69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0695 77.82L26.9995 77.86L26.4395 74.82L26.5195 74.86L27.0695 77.82Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2897 77.94L27.2197 77.99L26.6597 74.95L26.7297 74.98L26.7397 74.99L27.2897 77.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5096 78.07L27.4496 78.11L26.8896 75.07L26.9696 75.12L27.5096 78.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7294 78.2L27.6694 78.24L27.1094 75.2L27.1394 75.22L27.1894 75.25L27.7294 78.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9496 78.33L27.8896 78.37L27.3296 75.33L27.4096 75.38L27.9496 78.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1793 78.46L28.1093 78.5L27.5493 75.46L27.6293 75.5L28.1793 78.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3995 78.59L28.3395 78.63L27.7695 75.59L27.8495 75.63L28.3995 78.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4495 77.77V78.15L27.9995 75.71L28.0795 75.76L28.4495 77.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4497 76.69V77.08L28.2197 75.84L28.2697 75.87L28.2997 75.89L28.4497 76.69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4496 78.4V78.47L28.1996 78.5L28.0996 78.44L28.4496 78.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4495 78.11V78.18L27.7895 78.26L27.6895 78.2L28.4495 78.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4493 77.83V77.9L27.3793 78.02L27.2793 77.97L28.4493 77.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4496 77.5499V77.6199L26.9696 77.7899L26.8696 77.7299L28.4496 77.5499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4495 77.2599V77.3399L26.5595 77.5499L26.4595 77.4899L28.4495 77.2599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4493 76.98V77.05L26.1493 77.32L26.0493 77.26L28.4493 76.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4496 76.7V76.77L25.8296 77.07L25.8396 77L28.4496 76.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4495 76.41V76.49L25.7295 76.8V76.73L28.4495 76.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4495 76.1299V76.1999L25.7295 76.5199V76.4399L28.4495 76.1299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3695 75.9299L25.7295 76.2299V76.1599L28.2695 75.8699L28.3695 75.9299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9595 75.6899L25.7295 75.9499V75.8799L27.8595 75.6299L27.9595 75.6899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5495 75.46L25.7295 75.67V75.6L27.4495 75.4L27.5495 75.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1395 75.22L25.7295 75.38V75.31L27.0395 75.16L27.1395 75.22Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7295 74.9799L25.7295 75.0999V75.0299L26.6295 74.9299L26.7295 74.9799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3195 74.7499L25.7295 74.8199V74.7499L26.2195 74.6899L26.3195 74.7499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9195 74.51L25.7295 74.54V74.46L25.8095 74.45L25.9195 74.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2993 75.72L28.4293 78.69L31.3493 80.54L31.4793 80.46V77.4L28.4293 75.64L28.2993 75.72V75.72ZM28.5793 75.89L31.3393 77.48V80.2L28.5793 78.61V75.89V75.89Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2993 78.78L31.3493 80.54V77.48L28.2993 75.72V78.78ZM28.4493 75.98L31.2093 77.57V80.29L28.4493 78.7V75.98V75.98Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4793 77.4L31.3493 77.48L28.2993 75.72L28.4293 75.63L31.4793 77.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7093 78.77L28.6893 78.78L28.6493 78.81L28.6393 78.75L28.4893 77.93V77.54L28.7093 78.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9393 78.9L28.9093 78.91L28.8693 78.94L28.8593 78.88L28.4893 76.86V76.46L28.9393 78.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0893 79.07V79.06L28.5293 76.03L28.5693 76.05L28.6093 76.07L29.1593 79.02L29.0893 79.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3793 79.15L29.3193 79.19L28.7593 76.15L28.8393 76.2L29.3793 79.15Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5995 79.28L29.5395 79.32L28.9795 76.28L29.0595 76.33L29.5995 79.28Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8192 79.41L29.7592 79.45L29.1992 76.41L29.2792 76.46L29.8192 79.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0494 79.54L29.9794 79.58L29.4194 76.54L29.4894 76.58H29.4994L30.0494 79.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2692 79.67L30.2092 79.71L29.6392 76.67L29.7192 76.71L30.2692 79.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4891 79.79L30.4291 79.83L29.8691 76.79L29.8991 76.81L29.9491 76.84L30.4891 79.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7094 79.92L30.6494 79.96L30.0894 76.92L30.1694 76.97L30.7094 79.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9391 80.05L30.8691 80.09L30.3091 77.05L30.3891 77.1L30.9391 80.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1593 80.1801L31.0893 80.2201L30.5293 77.1801L30.6093 77.2301L31.1593 80.1801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.199 79.3601V79.7501L30.749 77.3101L30.829 77.3501L31.199 79.3601Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1995 78.2801V78.6701L30.9795 77.4401L31.0195 77.4601L31.0595 77.4801L31.1995 78.2801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1991 79.99V80.06L30.9591 80.09H30.9491L30.8491 80.03L31.1991 79.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1992 79.71V79.78L30.5492 79.85L30.4492 79.79L31.1992 79.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1991 79.42V79.49L30.1391 79.62L30.0391 79.56L31.1991 79.42Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1994 79.14V79.21L29.7294 79.38L29.6294 79.32L31.1994 79.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1992 78.86V78.93L29.3192 79.14L29.2192 79.09L31.1992 78.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1991 78.57V78.64L28.9091 78.91L28.8091 78.85L31.1991 78.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1991 78.29V78.36L28.5791 78.66L28.5991 78.59L31.1991 78.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1993 78.01V78.08L28.4893 78.39V78.32L31.1993 78.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1993 77.72V77.8L28.4893 78.11V78.04L31.1993 77.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1293 77.52L28.4893 77.83V77.75L31.0193 77.46L31.1293 77.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7193 77.28L28.4893 77.54V77.47L30.6193 77.23L30.7193 77.28Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3093 77.05L28.4893 77.26V77.19L30.2093 76.99L30.3093 77.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8993 76.81L28.4893 76.98V76.91L29.7993 76.76L29.8993 76.81Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4893 76.58L28.4893 76.69V76.62L29.3893 76.52L29.4893 76.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0793 76.34L28.4893 76.41V76.34L28.9793 76.28L29.0793 76.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6693 76.11L28.4893 76.13V76.06L28.5693 76.05L28.6693 76.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0596 77.31L31.1896 80.28L34.1096 82.13L34.2396 82.05V78.99L31.1896 77.23L31.0596 77.31V77.31ZM31.3396 77.48L34.0996 79.07V81.79L31.3396 80.2V77.48V77.48Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0596 80.37L34.1096 82.13V79.07L31.0596 77.31V80.37ZM31.2096 77.57L33.9696 79.16V81.88L31.2096 80.29V77.57V77.57Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2396 78.99L34.1096 79.07L31.0596 77.31L31.1896 77.23L34.2396 78.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4695 80.36L31.4495 80.37L31.4095 80.4L31.3995 80.34L31.2495 79.52V79.14L31.4695 80.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6995 80.49L31.6695 80.5L31.6295 80.53L31.6195 80.47L31.2495 78.45V78.05L31.6995 80.49Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8496 80.66L31.2896 77.62L31.3295 77.64L31.3696 77.66L31.9195 80.62L31.8496 80.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1393 80.75L32.0693 80.79L31.5093 77.75L31.5893 77.79L32.1393 80.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3597 80.87L32.2997 80.91L31.7397 77.88L31.8197 77.92L32.3597 80.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5795 81L32.5195 81.04L31.9595 78L32.0395 78.05L32.5795 81Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8097 81.13L32.7397 81.17L32.1797 78.13L32.2497 78.17L32.2597 78.18L32.8097 81.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0294 81.26L32.9594 81.3L32.3994 78.26L32.4794 78.31L33.0294 81.26Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2496 81.39L33.1896 81.43L32.6196 78.39L32.6596 78.41L32.6996 78.43L33.2496 81.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4696 81.51L33.4096 81.55L32.8496 78.52L32.9296 78.56L33.4696 81.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6893 81.64L33.6293 81.68L33.0693 78.64L33.1493 78.69L33.6893 81.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9195 81.77L33.8495 81.81L33.2896 78.77L33.3695 78.82L33.9195 81.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9593 80.95V81.34L33.5093 78.9L33.5893 78.95L33.9593 80.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9595 79.88V80.26L33.7295 79.03L33.7795 79.06L33.8195 79.07L33.9595 79.88Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9594 81.58V81.65L33.7094 81.68L33.6094 81.62L33.9594 81.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9597 81.2999V81.3699L33.2997 81.4399L33.1997 81.3899L33.9597 81.2999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9593 81.02V81.09L32.8993 81.21L32.7993 81.15L33.9593 81.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9596 80.73V80.8L32.4897 80.97L32.3896 80.91L33.9596 80.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9595 80.45V80.52L32.0795 80.74L31.9795 80.68L33.9595 80.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9593 80.1699V80.2399L31.6693 80.4999L31.5693 80.4399L33.9593 80.1699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9594 79.8799V79.9499L31.3394 80.2599L31.3594 80.1799L33.9594 79.8799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9595 79.6V79.67L31.2495 79.98V79.91L33.9595 79.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9595 79.3199V79.3899L31.2495 79.6999V79.6299L33.9595 79.3199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8795 79.1099L31.2495 79.4199V79.3499L33.7795 79.0599L33.8795 79.1099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4795 78.8799L31.2495 79.1399V79.0599L33.3695 78.8199L33.4795 78.8799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0695 78.64L31.2495 78.85V78.78L32.9595 78.58L33.0695 78.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6595 78.41L31.2495 78.57V78.5L32.5495 78.35H32.5595L32.6595 78.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2495 78.17L31.2495 78.29V78.21L32.1495 78.11L32.2495 78.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8395 77.9299L31.2495 77.9999V77.9299L31.7395 77.8799L31.8395 77.9299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4295 77.7L31.2495 77.72V77.65L31.3295 77.64L31.4295 77.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8193 78.8999L33.9493 81.8699L36.8693 83.7199L36.9993 83.6399V80.5799L33.9493 78.8199L33.8193 78.8999V78.8999ZM34.0993 79.0699L36.8593 80.66V83.3799L34.0993 81.7899V79.0699Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8193 81.96L36.8693 83.72V80.66L33.8193 78.9V81.96ZM33.9693 79.16L36.7293 80.75V83.47L33.9693 81.88V79.16Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9993 80.5799L36.8693 80.6699L33.8193 78.8999L33.9393 78.8199L36.9993 80.5799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2295 81.95L34.2095 81.97L34.1695 81.99L34.1595 81.93L33.9995 81.11V80.73L34.2295 81.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4495 82.08L34.4295 82.09L34.3895 82.12L34.3795 82.06L33.9995 80.04V79.65L34.4495 82.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6093 82.25L34.0493 79.21L34.0893 79.23L34.1293 79.26L34.6793 82.21L34.6093 82.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8995 82.34L34.8295 82.38L34.2695 79.34L34.3495 79.39L34.8995 82.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1197 82.47L35.0497 82.51L34.4897 79.47H34.4997L34.5697 79.51L35.1197 82.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3397 82.59L35.2797 82.63L34.7197 79.59L34.7997 79.64L35.3397 82.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5595 82.72L35.4995 82.76L34.9395 79.72L35.0095 79.76L35.0195 79.77L35.5595 82.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7897 82.85L35.7197 82.89L35.1597 79.85L35.2397 79.9L35.7897 82.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0094 82.98L35.9394 83.02L35.3794 79.98L35.4194 80L35.4594 80.02L36.0094 82.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2296 83.11L36.1696 83.15L35.5996 80.11L35.6896 80.16L36.2296 83.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4496 83.24L36.3896 83.27L35.8296 80.23L35.9096 80.28L36.4496 83.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6693 83.36L36.6093 83.4L36.0493 80.36L36.1293 80.41L36.6693 83.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7195 82.54V82.93L36.2695 80.49L36.3495 80.54L36.7195 82.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7197 81.47V81.86L36.4897 80.62L36.5397 80.65L36.5697 80.67L36.7197 81.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7196 83.17V83.24L36.4696 83.27L36.3696 83.21L36.7196 83.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7195 82.89V82.96L36.0595 83.04L35.9595 82.98L36.7195 82.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7193 82.61V82.68L35.6493 82.8L35.5493 82.74L36.7193 82.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7197 82.3199V82.3999L35.2496 82.5699L35.1396 82.5099L36.7197 82.3199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7197 82.04V82.11L34.8397 82.33L34.7397 82.27L36.7197 82.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7196 81.76V81.83L34.4296 82.09L34.3296 82.03L36.7196 81.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7196 81.48V81.55L34.0996 81.85L34.1196 81.78L36.7196 81.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7195 81.19V81.26L33.9995 81.58V81.51L36.7195 81.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7195 80.91V80.98L33.9995 81.29V81.22L36.7195 80.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6395 80.71L33.9995 81.01V80.94L36.5395 80.65L36.6395 80.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2295 80.47L33.9995 80.73V80.66L36.1295 80.41L36.2295 80.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8295 80.23L33.9995 80.44V80.37L35.7195 80.18L35.8295 80.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4195 80L33.9995 80.16V80.09L35.3095 79.94L35.4195 80Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0095 79.76L33.9995 79.88V79.81L34.8995 79.7H34.9095L35.0095 79.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5995 79.53L33.9995 79.59V79.52L34.4895 79.47H34.4995L34.5995 79.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1895 79.29L33.9995 79.31V79.24L34.0895 79.23L34.1895 79.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0695 74.04L45.0195 75.8V78.86L45.1495 78.94L48.0695 77.09L48.1995 74.12L48.0695 74.04V74.04ZM47.9195 77.01L45.1595 78.6V75.88L47.9195 74.29V77.01Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1896 74.13L45.1396 75.89V78.95L48.1896 77.19V74.13ZM48.0396 77.1L45.2796 78.69V75.97L48.0396 74.38V77.1Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0098 75.8L45.1398 75.89L48.1898 74.13L48.0698 74.04L45.0098 75.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7798 77.18L47.7998 77.19L47.8398 77.22L47.8498 77.16L48.0098 76.34V75.95L47.7798 77.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5596 77.3L47.5796 77.32L47.6196 77.34L47.6296 77.29L48.0096 75.26V74.87L47.5596 77.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3996 77.47L47.9596 74.43L47.9196 74.45L47.8796 74.48L47.3296 77.43L47.3996 77.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1094 77.56L47.1794 77.6L47.7394 74.56L47.6594 74.61L47.1094 77.56Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8896 77.69L46.9596 77.73L47.5196 74.69H47.5096L47.4396 74.74L46.8896 77.69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6694 77.82L46.7294 77.86L47.2894 74.82L47.2094 74.86L46.6694 77.82Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4497 77.94L46.5097 77.99L47.0697 74.95L46.9997 74.98L46.9897 74.99L46.4497 77.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2197 78.07L46.2897 78.11L46.8497 75.07L46.7697 75.12L46.2197 78.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9995 78.2L46.0695 78.24L46.6295 75.2L46.5895 75.22L46.5495 75.25L45.9995 78.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7798 78.33L45.8398 78.37L46.4098 75.33L46.3198 75.38L45.7798 78.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5596 78.46L45.6196 78.5L46.1796 75.46L46.0996 75.5L45.5596 78.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3394 78.59L45.3994 78.63L45.9594 75.59L45.8794 75.63L45.3394 78.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 77.77V78.15L45.7396 75.71L45.6595 75.76L45.2896 77.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 76.69V77.08L45.5196 75.84L45.4696 75.87L45.4395 75.89L45.2896 76.69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 78.4V78.47L45.5396 78.5L45.6395 78.44L45.2896 78.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 78.11V78.18L45.9496 78.26L46.0495 78.2L45.2896 78.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 77.83V77.9L46.3596 78.02L46.4595 77.97L45.2896 77.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 77.5499V77.6199L46.7595 77.7899L46.8695 77.7299L45.2896 77.5499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 77.2599V77.3399L47.1695 77.5499L47.2696 77.4899L45.2896 77.2599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 76.98V77.05L47.5796 77.32L47.6796 77.26L45.2896 76.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 76.7V76.77L47.9095 77.07L47.8895 77L45.2896 76.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 76.41V76.49L48.0095 76.8V76.73L45.2896 76.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2896 76.1299V76.1999L48.0095 76.5199V76.4399L45.2896 76.1299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3696 75.9299L48.0096 76.2299V76.1599L45.4696 75.8699L45.3696 75.9299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7798 75.6899L48.0098 75.9499V75.8799L45.8798 75.6299L45.7798 75.6899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1797 75.46L48.0097 75.67V75.6L46.2897 75.4L46.1797 75.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5894 75.22L48.0094 75.38V75.31L46.6994 75.16L46.5894 75.22Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9995 74.9799L48.0095 75.0999V75.0299L47.1095 74.9299H47.0995L46.9995 74.9799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4097 74.7499L48.0097 74.8199V74.7499L47.5197 74.6899H47.5097L47.4097 74.7499Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8193 74.51L48.0093 74.54V74.46L47.9193 74.45L47.8193 74.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3098 75.63L42.2598 77.39V80.45L42.3898 80.53L45.3098 78.68L45.4398 75.71L45.3098 75.63V75.63ZM45.1598 78.6L42.3998 80.19V77.47L45.1598 75.88V78.6Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4396 75.72L42.3896 77.48V80.54L45.4396 78.78V75.72ZM45.2896 78.69L42.5296 80.28V77.56L45.2896 75.97V78.69Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2598 77.4L42.3798 77.48L45.4398 75.72L45.3098 75.63L42.2598 77.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.02 78.77L45.04 78.78L45.09 78.81L45.1 78.75L45.25 77.93V77.54L45.02 78.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7998 78.9L44.8198 78.91L44.8598 78.94L44.8698 78.88L45.2498 76.86V76.46L44.7998 78.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6396 79.07V79.06L45.1996 76.03L45.1596 76.05L45.1196 76.07L44.5796 79.02L44.6396 79.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3496 79.15L44.4196 79.19L44.9796 76.15L44.8996 76.2L44.3496 79.15Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1299 79.28L44.1999 79.32L44.7599 76.28L44.6799 76.33L44.1299 79.28Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9097 79.41L43.9797 79.45L44.5397 76.41L44.4597 76.46L43.9097 79.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6899 79.54L43.7499 79.58L44.3099 76.54L44.2499 76.58H44.2399H44.2299L43.6899 79.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4697 79.67L43.5297 79.71L44.0897 76.67L44.0097 76.71L43.4697 79.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2397 79.79L43.3097 79.83L43.8697 76.79L43.8397 76.81H43.8297L43.7897 76.84L43.2397 79.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.02 79.92L43.09 79.96L43.65 76.92L43.57 76.97L43.02 79.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7998 80.05L42.8598 80.09L43.4298 77.05L43.3398 77.1L42.7998 80.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5796 80.1801L42.6396 80.2201L43.1996 77.1801L43.1196 77.2301L42.5796 80.1801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 79.3601V79.7501L42.9798 77.3101L42.8998 77.3501L42.5298 79.3601Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 78.2801V78.6701L42.7598 77.4401L42.7098 77.4601L42.6798 77.4801L42.5298 78.2801Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 79.99V80.06L42.7798 80.09L42.8798 80.03L42.5298 79.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 79.71V79.78L43.1898 79.85L43.2898 79.79L42.5298 79.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 79.42V79.49L43.5998 79.62L43.6998 79.56L42.5298 79.42Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 79.14V79.21L44.0098 79.38L44.1098 79.32L42.5298 79.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 78.86V78.93L44.4098 79.14L44.5198 79.09L42.5298 78.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 78.57V78.64L44.8198 78.91L44.9198 78.85L42.5298 78.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 78.29V78.36L45.1498 78.66L45.1298 78.59L42.5298 78.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 78.01V78.08L45.2498 78.39V78.32L42.5298 78.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5298 77.72V77.8L45.2498 78.11V78.04L42.5298 77.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6099 77.52L45.2499 77.83V77.75L42.7099 77.46L42.6099 77.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.02 77.28L45.25 77.54V77.47L43.12 77.23L43.02 77.28Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4297 77.05L45.2497 77.26V77.19L43.5297 76.99L43.4297 77.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8398 76.81L45.2498 76.98V76.91L43.9398 76.76L43.8398 76.81Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 76.58L45.25 76.69V76.62L44.35 76.52L44.25 76.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6499 76.34L45.2499 76.41V76.34L44.7599 76.28L44.6499 76.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0596 76.11L45.2496 76.13V76.06L45.1596 76.05L45.0596 76.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5495 77.23L39.4995 78.99V82.05L39.6295 82.13L42.5495 80.28L42.6795 77.31L42.5495 77.23V77.23ZM42.3995 80.2L39.6395 81.79V79.07L42.3995 77.48V80.2Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6794 77.31L39.6294 79.07V82.13L42.6794 80.37V77.31ZM42.5294 80.28L39.7694 81.87V79.15L42.5294 77.56V80.28Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4995 78.99L39.6295 79.07L42.6795 77.31L42.5495 77.23L39.4995 78.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2598 80.36L42.2798 80.37L42.3298 80.4L42.3398 80.34L42.4898 79.52V79.14L42.2598 80.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0396 80.49L42.0596 80.5L42.1096 80.53L42.1195 80.47L42.4896 78.45V78.05L42.0396 80.49Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8793 80.66L42.4393 77.62L42.4093 77.64L42.3593 77.66L41.8193 80.62L41.8793 80.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5996 80.75L41.6596 80.79L42.2196 77.75L42.1396 77.79L41.5996 80.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3696 80.87L41.4396 80.91L41.9996 77.88L41.9196 77.92L41.3696 80.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1494 81L41.2194 81.04L41.7794 78L41.6994 78.05L41.1494 81Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9297 81.13L40.9997 81.17L41.5597 78.13L41.4897 78.17L41.4797 78.18L40.9297 81.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7095 81.26L40.7695 81.3L41.3295 78.26L41.2495 78.31L40.7095 81.26Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4897 81.39L40.5497 81.43L41.1097 78.39L41.0797 78.41L41.0297 78.43L40.4897 81.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2598 81.51L40.3298 81.55L40.8898 78.52L40.8098 78.56L40.2598 81.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0396 81.64L40.1096 81.68L40.6695 78.64L40.5896 78.69L40.0396 81.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8193 81.77L39.8793 81.81L40.4393 78.77L40.3593 78.82L39.8193 81.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 80.95V81.34L40.2195 78.9L40.1395 78.95L39.7695 80.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 79.88V80.26L39.9995 79.03L39.9495 79.06L39.9195 79.07L39.7695 79.88Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 81.58V81.65L40.0195 81.68L40.1195 81.62L39.7695 81.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 81.2999V81.3699L40.4295 81.4399L40.5295 81.3899L39.7695 81.2999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 81.02V81.09L40.8395 81.21L40.9395 81.15L39.7695 81.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 80.73V80.8L41.2495 80.97L41.3495 80.91L39.7695 80.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 80.45V80.52L41.6595 80.74L41.7595 80.68L39.7695 80.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 80.1699V80.2399L42.0695 80.4999L42.1595 80.4399L39.7695 80.1699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 79.8799V79.9499L42.3895 80.2599L42.3695 80.1799L39.7695 79.8799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 79.6V79.67L42.4895 79.98V79.91L39.7695 79.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7695 79.3199V79.3899L42.4895 79.6999V79.6299L39.7695 79.3199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8496 79.1099L42.4896 79.4199V79.3499L39.9496 79.0599L39.8496 79.1099Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2598 78.8799L42.4898 79.1399V79.0599L40.3598 78.8199L40.2598 78.8799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6694 78.64L42.4894 78.85V78.78L40.7694 78.58L40.6694 78.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0796 78.41L42.4896 78.57V78.5L41.1796 78.35L41.0796 78.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4897 78.17L42.4897 78.29V78.21L41.5897 78.11L41.4897 78.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8896 77.9299L42.4897 77.9999V77.9299L41.9996 77.8799L41.8896 77.9299Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2993 77.7L42.4893 77.72V77.65L42.4093 77.64L42.2993 77.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7897 78.8199L36.7397 80.5799V83.6399L36.8697 83.7199L39.7897 81.8699L39.9197 78.8999L39.7897 78.8199V78.8199ZM39.6397 81.7899L36.8797 83.3799V80.66L39.6397 79.0699V81.7899Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9196 78.9L36.8696 80.66V83.72L39.9196 81.96V78.9ZM39.7696 81.87L37.0096 83.46V80.74L39.7696 79.15V81.87Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7397 80.5799L36.8697 80.6699L39.9197 78.8999L39.7897 78.8199L36.7397 80.5799Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5098 81.95L39.5298 81.97L39.5698 81.99L39.5798 81.93L39.7298 81.11V80.73L39.5098 81.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2798 82.08L39.2998 82.09L39.3498 82.12L39.3598 82.06L39.7298 80.04V79.65L39.2798 82.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1296 82.25L39.6896 79.21L39.6496 79.23L39.6096 79.26L39.0596 82.21L39.1296 82.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8398 82.34L38.8998 82.38L39.4598 79.34L39.3798 79.39L38.8398 82.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6196 82.47L38.6796 82.51L39.2396 79.47L39.1596 79.51L38.6196 82.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3896 82.59L38.4596 82.63L39.0196 79.59L38.9396 79.64L38.3896 82.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1699 82.72L38.2399 82.76L38.7999 79.72L38.7299 79.76L38.7199 79.77L38.1699 82.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9497 82.85L38.0097 82.89L38.5797 79.85L38.4997 79.9L37.9497 82.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.73 82.98L37.79 83.02L38.35 79.98L38.32 80L38.27 80.02L37.73 82.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5098 83.11L37.5698 83.15L38.1298 80.11L38.0498 80.16L37.5098 83.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2798 83.24L37.3498 83.27L37.9098 80.23L37.8298 80.28L37.2798 83.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0596 83.36L37.1296 83.4L37.6896 80.36L37.6096 80.41L37.0596 83.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 82.54V82.93L37.4598 80.49L37.3798 80.54L37.0098 82.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 81.47V81.86L37.2398 80.62L37.1998 80.65H37.1898L37.1598 80.67L37.0098 81.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 83.17V83.24L37.2598 83.27L37.3698 83.21L37.0098 83.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 82.89V82.96L37.6698 83.04L37.7698 82.98L37.0098 82.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 82.61V82.68L38.0798 82.8L38.1798 82.74L37.0098 82.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 82.3199V82.3999L38.4898 82.5699L38.5898 82.5099L37.0098 82.3199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 82.04V82.11L38.8998 82.33L38.9998 82.27L37.0098 82.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 81.76V81.83L39.3098 82.09L39.4098 82.03L37.0098 81.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 81.48V81.55L39.6398 81.85L39.6198 81.78L37.0098 81.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 81.19V81.26L39.7298 81.58V81.51L37.0098 81.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 80.91V80.98L39.7298 81.29V81.22L37.0098 80.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0898 80.71L39.7298 81.01V80.94L37.1998 80.65H37.1898L37.0898 80.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 80.47L39.73 80.73V80.66L37.6 80.41L37.5 80.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9097 80.23L39.7297 80.44V80.37L38.0097 80.18L37.9097 80.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3198 80L39.7298 80.16V80.09L38.4198 79.94L38.3198 80Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.73 79.76L39.73 79.88V79.81L38.83 79.7L38.73 79.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1396 79.53L39.7296 79.59V79.52L39.2397 79.47L39.1396 79.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5396 79.29L39.7295 79.31V79.24L39.6496 79.23L39.5396 79.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1998 68.41L101.6 73.86V74.51L89.8198 67.68V67.03L92.1998 68.41Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6 73.86V74.51L112.81 67.94V67.29L110.88 68.4V68.41L101.6 73.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8198 67.03L101.6 73.86L112.81 67.29L100.67 60.22L89.8198 67.03Z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.19 57.61L109.47 56.87L108.52 55.42L108.19 55.6V57.61Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.41 51.67L108.19 55.6V57.61L99.8398 52.77L101.41 51.67Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.19 55.6L108.52 55.42L101.74 51.5L101.41 51.67L108.19 55.6Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.85 58.39L108.13 57.66L107.19 56.21L106.85 56.38V58.39Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.08 52.46L106.85 56.38V58.39L98.5 53.55L100.08 52.46Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.85 56.38L107.19 56.21L100.41 52.29L100.08 52.46L106.85 56.38Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.52 59.18L106.8 58.44L105.85 56.99L105.52 57.17V59.18Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7399 53.24L105.52 57.17V59.18L97.1699 54.33L98.7399 53.24Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.52 57.17L105.85 56.99L99.0697 53.07L98.7397 53.24L105.52 57.17Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 59.96L105.46 59.22L104.52 57.78L104.19 57.95V59.96Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4101 54.03L104.19 57.95V59.96L95.8301 55.12L97.4101 54.03Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 57.95L104.52 57.78L97.7402 53.85L97.4102 54.03L104.19 57.95Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.85 60.75L104.13 60.01L103.18 58.56L102.85 58.73V60.75Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07 54.81L102.85 58.73V60.75L94.5 55.9L96.07 54.81Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.85 58.73L103.18 58.56L96.3998 54.64L96.0698 54.81L102.85 58.73Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.52 61.53L102.79 60.79L101.85 59.35L101.52 59.52V61.53Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7399 55.6L101.52 59.52V61.53L93.1699 56.69L94.7399 55.6Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.52 59.52L101.85 59.35L95.0697 55.42L94.7397 55.6L101.52 59.52Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8499 57.66L101.52 61.53V71.88L93.1699 67.04V56.69L94.8499 57.66Z",
    fill: "#009CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.52 61.53V71.88L109.47 67.22V56.87L108.1 57.66V57.67L101.52 61.53Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0301 63.3V70.77L94.5601 69.35V61.88L97.0301 63.3Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87 63.55V64.66L99.6699 63.97V62.86L100.87 63.55Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0303 63.3L98.3203 60.86V70.03L97.0303 70.77V63.3Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3201 60.86L95.8501 59.44L94.5601 61.88L97.0301 63.3L98.3201 60.86Z",
    fill: "#9AD8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.03 60.79L108.31 60.62C108.31 60.62 108.38 60.57 108.42 60.55C108.58 60.48 108.76 60.48 108.93 60.58C109.31 60.8 109.55 61.21 109.55 61.66V68.23C109.55 68.44 109.44 68.61 109.28 68.71H109.26L108.81 68.98L108.78 68.75C108.78 68.75 108.73 68.73 108.71 68.71C108.33 68.49 108.09 68.08 108.09 67.63V61.17L108.03 60.77V60.79Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43 60.56C108.59 60.49 108.77 60.49 108.94 60.59C109.23 60.76 109.44 61.04 109.52 61.36L108.09 62.19V61.2L108.03 60.8L108.31 60.63C108.31 60.63 108.38 60.58 108.42 60.56H108.43Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.32 60.92C109.41 61.05 109.48 61.2 109.52 61.35L108.09 62.18V61.63L109.32 60.92Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.16 61.9V68.47C109.16 68.91 108.69 69.18 108.31 68.96C107.93 68.74 107.69 68.33 107.69 67.88V61.31C107.69 60.87 108.16 60.6 108.54 60.82C108.92 61.04 109.16 61.45 109.16 61.9V61.9Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.26 61.24L107.54 61.07C107.54 61.07 107.61 61.02 107.65 61C107.81 60.93 107.99 60.93 108.16 61.03C108.54 61.25 108.78 61.66 108.78 62.11V68.68C108.78 68.89 108.67 69.06 108.51 69.16H108.49L108.04 69.43L108.01 69.2C108.01 69.2 107.96 69.18 107.94 69.16C107.56 68.94 107.32 68.53 107.32 68.08V61.62L107.26 61.22V61.24Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.66 61C107.82 60.93 108 60.93 108.17 61.03C108.46 61.2 108.67 61.48 108.75 61.8L107.32 62.63V61.64L107.26 61.24L107.54 61.07C107.54 61.07 107.61 61.02 107.65 61H107.66Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55 61.37C108.64 61.5 108.71 61.65 108.75 61.8L107.32 62.63V62.08L108.55 61.37Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39 62.34V68.91C108.39 69.35 107.92 69.62 107.54 69.4C107.16 69.18 106.92 68.77 106.92 68.32V61.75C106.92 61.31 107.39 61.04 107.77 61.26C108.15 61.48 108.39 61.89 108.39 62.34V62.34Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49 61.68L106.77 61.51C106.77 61.51 106.84 61.46 106.88 61.44C107.04 61.37 107.22 61.37 107.39 61.47C107.77 61.69 108.01 62.1 108.01 62.55V69.12C108.01 69.33 107.9 69.5 107.74 69.6H107.72L107.27 69.87L107.24 69.64C107.24 69.64 107.19 69.62 107.17 69.6C106.79 69.38 106.55 68.97 106.55 68.52V62.06L106.49 61.66V61.68Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89 61.45C107.05 61.38 107.23 61.38 107.4 61.48C107.69 61.65 107.9 61.93 107.98 62.25L106.55 63.08V62.09L106.49 61.69L106.77 61.52C106.77 61.52 106.84 61.47 106.88 61.45H106.89Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.78 61.81C107.87 61.94 107.94 62.09 107.98 62.24L106.55 63.07V62.52L107.78 61.81Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.62 62.78V69.35C107.62 69.79 107.15 70.06 106.77 69.84C106.39 69.62 106.15 69.21 106.15 68.76V62.19C106.15 61.75 106.62 61.48 107 61.7C107.38 61.92 107.62 62.33 107.62 62.78V62.78Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 62.12L106 61.95C106 61.95 106.07 61.9 106.11 61.88C106.27 61.81 106.45 61.81 106.62 61.91C107 62.13 107.24 62.54 107.24 62.99V69.56C107.24 69.77 107.13 69.94 106.97 70.04H106.95L106.5 70.31L106.47 70.08C106.47 70.08 106.42 70.06 106.4 70.04C106.02 69.82 105.78 69.41 105.78 68.96V62.5L105.72 62.1V62.12Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12 61.89C106.28 61.82 106.46 61.82 106.63 61.92C106.92 62.09 107.13 62.37 107.21 62.69L105.78 63.52V62.53L105.72 62.13L106 61.96C106 61.96 106.07 61.91 106.11 61.89H106.12Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.01 62.26C107.1 62.39 107.17 62.54 107.21 62.69L105.78 63.52V62.97L107.01 62.26Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.85 63.23V69.8C106.85 70.24 106.38 70.51 106 70.29C105.62 70.07 105.38 69.66 105.38 69.21V62.64C105.38 62.2 105.85 61.93 106.23 62.15C106.61 62.37 106.85 62.78 106.85 63.23V63.23Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.95 62.57L105.23 62.4C105.23 62.4 105.3 62.35 105.34 62.33C105.5 62.26 105.68 62.26 105.85 62.36C106.23 62.58 106.47 62.99 106.47 63.44V70.01C106.47 70.22 106.36 70.39 106.2 70.49H106.18L105.73 70.76L105.7 70.53C105.7 70.53 105.65 70.51 105.63 70.49C105.25 70.27 105.01 69.86 105.01 69.41V62.95L104.95 62.55V62.57Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35 62.34C105.51 62.27 105.69 62.27 105.86 62.37C106.15 62.54 106.36 62.82 106.44 63.14L105.01 63.97V62.98L104.95 62.58L105.23 62.41C105.23 62.41 105.3 62.36 105.34 62.34H105.35Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.24 62.7C106.33 62.83 106.4 62.98 106.44 63.13L105.01 63.96V63.41L106.24 62.7Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.08 63.67V70.24C106.08 70.68 105.61 70.95 105.23 70.73C104.85 70.51 104.61 70.1 104.61 69.65V63.08C104.61 62.64 105.08 62.37 105.46 62.59C105.84 62.81 106.08 63.22 106.08 63.67Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.18 63.01L104.46 62.84C104.46 62.84 104.53 62.79 104.57 62.77C104.73 62.7 104.91 62.7 105.08 62.8C105.46 63.02 105.7 63.43 105.7 63.88V70.4499C105.7 70.6599 105.59 70.83 105.43 70.93H105.41L104.96 71.1999L104.93 70.97C104.93 70.97 104.88 70.95 104.86 70.93C104.48 70.71 104.24 70.3 104.24 69.85V63.39L104.18 62.99V63.01Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.57 62.78C104.73 62.71 104.91 62.71 105.08 62.81C105.37 62.98 105.58 63.26 105.66 63.58L104.23 64.41V63.42L104.17 63.02L104.45 62.85C104.45 62.85 104.52 62.8 104.56 62.78H104.57Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46 63.14C105.55 63.27 105.62 63.42 105.66 63.57L104.23 64.4V63.85L105.46 63.14V63.14Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.31 64.12V70.69C105.31 71.13 104.84 71.4 104.46 71.18C104.08 70.96 103.84 70.55 103.84 70.1V63.53C103.84 63.09 104.31 62.82 104.69 63.04C105.07 63.26 105.31 63.67 105.31 64.12V64.12Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.41 63.46L103.69 63.29C103.69 63.29 103.76 63.24 103.8 63.22C103.96 63.15 104.14 63.15 104.31 63.25C104.69 63.47 104.93 63.88 104.93 64.33V70.9C104.93 71.11 104.82 71.28 104.66 71.38H104.64L104.19 71.65L104.16 71.42C104.16 71.42 104.11 71.4 104.09 71.38C103.71 71.16 103.47 70.75 103.47 70.3V63.84L103.41 63.44V63.46Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.8 63.23C103.96 63.16 104.14 63.16 104.31 63.26C104.6 63.43 104.81 63.71 104.89 64.03L103.46 64.86V63.87L103.4 63.47L103.68 63.3C103.68 63.3 103.75 63.25 103.79 63.23H103.8Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.69 63.59C104.78 63.72 104.85 63.87 104.89 64.02L103.46 64.85V64.3L104.69 63.59V63.59Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.54 64.56V71.13C104.54 71.57 104.07 71.84 103.69 71.62C103.31 71.4 103.07 70.99 103.07 70.54V63.97C103.07 63.53 103.54 63.26 103.92 63.48C104.3 63.7 104.54 64.11 104.54 64.56V64.56Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.64 63.9L102.92 63.73C102.92 63.73 102.99 63.68 103.03 63.66C103.19 63.59 103.37 63.59 103.54 63.69C103.92 63.91 104.16 64.32 104.16 64.77V71.34C104.16 71.55 104.05 71.72 103.89 71.82H103.87L103.42 72.09L103.39 71.86C103.39 71.86 103.34 71.84 103.32 71.82C102.94 71.6 102.7 71.19 102.7 70.74V64.28L102.64 63.88V63.9Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.03 63.67C103.19 63.6 103.37 63.6 103.54 63.7C103.83 63.87 104.04 64.15 104.12 64.47L102.69 65.3V64.31L102.63 63.91L102.91 63.74C102.91 63.74 102.98 63.69 103.02 63.67H103.03Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.92 64.03C104.01 64.16 104.08 64.31 104.12 64.46L102.69 65.29V64.74L103.92 64.03V64.03Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.77 65.01V71.58C103.77 72.02 103.3 72.29 102.92 72.07C102.54 71.85 102.3 71.44 102.3 70.99V64.42C102.3 63.98 102.77 63.71 103.15 63.93C103.53 64.15 103.77 64.56 103.77 65.01V65.01Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.09 66.36V67.31L107.82 66.31V65.37L106.09 66.36Z",
    fill: "#BD9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.77 65.01V71.58C103.77 72.02 103.3 72.29 102.92 72.07C102.54 71.85 102.3 71.44 102.3 70.99V64.42C102.3 63.98 102.77 63.71 103.15 63.93C103.53 64.15 103.77 64.56 103.77 65.01V65.01Z",
    fill: "#CC5F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.97 57.78L105.49 55.72V55.33L98.0298 55.13V55.51L101.97 57.78Z",
    fill: "#9DA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.97 57.4L105.49 55.33L101.61 53.1L98.0298 55.13L101.97 57.4Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.97 57.4V57.78L98.0298 55.51V55.13L101.97 57.4Z",
    fill: "#D4D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23 44.49L101.35 44.83L102.88 49.13L103.22 50.07L103.13 49.1L102.82 48.25L101.39 44.24L101.28 43.94L101.23 44.49Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.72 50.07L101.06 49.13L102.59 44.83L102.71 44.49L102.66 43.94L102.55 44.24L101.12 48.25L100.81 49.1L100.72 50.07Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19 38.8L102.56 44.24L102.6 44.83L102.83 48.25L102.89 49.13L103.34 55.83C103.34 55.83 103.39 55.81 103.4 55.8L103.42 55.78C103.72 55.6 103.67 54.98 103.67 54.98L103.22 50.07L103.14 49.1L102.72 44.49L102.67 43.93L102.2 38.79L102.19 38.8Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.53 55.78L100.55 55.8C100.55 55.8 100.59 55.82 100.61 55.83L101.06 49.13L101.12 48.25L101.35 44.83L101.39 44.24L101.76 38.8L101.29 43.94L101.24 44.5L100.82 49.11L100.74 50.08L100.29 54.99C100.29 54.99 100.24 55.61 100.54 55.79L100.53 55.78Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.64 56.14C101.76 56.16 101.88 56.17 101.99 56.17C102.09 56.17 102.2 56.17 102.3 56.14L102.18 38.8H101.75L101.63 56.13L101.64 56.14Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.16 38.78C102.04 38.7 101.9 38.7 101.78 38.78C101.78 38.78 101.74 38.88 101.78 38.91C101.9 38.99 102.04 38.99 102.16 38.91C102.16 38.91 102.2 38.81 102.16 38.78Z",
    fill: "#7EC7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.33 55.82L101.01 49.32L101.07 48.79L103.27 54.94L103.33 55.82Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.61 55.82L102.93 49.32L102.87 48.79L100.67 54.94L100.61 55.82Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2201 78.2601L84.6301 83.7101V84.3601L72.8501 77.5301V76.8801L75.2201 78.2601Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6299 83.7101V84.3601L95.8399 77.7901V77.1401L93.9099 78.2501V78.2601L84.6299 83.7101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8501 76.8801L84.6301 83.7101L95.8401 77.1401L83.7001 70.0701L72.8501 76.8801Z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2202 67.46L92.4902 66.72L91.5502 65.27L91.2202 65.45V67.46Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4401 61.53L91.2201 65.45V67.46L82.8701 62.62L84.4401 61.53Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2199 65.45L91.5499 65.27L84.7699 61.35L84.4399 61.53L91.2199 65.45Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8799 68.24L91.1599 67.51L90.2199 66.06L89.8799 66.23V68.24Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0998 62.31L89.8798 66.23V68.24L81.5298 63.4L83.0998 62.31Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8796 66.23L90.2196 66.06L83.4396 62.14L83.0996 62.31L89.8796 66.23Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5498 69.03L89.8298 68.29L88.8798 66.84L88.5498 67.02V69.03Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7697 63.09L88.5497 67.02V69.03L80.1997 64.19L81.7697 63.09Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5495 67.02L88.8795 66.84L82.0995 62.92L81.7695 63.09L88.5495 67.02Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.21 69.81L88.49 69.07L87.55 67.63L87.21 67.8V69.81Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4399 63.88L87.2099 67.8V69.81L78.8599 64.97L80.4399 63.88Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2099 67.8L87.5499 67.63L80.7699 63.7L80.4399 63.88L87.2099 67.8Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8799 70.6L87.1599 69.86L86.2099 68.41L85.8799 68.59V70.6Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0998 64.66L85.8798 68.59V70.6L77.5298 65.75L79.0998 64.66Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8796 68.59L86.2096 68.4101L79.4296 64.4901L79.0996 64.6601L85.8796 68.59Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5498 71.38L85.8198 70.64L84.8798 69.2L84.5498 69.37V71.38Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7699 65.45L84.5499 69.37V71.38L76.1899 66.54L77.7699 65.45Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.55 69.37L84.88 69.2L78.1 65.27L77.77 65.45L84.55 69.37Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8799 67.52L84.5399 71.38V81.74L76.1899 76.89V66.54L77.8799 67.52Z",
    fill: "#009CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5498 71.38V81.73L92.4898 77.07V66.72L91.1298 67.51V67.52L84.5498 71.38Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0603 73.15V80.62L77.5903 79.2V71.73L80.0603 73.15Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9002 73.4V74.51L82.7002 73.82V72.71L83.9002 73.4Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0605 73.15L81.3505 70.71V79.88L80.0605 80.62V73.15Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3503 70.71L78.8803 69.29L77.5903 71.73L80.0603 73.15L81.3503 70.71Z",
    fill: "#9AD8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0601 70.64L91.3401 70.47C91.3401 70.47 91.4101 70.42 91.4501 70.4C91.6101 70.33 91.7901 70.33 91.9601 70.43C92.3401 70.65 92.5801 71.06 92.5801 71.51V78.08C92.5801 78.29 92.4701 78.46 92.3101 78.56H92.2901L91.8401 78.83L91.8101 78.6C91.8101 78.6 91.7601 78.58 91.7401 78.56C91.3601 78.34 91.1201 77.93 91.1201 77.48V71.02L91.0601 70.62V70.64Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4601 70.41C91.6201 70.34 91.8001 70.34 91.9701 70.44C92.2601 70.61 92.4701 70.89 92.5501 71.21L91.1201 72.04V71.05L91.0601 70.65L91.3401 70.48C91.3401 70.48 91.4101 70.43 91.4501 70.41H91.4601Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3501 70.77C92.4401 70.9 92.5101 71.05 92.5501 71.2L91.1201 72.03V71.48L92.3501 70.77V70.77Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1902 71.75V78.32C92.1902 78.76 91.7202 79.03 91.3402 78.81C90.9602 78.59 90.7202 78.18 90.7202 77.73V71.16C90.7202 70.72 91.1902 70.45 91.5702 70.67C91.9502 70.89 92.1902 71.3 92.1902 71.75Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29 71.09L90.57 70.92C90.57 70.92 90.64 70.87 90.68 70.85C90.84 70.78 91.02 70.78 91.19 70.88C91.57 71.1 91.81 71.51 91.81 71.96V78.53C91.81 78.74 91.7 78.91 91.54 79.01H91.52L91.07 79.28L91.04 79.05C91.04 79.05 90.99 79.03 90.97 79.01C90.59 78.79 90.35 78.38 90.35 77.93V71.47L90.29 71.07V71.09Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.69 70.85C90.85 70.78 91.03 70.78 91.2 70.88C91.49 71.05 91.7 71.33 91.78 71.65L90.35 72.48V71.49L90.29 71.09L90.57 70.92C90.57 70.92 90.64 70.87 90.68 70.85H90.69Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5801 71.22C91.6701 71.35 91.7401 71.5 91.7801 71.65L90.3501 72.48V71.93L91.5801 71.22V71.22Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4202 72.19V78.76C91.4202 79.2 90.9502 79.47 90.5702 79.25C90.1902 79.03 89.9502 78.62 89.9502 78.17V71.6C89.9502 71.16 90.4202 70.89 90.8002 71.11C91.1802 71.33 91.4202 71.74 91.4202 72.19Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.52 71.53L89.8 71.36C89.8 71.36 89.87 71.31 89.91 71.29C90.07 71.22 90.25 71.22 90.42 71.32C90.8 71.54 91.04 71.95 91.04 72.4V78.97C91.04 79.18 90.93 79.35 90.77 79.45H90.75L90.3 79.72L90.27 79.49C90.27 79.49 90.22 79.47 90.2 79.45C89.82 79.23 89.58 78.82 89.58 78.37V71.91L89.52 71.51V71.53Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.92 71.3C90.08 71.23 90.26 71.23 90.43 71.33C90.72 71.5 90.93 71.78 91.01 72.1L89.58 72.93V71.94L89.52 71.54L89.8 71.37C89.8 71.37 89.87 71.32 89.91 71.3H89.92Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8101 71.66C90.9001 71.79 90.9701 71.94 91.0101 72.09L89.5801 72.92V72.37L90.8101 71.66V71.66Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6502 72.63V79.2C90.6502 79.64 90.1802 79.91 89.8002 79.69C89.4202 79.47 89.1802 79.06 89.1802 78.61V72.04C89.1802 71.6 89.6502 71.33 90.0302 71.55C90.4102 71.77 90.6502 72.18 90.6502 72.63Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.75 71.9801L89.03 71.81C89.03 71.81 89.1 71.76 89.14 71.74C89.3 71.67 89.48 71.67 89.65 71.77C90.03 71.99 90.27 72.4 90.27 72.85V79.42C90.27 79.63 90.16 79.8 90 79.9H89.98L89.53 80.17L89.5 79.9401C89.5 79.9401 89.45 79.92 89.43 79.9C89.05 79.68 88.81 79.27 88.81 78.82V72.36L88.75 71.96V71.9801Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1402 71.74C89.3002 71.67 89.4802 71.67 89.6502 71.77C89.9402 71.94 90.1502 72.22 90.2302 72.54L88.8002 73.3701V72.38L88.7402 71.9801L89.0202 71.81C89.0202 71.81 89.0902 71.76 89.1302 71.74H89.1402Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0303 72.11C90.1203 72.24 90.1903 72.39 90.2303 72.54L88.8003 73.37V72.82L90.0303 72.11V72.11Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8801 73.08V79.65C89.8801 80.09 89.4102 80.36 89.0302 80.14C88.6502 79.92 88.4102 79.51 88.4102 79.06V72.49C88.4102 72.05 88.8802 71.78 89.2602 72C89.6402 72.22 89.8801 72.63 89.8801 73.08V73.08Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.98 72.42L88.26 72.25C88.26 72.25 88.33 72.2 88.37 72.18C88.53 72.11 88.71 72.11 88.88 72.21C89.26 72.43 89.5 72.84 89.5 73.29V79.86C89.5 80.07 89.39 80.24 89.23 80.34H89.21L88.76 80.61L88.73 80.38C88.73 80.38 88.68 80.36 88.66 80.34C88.28 80.12 88.04 79.71 88.04 79.26V72.8L87.98 72.4V72.42Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3702 72.19C88.5302 72.12 88.7102 72.12 88.8802 72.22C89.1702 72.39 89.3802 72.67 89.4602 72.99L88.0302 73.82V72.83L87.9702 72.43L88.2502 72.26C88.2502 72.26 88.3202 72.21 88.3602 72.19H88.3702Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2603 72.55C89.3503 72.68 89.4203 72.83 89.4603 72.98L88.0303 73.81V73.26L89.2603 72.55V72.55Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1101 73.52V80.09C89.1101 80.53 88.6401 80.8 88.2601 80.58C87.8801 80.36 87.6401 79.95 87.6401 79.5V72.93C87.6401 72.49 88.1101 72.22 88.4901 72.44C88.8701 72.66 89.1101 73.07 89.1101 73.52V73.52Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.21 72.86L87.49 72.69C87.49 72.69 87.56 72.6401 87.6 72.6201C87.76 72.5501 87.94 72.55 88.11 72.65C88.49 72.87 88.73 73.2801 88.73 73.7301V80.3001C88.73 80.5101 88.62 80.68 88.46 80.78H88.44L87.99 81.0501L87.96 80.82C87.96 80.82 87.91 80.8 87.89 80.78C87.51 80.56 87.27 80.15 87.27 79.7V73.24L87.21 72.84V72.86Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6002 72.6301C87.7602 72.5601 87.9402 72.5601 88.1102 72.6601C88.4002 72.8301 88.6102 73.1101 88.6902 73.4301L87.2602 74.2601V73.2701L87.2002 72.8701L87.4802 72.7001C87.4802 72.7001 87.5502 72.6501 87.5902 72.6301H87.6002Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4902 73.0001C88.5802 73.1301 88.6503 73.2801 88.6903 73.4301L87.2603 74.2601V73.7101L88.4902 73.0001V73.0001Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3401 73.9701V80.5401C88.3401 80.9801 87.8701 81.2501 87.4901 81.0301C87.1101 80.8101 86.8701 80.4001 86.8701 79.9501V73.3801C86.8701 72.9401 87.3401 72.6701 87.7201 72.8901C88.1001 73.1101 88.3401 73.5201 88.3401 73.9701Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4399 73.31L86.7199 73.14C86.7199 73.14 86.7899 73.09 86.8299 73.07C86.9899 73 87.1699 73 87.3399 73.1C87.7199 73.32 87.9599 73.73 87.9599 74.18V80.75C87.9599 80.96 87.8499 81.13 87.6899 81.23H87.6699L87.2199 81.5L87.1899 81.27C87.1899 81.27 87.1399 81.25 87.1199 81.23C86.7399 81.01 86.4999 80.6 86.4999 80.15V73.69L86.4399 73.29V73.31Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8302 73.08C86.9902 73.01 87.1702 73.01 87.3402 73.11C87.6302 73.28 87.8402 73.56 87.9202 73.88L86.4902 74.71V73.72L86.4302 73.32L86.7102 73.15C86.7102 73.15 86.7802 73.1 86.8202 73.08H86.8302Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7202 73.44C87.8102 73.57 87.8802 73.72 87.9202 73.87L86.4902 74.7V74.15L87.7202 73.44V73.44Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5701 74.41V80.98C87.5701 81.42 87.1001 81.69 86.7201 81.47C86.3401 81.25 86.1001 80.84 86.1001 80.39V73.82C86.1001 73.38 86.5701 73.11 86.9501 73.33C87.3301 73.55 87.5701 73.96 87.5701 74.41Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6699 73.75L85.9499 73.58C85.9499 73.58 86.0199 73.53 86.0599 73.51C86.2199 73.44 86.3999 73.44 86.5699 73.54C86.9499 73.76 87.1899 74.17 87.1899 74.62V81.19C87.1899 81.4 87.0799 81.57 86.9199 81.67H86.8999L86.4499 81.94L86.4199 81.71C86.4199 81.71 86.3699 81.69 86.3499 81.67C85.9699 81.45 85.7299 81.04 85.7299 80.59V74.13L85.6699 73.73V73.75Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0602 73.52C86.2202 73.45 86.4002 73.45 86.5702 73.55C86.8602 73.72 87.0702 74 87.1502 74.32L85.7202 75.15V74.16L85.6602 73.76L85.9402 73.59C85.9402 73.59 86.0102 73.54 86.0502 73.52H86.0602Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9502 73.88C87.0402 74.01 87.1102 74.16 87.1502 74.31L85.7202 75.14V74.59L86.9502 73.88V73.88Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8001 74.86V81.43C86.8001 81.87 86.3301 82.14 85.9501 81.92C85.5701 81.7 85.3301 81.29 85.3301 80.84V74.27C85.3301 73.83 85.8001 73.56 86.1801 73.78C86.5601 74 86.8001 74.41 86.8001 74.86V74.86Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1201 76.21V77.16L90.8501 76.16V75.22L89.1201 76.21Z",
    fill: "#BD9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8001 74.86V81.43C86.8001 81.87 86.3301 82.14 85.9501 81.92C85.5701 81.7 85.3301 81.29 85.3301 80.84V74.27C85.3301 73.83 85.8001 73.56 86.1801 73.78C86.5601 74 86.8001 74.41 86.8001 74.86V74.86Z",
    fill: "#CC5F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0001 67.64L88.5201 65.57V65.19L81.0601 64.98V65.36L85.0001 67.64Z",
    fill: "#9DA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0001 67.25L88.5201 65.19L84.6401 62.95L81.0601 64.98L85.0001 67.25Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0001 67.25V67.64L81.0601 65.36V64.98L85.0001 67.25Z",
    fill: "#D4D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2603 54.34L84.3802 54.68L85.9103 58.98L86.2503 59.92L86.1603 58.95L85.8503 58.1L84.4202 54.09L84.3102 53.79L84.2603 54.34Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75 59.92L84.09 58.98L85.62 54.68L85.74 54.34L85.69 53.79L85.58 54.09L84.15 58.1L83.84 58.95L83.75 59.92Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2202 48.65L85.5902 54.09L85.6302 54.68L85.8602 58.1L85.9202 58.98L86.3702 65.68C86.3702 65.68 86.4202 65.66 86.4302 65.65L86.4502 65.63C86.7502 65.45 86.7002 64.83 86.7002 64.83L86.2502 59.92L86.1702 58.95L85.7502 54.34L85.7002 53.78L85.2302 48.64L85.2202 48.65Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.56 65.63L83.58 65.65C83.58 65.65 83.62 65.67 83.64 65.68L84.09 58.98L84.15 58.1L84.38 54.68L84.42 54.09L84.79 48.65L84.32 53.79L84.27 54.35L83.85 58.96L83.77 59.93L83.32 64.84C83.32 64.84 83.27 65.46 83.57 65.64L83.56 65.63Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6702 65.99C84.7902 66.01 84.9101 66.02 85.0201 66.02C85.1201 66.02 85.2202 66.02 85.3302 65.99L85.2102 48.65H84.7802L84.6602 65.98L84.6702 65.99Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1903 48.64C85.0703 48.56 84.9303 48.56 84.8103 48.64C84.8103 48.64 84.7703 48.74 84.8103 48.77C84.9303 48.85 85.0703 48.85 85.1903 48.77C85.1903 48.77 85.2303 48.67 85.1903 48.64Z",
    fill: "#7EC7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.36 65.67L84.04 59.17L84.1 58.64L86.3 64.79L86.36 65.67Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6401 65.67L85.9601 59.17L85.9001 58.64L83.7001 64.79L83.6401 65.67Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2499 88.11L67.6599 93.56V94.21L55.8799 87.39V86.73L58.2499 88.11Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6597 93.5601V94.2101L78.8597 87.6401V86.9901L76.9397 88.1101V88.1201L67.6597 93.5601Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8799 86.73L67.6599 93.56L78.8599 86.99L66.7299 79.92L55.8799 86.73Z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.25 77.31L75.52 76.57L74.58 75.12L74.25 75.3V77.31Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4699 71.38L74.2499 75.3V77.31L65.8999 72.47L67.4699 71.38Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2497 75.3L74.5797 75.12L67.7997 71.2L67.4697 71.38L74.2497 75.3Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9097 78.09L74.1897 77.36L73.2397 75.91L72.9097 76.08V78.09Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1296 72.16L72.9096 76.08V78.09L64.5596 73.25L66.1296 72.16Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9094 76.08L73.2394 75.91L66.4694 71.99L66.1294 72.16L72.9094 76.08Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5796 78.88L72.8496 78.14L71.9096 76.69L71.5796 76.87V78.88Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7995 72.95L71.5795 76.87V78.88L63.2295 74.04L64.7995 72.95Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5793 76.87L71.9093 76.69L65.1293 72.77L64.7993 72.95L71.5793 76.87Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2397 79.66L71.5197 78.93L70.5798 77.48L70.2397 77.65V79.66Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4596 73.73L70.2396 77.65V79.66L61.8896 74.82L63.4596 73.73Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2395 77.65L70.5795 77.48L63.7995 73.56L63.4595 73.73L70.2395 77.65Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9097 80.45L70.1797 79.71L69.2397 78.26L68.9097 78.44V80.45Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1296 74.51L68.9096 78.44V80.45L60.5596 75.61L62.1296 74.51Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9094 78.44L69.2394 78.26L62.4594 74.34L62.1294 74.51L68.9094 78.44Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5698 81.23L68.8498 80.49L67.9098 79.05L67.5698 79.22V81.23Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7897 75.3L67.5697 79.22V81.23L59.2197 76.39L60.7897 75.3Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5695 79.22L67.9096 79.05L61.1296 75.12L60.7896 75.3L67.5695 79.22Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9097 77.37L67.5697 81.23V91.59L59.2197 86.74V76.39L60.9097 77.37Z",
    fill: "#009CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5698 81.23V91.59L75.5198 86.93V76.57L74.1598 77.36V77.37L67.5698 81.23Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0901 83V90.47L60.6201 89.05V81.58L63.0901 83Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.93 83.25V84.36L65.73 83.67V82.56L66.93 83.25Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0903 83L64.3803 80.56V89.73L63.0903 90.47V83Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3801 80.56L61.9101 79.14L60.6201 81.58L63.0901 83L64.3801 80.56Z",
    fill: "#9AD8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0898 80.49L74.3699 80.32C74.3699 80.32 74.4399 80.27 74.4799 80.25C74.6399 80.18 74.8198 80.18 74.9898 80.28C75.3698 80.5 75.6098 80.91 75.6098 81.36V87.93C75.6098 88.14 75.4998 88.31 75.3398 88.41H75.3198L74.8699 88.68L74.8398 88.45C74.8398 88.45 74.7898 88.43 74.7698 88.41C74.3898 88.19 74.1498 87.78 74.1498 87.33V80.87L74.0898 80.47V80.49Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4898 80.26C74.6498 80.19 74.8298 80.19 74.9998 80.29C75.2898 80.46 75.4998 80.74 75.5798 81.06L74.1498 81.89V80.9L74.0898 80.5L74.3699 80.33C74.3699 80.33 74.4399 80.28 74.4799 80.26H74.4898Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3799 80.63C75.4699 80.76 75.5399 80.91 75.5799 81.06L74.1499 81.89V81.34L75.3799 80.63V80.63Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.22 81.6V88.17C75.22 88.61 74.75 88.88 74.37 88.66C73.99 88.44 73.75 88.03 73.75 87.58V81.01C73.75 80.57 74.22 80.3 74.6 80.52C74.98 80.74 75.22 81.15 75.22 81.6Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3198 80.94L73.5998 80.77C73.5998 80.77 73.6698 80.72 73.7098 80.7C73.8698 80.63 74.0498 80.63 74.2198 80.73C74.5998 80.95 74.8398 81.36 74.8398 81.81V88.38C74.8398 88.59 74.7298 88.76 74.5698 88.86H74.5498L74.0998 89.13L74.0698 88.9C74.0698 88.9 74.0198 88.88 73.9998 88.86C73.6198 88.64 73.3798 88.23 73.3798 87.78V81.32L73.3198 80.92V80.94Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7101 80.71C73.8701 80.64 74.0501 80.64 74.2201 80.74C74.5101 80.91 74.7201 81.19 74.8001 81.51L73.3701 82.34V81.35L73.3101 80.95L73.5901 80.78C73.5901 80.78 73.6601 80.73 73.7001 80.71H73.7101Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6001 81.07C74.6901 81.2 74.7601 81.35 74.8001 81.5L73.3701 82.33V81.78L74.6001 81.07V81.07Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.45 82.04V88.61C74.45 89.05 73.98 89.32 73.6 89.1C73.22 88.88 72.98 88.47 72.98 88.02V81.45C72.98 81.01 73.45 80.74 73.83 80.96C74.21 81.18 74.45 81.59 74.45 82.04V82.04Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5498 81.38L72.8298 81.21C72.8298 81.21 72.8998 81.16 72.9398 81.14C73.0998 81.07 73.2798 81.07 73.4498 81.17C73.8298 81.39 74.0698 81.8 74.0698 82.25V88.82C74.0698 89.03 73.9598 89.2 73.7998 89.3H73.7798L73.3298 89.57L73.2998 89.34C73.2998 89.34 73.2498 89.32 73.2298 89.3C72.8498 89.08 72.6098 88.67 72.6098 88.22V81.76L72.5498 81.36V81.38Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94 81.15C73.1 81.08 73.28 81.08 73.45 81.18C73.74 81.35 73.95 81.63 74.03 81.95L72.6 82.78V81.79L72.54 81.39L72.82 81.22C72.82 81.22 72.89 81.17 72.93 81.15H72.94Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8301 81.51C73.9201 81.64 73.9901 81.79 74.0301 81.94L72.6001 82.77V82.22L73.8301 81.51V81.51Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.68 82.49V89.06C73.68 89.5 73.21 89.77 72.83 89.55C72.45 89.33 72.21 88.92 72.21 88.47V81.9C72.21 81.46 72.68 81.19 73.06 81.41C73.44 81.63 73.68 82.04 73.68 82.49V82.49Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7798 81.83L72.0598 81.66C72.0598 81.66 72.1298 81.61 72.1698 81.59C72.3298 81.52 72.5098 81.52 72.6798 81.62C73.0598 81.84 73.2998 82.25 73.2998 82.7V89.27C73.2998 89.48 73.1898 89.65 73.0298 89.75H73.0098L72.5598 90.02L72.5298 89.79C72.5298 89.79 72.4798 89.77 72.4598 89.75C72.0798 89.53 71.8398 89.12 71.8398 88.67V82.21L71.7798 81.81V81.83Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.17 81.59C72.33 81.52 72.51 81.52 72.68 81.62C72.97 81.79 73.18 82.07 73.26 82.39L71.83 83.22V82.23L71.77 81.83L72.05 81.66C72.05 81.66 72.12 81.61 72.16 81.59H72.17Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0601 81.96C73.1501 82.09 73.2201 82.24 73.2601 82.39L71.8301 83.22V82.67L73.0601 81.96V81.96Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9099 82.93V89.5C72.9099 89.94 72.4399 90.21 72.0599 89.99C71.6799 89.77 71.4399 89.36 71.4399 88.91V82.34C71.4399 81.9 71.9099 81.63 72.2899 81.85C72.6699 82.07 72.9099 82.48 72.9099 82.93Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0098 82.27L71.2898 82.1C71.2898 82.1 71.3598 82.05 71.3998 82.03C71.5598 81.96 71.7398 81.96 71.9098 82.06C72.2898 82.28 72.5298 82.69 72.5298 83.14V89.71C72.5298 89.92 72.4198 90.09 72.2598 90.19H72.2398L71.7898 90.46L71.7598 90.23C71.7598 90.23 71.7098 90.21 71.6898 90.19C71.3098 89.97 71.0698 89.56 71.0698 89.11V82.65L71.0098 82.25V82.27Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 82.04C71.56 81.97 71.74 81.97 71.91 82.07C72.2 82.24 72.41 82.52 72.49 82.84L71.06 83.67V82.68L71 82.28L71.28 82.11C71.28 82.11 71.35 82.06 71.39 82.04H71.4Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2901 82.4C72.3801 82.53 72.4501 82.68 72.4901 82.83L71.0601 83.66V83.11L72.2901 82.4V82.4Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1399 83.37V89.94C72.1399 90.38 71.6699 90.65 71.2899 90.43C70.9099 90.21 70.6699 89.8 70.6699 89.35V82.78C70.6699 82.34 71.1399 82.07 71.5199 82.29C71.8999 82.51 72.1399 82.92 72.1399 83.37Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2397 82.72L70.5197 82.55C70.5197 82.55 70.5897 82.5 70.6297 82.48C70.7897 82.41 70.9697 82.41 71.1397 82.51C71.5197 82.73 71.7598 83.14 71.7598 83.59V90.16C71.7598 90.37 71.6497 90.54 71.4897 90.64H71.4697L71.0197 90.91L70.9897 90.68C70.9897 90.68 70.9397 90.66 70.9197 90.64C70.5397 90.42 70.2998 90.01 70.2998 89.56V83.1L70.2397 82.7V82.72Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.63 82.48C70.79 82.41 70.97 82.41 71.14 82.51C71.43 82.68 71.64 82.96 71.72 83.28L70.29 84.11V83.12L70.23 82.72L70.51 82.55C70.51 82.55 70.58 82.5 70.62 82.48H70.63Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.52 82.85C71.61 82.98 71.68 83.13 71.72 83.28L70.29 84.11V83.56L71.52 82.85V82.85Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3699 83.82V90.39C71.3699 90.83 70.8999 91.1 70.5199 90.88C70.1399 90.66 69.8999 90.25 69.8999 89.8V83.23C69.8999 82.79 70.3699 82.52 70.7499 82.74C71.1299 82.96 71.3699 83.37 71.3699 83.82Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4697 83.16L69.7497 82.99C69.7497 82.99 69.8197 82.94 69.8597 82.92C70.0197 82.85 70.1997 82.85 70.3697 82.95C70.7497 83.17 70.9897 83.58 70.9897 84.03V90.6C70.9897 90.81 70.8797 90.98 70.7197 91.08H70.6997L70.2497 91.35L70.2197 91.12C70.2197 91.12 70.1697 91.1 70.1497 91.08C69.7697 90.86 69.5297 90.45 69.5297 90V83.54L69.4697 83.14V83.16Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.86 82.93C70.02 82.86 70.2 82.86 70.37 82.96C70.66 83.13 70.87 83.41 70.95 83.73L69.52 84.56V83.57L69.46 83.17L69.74 83C69.74 83 69.81 82.95 69.85 82.93H69.86Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.75 83.29C70.84 83.42 70.91 83.57 70.95 83.72L69.52 84.55V84L70.75 83.29V83.29Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5999 84.26V90.83C70.5999 91.27 70.1299 91.54 69.7499 91.32C69.3699 91.1 69.1299 90.69 69.1299 90.24V83.67C69.1299 83.23 69.5999 82.96 69.9799 83.18C70.3599 83.4 70.5999 83.81 70.5999 84.26V84.26Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6997 83.6L68.9797 83.43C68.9797 83.43 69.0497 83.38 69.0897 83.36C69.2497 83.29 69.4297 83.29 69.5997 83.39C69.9797 83.61 70.2197 84.02 70.2197 84.47V91.04C70.2197 91.25 70.1097 91.42 69.9497 91.52H69.9297L69.4797 91.79L69.4497 91.56C69.4497 91.56 69.3997 91.54 69.3797 91.52C68.9997 91.3 68.7597 90.89 68.7597 90.44V83.98L68.6997 83.58V83.6Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0899 83.37C69.2499 83.3 69.4299 83.3 69.5999 83.4C69.8899 83.57 70.0999 83.85 70.1799 84.17L68.7499 85V84.01L68.6899 83.61L68.9699 83.44C68.9699 83.44 69.0399 83.39 69.0799 83.37H69.0899Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.98 83.74C70.07 83.87 70.14 84.02 70.18 84.17L68.75 85V84.45L69.98 83.74V83.74Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8299 84.71V91.28C69.8299 91.72 69.3599 91.99 68.9799 91.77C68.5999 91.55 68.3599 91.14 68.3599 90.69V84.12C68.3599 83.68 68.8299 83.41 69.2099 83.63C69.5899 83.85 69.8299 84.26 69.8299 84.71V84.71Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1499 86.06V87.01L73.8699 86.02V85.07L72.1499 86.06Z",
    fill: "#BD9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8299 84.71V91.28C69.8299 91.72 69.3599 91.99 68.9799 91.77C68.5999 91.55 68.3599 91.14 68.3599 90.69V84.12C68.3599 83.68 68.8299 83.41 69.2099 83.63C69.5899 83.85 69.8299 84.26 69.8299 84.71V84.71Z",
    fill: "#CC5F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0298 77.49L71.5499 75.42V75.04L64.0898 74.83V75.21L68.0298 77.49Z",
    fill: "#9DA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0298 77.1L71.5499 75.04L67.6698 72.8L64.0898 74.83L68.0298 77.1Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0298 77.1V77.49L64.0898 75.21V74.83L68.0298 77.1Z",
    fill: "#D4D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.29 64.19L67.41 64.53L68.94 68.83L69.27 69.77L69.19 68.8L68.88 67.95L67.45 63.94L67.34 63.64L67.29 64.19Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7803 69.77L67.1203 68.83L68.6503 64.53L68.7703 64.19L68.7203 63.64L68.6103 63.94L67.1803 67.95L66.8703 68.8L66.7803 69.77Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.25 58.5L68.62 63.94L68.66 64.53L68.89 67.95L68.95 68.83L69.4 75.53C69.4 75.53 69.45 75.51 69.46 75.5L69.48 75.48C69.78 75.3 69.73 74.68 69.73 74.68L69.28 69.77L69.2 68.8L68.78 64.19L68.73 63.63L68.26 58.49L68.25 58.5Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.58 75.48L66.6 75.5C66.6 75.5 66.64 75.52 66.66 75.53L67.11 68.83L67.17 67.95L67.4 64.53L67.44 63.94L67.81 58.5L67.34 63.64L67.29 64.2L66.87 68.81L66.79 69.78L66.34 74.69C66.34 74.69 66.29 75.31 66.59 75.49L66.58 75.48Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6902 75.84C67.8102 75.86 67.9302 75.87 68.0402 75.87C68.1402 75.87 68.2502 75.87 68.3502 75.84L68.2302 58.5H67.8002L67.6802 75.83L67.6902 75.84Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22 58.49C68.1 58.41 67.96 58.41 67.84 58.49C67.84 58.49 67.8 58.59 67.84 58.62C67.96 58.7 68.1 58.7 68.22 58.62C68.22 58.62 68.26 58.52 68.22 58.49Z",
    fill: "#7EC7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3898 75.52L67.0698 69.02L67.1298 68.49L69.3298 74.64L69.3898 75.52Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6699 75.52L68.9899 69.02L68.9299 68.49L66.7299 74.64L66.6699 75.52Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2802 97.96L50.6802 103.41V104.07L38.9102 97.24V96.58L41.2802 97.96Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6899 103.41V104.07L61.8899 97.49V96.84L59.9699 97.96V97.97L50.6899 103.41Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9102 96.58L50.6902 103.41L61.8902 96.84L49.7602 89.77L38.9102 96.58Z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2803 87.16L58.5503 86.42L57.6103 84.98L57.2803 85.15V87.16Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5002 81.23L57.2802 85.15V87.16L48.9302 82.32L50.5002 81.23Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.28 85.15L57.61 84.98L50.83 81.05L50.5 81.23L57.28 85.15Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9399 87.95L57.2199 87.21L56.2699 85.76L55.9399 85.93V87.95Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1598 82.01L55.9398 85.93V87.95L47.5898 83.1L49.1598 82.01Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9397 85.93L56.2697 85.76L49.4897 81.84L49.1597 82.01L55.9397 85.93Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6099 88.73L55.8799 87.99L54.9399 86.54L54.6099 86.72V88.73Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8298 82.8L54.6098 86.72V88.73L46.2598 83.89L47.8298 82.8Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6096 86.7201L54.9396 86.5401L48.1596 82.6201L47.8296 82.8001L54.6096 86.7201Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.27 89.51L54.55 88.78L53.6 87.33L53.27 87.5V89.51Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4899 83.58L53.2699 87.5V89.51L44.9199 84.67L46.4899 83.58Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2697 87.5L53.5997 87.33L46.8297 83.41L46.4897 83.58L53.2697 87.5Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9399 90.3L53.2099 89.56L52.2699 88.11L51.9399 88.29V90.3Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1598 84.3701L51.9398 88.2901V90.3001L43.5898 85.4601L45.1598 84.3701Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9397 88.2901L52.2697 88.1101L45.4897 84.1901L45.1597 84.3701L51.9397 88.2901Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6001 91.08L51.8801 90.35L50.9401 88.9L50.6001 89.07V91.08Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.82 85.15L50.6 89.07V91.08L42.25 86.24L43.82 85.15Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5998 89.07L50.9398 88.9L44.1598 84.98L43.8198 85.15L50.5998 89.07Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93 87.2201L50.6 91.0801V101.44L42.25 96.59V86.2401L43.93 87.2201Z",
    fill: "#009CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6001 91.08V101.44L58.5501 96.78V86.42L57.1901 87.21V87.22L50.6001 91.08Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1204 92.8501V100.33L43.6504 98.9001V91.4301L46.1204 92.8501Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9603 93.1V94.22L48.7603 93.52V92.41L49.9603 93.1Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1206 92.85L47.4106 90.41V99.58L46.1206 100.33V92.85Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4104 90.4101L44.9404 88.9901L43.6504 91.4301L46.1204 92.8501L47.4104 90.4101Z",
    fill: "#9AD8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1201 90.34L57.4001 90.17C57.4001 90.17 57.4701 90.12 57.5101 90.1C57.6701 90.03 57.8501 90.03 58.0201 90.13C58.4001 90.35 58.6401 90.76 58.6401 91.21V97.78C58.6401 97.99 58.5301 98.16 58.3701 98.26H58.3501L57.9001 98.53L57.8701 98.3C57.8701 98.3 57.8201 98.28 57.8001 98.26C57.4201 98.04 57.1801 97.63 57.1801 97.18V90.72L57.1201 90.32V90.34Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5103 90.11C57.6703 90.04 57.8504 90.04 58.0204 90.14C58.3104 90.31 58.5203 90.59 58.6003 90.91L57.1703 91.74V90.75L57.1104 90.35L57.3904 90.18C57.3904 90.18 57.4604 90.13 57.5004 90.11H57.5103Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4004 90.48C58.4904 90.61 58.5604 90.76 58.6004 90.91L57.1704 91.74V91.19L58.4004 90.48V90.48Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2503 91.45V98.02C58.2503 98.46 57.7803 98.73 57.4003 98.51C57.0203 98.29 56.7803 97.88 56.7803 97.43V90.86C56.7803 90.42 57.2503 90.15 57.6303 90.37C58.0103 90.59 58.2503 91 58.2503 91.45V91.45Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3501 90.79L56.6301 90.62C56.6301 90.62 56.7001 90.57 56.7401 90.55C56.9001 90.48 57.0801 90.48 57.2501 90.58C57.6301 90.8 57.8701 91.21 57.8701 91.66V98.23C57.8701 98.44 57.7601 98.61 57.6001 98.71H57.5801L57.1301 98.98L57.1001 98.75C57.1001 98.75 57.0501 98.73 57.0301 98.71C56.6501 98.49 56.4101 98.08 56.4101 97.63V91.17L56.3501 90.77V90.79Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7403 90.5601C56.9003 90.4901 57.0803 90.4901 57.2503 90.5901C57.5403 90.7601 57.7503 91.0401 57.8303 91.3601L56.4003 92.1901V91.2001L56.3403 90.8001L56.6203 90.6301C56.6203 90.6301 56.6903 90.5801 56.7303 90.5601H56.7403Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6304 90.92C57.7204 91.05 57.7904 91.2 57.8304 91.35L56.4004 92.18V91.63L57.6304 90.92V90.92Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4803 91.89V98.46C57.4803 98.9 57.0103 99.17 56.6303 98.95C56.2503 98.73 56.0103 98.32 56.0103 97.87V91.3C56.0103 90.86 56.4803 90.59 56.8603 90.81C57.2403 91.03 57.4803 91.44 57.4803 91.89V91.89Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5801 91.2301L55.8601 91.06C55.8601 91.06 55.9301 91.01 55.9701 90.99C56.1301 90.92 56.3101 90.92 56.4801 91.02C56.8601 91.24 57.1001 91.65 57.1001 92.1V98.67C57.1001 98.88 56.9901 99.05 56.8301 99.15H56.8101L56.3601 99.42L56.3301 99.1901C56.3301 99.1901 56.2801 99.17 56.2601 99.15C55.8801 98.93 55.6401 98.52 55.6401 98.07V91.61L55.5801 91.21V91.2301Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9703 91.0001C56.1303 90.9301 56.3103 90.9301 56.4803 91.0301C56.7703 91.2001 56.9803 91.4801 57.0603 91.8001L55.6303 92.6301V91.6401L55.5703 91.2401L55.8503 91.0701C55.8503 91.0701 55.9203 91.0201 55.9603 91.0001H55.9703Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8604 91.3701C56.9504 91.5001 57.0204 91.6501 57.0604 91.8001L55.6304 92.6301V92.0801L56.8604 91.3701V91.3701Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7102 92.34V98.9101C56.7102 99.3501 56.2402 99.6201 55.8602 99.4001C55.4802 99.1801 55.2402 98.7701 55.2402 98.3201V91.7501C55.2402 91.3101 55.7102 91.0401 56.0902 91.2601C56.4702 91.4801 56.7102 91.89 56.7102 92.34Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8101 91.6801L55.0901 91.5101C55.0901 91.5101 55.1601 91.4601 55.2001 91.4401C55.3601 91.3701 55.5401 91.3701 55.7101 91.4701C56.0901 91.6901 56.3301 92.1001 56.3301 92.5501V99.1201C56.3301 99.3301 56.2201 99.5001 56.0601 99.6001H56.0401L55.5901 99.8701L55.5601 99.6401C55.5601 99.6401 55.5101 99.6201 55.4901 99.6001C55.1101 99.3801 54.8701 98.9701 54.8701 98.5201V92.0601L54.8101 91.6601V91.6801Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2003 91.4501C55.3603 91.3801 55.5403 91.3801 55.7103 91.4801C56.0003 91.6501 56.2103 91.9301 56.2903 92.2501L54.8603 93.0801V92.0901L54.8003 91.6901L55.0803 91.5201C55.0803 91.5201 55.1503 91.4701 55.1903 91.4501H55.2003Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0904 91.8101C56.1804 91.9401 56.2504 92.0901 56.2904 92.2401L54.8604 93.0701V92.5201L56.0904 91.8101V91.8101Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9402 92.7801V99.3501C55.9402 99.7901 55.4702 100.06 55.0902 99.8401C54.7102 99.6201 54.4702 99.2101 54.4702 98.7601V92.1901C54.4702 91.7501 54.9402 91.4801 55.3202 91.7001C55.7002 91.9201 55.9402 92.3301 55.9402 92.7801Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.04 92.1201L54.32 91.9501C54.32 91.9501 54.39 91.9001 54.43 91.8801C54.59 91.8101 54.77 91.8101 54.94 91.9101C55.32 92.1301 55.56 92.5401 55.56 92.9901V99.5601C55.56 99.7701 55.45 99.9401 55.29 100.04H55.27L54.82 100.31L54.79 100.08C54.79 100.08 54.74 100.06 54.72 100.04C54.34 99.8201 54.1 99.4101 54.1 98.9601V92.5001L54.04 92.1001V92.1201Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4303 91.8901C54.5903 91.8201 54.7703 91.8201 54.9403 91.9201C55.2303 92.0901 55.4403 92.3701 55.5203 92.6901L54.0903 93.5201V92.5301L54.0303 92.1301L54.3103 91.9601C54.3103 91.9601 54.3803 91.9101 54.4203 91.8901H54.4303Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3203 92.2501C55.4103 92.3801 55.4803 92.5301 55.5203 92.6801L54.0903 93.5101V92.9601L55.3203 92.2501V92.2501Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1702 93.2301V99.8001C55.1702 100.24 54.7002 100.51 54.3202 100.29C53.9402 100.07 53.7002 99.6601 53.7002 99.2101V92.6401C53.7002 92.2001 54.1702 91.9301 54.5502 92.1501C54.9302 92.3701 55.1702 92.7801 55.1702 93.2301V93.2301Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.27 92.57L53.55 92.4C53.55 92.4 53.62 92.35 53.66 92.33C53.82 92.26 54 92.26 54.17 92.36C54.55 92.58 54.79 92.99 54.79 93.44V100.01C54.79 100.22 54.68 100.39 54.52 100.49H54.5L54.05 100.76L54.02 100.53C54.02 100.53 53.97 100.51 53.95 100.49C53.57 100.27 53.33 99.86 53.33 99.41V92.95L53.27 92.55V92.57Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6603 92.33C53.8203 92.26 54.0003 92.26 54.1703 92.36C54.4603 92.53 54.6703 92.81 54.7503 93.13L53.3203 93.96V92.97L53.2603 92.57L53.5403 92.4C53.5403 92.4 53.6103 92.35 53.6503 92.33H53.6603Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5503 92.7C54.6403 92.83 54.7103 92.98 54.7503 93.13L53.3203 93.96V93.41L54.5503 92.7V92.7Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4002 93.67V100.24C54.4002 100.68 53.9302 100.95 53.5502 100.73C53.1702 100.51 52.9302 100.1 52.9302 99.65V93.08C52.9302 92.64 53.4002 92.37 53.7802 92.59C54.1602 92.81 54.4002 93.22 54.4002 93.67V93.67Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 93.01L52.78 92.84C52.78 92.84 52.85 92.79 52.89 92.77C53.05 92.7 53.23 92.7 53.4 92.8C53.78 93.02 54.02 93.43 54.02 93.88V100.45C54.02 100.66 53.91 100.83 53.75 100.93H53.73L53.28 101.2L53.25 100.97C53.25 100.97 53.2 100.95 53.18 100.93C52.8 100.71 52.56 100.3 52.56 99.85V93.39L52.5 92.99V93.01Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8902 92.78C53.0502 92.71 53.2302 92.71 53.4002 92.81C53.6902 92.98 53.9002 93.26 53.9802 93.58L52.5502 94.41V93.42L52.4902 93.02L52.7702 92.85C52.7702 92.85 52.8402 92.8 52.8802 92.78H52.8902Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7803 93.14C53.8703 93.27 53.9403 93.42 53.9803 93.57L52.5503 94.4V93.85L53.7803 93.14V93.14Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6302 94.11V100.68C53.6302 101.12 53.1602 101.39 52.7802 101.17C52.4002 100.95 52.1602 100.54 52.1602 100.09V93.52C52.1602 93.08 52.6302 92.81 53.0102 93.03C53.3902 93.25 53.6302 93.66 53.6302 94.11V94.11Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.73 93.45L52.01 93.28C52.01 93.28 52.08 93.23 52.12 93.21C52.28 93.14 52.46 93.14 52.63 93.24C53.01 93.46 53.25 93.87 53.25 94.32V100.89C53.25 101.1 53.14 101.27 52.98 101.37H52.96L52.51 101.64L52.48 101.41C52.48 101.41 52.43 101.39 52.41 101.37C52.03 101.15 51.79 100.74 51.79 100.29V93.83L51.73 93.43V93.45Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1202 93.22C52.2802 93.15 52.4602 93.15 52.6302 93.25C52.9202 93.42 53.1302 93.7 53.2102 94.02L51.7802 94.85V93.86L51.7202 93.46L52.0002 93.29C52.0002 93.29 52.0702 93.24 52.1102 93.22H52.1202Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0103 93.59C53.1003 93.72 53.1703 93.87 53.2103 94.02L51.7803 94.85V94.3L53.0103 93.59V93.59Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8601 94.56V101.13C52.8601 101.57 52.3901 101.84 52.0101 101.62C51.6301 101.4 51.3901 100.99 51.3901 100.54V93.97C51.3901 93.53 51.8601 93.26 52.2401 93.48C52.6201 93.7 52.8601 94.11 52.8601 94.56Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 95.91V96.86L56.9002 95.87V94.92L55.1802 95.91Z",
    fill: "#BD9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8601 94.56V101.13C52.8601 101.57 52.3901 101.84 52.0101 101.62C51.6301 101.4 51.3901 100.99 51.3901 100.54V93.97C51.3901 93.53 51.8601 93.26 52.2401 93.48C52.6201 93.7 52.8601 94.11 52.8601 94.56Z",
    fill: "#CC5F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0601 87.34L54.5801 85.2701V84.8901L47.1201 84.6801V85.0601L51.0601 87.34Z",
    fill: "#9DA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0601 86.95L54.5801 84.89L50.7001 82.65L47.1201 84.68L51.0601 86.95Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0601 86.9501V87.34L47.1201 85.0601V84.6801L51.0601 86.9501Z",
    fill: "#D4D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3105 74.0501L50.4405 74.3801L51.9705 78.6801L52.3005 79.6201L52.2205 78.6601L51.9105 77.8001L50.4705 73.7901L50.3705 73.4901L50.3105 74.0501Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8105 79.6201L50.1505 78.6801L51.6805 74.3801L51.8005 74.0501L51.7505 73.4901L51.6405 73.7901L50.2105 77.8001L49.9005 78.6601L49.8105 79.6201Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2705 68.35L51.6405 73.79L51.6805 74.38L51.9105 77.8L51.9705 78.68L52.4205 85.38C52.4205 85.38 52.4705 85.36 52.4805 85.35L52.5005 85.33C52.8005 85.15 52.7505 84.53 52.7505 84.53L52.3005 79.62L52.2205 78.65L51.8005 74.04L51.7505 73.48L51.2805 68.34L51.2705 68.35Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6103 85.33L49.6303 85.35C49.6303 85.35 49.6703 85.37 49.6903 85.38L50.1403 78.68L50.2003 77.8L50.4303 74.38L50.4703 73.79L50.8403 68.35L50.3703 73.49L50.3203 74.05L49.9003 78.66L49.8203 79.63L49.3703 84.54C49.3703 84.54 49.3203 85.16 49.6203 85.34L49.6103 85.33Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7205 85.69C50.8405 85.71 50.9604 85.72 51.0704 85.72C51.1704 85.72 51.2805 85.72 51.3805 85.69L51.2604 68.35H50.8305L50.7104 85.68L50.7205 85.69Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2503 68.34C51.1303 68.26 50.9903 68.26 50.8703 68.34C50.8703 68.34 50.8303 68.44 50.8703 68.47C50.9903 68.55 51.1303 68.55 51.2503 68.47C51.2503 68.47 51.2903 68.37 51.2503 68.34Z",
    fill: "#7EC7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4201 85.37L50.1001 78.87L50.1601 78.34L52.3601 84.49L52.4201 85.37Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7002 85.37L52.0102 78.87L51.9502 78.34L49.7602 84.49L49.7002 85.37Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54 78.93L120.94 84.38V85.03L109.16 78.2V77.55L111.54 78.93Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.94 84.38V85.03L132.15 78.46V77.81L130.22 78.92V78.93L120.94 84.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.16 77.55L120.94 84.38L132.15 77.81L120.01 70.74L109.16 77.55Z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.53 68.13L128.81 67.39L127.86 65.94L127.53 66.11V68.13Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.75 62.19L127.53 66.11V68.13L119.18 63.28L120.75 62.19Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.53 66.11L127.86 65.94L121.08 62.02L120.75 62.19L127.53 66.11Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.19 68.91L127.47 68.17L126.53 66.72L126.19 66.9V68.91Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.42 62.98L126.19 66.9V68.91L117.84 64.07L119.42 62.98Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.19 66.9001L126.53 66.7201L119.75 62.8L119.42 62.98L126.19 66.9001Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.86 69.69L126.14 68.96L125.19 67.51L124.86 67.68V69.69Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08 63.76L124.86 67.68V69.69L116.51 64.85L118.08 63.76Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.86 67.68L125.19 67.51L118.41 63.59L118.08 63.76L124.86 67.68Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.53 70.48L124.8 69.74L123.86 68.29L123.53 68.47V70.48Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75 64.54L123.53 68.47V70.48L115.17 65.64L116.75 64.54Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.53 68.47L123.86 68.29L117.08 64.37L116.75 64.54L123.53 68.47Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.19 71.26L123.47 70.53L122.52 69.08L122.19 69.25V71.26Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.41 65.33L122.19 69.25V71.26L113.84 66.42L115.41 65.33Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.19 69.25L122.52 69.08L115.74 65.16L115.41 65.33L122.19 69.25Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86 72.05L122.13 71.31L121.19 69.86L120.86 70.04V72.05Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.08 66.11L120.86 70.04V72.05L112.51 67.21L114.08 66.11Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86 70.04L121.19 69.86L114.41 65.94L114.08 66.11L120.86 70.04Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.19 68.18L120.86 72.05V82.4L112.51 77.56V67.21L114.19 68.18Z",
    fill: "#009CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86 72.05V82.4L128.81 77.74V67.39L127.44 68.18V68.19L120.86 72.05Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37 73.82V81.29L113.9 79.87V72.39L116.37 73.82Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.21 74.07V75.18L119.01 74.49V73.37L120.21 74.07Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.371 73.82L117.661 71.38V80.54L116.371 81.29V73.82Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66 71.38L115.19 69.95L113.9 72.39L116.37 73.82L117.66 71.38Z",
    fill: "#9AD8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.37 71.31L127.65 71.14C127.65 71.14 127.72 71.09 127.76 71.07C127.92 71 128.1 71 128.27 71.1C128.65 71.32 128.89 71.73 128.89 72.18V78.75C128.89 78.96 128.78 79.13 128.62 79.23H128.6L128.15 79.5L128.12 79.27C128.12 79.27 128.07 79.25 128.05 79.23C127.67 79.01 127.43 78.6 127.43 78.15V71.69L127.37 71.29V71.31Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77 71.08C127.93 71.01 128.11 71.01 128.28 71.11C128.57 71.28 128.78 71.56 128.86 71.88L127.43 72.71V71.72L127.37 71.32L127.65 71.15C127.65 71.15 127.72 71.1 127.76 71.08H127.77Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.66 71.44C128.75 71.57 128.83 71.72 128.86 71.87L127.43 72.7V72.15L128.66 71.44V71.44Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 72.41V78.98C128.5 79.42 128.03 79.69 127.65 79.47C127.27 79.25 127.03 78.84 127.03 78.39V71.82C127.03 71.38 127.5 71.11 127.88 71.33C128.26 71.55 128.5 71.96 128.5 72.41Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6 71.75L126.88 71.58C126.88 71.58 126.95 71.53 126.99 71.51C127.15 71.44 127.33 71.44 127.5 71.54C127.88 71.76 128.12 72.17 128.12 72.62V79.19C128.12 79.4 128.01 79.57 127.85 79.67H127.83L127.38 79.94L127.35 79.71C127.35 79.71 127.3 79.69 127.28 79.67C126.9 79.45 126.66 79.04 126.66 78.59V72.13L126.6 71.73V71.75Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 71.52C127.16 71.45 127.34 71.45 127.51 71.55C127.8 71.72 128.01 72 128.09 72.32L126.66 73.15V72.16L126.6 71.76L126.88 71.59C126.88 71.59 126.95 71.54 126.99 71.52H127Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.89 71.88C127.98 72.01 128.06 72.16 128.09 72.31L126.66 73.14V72.59L127.89 71.88V71.88Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.73 72.86V79.43C127.73 79.87 127.26 80.14 126.88 79.92C126.5 79.7 126.26 79.29 126.26 78.84V72.27C126.26 71.83 126.73 71.56 127.11 71.78C127.49 72 127.73 72.41 127.73 72.86V72.86Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83 72.2L126.11 72.03C126.11 72.03 126.18 71.98 126.22 71.96C126.38 71.89 126.56 71.89 126.73 71.99C127.11 72.21 127.35 72.62 127.35 73.07V79.64C127.35 79.85 127.24 80.02 127.08 80.12H127.06L126.61 80.39L126.58 80.16C126.58 80.16 126.53 80.14 126.51 80.12C126.13 79.9 125.89 79.49 125.89 79.04V72.58L125.83 72.18V72.2Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.23 71.97C126.39 71.9 126.57 71.9 126.74 72C127.03 72.17 127.24 72.45 127.32 72.77L125.89 73.6V72.61L125.83 72.21L126.11 72.04C126.11 72.04 126.18 71.99 126.22 71.97H126.23Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12 72.33C127.21 72.46 127.29 72.61 127.32 72.76L125.89 73.59V73.04L127.12 72.33V72.33Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.96 73.3V79.87C126.96 80.31 126.49 80.58 126.11 80.36C125.73 80.14 125.49 79.73 125.49 79.28V72.71C125.49 72.27 125.96 72 126.34 72.22C126.72 72.44 126.96 72.85 126.96 73.3V73.3Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06 72.64L125.34 72.47C125.34 72.47 125.41 72.42 125.45 72.4C125.61 72.33 125.79 72.33 125.96 72.43C126.34 72.65 126.58 73.06 126.58 73.51V80.08C126.58 80.29 126.47 80.46 126.31 80.56H126.29L125.84 80.83L125.81 80.6C125.81 80.6 125.76 80.58 125.74 80.56C125.36 80.34 125.12 79.93 125.12 79.48V73.02L125.06 72.62V72.64Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.46 72.41C125.62 72.34 125.8 72.34 125.97 72.44C126.26 72.61 126.47 72.89 126.55 73.21L125.12 74.04V73.05L125.06 72.65L125.34 72.48C125.34 72.48 125.41 72.43 125.45 72.41H125.46Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35 72.77C126.44 72.9 126.52 73.05 126.55 73.2L125.12 74.03V73.48L126.35 72.77V72.77Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.19 73.75V80.32C126.19 80.76 125.72 81.03 125.34 80.81C124.96 80.59 124.72 80.18 124.72 79.73V73.16C124.72 72.72 125.19 72.45 125.57 72.67C125.95 72.89 126.19 73.3 126.19 73.75Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.29 73.09L124.57 72.92C124.57 72.92 124.64 72.87 124.68 72.85C124.84 72.78 125.02 72.78 125.19 72.88C125.57 73.1 125.81 73.51 125.81 73.96V80.53C125.81 80.74 125.7 80.91 125.54 81.01H125.52L125.07 81.28L125.04 81.05C125.04 81.05 124.99 81.03 124.97 81.01C124.59 80.79 124.35 80.38 124.35 79.93V73.47L124.29 73.07V73.09Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.69 72.85C124.85 72.78 125.03 72.78 125.2 72.88C125.49 73.05 125.7 73.33 125.78 73.65L124.35 74.48V73.49L124.29 73.09L124.57 72.92C124.57 72.92 124.64 72.87 124.68 72.85H124.69Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58 73.22C125.67 73.35 125.75 73.5 125.78 73.65L124.35 74.48V73.93L125.58 73.22V73.22Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.42 74.19V80.76C125.42 81.2 124.95 81.47 124.57 81.25C124.19 81.03 123.95 80.62 123.95 80.17V73.6C123.95 73.16 124.42 72.89 124.8 73.11C125.18 73.33 125.42 73.74 125.42 74.19Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.52 73.53L123.8 73.36C123.8 73.36 123.87 73.31 123.91 73.29C124.07 73.22 124.25 73.22 124.42 73.32C124.8 73.54 125.04 73.95 125.04 74.4V80.97C125.04 81.18 124.93 81.35 124.77 81.45H124.75L124.3 81.72L124.27 81.49C124.27 81.49 124.22 81.47 124.2 81.45C123.82 81.23 123.58 80.82 123.58 80.37V73.91L123.52 73.51V73.53Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.91 73.3C124.07 73.23 124.25 73.23 124.42 73.33C124.71 73.5 124.92 73.78 125 74.1L123.57 74.93V73.94L123.51 73.54L123.79 73.37C123.79 73.37 123.86 73.32 123.9 73.3H123.91Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8 73.66C124.89 73.79 124.97 73.94 125 74.09L123.57 74.92V74.37L124.8 73.66V73.66Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.65 74.63V81.2C124.65 81.64 124.18 81.91 123.8 81.69C123.42 81.47 123.18 81.06 123.18 80.61V74.04C123.18 73.6 123.65 73.33 124.03 73.55C124.41 73.77 124.65 74.18 124.65 74.63Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75 73.97L123.03 73.8C123.03 73.8 123.1 73.75 123.14 73.73C123.3 73.66 123.48 73.66 123.65 73.76C124.03 73.98 124.27 74.39 124.27 74.84V81.41C124.27 81.62 124.16 81.79 124 81.89H123.98L123.53 82.16L123.5 81.93C123.5 81.93 123.45 81.91 123.43 81.89C123.05 81.67 122.81 81.26 122.81 80.81V74.35L122.75 73.95V73.97Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.14 73.74C123.3 73.67 123.48 73.67 123.65 73.77C123.94 73.94 124.15 74.22 124.23 74.54L122.8 75.3701V74.38L122.74 73.9801L123.02 73.81C123.02 73.81 123.09 73.76 123.13 73.74H123.14Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.03 74.11C124.12 74.24 124.2 74.39 124.23 74.54L122.8 75.37V74.82L124.03 74.11V74.11Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88 75.08V81.65C123.88 82.09 123.41 82.36 123.03 82.14C122.65 81.92 122.41 81.51 122.41 81.06V74.49C122.41 74.05 122.88 73.78 123.26 74C123.64 74.22 123.88 74.63 123.88 75.08V75.08Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.98 74.42L122.26 74.25C122.26 74.25 122.33 74.2 122.37 74.18C122.53 74.11 122.71 74.11 122.88 74.21C123.26 74.43 123.5 74.84 123.5 75.29V81.86C123.5 82.07 123.39 82.24 123.23 82.34H123.21L122.76 82.61L122.73 82.38C122.73 82.38 122.68 82.36 122.66 82.34C122.28 82.12 122.04 81.71 122.04 81.26V74.8L121.98 74.4V74.42Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37 74.19C122.53 74.12 122.71 74.12 122.88 74.22C123.17 74.39 123.38 74.67 123.46 74.99L122.03 75.82V74.83L121.97 74.43L122.25 74.26C122.25 74.26 122.32 74.21 122.36 74.19H122.37Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.26 74.55C123.35 74.68 123.43 74.83 123.46 74.98L122.03 75.81V75.26L123.26 74.55V74.55Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.11 75.52V82.09C123.11 82.53 122.64 82.8 122.26 82.58C121.88 82.36 121.64 81.95 121.64 81.5V74.93C121.64 74.49 122.11 74.22 122.49 74.44C122.87 74.66 123.11 75.07 123.11 75.52V75.52Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.43 76.88V77.82L127.16 76.83V75.88L125.43 76.88Z",
    fill: "#BD9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.11 75.52V82.09C123.11 82.53 122.64 82.8 122.26 82.58C121.88 82.36 121.64 81.95 121.64 81.5V74.93C121.64 74.49 122.11 74.22 122.49 74.44C122.87 74.66 123.11 75.07 123.11 75.52V75.52Z",
    fill: "#CC5F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31 68.3L124.83 66.24V65.85L117.37 65.64V66.03L121.31 68.3Z",
    fill: "#9DA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31 67.92L124.83 65.85L120.95 63.61L117.37 65.64L121.31 67.92Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31 67.92V68.3L117.37 66.03V65.64L121.31 67.92Z",
    fill: "#D4D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57 55.01L120.69 55.35L122.22 59.64L122.56 60.59L122.47 59.62L122.16 58.77L120.73 54.76L120.62 54.45L120.57 55.01Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.06 60.59L120.4 59.64L121.93 55.35L122.05 55.01L122 54.45L121.89 54.76L120.46 58.77L120.15 59.62L120.06 60.59Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 49.32L121.9 54.76L121.94 55.35L122.17 58.77L122.23 59.65L122.68 66.35C122.68 66.35 122.73 66.33 122.74 66.32L122.76 66.3C123.06 66.12 123.01 65.5 123.01 65.5L122.56 60.59L122.48 59.62L122.06 55.01L122.01 54.45L121.54 49.31L121.53 49.32Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.87 66.29L119.89 66.31C119.89 66.31 119.93 66.33 119.95 66.34L120.4 59.64L120.46 58.76L120.69 55.34L120.73 54.75L121.1 49.31L120.63 54.45L120.58 55.01L120.16 59.62L120.08 60.59L119.63 65.5C119.63 65.5 119.58 66.12 119.88 66.3L119.87 66.29Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.98 66.65C121.1 66.67 121.22 66.68 121.33 66.68C121.43 66.68 121.54 66.68 121.64 66.65L121.52 49.31H121.09L120.97 66.64L120.98 66.65Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5 49.3C121.38 49.22 121.24 49.22 121.12 49.3C121.12 49.3 121.08 49.4 121.12 49.43C121.24 49.51 121.38 49.51 121.49 49.43C121.49 49.43 121.53 49.33 121.49 49.3H121.5Z",
    fill: "#7EC7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 66.34L120.35 59.83L120.41 59.31L122.61 65.45L122.67 66.34Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.95 66.34L122.27 59.83L122.21 59.31L120.01 65.45L119.95 66.34Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5599 88.78L103.97 94.23V94.88L92.1899 88.05V87.4L94.5599 88.78Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.97 94.23V94.88L115.18 88.31V87.66L113.25 88.77V88.78L103.97 94.23Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1899 87.4L103.97 94.23L115.18 87.66L103.04 80.59L92.1899 87.4Z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56 77.98L111.83 77.24L110.89 75.79L110.56 75.96V77.98Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.78 72.04L110.56 75.96V77.98L102.21 73.13L103.78 72.04Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56 75.9601L110.89 75.7901L104.11 71.8701L103.78 72.0401L110.56 75.9601Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22 78.76L110.5 78.02L109.56 76.58L109.22 76.75V78.76Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.44 72.83L109.22 76.75V78.76L100.87 73.92L102.44 72.83Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.219 76.75L109.559 76.58L102.779 72.65L102.439 72.83L109.219 76.75Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89 79.55L109.17 78.81L108.22 77.36L107.89 77.53V79.55Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.11 73.61L107.89 77.53V79.55L99.5396 74.7L101.11 73.61Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.889 77.5301L108.219 77.3601L101.439 73.4401L101.109 73.6101L107.889 77.5301Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55 80.33L107.83 79.59L106.89 78.14L106.55 78.32V80.33Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7797 74.4L106.55 78.32V80.33L98.1997 75.49L99.7797 74.4Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55 78.32L106.89 78.14L100.11 74.22L99.7798 74.4L106.55 78.32Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.22 81.1101L106.5 80.3801L105.55 78.9301L105.22 79.1001V81.1101Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4396 75.1801L105.22 79.1001V81.1101L96.8696 76.2701L98.4396 75.1801Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.219 79.1001L105.549 78.9301L98.7694 75.0101L98.4395 75.1801L105.219 79.1001Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.89 81.9L105.16 81.16L104.22 79.71L103.89 79.89V81.9Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1098 75.96L103.89 79.89V81.9L95.5298 77.06L97.1098 75.96Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.89 79.89L104.22 79.71L97.4399 75.79L97.1099 75.96L103.89 79.89Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2198 78.0301L103.88 81.9001V92.2501L95.5298 87.4101V77.0601L97.2198 78.0301Z",
    fill: "#009CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.89 81.9001V92.2501L111.83 87.59V77.2401L110.47 78.0301V78.0401L103.89 81.9001Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4002 83.6701V91.1401L96.9302 89.7201V82.2501L99.4002 83.6701Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.24 83.92V85.03L102.04 84.34V83.23L103.24 83.92Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4004 83.67L100.69 81.23V90.4L99.4004 91.14V83.67Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.69 81.23L98.2202 79.8L96.9302 82.25L99.4002 83.67L100.69 81.23Z",
    fill: "#9AD8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 81.16L110.68 80.99C110.68 80.99 110.75 80.94 110.79 80.92C110.95 80.85 111.13 80.85 111.3 80.95C111.68 81.17 111.92 81.58 111.92 82.03V88.6C111.92 88.81 111.81 88.98 111.65 89.08H111.63L111.18 89.35L111.15 89.12C111.15 89.12 111.1 89.1 111.08 89.08C110.7 88.86 110.46 88.45 110.46 88V81.54L110.4 81.14V81.16Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8 80.93C110.96 80.86 111.14 80.86 111.31 80.96C111.6 81.13 111.81 81.4101 111.89 81.7301L110.46 82.56V81.57L110.4 81.17L110.68 81C110.68 81 110.75 80.95 110.79 80.93H110.8Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.69 81.29C111.78 81.42 111.85 81.57 111.89 81.72L110.46 82.55V82L111.69 81.29V81.29Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.53 82.26V88.83C111.53 89.27 111.06 89.54 110.68 89.32C110.3 89.1 110.06 88.69 110.06 88.24V81.67C110.06 81.23 110.53 80.96 110.91 81.18C111.29 81.4 111.53 81.81 111.53 82.26V82.26Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63 81.6L109.91 81.43C109.91 81.43 109.98 81.38 110.02 81.36C110.18 81.29 110.36 81.29 110.53 81.39C110.91 81.61 111.15 82.02 111.15 82.47V89.04C111.15 89.25 111.04 89.42 110.88 89.52H110.86L110.41 89.79L110.38 89.56C110.38 89.56 110.33 89.54 110.31 89.52C109.93 89.3 109.69 88.89 109.69 88.44V81.98L109.63 81.58V81.6Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.03 81.3701C110.19 81.3001 110.37 81.3 110.54 81.4C110.83 81.57 111.04 81.85 111.12 82.17L109.69 83V82.01L109.63 81.61L109.91 81.44C109.91 81.44 109.98 81.3901 110.02 81.3701H110.03Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.92 81.7401C111.01 81.8701 111.08 82.0201 111.12 82.1701L109.69 83.0001V82.4501L110.92 81.7401V81.7401Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.76 82.7101V89.2801C110.76 89.7201 110.29 89.99 109.91 89.77C109.53 89.55 109.29 89.1401 109.29 88.6901V82.1201C109.29 81.6801 109.76 81.41 110.14 81.63C110.52 81.85 110.76 82.2601 110.76 82.7101V82.7101Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.86 82.0501L109.14 81.8801C109.14 81.8801 109.21 81.8301 109.25 81.8101C109.41 81.7401 109.59 81.7401 109.76 81.8401C110.14 82.0601 110.38 82.4701 110.38 82.9201V89.4901C110.38 89.7001 110.27 89.8701 110.11 89.9701H110.09L109.64 90.2401L109.61 90.0101C109.61 90.0101 109.56 89.9901 109.54 89.9701C109.16 89.7501 108.92 89.3401 108.92 88.8901V82.4301L108.86 82.0301V82.0501Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.26 81.8201C109.42 81.7501 109.6 81.7501 109.77 81.8501C110.06 82.0201 110.27 82.3001 110.35 82.6201L108.92 83.4501V82.4601L108.86 82.0601L109.14 81.8901C109.14 81.8901 109.21 81.8401 109.25 81.8201H109.26Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.15 82.1801C110.24 82.3101 110.31 82.4601 110.35 82.6101L108.92 83.4401V82.8901L110.15 82.1801V82.1801Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.99 83.1501V89.7201C109.99 90.1601 109.52 90.4301 109.14 90.2101C108.76 89.9901 108.52 89.5801 108.52 89.1301V82.5601C108.52 82.1201 108.99 81.8501 109.37 82.0701C109.75 82.2901 109.99 82.7001 109.99 83.1501Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.09 82.4901L108.37 82.3201C108.37 82.3201 108.44 82.2701 108.48 82.2501C108.64 82.1801 108.82 82.1801 108.99 82.2801C109.37 82.5001 109.61 82.9101 109.61 83.3601V89.9301C109.61 90.1401 109.5 90.3101 109.34 90.4101H109.32L108.87 90.6801L108.84 90.4501C108.84 90.4501 108.79 90.4301 108.77 90.4101C108.39 90.1901 108.15 89.7801 108.15 89.3301V82.8701L108.09 82.4701V82.4901Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49 82.2601C108.65 82.1901 108.83 82.1901 109 82.2901C109.29 82.4601 109.5 82.7401 109.58 83.0601L108.15 83.8901V82.9001L108.09 82.5001L108.37 82.3301C108.37 82.3301 108.44 82.2801 108.48 82.2601H108.49Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.37 82.6201C109.46 82.7501 109.53 82.9001 109.57 83.0501L108.14 83.8801V83.3301L109.37 82.6201V82.6201Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22 83.6001V90.1701C109.22 90.6101 108.75 90.8801 108.37 90.6601C107.99 90.4401 107.75 90.0301 107.75 89.5801V83.0101C107.75 82.5701 108.22 82.3001 108.6 82.5201C108.98 82.7401 109.22 83.1501 109.22 83.6001Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.32 82.94L107.6 82.77C107.6 82.77 107.67 82.72 107.71 82.7C107.87 82.63 108.05 82.63 108.22 82.73C108.6 82.95 108.84 83.36 108.84 83.81V90.38C108.84 90.59 108.73 90.76 108.57 90.86H108.55L108.1 91.13L108.07 90.9C108.07 90.9 108.02 90.88 108 90.86C107.62 90.64 107.38 90.23 107.38 89.78V83.32L107.32 82.92V82.94Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 82.7C107.87 82.63 108.05 82.63 108.22 82.73C108.51 82.9 108.72 83.18 108.8 83.5L107.37 84.33V83.34L107.31 82.94L107.59 82.77C107.59 82.77 107.66 82.72 107.7 82.7H107.71Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.6 83.07C108.69 83.2 108.76 83.35 108.8 83.5L107.37 84.33V83.78L108.6 83.07V83.07Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.45 84.04V90.61C108.45 91.05 107.98 91.32 107.6 91.1C107.22 90.88 106.98 90.47 106.98 90.02V83.45C106.98 83.01 107.45 82.74 107.83 82.96C108.21 83.18 108.45 83.59 108.45 84.04V84.04Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55 83.3801L106.83 83.2101C106.83 83.2101 106.9 83.1601 106.94 83.1401C107.1 83.0701 107.28 83.0701 107.45 83.1701C107.83 83.3901 108.07 83.8001 108.07 84.2501V90.8201C108.07 91.0301 107.96 91.2001 107.8 91.3001H107.78L107.33 91.5701L107.3 91.3401C107.3 91.3401 107.25 91.3201 107.23 91.3001C106.85 91.0801 106.61 90.6701 106.61 90.2201V83.7601L106.55 83.3601V83.3801Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.94 83.1501C107.1 83.0801 107.28 83.0801 107.45 83.1801C107.74 83.3501 107.95 83.6301 108.03 83.9501L106.6 84.7801V83.7901L106.54 83.3901L106.82 83.2201C106.82 83.2201 106.89 83.1701 106.93 83.1501H106.94Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.83 83.5101C107.92 83.6401 108 83.7901 108.03 83.9401L106.6 84.7701V84.2201L107.83 83.5101V83.5101Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.68 84.4901V91.0601C107.68 91.5001 107.21 91.7701 106.83 91.5501C106.45 91.3301 106.21 90.9201 106.21 90.4701V83.9001C106.21 83.4601 106.68 83.1901 107.06 83.4101C107.44 83.6301 107.68 84.0401 107.68 84.4901V84.4901Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.78 83.83L106.06 83.66C106.06 83.66 106.13 83.61 106.17 83.59C106.33 83.52 106.51 83.52 106.68 83.62C107.06 83.84 107.3 84.25 107.3 84.7V91.27C107.3 91.48 107.19 91.65 107.03 91.75H107.01L106.56 92.02L106.53 91.79C106.53 91.79 106.48 91.77 106.46 91.75C106.08 91.53 105.84 91.12 105.84 90.67V84.21L105.78 83.81V83.83Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17 83.59C106.33 83.52 106.51 83.52 106.68 83.62C106.97 83.79 107.18 84.07 107.26 84.39L105.83 85.22V84.23L105.77 83.83L106.05 83.66C106.05 83.66 106.12 83.61 106.16 83.59H106.17Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.06 83.96C107.15 84.09 107.23 84.24 107.26 84.39L105.83 85.22V84.67L107.06 83.96V83.96Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.91 84.93V91.5C106.91 91.94 106.44 92.21 106.06 91.99C105.68 91.77 105.44 91.36 105.44 90.91V84.34C105.44 83.9 105.91 83.63 106.29 83.85C106.67 84.07 106.91 84.48 106.91 84.93Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.01 84.27L105.29 84.1C105.29 84.1 105.36 84.05 105.4 84.03C105.56 83.96 105.74 83.96 105.91 84.06C106.29 84.28 106.53 84.69 106.53 85.14V91.71C106.53 91.92 106.42 92.09 106.26 92.19H106.24L105.79 92.46L105.76 92.23C105.76 92.23 105.71 92.21 105.69 92.19C105.31 91.97 105.07 91.56 105.07 91.11V84.65L105.01 84.25V84.27Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.4 84.04C105.56 83.97 105.74 83.97 105.91 84.07C106.2 84.24 106.41 84.52 106.49 84.84L105.06 85.67V84.68L105 84.28L105.28 84.11C105.28 84.11 105.35 84.06 105.39 84.04H105.4Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.29 84.4C106.38 84.53 106.46 84.68 106.49 84.83L105.06 85.66V85.11L106.29 84.4V84.4Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.14 85.37V91.94C106.14 92.38 105.67 92.65 105.29 92.43C104.91 92.21 104.67 91.8 104.67 91.35V84.78C104.67 84.34 105.14 84.07 105.52 84.29C105.9 84.51 106.14 84.92 106.14 85.37Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.46 86.73V87.68L110.19 86.68V85.73L108.46 86.73Z",
    fill: "#BD9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.14 85.37V91.94C106.14 92.38 105.67 92.65 105.29 92.43C104.91 92.21 104.67 91.8 104.67 91.35V84.78C104.67 84.34 105.14 84.07 105.52 84.29C105.9 84.51 106.14 84.92 106.14 85.37Z",
    fill: "#CC5F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.34 78.1501L107.86 76.09V75.7001L100.4 75.4901V75.8801L104.34 78.1501Z",
    fill: "#9DA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.34 77.77L107.86 75.7L103.98 73.46L100.4 75.49L104.34 77.77Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.34 77.7701V78.1501L100.4 75.8801V75.4901L104.34 77.7701Z",
    fill: "#D4D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6 64.86L103.72 65.2L105.25 69.49L105.59 70.44L105.5 69.47L105.19 68.62L103.76 64.61L103.65 64.3L103.6 64.86Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.09 70.44L103.43 69.49L104.96 65.2L105.08 64.86L105.03 64.3L104.92 64.61L103.49 68.62L103.18 69.47L103.09 70.44Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.56 59.17L104.93 64.61L104.97 65.2L105.2 68.62L105.26 69.5L105.71 76.2C105.71 76.2 105.76 76.18 105.77 76.17H105.79C106.09 75.98 106.04 75.35 106.04 75.35L105.59 70.44L105.51 69.47L105.09 64.86L105.04 64.3L104.57 59.16L104.56 59.17Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9 76.15H102.92C102.92 76.15 102.96 76.19 102.98 76.2L103.43 69.5L103.49 68.62L103.72 65.2L103.76 64.61L104.13 59.17L103.66 64.31L103.61 64.87L103.19 69.48L103.11 70.45L102.66 75.36C102.66 75.36 102.61 75.98 102.91 76.16L102.9 76.15Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.01 76.51C104.13 76.53 104.25 76.54 104.36 76.54C104.46 76.54 104.57 76.54 104.67 76.51L104.55 59.17H104.12L104 76.5L104.01 76.51Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.53 59.15C104.41 59.07 104.27 59.07 104.15 59.15C104.15 59.15 104.11 59.25 104.15 59.28C104.27 59.36 104.41 59.36 104.52 59.28C104.52 59.28 104.56 59.18 104.52 59.15H104.53Z",
    fill: "#7EC7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 76.19L103.38 69.68L103.44 69.16L105.64 75.31L105.7 76.19Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.98 76.19L105.3 69.68L105.24 69.16L103.04 75.31L102.98 76.19Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5902 98.6299L87.0002 104.08V104.73L75.2202 97.8999V97.2499L77.5902 98.6299Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 104.08V104.73L98.21 98.16V97.5099L96.28 98.6199V98.6299L87 104.08Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2202 97.2499L87.0002 104.08L98.2102 97.5099L86.0702 90.4399L75.2202 97.2499Z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5903 87.83L94.8603 87.09L93.9203 85.64L93.5903 85.82V87.83Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8102 81.89L93.5902 85.82V87.83L85.2402 82.98L86.8102 81.89Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5901 85.82L93.9201 85.64L87.1401 81.72L86.8101 81.89L93.5901 85.82Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25 88.61L93.53 87.87L92.58 86.43L92.25 86.6V88.61Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4699 82.68L92.2499 86.6V88.61L83.8999 83.77L85.4699 82.68Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2497 86.6L92.5797 86.43L85.8097 82.5L85.4697 82.68L92.2497 86.6Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9199 89.4L92.1899 88.66L91.2499 87.21L90.9199 87.38V89.4Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1398 83.46L90.9198 87.38V89.4L82.5698 84.55L84.1398 83.46Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9196 87.38L91.2496 87.21L84.4697 83.29L84.1396 83.46L90.9196 87.38Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5801 90.1799L90.8601 89.4399L89.9201 87.9999L89.5801 88.1699V90.1799Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8 84.2499L89.58 88.1699V90.1799L81.23 85.3399L82.8 84.2499Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5798 88.1699L89.9198 87.9999L83.1398 84.0699L82.7998 84.2499L89.5798 88.1699Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.25 90.97L89.53 90.23L88.58 88.78L88.25 88.95V90.97Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4699 85.03L88.2499 88.95V90.97L79.8999 86.12L81.4699 85.03Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2497 88.95L88.5797 88.78L81.7997 84.86L81.4697 85.03L88.2497 88.95Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9102 91.7499L88.1902 91.0099L87.2502 89.5599L86.9102 89.7399V91.7499Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1401 85.8199L86.9101 89.7399V91.7499L78.5601 86.91L80.1401 85.8199Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9101 89.74L87.2501 89.56L80.4701 85.64L80.1401 85.82L86.9101 89.74Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2501 87.88L86.9101 91.75V102.1L78.5601 97.26V86.91L80.2501 87.88Z",
    fill: "#009CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9102 91.75V102.1L94.8602 97.44V87.09L93.5002 87.88V87.89L86.9102 91.75Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4305 93.52V100.99L79.9604 99.57V92.1L82.4305 93.52Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2703 93.77V94.88L85.0703 94.19V93.08L86.2703 93.77Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4307 93.52L83.7207 91.08V100.25L82.4307 100.99V93.52Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7205 91.08L81.2505 89.66L79.9604 92.1L82.4305 93.52L83.7205 91.08Z",
    fill: "#9AD8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4302 91.01L93.7102 90.84C93.7102 90.84 93.7802 90.79 93.8202 90.77C93.9802 90.7 94.1602 90.7 94.3302 90.8C94.7102 91.02 94.9502 91.43 94.9502 91.88V98.45C94.9502 98.66 94.8402 98.83 94.6802 98.93H94.6602L94.2102 99.2L94.1802 98.97C94.1802 98.97 94.1302 98.95 94.1102 98.93C93.7302 98.71 93.4902 98.3 93.4902 97.85V91.39L93.4302 90.99V91.01Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8302 90.78C93.9902 90.71 94.1702 90.71 94.3402 90.81C94.6302 90.98 94.8402 91.26 94.9202 91.58L93.4902 92.41V91.42L93.4302 91.02L93.7102 90.85C93.7102 90.85 93.7802 90.8 93.8202 90.78H93.8302Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7202 91.14C94.8102 91.27 94.8802 91.42 94.9202 91.57L93.4902 92.4V91.85L94.7202 91.14V91.14Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5603 92.11V98.68C94.5603 99.12 94.0903 99.39 93.7103 99.17C93.3303 98.95 93.0903 98.54 93.0903 98.09V91.52C93.0903 91.08 93.5603 90.81 93.9403 91.03C94.3203 91.25 94.5603 91.66 94.5603 92.11V92.11Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6602 91.46L92.9402 91.29C92.9402 91.29 93.0102 91.24 93.0502 91.22C93.2102 91.15 93.3902 91.15 93.5602 91.25C93.9402 91.47 94.1802 91.88 94.1802 92.33V98.9C94.1802 99.11 94.0702 99.28 93.9102 99.38H93.8902L93.4402 99.65L93.4102 99.42C93.4102 99.42 93.3601 99.4 93.3401 99.38C92.9601 99.16 92.7202 98.75 92.7202 98.3V91.84L92.6602 91.44V91.46Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0602 91.22C93.2202 91.15 93.4002 91.15 93.5702 91.25C93.8602 91.42 94.0702 91.7 94.1502 92.02L92.7202 92.85V91.86L92.6602 91.46L92.9402 91.29C92.9402 91.29 93.0102 91.24 93.0502 91.22H93.0602Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9502 91.59C94.0402 91.72 94.1102 91.87 94.1502 92.02L92.7202 92.85V92.3L93.9502 91.59V91.59Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7903 92.56V99.13C93.7903 99.57 93.3203 99.84 92.9403 99.62C92.5603 99.4 92.3203 98.99 92.3203 98.54V91.97C92.3203 91.53 92.7903 91.26 93.1703 91.48C93.5503 91.7 93.7903 92.11 93.7903 92.56Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8901 91.9L92.1701 91.73C92.1701 91.73 92.2401 91.68 92.2801 91.66C92.4401 91.59 92.6201 91.59 92.7901 91.69C93.1701 91.91 93.4101 92.32 93.4101 92.77V99.34C93.4101 99.55 93.3001 99.72 93.1401 99.82H93.1201L92.6701 100.09L92.6401 99.86C92.6401 99.86 92.5901 99.84 92.5701 99.82C92.1901 99.6 91.9501 99.19 91.9501 98.74V92.28L91.8901 91.88V91.9Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2804 91.67C92.4404 91.6 92.6204 91.6 92.7904 91.7C93.0804 91.87 93.2904 92.15 93.3704 92.47L91.9404 93.3V92.31L91.8804 91.91L92.1604 91.74C92.1604 91.74 92.2304 91.69 92.2704 91.67H92.2804Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1704 92.03C93.2604 92.16 93.3304 92.31 93.3704 92.46L91.9404 93.29V92.74L93.1704 92.03V92.03Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0203 93V99.57C93.0203 100.01 92.5503 100.28 92.1703 100.06C91.7903 99.84 91.5503 99.43 91.5503 98.98V92.41C91.5503 91.97 92.0203 91.7 92.4003 91.92C92.7803 92.14 93.0203 92.55 93.0203 93Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1201 92.34L91.4001 92.17C91.4001 92.17 91.4701 92.12 91.5101 92.1C91.6701 92.03 91.8501 92.03 92.0201 92.13C92.4001 92.35 92.6401 92.76 92.6401 93.21V99.78C92.6401 99.99 92.5301 100.16 92.3701 100.26H92.3501L91.9001 100.53L91.8701 100.3C91.8701 100.3 91.8201 100.28 91.8001 100.26C91.4201 100.04 91.1801 99.63 91.1801 99.18V92.72L91.1201 92.32V92.34Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5104 92.11C91.6704 92.04 91.8503 92.04 92.0203 92.14C92.3103 92.31 92.5203 92.59 92.6003 92.91L91.1703 93.74V92.75L91.1104 92.35L91.3904 92.18C91.3904 92.18 91.4604 92.13 91.5004 92.11H91.5104Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4004 92.48C92.4904 92.61 92.5604 92.76 92.6004 92.91L91.1704 93.74V93.19L92.4004 92.48V92.48Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2503 93.45V100.02C92.2503 100.46 91.7803 100.73 91.4003 100.51C91.0203 100.29 90.7803 99.88 90.7803 99.43V92.86C90.7803 92.42 91.2503 92.15 91.6303 92.37C92.0103 92.59 92.2503 93 92.2503 93.45V93.45Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3501 92.79L90.6301 92.62C90.6301 92.62 90.7001 92.57 90.7401 92.55C90.9001 92.48 91.0801 92.48 91.2501 92.58C91.6301 92.8 91.8701 93.21 91.8701 93.66V100.23C91.8701 100.44 91.7601 100.61 91.6001 100.71H91.5801L91.1301 100.98L91.1001 100.75C91.1001 100.75 91.0501 100.73 91.0301 100.71C90.6501 100.49 90.4101 100.08 90.4101 99.63V93.17L90.3501 92.77V92.79Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7403 92.5601C90.9003 92.4901 91.0803 92.4901 91.2503 92.5901C91.5403 92.7601 91.7503 93.0401 91.8303 93.3601L90.4003 94.1901V93.2001L90.3403 92.8001L90.6203 92.6301C90.6203 92.6301 90.6903 92.5801 90.7303 92.5601H90.7403Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6304 92.92C91.7204 93.05 91.7904 93.2 91.8304 93.35L90.4004 94.18V93.63L91.6304 92.92V92.92Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4803 93.89V100.46C91.4803 100.9 91.0102 101.17 90.6302 100.95C90.2502 100.73 90.0103 100.32 90.0103 99.87V93.3C90.0103 92.86 90.4803 92.59 90.8603 92.81C91.2403 93.03 91.4803 93.44 91.4803 93.89V93.89Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5801 93.2301L89.8601 93.06C89.8601 93.06 89.9301 93.01 89.9701 92.99C90.1301 92.92 90.3101 92.92 90.4801 93.02C90.8601 93.24 91.1001 93.65 91.1001 94.1V100.67C91.1001 100.88 90.9901 101.05 90.8301 101.15H90.8101L90.3601 101.42L90.3301 101.19C90.3301 101.19 90.2801 101.17 90.2601 101.15C89.8801 100.93 89.6401 100.52 89.6401 100.07V93.61L89.5801 93.21V93.2301Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9703 93.0001C90.1303 92.9301 90.3103 92.9301 90.4803 93.0301C90.7703 93.2001 90.9803 93.4801 91.0603 93.8001L89.6303 94.6301V93.6401L89.5703 93.2401L89.8503 93.0701C89.8503 93.0701 89.9203 93.0201 89.9603 93.0001H89.9703Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8604 93.36C90.9504 93.49 91.0304 93.64 91.0604 93.79L89.6304 94.62V94.07L90.8604 93.36V93.36Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7102 94.34V100.91C90.7102 101.35 90.2402 101.62 89.8602 101.4C89.4802 101.18 89.2402 100.77 89.2402 100.32V93.7501C89.2402 93.3101 89.7102 93.0401 90.0902 93.2601C90.4702 93.4801 90.7102 93.89 90.7102 94.34Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8101 93.68L89.0901 93.51C89.0901 93.51 89.1601 93.46 89.2001 93.44C89.3601 93.37 89.5401 93.37 89.7101 93.47C90.0901 93.69 90.3301 94.1 90.3301 94.55V101.12C90.3301 101.33 90.2201 101.5 90.0601 101.6H90.0401L89.5901 101.87L89.5601 101.64C89.5601 101.64 89.5101 101.62 89.4901 101.6C89.1101 101.38 88.8701 100.97 88.8701 100.52V94.06L88.8101 93.66V93.68Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2003 93.44C89.3603 93.37 89.5403 93.37 89.7103 93.47C90.0003 93.64 90.2103 93.92 90.2903 94.24L88.8603 95.07V94.08L88.8003 93.68L89.0803 93.51C89.0803 93.51 89.1503 93.46 89.1903 93.44H89.2003Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0903 93.81C90.1803 93.94 90.2604 94.09 90.2904 94.24L88.8604 95.07V94.52L90.0903 93.81V93.81Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9402 94.78V101.35C89.9402 101.79 89.4702 102.06 89.0902 101.84C88.7102 101.62 88.4702 101.21 88.4702 100.76V94.19C88.4702 93.75 88.9402 93.48 89.3202 93.7C89.7002 93.92 89.9402 94.33 89.9402 94.78Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.04 94.12L88.32 93.95C88.32 93.95 88.39 93.9 88.43 93.88C88.59 93.81 88.77 93.81 88.94 93.91C89.32 94.13 89.56 94.54 89.56 94.99V101.56C89.56 101.77 89.45 101.94 89.29 102.04H89.27L88.82 102.31L88.79 102.08C88.79 102.08 88.74 102.06 88.72 102.04C88.34 101.82 88.1 101.41 88.1 100.96V94.5L88.04 94.1V94.12Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4303 93.89C88.5903 93.82 88.7703 93.82 88.9403 93.92C89.2303 94.09 89.4403 94.37 89.5203 94.69L88.0903 95.52V94.53L88.0303 94.13L88.3103 93.96C88.3103 93.96 88.3803 93.91 88.4203 93.89H88.4303Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3203 94.25C89.4103 94.38 89.4903 94.53 89.5203 94.68L88.0903 95.51V94.96L89.3203 94.25V94.25Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1702 95.22V101.79C89.1702 102.23 88.7002 102.5 88.3202 102.28C87.9402 102.06 87.7002 101.65 87.7002 101.2V94.63C87.7002 94.19 88.1702 93.92 88.5502 94.14C88.9302 94.36 89.1702 94.77 89.1702 95.22Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4902 96.58V97.53L93.2202 96.53V95.59L91.4902 96.58Z",
    fill: "#BD9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1702 95.22V101.79C89.1702 102.23 88.7002 102.5 88.3202 102.28C87.9402 102.06 87.7002 101.65 87.7002 101.2V94.63C87.7002 94.19 88.1702 93.92 88.5502 94.14C88.9302 94.36 89.1702 94.77 89.1702 95.22Z",
    fill: "#CC5F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3702 88L90.8902 85.94V85.55L83.4302 85.34V85.73L87.3702 88Z",
    fill: "#9DA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3702 87.62L90.8902 85.55L87.0102 83.32L83.4302 85.34L87.3702 87.62Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3702 87.62V88L83.4302 85.73V85.34L87.3702 87.62Z",
    fill: "#D4D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6304 74.71L86.7504 75.05L88.2804 79.34L88.6104 80.29L88.5304 79.32L88.2204 78.47L86.7904 74.46L86.6804 74.16L86.6304 74.71Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1206 80.29L86.4606 79.34L87.9906 75.05L88.1106 74.71L88.0606 74.16L87.9506 74.46L86.5206 78.47L86.2106 79.32L86.1206 80.29Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5903 69.02L87.9603 74.46L88.0003 75.05L88.2303 78.47L88.2903 79.35L88.7403 86.05C88.7403 86.05 88.7903 86.03 88.8003 86.02L88.8203 86C89.1203 85.82 89.0703 85.2 89.0703 85.2L88.6203 80.29L88.5403 79.32L88.1203 74.71L88.0703 74.15L87.6003 69.01L87.5903 69.02Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9204 86L85.9404 86.02C85.9404 86.02 85.9804 86.04 86.0004 86.05L86.4504 79.35L86.5104 78.47L86.7404 75.05L86.7804 74.46L87.1504 69.02L86.6804 74.16L86.6304 74.72L86.2104 79.33L86.1304 80.3L85.6804 85.21C85.6804 85.21 85.6304 85.83 85.9304 86.01L85.9204 86Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0305 86.36C87.1505 86.38 87.2705 86.39 87.3805 86.39C87.4805 86.39 87.5905 86.39 87.6905 86.36L87.5705 69.02H87.1405L87.0205 86.35L87.0305 86.36Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5604 69C87.4404 68.92 87.3004 68.92 87.1804 69C87.1804 69 87.1404 69.1 87.1804 69.13C87.3004 69.21 87.4404 69.21 87.5504 69.13C87.5504 69.13 87.5904 69.03 87.5504 69H87.5604Z",
    fill: "#7EC7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7302 86.04L86.4102 79.53L86.4702 79.01L88.6702 85.16L88.7302 86.04Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0103 86.04L88.3303 79.53L88.2702 79.01L86.0703 85.16L86.0103 86.04Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.62 108.48L70.02 113.93V114.58L58.25 107.75V107.1L60.62 108.48Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0298 113.93V114.58L81.2298 108.01V107.36L79.3098 108.47V108.48L70.0298 113.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.25 107.1L70.03 113.93L81.23 107.36L69.1 100.29L58.25 107.1Z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6201 97.68L77.8901 96.94L76.9501 95.49L76.6201 95.67V97.68Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.84 91.74L76.62 95.67V97.68L68.27 92.84L69.84 91.74Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6199 95.67L76.9498 95.49L70.1698 91.57L69.8398 91.74L76.6199 95.67Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2798 98.46L76.5598 97.73L75.6098 96.28L75.2798 96.45V98.46Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4997 92.53L75.2797 96.45V98.46L66.9297 93.62L68.4997 92.53Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2795 96.45L75.6095 96.28L68.8295 92.36L68.4995 92.53L75.2795 96.45Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9497 99.25L75.2197 98.51L74.2797 97.06L73.9497 97.24V99.25Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1696 93.31L73.9496 97.24V99.25L65.5996 94.4L67.1696 93.31Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9494 97.24L74.2794 97.06L67.4994 93.14L67.1694 93.31L73.9494 97.24Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6099 100.03L73.8899 99.29L72.9399 97.85L72.6099 98.02V100.03Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8298 94.1L72.6098 98.02V100.03L64.2598 95.19L65.8298 94.1Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6096 98.02L72.9396 97.85L66.1696 93.92L65.8296 94.1L72.6096 98.02Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2798 100.82L72.5498 100.08L71.6098 98.63L71.2798 98.8V100.82Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4997 94.88L71.2797 98.8V100.82L62.9297 95.97L64.4997 94.88Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2795 98.8L71.6095 98.63L64.8295 94.71L64.4995 94.88L71.2795 98.8Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9399 101.6L71.2199 100.86L70.2799 99.42L69.9399 99.59V101.6Z",
    fill: "#0073A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1598 95.67L69.9398 99.59V101.6L61.5898 96.76L63.1598 95.67Z",
    fill: "#00AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9397 99.59L70.2797 99.42L63.4997 95.49L63.1597 95.67L69.9397 99.59Z",
    fill: "#9FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2698 97.73L69.9398 101.6V111.95L61.5898 107.11V96.76L63.2698 97.73Z",
    fill: "#009CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9399 101.6V111.95L77.8899 107.29V96.94L76.5299 97.73V97.74L69.9399 101.6Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4602 103.37V110.84L62.9902 109.42V101.95L65.4602 103.37Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3001 103.62V104.73L68.1001 104.04V102.93L69.3001 103.62Z",
    fill: "#00AFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4604 103.37L66.7505 100.93V110.1L65.4604 110.84V103.37Z",
    fill: "#005D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7502 100.93L64.2802 99.51L62.9902 101.95L65.4602 103.37L66.7502 100.93Z",
    fill: "#9AD8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.46 100.86L76.74 100.69C76.74 100.69 76.81 100.64 76.85 100.62C77.01 100.55 77.19 100.55 77.36 100.65C77.74 100.87 77.98 101.28 77.98 101.73V108.3C77.98 108.51 77.87 108.68 77.71 108.78H77.69L77.24 109.05L77.21 108.82C77.21 108.82 77.16 108.8 77.14 108.78C76.76 108.56 76.52 108.15 76.52 107.7V101.24L76.46 100.84V100.86Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8502 100.63C77.0102 100.56 77.1902 100.56 77.3602 100.66C77.6502 100.83 77.8602 101.11 77.9402 101.43L76.5102 102.26V101.27L76.4502 100.87L76.7302 100.7C76.7302 100.7 76.8002 100.65 76.8402 100.63H76.8502Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7402 100.99C77.8302 101.12 77.9003 101.27 77.9403 101.42L76.5103 102.25V101.7L77.7402 100.99V100.99Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5901 101.97V108.54C77.5901 108.98 77.1201 109.25 76.7401 109.03C76.3601 108.81 76.1201 108.4 76.1201 107.95V101.38C76.1201 100.94 76.5901 100.67 76.9701 100.89C77.3501 101.11 77.5901 101.52 77.5901 101.97Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6899 101.31L75.9699 101.14C75.9699 101.14 76.0399 101.09 76.0799 101.07C76.2399 101 76.4199 101 76.5899 101.1C76.9699 101.32 77.2099 101.73 77.2099 102.18V108.75C77.2099 108.96 77.0999 109.13 76.9399 109.23H76.9199L76.4699 109.5L76.4399 109.27C76.4399 109.27 76.3899 109.25 76.3699 109.23C75.9899 109.01 75.7499 108.6 75.7499 108.15V101.69L75.6899 101.29V101.31Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0802 101.07C76.2402 101 76.4202 101 76.5902 101.1C76.8802 101.27 77.0902 101.55 77.1702 101.87L75.7402 102.7V101.71L75.6802 101.31L75.9602 101.14C75.9602 101.14 76.0302 101.09 76.0702 101.07H76.0802Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9702 101.44C77.0602 101.57 77.1302 101.72 77.1702 101.87L75.7402 102.7V102.15L76.9702 101.44V101.44Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8201 102.41V108.98C76.8201 109.42 76.3501 109.69 75.9701 109.47C75.5901 109.25 75.3501 108.84 75.3501 108.39V101.82C75.3501 101.38 75.8201 101.11 76.2001 101.33C76.5801 101.55 76.8201 101.96 76.8201 102.41Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9199 101.75L75.1999 101.58C75.1999 101.58 75.2699 101.53 75.3099 101.51C75.4699 101.44 75.6499 101.44 75.8199 101.54C76.1999 101.76 76.4399 102.17 76.4399 102.62V109.19C76.4399 109.4 76.3299 109.57 76.1699 109.67H76.1499L75.6999 109.94L75.6699 109.71C75.6699 109.71 75.6199 109.69 75.5999 109.67C75.2199 109.45 74.9799 109.04 74.9799 108.59V102.13L74.9199 101.73V101.75Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3102 101.52C75.4702 101.45 75.6502 101.45 75.8202 101.55C76.1102 101.72 76.3202 102 76.4002 102.32L74.9702 103.15V102.16L74.9102 101.76L75.1902 101.59C75.1902 101.59 75.2602 101.54 75.3002 101.52H75.3102Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2002 101.88C76.2902 102.01 76.3602 102.16 76.4002 102.31L74.9702 103.14V102.59L76.2002 101.88V101.88Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0501 102.85V109.42C76.0501 109.86 75.5801 110.13 75.2001 109.91C74.8201 109.69 74.5801 109.28 74.5801 108.83V102.26C74.5801 101.82 75.0501 101.55 75.4301 101.77C75.8101 101.99 76.0501 102.4 76.0501 102.85Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1499 102.19L74.4299 102.02C74.4299 102.02 74.4999 101.97 74.5399 101.95C74.6999 101.88 74.8799 101.88 75.0499 101.98C75.4299 102.2 75.6699 102.61 75.6699 103.06V109.63C75.6699 109.84 75.5599 110.01 75.3999 110.11H75.3799L74.9299 110.38L74.8999 110.15C74.8999 110.15 74.8499 110.13 74.8299 110.11C74.4499 109.89 74.2099 109.48 74.2099 109.03V102.57L74.1499 102.17V102.19Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5401 101.96C74.7001 101.89 74.8801 101.89 75.0501 101.99C75.3401 102.16 75.5501 102.44 75.6301 102.76L74.2001 103.59V102.6L74.1401 102.2L74.4201 102.03C74.4201 102.03 74.4901 101.98 74.5301 101.96H74.5401Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4302 102.33C75.5202 102.46 75.5902 102.61 75.6302 102.76L74.2002 103.59V103.04L75.4302 102.33V102.33Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2801 103.3V109.87C75.2801 110.31 74.8101 110.58 74.4301 110.36C74.0501 110.14 73.8101 109.73 73.8101 109.28V102.71C73.8101 102.27 74.2801 102 74.6601 102.22C75.0401 102.44 75.2801 102.85 75.2801 103.3V103.3Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3799 102.64L73.6599 102.47C73.6599 102.47 73.7299 102.42 73.7699 102.4C73.9299 102.33 74.1099 102.33 74.2799 102.43C74.6599 102.65 74.8999 103.06 74.8999 103.51V110.08C74.8999 110.29 74.7899 110.46 74.6299 110.56H74.6099L74.1599 110.83L74.1299 110.6C74.1299 110.6 74.0799 110.58 74.0599 110.56C73.6799 110.34 73.4399 109.93 73.4399 109.48V103.02L73.3799 102.62V102.64Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7701 102.41C73.9301 102.34 74.1101 102.34 74.2801 102.44C74.5701 102.61 74.7801 102.89 74.8601 103.21L73.4301 104.04V103.05L73.3701 102.65L73.6501 102.48C73.6501 102.48 73.7201 102.43 73.7601 102.41H73.7701Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6602 102.77C74.7502 102.9 74.8202 103.05 74.8602 103.2L73.4302 104.03V103.48L74.6602 102.77V102.77Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.51 103.74V110.31C74.51 110.75 74.04 111.02 73.66 110.8C73.28 110.58 73.04 110.17 73.04 109.72V103.15C73.04 102.71 73.51 102.44 73.89 102.66C74.27 102.88 74.51 103.29 74.51 103.74V103.74Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6099 103.08L72.8899 102.91C72.8899 102.91 72.9599 102.86 72.9999 102.84C73.1599 102.77 73.3399 102.77 73.5099 102.87C73.8899 103.09 74.1299 103.5 74.1299 103.95V110.52C74.1299 110.73 74.0199 110.9 73.8599 111H73.8399L73.3899 111.27L73.3599 111.04C73.3599 111.04 73.3099 111.02 73.2899 111C72.9099 110.78 72.6699 110.37 72.6699 109.92V103.46L72.6099 103.06V103.08Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0001 102.85C73.1601 102.78 73.3401 102.78 73.5101 102.88C73.8001 103.05 74.0101 103.33 74.0901 103.65L72.6601 104.48V103.49L72.6001 103.09L72.8801 102.92C72.8801 102.92 72.9501 102.87 72.9901 102.85H73.0001Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8902 103.22C73.9802 103.35 74.0601 103.5 74.0901 103.65L72.6602 104.48V103.93L73.8902 103.22V103.22Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.74 104.19V110.76C73.74 111.2 73.27 111.47 72.89 111.25C72.51 111.03 72.27 110.62 72.27 110.17V103.6C72.27 103.16 72.74 102.89 73.12 103.11C73.5 103.33 73.74 103.74 73.74 104.19Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8398 103.53L72.1199 103.36C72.1199 103.36 72.1899 103.31 72.2299 103.29C72.3899 103.22 72.5698 103.22 72.7398 103.32C73.1198 103.54 73.3598 103.95 73.3598 104.4V110.97C73.3598 111.18 73.2498 111.35 73.0898 111.45H73.0698L72.6199 111.72L72.5898 111.49C72.5898 111.49 72.5398 111.47 72.5198 111.45C72.1398 111.23 71.8998 110.82 71.8998 110.37V103.91L71.8398 103.51V103.53Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2301 103.3C72.3901 103.23 72.5701 103.23 72.7401 103.33C73.0301 103.5 73.2401 103.78 73.3201 104.1L71.8901 104.93V103.94L71.8301 103.54L72.1101 103.37C72.1101 103.37 72.1801 103.32 72.2201 103.3H72.2301Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1201 103.66C73.2101 103.79 73.2901 103.94 73.3201 104.09L71.8901 104.92V104.37L73.1201 103.66V103.66Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.97 104.63V111.2C72.97 111.64 72.5 111.91 72.12 111.69C71.74 111.47 71.5 111.06 71.5 110.61V104.04C71.5 103.6 71.97 103.33 72.35 103.55C72.73 103.77 72.97 104.18 72.97 104.63Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0698 103.97L71.3498 103.8C71.3498 103.8 71.4198 103.75 71.4598 103.73C71.6198 103.66 71.7998 103.66 71.9698 103.76C72.3498 103.98 72.5898 104.39 72.5898 104.84V111.41C72.5898 111.62 72.4798 111.79 72.3198 111.89H72.2998L71.8498 112.16L71.8198 111.93C71.8198 111.93 71.7698 111.91 71.7498 111.89C71.3698 111.67 71.1298 111.26 71.1298 110.81V104.35L71.0698 103.95V103.97Z",
    fill: "#9B3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4601 103.74C71.6201 103.67 71.8001 103.67 71.9701 103.77C72.2601 103.94 72.4701 104.22 72.5501 104.54L71.1201 105.37V104.38L71.0601 103.98L71.3401 103.81C71.3401 103.81 71.4101 103.76 71.4501 103.74H71.4601Z",
    fill: "#EF8F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3501 104.1C72.4401 104.23 72.5201 104.38 72.5501 104.53L71.1201 105.36V104.81L72.3501 104.1V104.1Z",
    fill: "#C4625F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2 105.08V111.65C72.2 112.09 71.73 112.36 71.35 112.14C70.97 111.92 70.73 111.51 70.73 111.06V104.49C70.73 104.05 71.2 103.78 71.58 104C71.96 104.22 72.2 104.63 72.2 105.08V105.08Z",
    fill: "#821B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.52 106.43V107.38L76.24 106.38V105.44L74.52 106.43Z",
    fill: "#BD9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2 105.08V111.65C72.2 112.09 71.73 112.36 71.35 112.14C70.97 111.92 70.73 111.51 70.73 111.06V104.49C70.73 104.05 71.2 103.78 71.58 104C71.96 104.22 72.2 104.63 72.2 105.08V105.08Z",
    fill: "#CC5F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4 97.85L73.92 95.79V95.41L66.46 95.2V95.58L70.4 97.85Z",
    fill: "#9DA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4 97.47L73.92 95.41L70.04 93.17L66.46 95.2L70.4 97.47Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4 97.47V97.85L66.46 95.58V95.2L70.4 97.47Z",
    fill: "#D4D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6504 84.56L69.7804 84.9L71.3104 89.2L71.6404 90.14L71.5604 89.17L71.2504 88.32L69.8104 84.31L69.7104 84.01L69.6504 84.56Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1504 90.14L69.4904 89.2L71.0204 84.9L71.1404 84.56L71.0904 84.01L70.9804 84.31L69.5504 88.32L69.2404 89.17L69.1504 90.14Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6104 78.87L70.9804 84.31L71.0203 84.9L71.2504 88.32L71.3103 89.2L71.7604 95.9C71.7604 95.9 71.8104 95.88 71.8204 95.87L71.8403 95.85C72.1403 95.67 72.0903 95.05 72.0903 95.05L71.6404 90.14L71.5603 89.17L71.1404 84.56L71.0903 84L70.6204 78.86L70.6104 78.87Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9502 95.85L68.9702 95.87C68.9702 95.87 69.0102 95.89 69.0302 95.9L69.4802 89.2L69.5402 88.32L69.7702 84.9L69.8102 84.31L70.1802 78.87L69.7102 84.01L69.6602 84.57L69.2402 89.18L69.1602 90.15L68.7102 95.06C68.7102 95.06 68.6602 95.68 68.9602 95.86L68.9502 95.85Z",
    fill: "#2F5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0603 96.21C70.1803 96.23 70.3003 96.24 70.4103 96.24C70.5103 96.24 70.6203 96.24 70.7203 96.21L70.6003 78.87H70.1703L70.0503 96.2L70.0603 96.21Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5902 78.86C70.4702 78.78 70.3302 78.78 70.2102 78.86C70.2102 78.86 70.1702 78.96 70.2102 78.99C70.3302 79.07 70.4702 79.07 70.5802 78.99C70.5802 78.99 70.6202 78.89 70.5802 78.86H70.5902Z",
    fill: "#7EC7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7599 95.89L69.4399 89.39L69.4999 88.86L71.6999 95.01L71.7599 95.89Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.04 95.89L71.36 89.39L71.3 88.86L69.1 95.01L69.04 95.89Z",
    fill: "#4486AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.669 73.08L133.939 75.81V80.56L134.139 80.69L138.669 77.82L138.869 73.21L138.669 73.08ZM138.439 77.69L134.159 80.16V75.95L138.439 73.48V77.69Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.87 73.21L134.14 75.94V80.69L138.87 77.96V73.21ZM138.64 77.82L134.36 80.29V76.08L138.64 73.61V77.82Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.939 75.81L134.139 75.95L138.869 73.21L138.669 73.08L133.939 75.81Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.229 77.94L138.259 77.96L138.329 78L138.35 77.91L138.579 76.64V76.04L138.229 77.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.88 78.14L137.92 78.16L137.98 78.2L138 78.11L138.58 74.97V74.37L137.88 78.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.64 78.4L138.51 73.69L138.45 73.72L138.38 73.76L137.54 78.34L137.64 78.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.189 78.54L137.289 78.6L138.159 73.89L138.039 73.96L137.189 78.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.85 78.74L136.95 78.8L137.82 74.09L137.7 74.16L136.85 78.74Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.51 78.94L136.61 79L137.48 74.28L137.35 74.36L136.51 78.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16 79.13L136.26 79.2L137.13 74.48L137.02 74.54L137.01 74.55L136.16 79.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82 79.33L135.92 79.4L136.79 74.68L136.66 74.75L135.82 79.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.47 79.53L135.57 79.6L136.44 74.88L136.39 74.91L136.32 74.95L135.47 79.53Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.13 79.73L135.23 79.79L136.1 75.08L135.97 75.15L135.13 79.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.78 79.93L134.88 79.99L135.75 75.28L135.63 75.35L134.78 79.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.439 80.13L134.539 80.19L135.409 75.48L135.279 75.55L134.439 80.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 78.86V79.46L135.06 75.67L134.94 75.75L134.37 78.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 77.19V77.79L134.72 75.88L134.65 75.92L134.6 75.95L134.37 77.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 79.84V79.94L134.75 79.99L134.91 79.9L134.37 79.84Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 79.4V79.5L135.39 79.62L135.54 79.53L134.37 79.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 78.96V79.07L136.02 79.26L136.18 79.17L134.37 78.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 78.52V78.63L136.65 78.89L136.81 78.8L134.37 78.52Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 78.08V78.19L137.29 78.53L137.44 78.43L134.37 78.08Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 77.64V77.75L137.92 78.16L138.08 78.07L134.37 77.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 77.2V77.31L138.43 77.78L138.4 77.67L134.37 77.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 76.76V76.87L138.58 77.36V77.25L134.37 76.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37 76.32V76.43L138.58 76.92V76.81L134.37 76.32Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.49 76.01L138.58 76.48V76.37L134.65 75.92L134.49 76.01Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.12 75.64L138.58 76.04V75.93L135.28 75.55L135.12 75.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76 75.2801L138.58 75.6001V75.4901L135.92 75.1901H135.91L135.76 75.2801Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.39 74.91L138.58 75.16V75.05L136.55 74.82L136.39 74.91Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.02 74.54L138.58 74.72V74.61L137.18 74.45L137.02 74.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.66 74.18L138.58 74.28V74.17L137.82 74.09L137.66 74.18Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.29 73.81L138.58 73.85V73.73L138.45 73.72L138.29 73.81Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.39 75.55L129.66 78.28V83.03L129.86 83.16L134.39 80.29L134.59 75.68L134.39 75.55ZM134.16 80.16L129.88 82.63V78.42L134.16 75.95V80.16Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.59 75.6801L129.86 78.4101V83.1601L134.59 80.4301V75.6801ZM134.36 80.2901L130.08 82.7601V78.5501L134.36 76.0801V80.2901Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.66 78.28L129.86 78.42L134.59 75.68L134.39 75.55L129.66 78.28Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.95 80.41L133.98 80.43L134.05 80.47L134.07 80.38L134.3 79.11V78.51L133.95 80.41Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.61 80.61L133.64 80.63L133.71 80.67L133.72 80.58L134.3 77.44V76.84L133.61 80.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.36 80.87L134.23 76.16L134.17 76.19L134.11 76.23L133.26 80.81L133.36 80.87Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92 81.01L133.02 81.07L133.89 76.36L133.76 76.43L132.92 81.01Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.57 81.2101L132.67 81.2701L133.54 76.5601L133.42 76.6301L132.57 81.2101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.23 81.41L132.33 81.47L133.2 76.75L133.07 76.83L132.23 81.41Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.88 81.6L131.98 81.67L132.85 76.95L132.75 77.01H132.74L132.73 77.02L131.88 81.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54 81.8L131.64 81.87L132.51 77.15L132.38 77.22L131.54 81.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.19 82L131.29 82.07L132.16 77.35L132.11 77.38L132.04 77.42L131.19 82Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.85 82.2L130.95 82.26L131.82 77.55L131.69 77.62L130.85 82.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5 82.4001L130.61 82.4601L131.48 77.7401L131.35 77.8201L130.5 82.4001Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.16 82.6L130.26 82.66L131.13 77.95L131.01 78.02L130.16 82.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 81.33V81.93L130.79 78.14L130.66 78.22L130.09 81.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 79.66V80.26L130.44 78.35L130.37 78.39L130.32 78.42L130.09 79.66Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 82.3101V82.4101L130.47 82.4601H130.48L130.63 82.3701L130.09 82.3101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 81.8701V81.9701L131.11 82.09L131.27 82.0001L130.09 81.8701Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 81.4301V81.5401L131.74 81.7301L131.9 81.6401L130.09 81.4301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 80.9901V81.1001L132.37 81.3601L132.53 81.2701L130.09 80.9901Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 80.55V80.66L133.01 81L133.17 80.9L130.09 80.55Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 80.11V80.22L133.64 80.63L133.8 80.54L130.09 80.11Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 79.67V79.78L134.15 80.25L134.12 80.14L130.09 79.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 79.23V79.34L134.3 79.83V79.72L130.09 79.23Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 78.79V78.9L134.3 79.39V79.28L130.09 78.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21 78.4801L134.3 78.9501V78.8401L130.37 78.3901L130.21 78.4801Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.84 78.1101L134.3 78.5101V78.4001L131 78.0201L130.84 78.1101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48 77.7401L134.3 78.0701V77.9601L131.64 77.6501L131.48 77.7401Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11 77.38L134.3 77.63V77.52L132.27 77.29L132.11 77.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.75 77.01L134.3 77.19V77.08L132.91 76.92H132.9L132.75 77.01Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.38 76.6501L134.3 76.7501V76.6401L133.54 76.5601L133.38 76.6501Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.01 76.2801L134.3 76.3201V76.2001L134.17 76.1901L134.01 76.2801Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.119 78.02L125.389 80.75V85.5L125.589 85.63L130.119 82.76L130.319 78.15L130.119 78.02ZM129.889 82.63L125.609 85.1V80.89L129.889 78.42V82.63Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.319 78.15L125.589 80.88V85.63L130.319 82.9V78.15ZM130.089 82.76L125.809 85.23V81.02L130.089 78.55V82.76Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.379 80.75L125.579 80.88L130.319 78.15L130.119 78.02L125.379 80.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.669 82.88L129.709 82.9L129.769 82.94L129.789 82.85L130.019 81.58V80.98L129.669 82.88Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33 83.08L129.36 83.1L129.43 83.14L129.44 83.05L130.02 79.91V79.3L129.33 83.08Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.079 83.34L129.949 78.63L129.889 78.66L129.829 78.7L128.979 83.28L129.079 83.34Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.64 83.48L128.74 83.54L129.61 78.83L129.48 78.9L128.64 83.48Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.29 83.68L128.39 83.74L129.26 79.03L129.14 79.1L128.29 83.68Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.95 83.88L128.05 83.94L128.92 79.22L128.79 79.3L127.95 83.88Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6 84.07L127.71 84.14L128.58 79.42L128.47 79.48L128.45 79.49L127.6 84.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.26 84.27L127.36 84.34L128.23 79.62L128.11 79.69L127.26 84.27Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.919 84.47L127.019 84.53L127.889 79.82L127.829 79.85L127.759 79.89L126.919 84.47Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.569 84.67L126.669 84.73L127.539 80.02L127.419 80.09L126.569 84.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.229 84.87L126.329 84.93L127.199 80.21L127.069 80.29L126.229 84.87Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.879 85.07L125.979 85.13L126.849 80.42L126.729 80.49L125.879 85.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 83.8V84.4L126.51 80.61L126.38 80.69L125.81 83.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 82.13V82.73L126.16 80.81L126.09 80.86L126.04 80.89L125.81 82.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 84.78V84.88L126.2 84.93L126.35 84.84L125.81 84.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 84.33V84.44L126.83 84.56L126.99 84.47L125.81 84.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 83.9V84.01L127.47 84.2L127.62 84.11L125.81 83.9Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 83.46V83.57L128.1 83.83L128.26 83.74L125.81 83.46Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 83.02V83.13L128.73 83.47L128.89 83.37L125.81 83.02Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 82.58V82.69L129.37 83.1L129.52 83.01L125.81 82.58Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 82.14V82.25L129.87 82.72L129.85 82.61L125.81 82.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 81.7V81.81L130.02 82.3V82.19L125.81 81.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81 81.26V81.37L130.02 81.86V81.75L125.81 81.26Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.93 80.95L130.02 81.42V81.31L126.09 80.86L125.93 80.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.569 80.5801L130.019 80.9801V80.8701L126.719 80.4901L126.569 80.5801Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2 80.2101L130.02 80.5401V80.4301L127.36 80.1201L127.2 80.2101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.83 79.85L130.02 80.1V79.99L127.99 79.76L127.83 79.85Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.47 79.48L130.02 79.66V79.55L128.63 79.39L128.47 79.48Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.1 79.12L130.02 79.22V79.11L129.26 79.03L129.1 79.12Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.729 78.75L130.02 78.79V78.67L129.889 78.66L129.729 78.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.839 80.49L121.109 83.22V87.97L121.309 88.1L125.839 85.23L126.039 80.62L125.839 80.49ZM125.609 85.1L121.329 87.57V83.36L125.609 80.89V85.1Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.04 80.62L121.31 83.35V88.1L126.04 85.37V80.62ZM125.81 85.23L121.53 87.7V83.49L125.81 81.02V85.23Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 83.22L121.3 83.35L126.04 80.62L125.84 80.49L121.1 83.22Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4 85.35L125.43 85.37L125.49 85.41L125.51 85.32L125.75 84.05V83.45L125.4 85.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.05 85.55L125.08 85.57L125.15 85.61L125.17 85.52L125.75 82.38V81.77L125.05 85.55Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.81 85.81L125.67 81.1L125.62 81.13L125.55 81.17L124.71 85.75L124.81 85.81Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.36 85.95L124.46 86.01L125.33 81.3L125.21 81.37L124.36 85.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.02 86.15L124.12 86.21L124.98 81.5L124.86 81.57L124.02 86.15Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.67 86.35L123.77 86.41L124.64 81.69L124.52 81.77L123.67 86.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.33 86.54L123.43 86.61L124.3 81.89L124.19 81.95L124.17 81.96L123.33 86.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.98 86.74L123.08 86.81L123.95 82.09L123.83 82.16L122.98 86.74Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.64 86.94L122.74 87L123.61 82.29L123.56 82.32H123.55L123.48 82.36L122.64 86.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29 87.14L122.39 87.2L123.26 82.49L123.14 82.56L122.29 87.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.95 87.34L122.05 87.4L122.92 82.68L122.79 82.76L121.95 87.34Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 87.54L121.7 87.6L122.57 82.89L122.45 82.96L121.6 87.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 86.27V86.87L122.23 83.08L122.11 83.16L121.53 86.27Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 84.6V85.2L121.89 83.28L121.81 83.33L121.76 83.36L121.53 84.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 87.24V87.35L121.92 87.4L122.08 87.31L121.53 87.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 86.8V86.91L122.55 87.03L122.71 86.94L121.53 86.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 86.37V86.48L123.19 86.67L123.34 86.58L121.53 86.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 85.93V86.04L123.82 86.3L123.98 86.21L121.53 85.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 85.49V85.6L124.45 85.93L124.61 85.84L121.53 85.49Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 85.05V85.16L125.09 85.57L125.24 85.48L121.53 85.05Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 84.61V84.72L125.6 85.19L125.57 85.08L121.53 84.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 84.17V84.28L125.75 84.77V84.66L121.53 84.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 83.73V83.84L125.75 84.33V84.22L121.53 83.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65 83.42L125.75 83.89V83.78L121.81 83.33L121.65 83.42Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29 83.05L125.75 83.45V83.34L122.45 82.96H122.44L122.29 83.05Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.92 82.68L125.75 83.01V82.9L123.08 82.59L122.92 82.68Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.56 82.32L125.75 82.57V82.46L123.72 82.23H123.71L123.56 82.32Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.19 81.95L125.75 82.13V82.02L124.35 81.86L124.19 81.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.82 81.59L125.75 81.69V81.58L124.98 81.5L124.82 81.59Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.46 81.22L125.75 81.26V81.14L125.62 81.13L125.46 81.22Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.33 83.1L116.6 85.83V90.58L116.8 90.71L121.33 87.84L121.53 83.23L121.33 83.1ZM121.1 87.71L116.82 90.18V85.97L121.1 83.5V87.71Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 83.23L116.8 85.96V90.71L121.53 87.98V83.23ZM121.3 87.84L117.02 90.31V86.1L121.3 83.63V87.84Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.6 85.83L116.8 85.97L121.53 83.23L121.33 83.1L116.6 85.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.89 87.96L120.92 87.98L120.99 88.03L121.01 87.93L121.24 86.66V86.06L120.89 87.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.54 88.16L120.58 88.18L120.64 88.22L120.66 88.13L121.24 84.99V84.39L120.54 88.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.3 88.42L121.17 83.71L121.11 83.74L121.04 83.78L120.2 88.36L120.3 88.42Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.86 88.56L119.95 88.62L120.82 83.91L120.7 83.98L119.86 88.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51 88.76L119.61 88.82L120.48 84.11L120.36 84.18L119.51 88.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.17 88.96L119.27 89.02L120.14 84.3L120.01 84.38L119.17 88.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.82 89.15L118.92 89.22L119.79 84.5L119.68 84.56L119.67 84.57L118.82 89.15Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.48 89.35L118.58 89.42L119.45 84.7L119.32 84.77L118.48 89.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.13 89.55L118.23 89.62L119.1 84.9L119.05 84.93L118.98 84.97L118.13 89.55Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79 89.75L117.89 89.81L118.76 85.1L118.63 85.17L117.79 89.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44 89.95L117.54 90.01L118.41 85.3L118.29 85.37L117.44 89.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.1 90.15L117.2 90.21L118.07 85.5L117.94 85.57L117.1 90.15Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 88.88V89.48L117.72 85.7L117.6 85.77L117.03 88.88Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 87.21V87.81L117.38 85.9L117.31 85.94L117.26 85.97L117.03 87.21Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 89.86V89.97L117.41 90.01L117.57 89.92L117.03 89.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 89.42V89.53L118.05 89.64L118.2 89.55L117.03 89.42Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 88.98V89.09L118.68 89.28L118.84 89.19L117.03 88.98Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 88.54V88.65L119.31 88.91L119.47 88.82L117.03 88.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 88.1V88.21L119.95 88.55L120.11 88.45L117.03 88.1Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 87.66V87.77L120.58 88.18L120.74 88.09L117.03 87.66Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 87.22V87.33L121.09 87.8L121.06 87.69L117.03 87.22Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 86.78V86.89L121.24 87.38V87.27L117.03 86.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 86.34V86.45L121.24 86.94V86.83L117.03 86.34Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15 86.0301L121.24 86.5001V86.3901L117.31 85.9401L117.15 86.0301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.78 85.6601L121.24 86.0601V85.9501L117.94 85.5701L117.78 85.6601Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42 85.3001L121.24 85.6201V85.5101L118.58 85.2101H118.57L118.42 85.3001Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05 84.93L121.24 85.18V85.07L119.21 84.84L119.05 84.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.68 84.56L121.24 84.74V84.63L119.84 84.47L119.68 84.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.32 84.2L121.24 84.3V84.19L120.48 84.11L120.32 84.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.95 83.8301L121.24 83.8701V83.7601L121.11 83.7401L120.95 83.8301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05 85.5701L112.32 88.3001V93.0501L112.52 93.1801L117.05 90.3101L117.25 85.7001L117.05 85.5701ZM116.82 90.1801L112.54 92.6501V88.4401L116.82 85.9701V90.1801Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25 85.7001L112.52 88.4301V93.1801L117.25 90.4501V85.7001ZM117.02 90.3101L112.74 92.7801V88.5701L117.02 86.1001V90.3101Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 88.3001L112.52 88.4401L117.25 85.7001L117.05 85.5701L112.32 88.3001Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.61 90.43L116.64 90.45L116.71 90.49L116.73 90.4L116.96 89.13V88.53L116.61 90.43Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.27 90.63L116.3 90.65L116.37 90.69L116.38 90.6L116.96 87.46V86.86L116.27 90.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.02 90.8901L116.89 86.1801L116.83 86.2101L116.77 86.2501L115.92 90.8301L116.02 90.8901Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.58 91.0301L115.68 91.0901L116.55 86.3801L116.42 86.4501L115.58 91.0301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.23 91.2301L115.33 91.2901L116.2 86.5801L116.08 86.6501L115.23 91.2301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.89 91.43L114.99 91.49L115.86 86.77L115.73 86.85L114.89 91.43Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.54 91.62L114.64 91.69L115.51 86.97L115.41 87.03L115.39 87.04L114.54 91.62Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2 91.82L114.3 91.89L115.17 87.17L115.04 87.24L114.2 91.82Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85 92.0201L113.95 92.09L114.82 87.3701L114.77 87.4001L114.7 87.4401L113.85 92.0201Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51 92.2201L113.61 92.2801L114.48 87.5701L114.35 87.6401L113.51 92.2201Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.16 92.42L113.27 92.48L114.14 87.77L114.01 87.84L113.16 92.42Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.82 92.62L112.92 92.68L113.79 87.97L113.67 88.04L112.82 92.62Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 91.35V91.95L113.45 88.17L113.32 88.24L112.75 91.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 89.6801V90.2801L113.1 88.3701L113.03 88.4101L112.98 88.4401L112.75 89.6801Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 92.3301V92.4301L113.13 92.4801H113.14L113.29 92.3901L112.75 92.3301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 91.8901V91.9901L113.77 92.1101L113.93 92.0201L112.75 91.8901Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 91.4501V91.5601L114.4 91.7501L114.56 91.6601L112.75 91.4501Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 91.0101V91.1201L115.03 91.3801L115.19 91.2901L112.75 91.0101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 90.5701V90.6801L115.67 91.0201L115.83 90.9201L112.75 90.5701Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 90.1301V90.2401L116.3 90.6501L116.46 90.5601L112.75 90.1301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 89.6901V89.8001L116.81 90.2701L116.78 90.1601L112.75 89.6901Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 89.2501V89.3601L116.96 89.8501V89.7401L112.75 89.2501Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75 88.8101V88.9201L116.96 89.4101V89.3001L112.75 88.8101Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.87 88.5001L116.96 88.9701V88.8601L113.03 88.4101L112.87 88.5001Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5 88.1301L116.96 88.5301V88.4201L113.66 88.0401L113.5 88.1301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14 87.7701L116.96 88.09V87.9801L114.3 87.6801L114.14 87.7701Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77 87.4001L116.96 87.6501V87.5401L114.93 87.3101L114.77 87.4001Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.41 87.0301L116.96 87.2101V87.1001L115.57 86.9401H115.56L115.41 87.0301Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.04 86.6701L116.96 86.7701V86.6601L116.2 86.5801L116.04 86.6701Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67 86.3001L116.96 86.3401V86.2301L116.83 86.2101L116.67 86.3001Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.779 88.04L108.049 90.77V95.52L108.249 95.65L112.779 92.78L112.979 88.17L112.779 88.04ZM112.549 92.65L108.269 95.12V90.91L112.549 88.44V92.65Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.98 88.17L108.25 90.9V95.65L112.98 92.92V88.17ZM112.75 92.78L108.47 95.25V91.04L112.75 88.57V92.78Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.04 90.77L108.24 90.91L112.98 88.17L112.78 88.04L108.04 90.77Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.33 92.9L112.37 92.92L112.43 92.96L112.45 92.87L112.68 91.6V91L112.33 92.9Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.99 93.1L112.02 93.12L112.09 93.16L112.1 93.07L112.68 89.93V89.33L111.99 93.1Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.74 93.36L112.61 88.65L112.55 88.68L112.49 88.72L111.64 93.3L111.74 93.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3 93.5L111.4 93.56L112.27 88.85L112.14 88.92L111.3 93.5Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.96 93.7L111.05 93.76L111.92 89.05L111.8 89.12L110.96 93.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.61 93.9L110.71 93.96L111.58 89.24L111.45 89.32L110.61 93.9Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.27 94.09L110.37 94.16L111.24 89.44L111.13 89.5L111.11 89.51L110.27 94.09Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.92 94.29L110.02 94.36L110.89 89.64L110.77 89.71L109.92 94.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.58 94.49L109.68 94.56L110.55 89.84L110.49 89.87L110.42 89.91L109.58 94.49Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.229 94.69L109.329 94.75L110.199 90.04L110.079 90.11L109.229 94.69Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.89 94.89L108.99 94.95L109.86 90.24L109.73 90.31L108.89 94.89Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 95.09L108.64 95.15L109.51 90.44L109.39 90.51L108.54 95.09Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 93.82V94.42L109.17 90.63L109.04 90.71L108.47 93.82Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 92.15V92.75L108.82 90.84L108.75 90.88L108.7 90.91L108.47 92.15Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 94.8V94.9L108.86 94.95L109.01 94.86L108.47 94.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 94.36V94.46L109.49 94.58L109.65 94.49L108.47 94.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 93.92V94.03L110.13 94.22L110.28 94.13L108.47 93.92Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 93.48V93.59L110.76 93.85L110.92 93.76L108.47 93.48Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 93.04V93.15L111.39 93.49L111.55 93.39L108.47 93.04Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 92.6V92.71L112.03 93.12L112.18 93.03L108.47 92.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 92.16V92.27L112.54 92.74L112.51 92.63L108.47 92.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 91.72V91.83L112.68 92.32V92.21L108.47 91.72Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47 91.28V91.39L112.68 91.88V91.77L108.47 91.28Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59 90.9701L112.68 91.4401V91.3301L108.75 90.8801L108.59 90.9701Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.229 90.6001L112.679 91.0001V90.8901L109.379 90.5101L109.229 90.6001Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.86 90.24L112.68 90.56V90.45L110.02 90.15L109.86 90.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49 89.87L112.68 90.12V90.01L110.65 89.78L110.49 89.87Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.13 89.5L112.68 89.68V89.57L111.29 89.41L111.13 89.5Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.76 89.14L112.68 89.24V89.13L111.92 89.05L111.76 89.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 88.7701L112.68 88.8101V88.7001L112.55 88.6801L112.39 88.7701Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5 90.51L103.77 93.24V97.99L103.97 98.12L108.5 95.25L108.7 90.64L108.5 90.51ZM108.27 95.12L103.99 97.59V93.38L108.27 90.91V95.12Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 90.64L103.97 93.37V98.12L108.7 95.39V90.64ZM108.47 95.25L104.19 97.72V93.51L108.47 91.04V95.25Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.76 93.24L103.96 93.38L108.7 90.64L108.5 90.51L103.76 93.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.06 95.37L108.09 95.39L108.15 95.43L108.17 95.34L108.41 94.07V93.47L108.06 95.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71 95.57L107.74 95.59L107.81 95.63L107.83 95.54L108.41 92.4V91.8L107.71 95.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.47 95.83L108.33 91.12L108.28 91.15L108.21 91.19L107.37 95.77L107.47 95.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.02 95.97L107.12 96.03L107.99 91.32L107.87 91.39L107.02 95.97Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.68 96.17L106.78 96.23L107.65 91.52H107.64L107.52 91.59L106.68 96.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.33 96.37L106.43 96.43L107.3 91.71L107.18 91.79L106.33 96.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 96.56L106.09 96.63L106.96 91.91L106.85 91.97L106.83 91.98L105.99 96.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.64 96.76L105.74 96.83L106.61 92.11L106.49 92.18L105.64 96.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3 96.96L105.4 97.03L106.27 92.31L106.22 92.34H106.21L106.14 92.38L105.3 96.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.95 97.16L105.05 97.22L105.92 92.51L105.8 92.58L104.95 97.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.61 97.36L104.71 97.42L105.58 92.7L105.45 92.78L104.61 97.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.26 97.56L104.36 97.62L105.23 92.91L105.11 92.98L104.26 97.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 96.29V96.89L104.89 93.1L104.77 93.18L104.19 96.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 94.62V95.22L104.55 93.31L104.47 93.35L104.42 93.38L104.19 94.62Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 97.27V97.37L104.58 97.42L104.74 97.33L104.19 97.27Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 96.83V96.93L105.21 97.05L105.37 96.96L104.19 96.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 96.39V96.5L105.85 96.69L106 96.6L104.19 96.39Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 95.95V96.06L106.48 96.32L106.64 96.23L104.19 95.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 95.51V95.62L107.11 95.96L107.27 95.86L104.19 95.51Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 95.07V95.18L107.75 95.59L107.9 95.5L104.19 95.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 94.63V94.74L108.26 95.21L108.23 95.1L104.19 94.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 94.19V94.3L108.41 94.79V94.68L104.19 94.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19 93.75V93.86L108.41 94.35V94.24L104.19 93.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.31 93.44L108.41 93.91V93.8L104.47 93.35L104.31 93.44Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.95 93.07L108.41 93.47V93.36L105.11 92.98L104.95 93.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.58 92.7L108.41 93.03V92.92L105.74 92.62V92.61L105.58 92.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.22 92.34L108.41 92.59V92.48L106.38 92.25H106.37L106.22 92.34Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.85 91.97L108.41 92.15V92.04L107.01 91.88L106.85 91.97Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48 91.61L108.41 91.71V91.6L107.65 91.52H107.64L107.48 91.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12 91.24L108.41 91.28V91.16L108.28 91.15L108.12 91.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 93.11L99.2695 95.84V100.59L99.4695 100.72L104 97.85L104.2 93.24L104 93.11ZM103.77 97.72L99.4895 100.19V95.98L103.77 93.51V97.72Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2 93.24L99.4697 95.97V100.72L104.2 97.99V93.24ZM103.97 97.85L99.6897 100.32V96.11L103.97 93.64V97.85Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2695 95.84L99.4695 95.98L104.2 93.24L104 93.11L99.2695 95.84Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.56 97.9699L103.59 97.9899L103.66 98.0299L103.67 97.9399L103.91 96.6699V96.0699L103.56 97.9699Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.209 98.17L103.249 98.19L103.309 98.23L103.329 98.14L103.909 95V94.4L103.209 98.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.97 98.43L103.84 93.72L103.78 93.75L103.71 93.79L102.87 98.37L102.97 98.43Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.52 98.57L102.62 98.63L103.49 93.92L103.37 93.99L102.52 98.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.18 98.77L102.28 98.83L103.15 94.12L103.03 94.19L102.18 98.77Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.84 98.9699L101.94 99.0299L102.81 94.3099L102.68 94.3899L101.84 98.9699Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.49 99.16L101.59 99.2299L102.46 94.5099L102.35 94.5699L102.34 94.5799L101.49 99.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.15 99.36L101.25 99.43L102.12 94.71L101.99 94.78L101.15 99.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8 99.56L100.9 99.63L101.77 94.91L101.72 94.94L101.65 94.98L100.8 99.56Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.459 99.76L100.559 99.82L101.429 95.11L101.299 95.18L100.459 99.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.11 99.96L100.21 100.02L101.08 95.3L100.96 95.38L100.11 99.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7695 100.16L99.8695 100.22L100.74 95.5099L100.61 95.5799L99.7695 100.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 98.89V99.49L100.39 95.7L100.27 95.78L99.6997 98.89Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 97.22V97.82L100.05 95.91L99.9797 95.95H99.9697L99.9297 95.98L99.6997 97.22Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 99.87V99.97L100.08 100.02L100.24 99.93L99.6997 99.87Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 99.43V99.53L100.72 99.65L100.87 99.56L99.6997 99.43Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 98.99V99.1L101.35 99.29L101.51 99.2L99.6997 98.99Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 98.55V98.66L101.98 98.92L102.14 98.83L99.6997 98.55Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 98.11V98.22L102.62 98.56L102.77 98.46L99.6997 98.11Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 97.67V97.78L103.25 98.19L103.4 98.1L99.6997 97.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 97.23V97.34L103.76 97.81L103.73 97.7L99.6997 97.23Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 96.79V96.9L103.91 97.39V97.28L99.6997 96.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6997 96.35V96.46L103.91 96.95V96.84L99.6997 96.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8198 96.04L103.91 96.51V96.4L99.9798 95.95H99.9698L99.8198 96.04Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.45 95.67L103.91 96.07V95.96L100.61 95.58L100.45 95.67Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.09 95.3L103.91 95.63V95.52L101.25 95.22H101.24L101.09 95.3Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.72 94.94L103.91 95.19V95.08L101.88 94.85L101.72 94.94Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.35 94.57L103.91 94.75V94.64L102.51 94.48L102.35 94.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.99 94.21L103.91 94.31V94.2L103.15 94.12L102.99 94.21Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.62 93.84L103.91 93.88V93.76L103.78 93.75L103.62 93.84Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7197 95.58L94.9897 98.31V103.06L95.1898 103.19L99.7197 100.32L99.9197 95.71L99.7197 95.58ZM99.4897 100.19L95.2097 102.66V98.45L99.4897 95.98V100.19Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9199 95.71L95.1899 98.44V103.19L99.9199 100.46V95.71ZM99.6899 100.32L95.4099 102.79V98.58L99.6899 96.11V100.32Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9897 98.31L95.1898 98.45L99.9197 95.71L99.7197 95.58L94.9897 98.31Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2798 100.44L99.3098 100.46L99.3798 100.5L99.3998 100.41L99.6298 99.1399V98.5399L99.2798 100.44Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9297 100.64L98.9697 100.66L99.0397 100.7L99.0497 100.61L99.6297 97.4699V96.8699L98.9297 100.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6898 100.9L99.5598 96.1899L99.4998 96.2199L99.4398 96.2599L98.5898 100.84L98.6898 100.9Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.25 101.04L98.35 101.1L99.22 96.39L99.09 96.46L98.25 101.04Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8999 101.24L97.9999 101.3L98.8699 96.59L98.7499 96.66L97.8999 101.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5601 101.44L97.6601 101.5L98.5301 96.7799L98.4001 96.8599L97.5601 101.44Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.21 101.63L97.31 101.7L98.18 96.9799L98.08 97.0399H98.07L98.06 97.0499L97.21 101.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8701 101.83L96.9701 101.9L97.8401 97.1799L97.7101 97.2499L96.8701 101.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.52 102.03L96.62 102.1L97.49 97.3799L97.44 97.41L97.37 97.4499L96.52 102.03Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1797 102.23L96.2797 102.29L97.1497 97.58L97.0197 97.65L96.1797 102.23Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8301 102.43L95.9401 102.49L96.8101 97.77L96.6801 97.85L95.8301 102.43Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4897 102.63L95.5897 102.69L96.4597 97.9799L96.3397 98.0499L95.4897 102.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 101.36V101.96L96.1199 98.1699L95.9899 98.2499L95.4199 101.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 99.6899V100.29L95.7699 98.3799L95.6999 98.4199L95.6499 98.4499L95.4199 99.6899Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 102.34V102.44L95.7999 102.49H95.8099L95.9599 102.4L95.4199 102.34Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 101.89V102L96.4399 102.12L96.5999 102.03L95.4199 101.89Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 101.46V101.57L97.0699 101.76L97.2299 101.67L95.4199 101.46Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 101.02V101.13L97.6999 101.39L97.8599 101.3L95.4199 101.02Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 100.58V100.69L98.3399 101.03L98.4999 100.93L95.4199 100.58Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 100.14V100.25L98.9699 100.66L99.1299 100.57L95.4199 100.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 99.7V99.81L99.4799 100.28L99.4499 100.17L95.4199 99.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 99.2599V99.3699L99.6299 99.8599V99.7499L95.4199 99.2599Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4199 98.8199V98.9299L99.6299 99.4199V99.3099L95.4199 98.8199Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54 98.51L99.63 98.98V98.87L95.7 98.42L95.54 98.51Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1699 98.14L99.6299 98.54V98.43L96.3299 98.05L96.1699 98.14Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8101 97.77L99.6301 98.1V97.99L96.9701 97.68L96.8101 97.77Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4399 97.41L99.6299 97.66V97.5499L97.5999 97.3199L97.4399 97.41Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0801 97.04L99.6301 97.22V97.11L98.2401 96.95H98.2301L98.0801 97.04Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 96.68L99.63 96.78V96.67L98.87 96.59L98.71 96.68Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3398 96.31L99.6298 96.35V96.23L99.4998 96.22L99.3398 96.31Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4492 98.05L90.7192 100.78V105.53L90.9192 105.66L95.4492 102.79L95.6492 98.18L95.4492 98.05ZM95.2192 102.66L90.9392 105.13V100.92L95.2192 98.45V102.66Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6494 98.18L90.9194 100.91V105.66L95.6494 102.93V98.18ZM95.4194 102.79L91.1394 105.26V101.05L95.4194 98.58V102.79Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7095 100.78L90.9095 100.91L95.6495 98.18L95.4495 98.05L90.7095 100.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9995 102.91L95.0395 102.93L95.0995 102.97L95.1195 102.88L95.3495 101.61V101.01L94.9995 102.91Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6597 103.11L94.6897 103.13L94.7597 103.17L94.7697 103.08L95.3497 99.94V99.33L94.6597 103.11Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4096 103.37L95.2796 98.66L95.2196 98.69L95.1596 98.73L94.3096 103.31L94.4096 103.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9697 103.51L94.0697 103.57L94.9397 98.86L94.8097 98.93L93.9697 103.51Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6196 103.71L93.7196 103.77L94.5896 99.0599L94.4696 99.1299L93.6196 103.71Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2798 103.91L93.3798 103.97L94.2498 99.25L94.1198 99.33L93.2798 103.91Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9297 104.1L93.0397 104.17L93.9097 99.45L93.7997 99.51L93.7797 99.52L92.9297 104.1Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5898 104.3L92.6898 104.37L93.5598 99.65L93.4398 99.72L92.5898 104.3Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2495 104.5L92.3495 104.56L93.2195 99.85L93.1595 99.88L93.0895 99.92L92.2495 104.5Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8994 104.7L91.9994 104.76L92.8694 100.05L92.7494 100.12L91.8994 104.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5596 104.9L91.6596 104.96L92.5296 100.24L92.3996 100.32L91.5596 104.9Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2095 105.1L91.3095 105.16L92.1795 100.45L92.0595 100.52L91.2095 105.1Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 103.83V104.43L91.8396 100.64L91.7096 100.72L91.1396 103.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 102.16V102.76L91.4896 100.84L91.4196 100.89L91.3697 100.92L91.1396 102.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 104.8V104.91L91.5296 104.96L91.6796 104.87L91.1396 104.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 104.36V104.47L92.1597 104.59L92.3196 104.5L91.1396 104.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 103.93V104.04L92.7997 104.23L92.9496 104.14L91.1396 103.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 103.49V103.6L93.4296 103.86L93.5797 103.77L91.1396 103.49Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 103.05V103.16L94.0596 103.49L94.2197 103.4L91.1396 103.05Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 102.61V102.72L94.6897 103.13L94.8496 103.04L91.1396 102.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 102.17V102.28L95.1996 102.75L95.1696 102.64L91.1396 102.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 101.73V101.84L95.3496 102.33V102.22L91.1396 101.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1396 101.29V101.4L95.3496 101.89V101.78L91.1396 101.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2598 100.98L95.3498 101.45V101.34L91.4198 100.89L91.2598 100.98Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8994 100.61L95.3494 101.01V100.9L92.0494 100.52L91.8994 100.61Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5298 100.24L95.3498 100.57V100.46L92.6898 100.15L92.5298 100.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1597 99.88L95.3497 100.13V100.02L93.3197 99.79L93.1597 99.88Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7998 99.51L95.3498 99.69V99.58L93.9598 99.42L93.7998 99.51Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4297 99.15L95.3497 99.25V99.14L94.5897 99.06L94.4297 99.15Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0596 98.78L95.3496 98.82V98.7L95.2196 98.69L95.0596 98.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1694 100.52L86.4395 103.25V108L86.6395 108.13L91.1694 105.26L91.3695 100.65L91.1694 100.52ZM90.9395 105.13L86.6595 107.6V103.39L90.9395 100.92V105.13Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3697 100.65L86.6396 103.38V108.13L91.3697 105.4V100.65ZM91.1396 105.26L86.8596 107.73V103.52L91.1396 101.05V105.26Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4297 103.25L86.6297 103.38L91.3697 100.65L91.1697 100.52L86.4297 103.25Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7197 105.38L90.7597 105.4L90.8197 105.44L90.8397 105.35L91.0797 104.08V103.48L90.7197 105.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3799 105.58L90.4099 105.6L90.4799 105.64L90.4999 105.55L91.0799 102.41V101.8L90.3799 105.58Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1398 105.84L90.9998 101.13L90.9398 101.16L90.8798 101.2L90.0298 105.78L90.1398 105.84Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6899 105.98L89.7899 106.04L90.6599 101.33L90.5399 101.4L89.6899 105.98Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3501 106.18L89.4501 106.24L90.3101 101.53L90.1901 101.6L89.3501 106.18Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 106.38L89.1 106.44L89.97 101.72L89.85 101.8L89 106.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6597 106.57L88.7597 106.64L89.6297 101.92L89.5197 101.98L89.4997 101.99L88.6597 106.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3101 106.77L88.4101 106.84L89.2801 102.12L89.1601 102.19L88.3101 106.77Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9697 106.97L88.0697 107.03L88.9397 102.32L88.8797 102.35L88.8097 102.39L87.9697 106.97Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6196 107.17L87.7196 107.23L88.5896 102.52L88.4696 102.59L87.6196 107.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2798 107.37L87.3798 107.43L88.2498 102.71L88.1198 102.79L87.2798 107.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9297 107.57L87.0297 107.63L87.8997 102.92L87.7797 102.99L86.9297 107.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 106.3V106.9L87.5599 103.11L87.4399 103.19L86.8599 106.3Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 104.63V105.23L87.2199 103.31L87.1399 103.36L87.0899 103.39L86.8599 104.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 107.27V107.38L87.2499 107.43L87.4099 107.34L86.8599 107.27Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 106.83V106.94L87.8799 107.06L88.0399 106.97L86.8599 106.83Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 106.4V106.51L88.5199 106.7L88.6699 106.61L86.8599 106.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 105.96V106.07L89.1499 106.33L89.3099 106.24L86.8599 105.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 105.52V105.63L89.7799 105.96L89.9399 105.87L86.8599 105.52Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 105.08V105.19L90.4199 105.6L90.5699 105.51L86.8599 105.08Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 104.64V104.75L90.9299 105.22L90.8999 105.11L86.8599 104.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 104.2V104.31L91.0799 104.8V104.69L86.8599 104.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 103.76V103.87L91.0799 104.36V104.25L86.8599 103.76Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.98 103.45L91.08 103.92V103.81L87.14 103.36L86.98 103.45Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6196 103.08L91.0796 103.48V103.37L87.7796 102.99H87.7696L87.6196 103.08Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.25 102.71L91.08 103.04V102.93L88.41 102.62L88.25 102.71Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8799 102.35L91.0799 102.6V102.49L89.0499 102.26H89.0399L88.8799 102.35Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.52 101.98L91.08 102.16V102.05L89.68 101.89L89.52 101.98Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1499 101.62L91.0799 101.72V101.61L90.3099 101.53L90.1499 101.62Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.79 101.25L91.08 101.29V101.17L90.94 101.16L90.79 101.25Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6597 103.13L81.9297 105.86V110.61L82.1297 110.74L86.6597 107.87L86.8597 103.26L86.6597 103.13ZM86.4297 107.74L82.1497 110.21V106L86.4297 103.53V107.74Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8599 103.26L82.1299 105.99V110.74L86.8599 108.01V103.26ZM86.6299 107.87L82.3499 110.34V106.13L86.6299 103.66V107.87Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9297 105.86L82.1297 106L86.8597 103.26L86.6597 103.13L81.9297 105.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2197 107.99L86.2497 108.01L86.3197 108.05L86.3297 107.96L86.5697 106.69V106.09L86.2197 107.99Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8696 108.19L85.9096 108.21L85.9696 108.25L85.9896 108.16L86.5696 105.02V104.42L85.8696 108.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6298 108.45L86.4998 103.74L86.4398 103.77L86.3698 103.81L85.5298 108.39L85.6298 108.45Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1797 108.59L85.2797 108.65L86.1497 103.94L86.0297 104.01L85.1797 108.59Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8398 108.79L84.9398 108.85L85.8098 104.14L85.6898 104.21L84.8398 108.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 108.99L84.6 109.05L85.47 104.33L85.34 104.41L84.5 108.99Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1499 109.18L84.2499 109.25L85.1199 104.53L85.0099 104.59L84.9999 104.6L84.1499 109.18Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8101 109.38L83.9101 109.45L84.7801 104.73L84.6501 104.8L83.8101 109.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.46 109.58L83.56 109.65L84.43 104.93L84.38 104.96L84.31 105L83.46 109.58Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1196 109.78L83.2196 109.84L84.0896 105.13L83.9596 105.2L83.1196 109.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.77 109.98L82.87 110.04L83.74 105.33L83.62 105.4L82.77 109.98Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4297 110.18L82.5297 110.24L83.3997 105.53L83.2697 105.6L82.4297 110.18Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 108.91V109.51L83.0499 105.72L82.9299 105.8L82.3599 108.91Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 107.24V107.84L82.7099 105.93L82.6399 105.97L82.5899 106L82.3599 107.24Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 109.89V109.99L82.7399 110.04L82.8999 109.95L82.3599 109.89Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 109.45V109.55L83.3799 109.67L83.5299 109.58L82.3599 109.45Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 109.01V109.12L84.0099 109.31L84.1699 109.22L82.3599 109.01Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 108.57V108.68L84.6399 108.94L84.7999 108.85L82.3599 108.57Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 108.13V108.24L85.2799 108.58L85.4299 108.48L82.3599 108.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 107.69V107.8L85.9099 108.21L86.0699 108.12L82.3599 107.69Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 107.25V107.36L86.4199 107.83L86.3899 107.72L82.3599 107.25Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 106.81V106.92L86.5699 107.41V107.3L82.3599 106.81Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3599 106.37V106.48L86.5699 106.97V106.86L82.3599 106.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.48 106.06L86.57 106.53V106.42L82.64 105.97L82.48 106.06Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1099 105.69L86.5699 106.09V105.98L83.2699 105.6L83.1099 105.69Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75 105.33L86.57 105.65V105.54L83.91 105.24H83.9L83.75 105.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3799 104.96L86.5699 105.21V105.1L84.5399 104.87L84.3799 104.96Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0098 104.59L86.5698 104.77V104.66L85.1698 104.5L85.0098 104.59Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6499 104.23L86.5699 104.33V104.22L85.8099 104.14L85.6499 104.23Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2798 103.86L86.5698 103.9V103.79L86.4398 103.77L86.2798 103.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3799 105.6L77.6499 108.33V113.08L77.8499 113.21L82.3799 110.34L82.5799 105.73L82.3799 105.6ZM82.1499 110.21L77.8699 112.68V108.47L82.1499 106V110.21Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5801 105.73L77.8501 108.46V113.21L82.5801 110.48V105.73ZM82.3501 110.34L78.0701 112.81V108.6L82.3501 106.13V110.34Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6499 108.33L77.8499 108.46L82.5799 105.73L82.3799 105.6L77.6499 108.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9399 110.46L81.9699 110.48L82.0399 110.52L82.0599 110.43L82.2899 109.16V108.56L81.9399 110.46Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6001 110.66L81.6301 110.68L81.7001 110.72L81.7101 110.63L82.2901 107.49V106.89L81.6001 110.66Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.35 110.92L82.22 106.21L82.16 106.24L82.1 106.28L81.25 110.86L81.35 110.92Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9102 111.06L81.0102 111.12L81.8801 106.41L81.7502 106.48L80.9102 111.06Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5601 111.26L80.6601 111.32L81.5301 106.61L81.4101 106.68L80.5601 111.26Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2202 111.46L80.3202 111.52L81.1902 106.8L81.0602 106.88L80.2202 111.46Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8701 111.65L79.9701 111.72L80.8401 107L80.7401 107.06H80.7301L80.7201 107.07L79.8701 111.65Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5303 111.85L79.6303 111.92L80.5003 107.2L80.3703 107.27L79.5303 111.85Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1802 112.05L79.2802 112.12L80.1502 107.4L80.1002 107.43L80.0302 107.47L79.1802 112.05Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8398 112.25L78.9398 112.31L79.8098 107.6L79.6798 107.67L78.8398 112.25Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4902 112.45L78.6002 112.51L79.4702 107.79L79.3402 107.87L78.4902 112.45Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1499 112.65L78.2499 112.71L79.1199 108L78.9999 108.07L78.1499 112.65Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 111.38V111.98L78.7801 108.19L78.6501 108.27L78.0801 111.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 109.71V110.31L78.4301 108.4L78.3601 108.44L78.3101 108.47L78.0801 109.71Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 112.36V112.46L78.4601 112.51H78.4701L78.6201 112.42L78.0801 112.36Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 111.91V112.02L79.1001 112.14L79.2601 112.05L78.0801 111.91Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 111.48V111.59L79.7301 111.78L79.8901 111.69L78.0801 111.48Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 111.04V111.15L80.3601 111.41L80.5201 111.32L78.0801 111.04Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 110.6V110.71L81.0001 111.05L81.1601 110.95L78.0801 110.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 110.16V110.27L81.6301 110.68L81.7901 110.59L78.0801 110.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 109.72V109.83L82.1401 110.3L82.1101 110.19L78.0801 109.72Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 109.28V109.39L82.2901 109.88V109.77L78.0801 109.28Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0801 108.84V108.95L82.2901 109.44V109.33L78.0801 108.84Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2002 108.53L82.2902 109V108.89L78.3602 108.44L78.2002 108.53Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8301 108.16L82.2901 108.56V108.45L78.9901 108.07L78.8301 108.16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4702 107.79L82.2902 108.12V108.01L79.6302 107.7L79.4702 107.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1001 107.43L82.2901 107.68V107.57L80.2601 107.34L80.1001 107.43Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7402 107.06L82.2902 107.24V107.13L80.9002 106.97H80.8902L80.7402 107.06Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3701 106.7L82.2901 106.8V106.69L81.5301 106.61L81.3701 106.7Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 106.33L82.29 106.37V106.25L82.16 106.24L82 106.33Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1094 108.07L73.3794 110.8V115.55L73.5794 115.68L78.1094 112.81L78.3094 108.2L78.1094 108.07ZM77.8794 112.68L73.5994 115.15V110.94L77.8794 108.47V112.68Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3096 108.2L73.5796 110.93V115.68L78.3096 112.95V108.2ZM78.0796 112.81L73.7996 115.28V111.07L78.0796 108.6V112.81Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3696 110.8L73.5696 110.93L78.3096 108.2L78.1096 108.07L73.3696 110.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6597 112.93L77.6997 112.95L77.7597 112.99L77.7797 112.9L78.0097 111.63V111.03L77.6597 112.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3198 113.13L77.3498 113.15L77.4198 113.19L77.4298 113.1L78.0098 109.96V109.35L77.3198 113.13Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0697 113.39L77.9397 108.68L77.8797 108.71L77.8197 108.75L76.9697 113.33L77.0697 113.39Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6299 113.53L76.7299 113.59L77.5999 108.88L77.4699 108.95L76.6299 113.53Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2798 113.73L76.3798 113.79L77.2498 109.08L77.1298 109.15L76.2798 113.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9399 113.93L76.0399 113.99L76.9099 109.27L76.7799 109.35L75.9399 113.93Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5898 114.12L75.6998 114.19L76.5698 109.47L76.4598 109.53L76.4398 109.54L75.5898 114.12Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.25 114.32L75.35 114.39L76.22 109.67L76.1 109.74L75.25 114.32Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9097 114.52L75.0097 114.58L75.8797 109.87L75.8197 109.9L75.7497 109.94L74.9097 114.52Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5596 114.72L74.6596 114.78L75.5296 110.07L75.4096 110.14L74.5596 114.72Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2197 114.92L74.3197 114.98L75.1897 110.26L75.0597 110.34L74.2197 114.92Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8696 115.12L73.9696 115.18L74.8396 110.47L74.7196 110.54L73.8696 115.12Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 113.85V114.45L74.4998 110.66L74.3698 110.74L73.7998 113.85Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 112.18V112.78L74.1498 110.86L74.0798 110.91L74.0298 110.94L73.7998 112.18Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 114.82V114.93L74.1898 114.98L74.3398 114.89L73.7998 114.82Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 114.38V114.49L74.8198 114.61L74.9798 114.52L73.7998 114.38Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 113.95V114.06L75.4598 114.25L75.6098 114.16L73.7998 113.95Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 113.51V113.62L76.0898 113.88L76.2398 113.79L73.7998 113.51Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 113.07V113.18L76.7198 113.51L76.8798 113.42L73.7998 113.07Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 112.63V112.74L77.3598 113.15L77.5098 113.06L73.7998 112.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 112.19V112.3L77.8598 112.77L77.8398 112.66L73.7998 112.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 111.75V111.86L78.0098 112.35V112.24L73.7998 111.75Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7998 111.31V111.42L78.0098 111.91V111.8L73.7998 111.31Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9199 111L78.0099 111.47V111.36L74.0799 110.91L73.9199 111Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5596 110.63L78.0096 111.03V110.92L74.7096 110.54L74.5596 110.63Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1899 110.26L78.0099 110.59V110.48L75.3499 110.17L75.1899 110.26Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8198 109.9L78.0098 110.15V110.04L75.9798 109.81L75.8198 109.9Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.46 109.53L78.01 109.71V109.6L76.62 109.44L76.46 109.53Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0898 109.17L78.0098 109.27V109.16L77.2498 109.08L77.0898 109.17Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7197 108.8L78.0097 108.84V108.72L77.8797 108.71L77.7197 108.8Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8296 110.54L69.0996 113.27V118.02L69.2996 118.15L73.8296 115.28L74.0296 110.67L73.8296 110.54ZM73.5996 115.15L69.3196 117.62V113.41L73.5996 110.94V115.15Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0298 110.67L69.2998 113.4V118.15L74.0298 115.42V110.67ZM73.7998 115.28L69.5198 117.75V113.54L73.7998 111.07V115.28Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0898 113.27L69.2898 113.4L74.0298 110.67L73.8298 110.54L69.0898 113.27Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3799 115.4L73.4199 115.42L73.4799 115.46L73.4999 115.37L73.7399 114.1V113.5L73.3799 115.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.04 115.6L73.07 115.62L73.14 115.66L73.16 115.57L73.74 112.43V111.82L73.04 115.6Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7999 115.86L73.6599 111.15L73.6099 111.18L73.5399 111.22L72.6899 115.8L72.7999 115.86Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3501 116L72.4501 116.06L73.3201 111.35L73.2001 111.42L72.3501 116Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0103 116.2L72.1103 116.26L72.9703 111.55L72.8503 111.62L72.0103 116.2Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6602 116.4L71.7602 116.46L72.6301 111.74L72.5102 111.82L71.6602 116.4Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3198 116.59L71.4198 116.66L72.2898 111.94L72.1798 112L72.1598 112.01L71.3198 116.59Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9702 116.79L71.0702 116.86L71.9402 112.14L71.8202 112.21L70.9702 116.79Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6299 116.99L70.7299 117.05L71.5999 112.34L71.5399 112.37L71.4699 112.41L70.6299 116.99Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2798 117.19L70.3798 117.25L71.2498 112.54L71.1298 112.61L70.2798 117.19Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9399 117.39L70.0399 117.45L70.9099 112.73L70.7799 112.81L69.9399 117.39Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5898 117.59L69.6898 117.65L70.5598 112.94L70.4398 113.01L69.5898 117.59Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 116.32V116.92L70.22 113.13L70.1 113.21L69.52 116.32Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 114.65V115.25L69.88 113.33L69.8 113.38L69.75 113.41L69.52 114.65Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 117.29V117.4L69.91 117.45L70.07 117.36L69.52 117.29Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 116.85V116.96L70.54 117.08L70.7 116.99L69.52 116.85Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 116.42V116.53L71.18 116.72L71.33 116.63L69.52 116.42Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 115.98V116.09L71.81 116.35L71.97 116.26L69.52 115.98Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 115.54V115.65L72.44 115.98L72.6 115.89L69.52 115.54Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 115.1V115.21L73.08 115.62L73.23 115.53L69.52 115.1Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 114.66V114.77L73.59 115.24L73.56 115.13L69.52 114.66Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 114.22V114.33L73.74 114.82V114.71L69.52 114.22Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 113.78V113.89L73.74 114.38V114.27L69.52 113.78Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6401 113.47L73.7401 113.94V113.83L69.8001 113.38L69.6401 113.47Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2798 113.1L73.7398 113.5V113.39L70.4398 113.01H70.4298L70.2798 113.1Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9102 112.73L73.7402 113.06V112.95L71.0702 112.64L70.9102 112.73Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.54 112.37L73.74 112.62V112.51L71.71 112.28H71.7L71.54 112.37Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1802 112L73.7402 112.18V112.07L72.3402 111.91L72.1802 112Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8101 111.64L73.7401 111.74V111.63L72.9701 111.55L72.8101 111.64Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4502 111.27L73.7402 111.31V111.19L73.6102 111.18L73.4502 111.27Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3901 93.24L34.5901 97.85L39.1201 100.72L39.3201 100.59V95.84L34.5901 93.11L34.3901 93.24ZM34.8201 93.51L39.1001 95.98V100.19L34.8201 97.72V93.51Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3901 97.99L39.1201 100.72V95.97L34.3901 93.24V97.99ZM34.6201 93.64L38.9001 96.11V100.32L34.6201 97.85V93.64Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3201 95.84L39.1201 95.98L34.3901 93.24L34.5901 93.11L39.3201 95.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0302 97.9699L35.0002 97.9899L34.9302 98.0299L34.9102 97.9399L34.6802 96.6699V96.0699L35.0302 97.9699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3802 98.17L35.3402 98.19L35.2702 98.23L35.2602 98.14L34.6802 95V94.4L35.3802 98.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.62 98.43L34.75 93.72L34.81 93.75L34.87 93.79L35.72 98.37L35.62 98.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0603 98.57L35.9603 98.63L35.0903 93.92L35.2203 93.99L36.0603 98.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4099 98.77L36.3099 98.83L35.4399 94.12L35.5599 94.19L36.4099 98.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7503 98.9699L36.6503 99.0299L35.7803 94.3099L35.9103 94.3899L36.7503 98.9699Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1004 99.16L37.0004 99.2299L36.1304 94.5099L36.2304 94.5699H36.2404L36.2504 94.5799L37.1004 99.16Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4402 99.36L37.3402 99.43L36.4702 94.71L36.6002 94.78L37.4402 99.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7903 99.56L37.6903 99.63L36.8203 94.91L36.8703 94.94L36.9403 94.98L37.7903 99.56Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1302 99.76L38.0302 99.82L37.1602 95.11L37.2902 95.18L38.1302 99.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.48 99.96L38.38 100.02L37.5 95.3L37.63 95.38L38.48 99.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8201 100.16L38.7201 100.22L37.8501 95.5099L37.9701 95.5799L38.8201 100.16Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8899 98.89V99.49L38.1899 95.7L38.3199 95.78L38.8899 98.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.89 97.22V97.82L38.54 95.91L38.61 95.95L38.66 95.98L38.89 97.22Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8901 99.87V99.97L38.5101 100.02H38.5001L38.3501 99.93L38.8901 99.87Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.89 99.43V99.53L37.87 99.65L37.71 99.56L38.89 99.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8901 98.99V99.1L37.2401 99.29L37.0801 99.2L38.8901 98.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8902 98.55V98.66L36.6102 98.92L36.4502 98.83L38.8902 98.55Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8901 98.11V98.22L35.9701 98.56L35.8101 98.46L38.8901 98.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8902 97.67V97.78L35.3402 98.19L35.1802 98.1L38.8902 97.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8901 97.23V97.34L34.8301 97.81L34.8601 97.7L38.8901 97.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8902 96.79V96.9L34.6802 97.39V97.28L38.8902 96.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8902 96.35V96.46L34.6802 96.95V96.84L38.8902 96.35Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7702 96.04L34.6802 96.51V96.4L38.6102 95.95L38.7702 96.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1402 95.67L34.6802 96.07V95.96L37.9802 95.58L38.1402 95.67Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5002 95.3L34.6802 95.63V95.52L37.3402 95.22L37.5002 95.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8702 94.94L34.6802 95.19V95.08L36.7102 94.85L36.8702 94.94Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2302 94.57L34.6802 94.75V94.64L36.0802 94.48L36.2302 94.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6002 94.21L34.6802 94.31V94.2L35.4402 94.12L35.6002 94.21Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9702 93.84L34.6802 93.88V93.76L34.8102 93.75L34.9702 93.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6602 95.71L38.8602 100.32L43.3902 103.19L43.5902 103.06V98.31L38.8602 95.58L38.6602 95.71ZM39.0902 95.98L43.3702 98.45V102.66L39.0902 100.19V95.98Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6602 100.46L43.3902 103.19V98.44L38.6602 95.71V100.46ZM38.8902 96.11L43.1702 98.58V102.79L38.8902 100.32V96.11Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6002 98.31L43.4002 98.45L38.6602 95.71L38.8602 95.58L43.6002 98.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.31 100.44L39.27 100.46L39.21 100.5L39.19 100.41L38.96 99.1399V98.5399L39.31 100.44Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.65 100.64L39.62 100.66L39.55 100.7L39.54 100.61L38.96 97.4699V96.8699L39.65 100.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8998 100.9L39.0298 96.1899L39.0898 96.2199L39.1498 96.2599L39.9998 100.84L39.8998 100.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3401 101.04L40.2401 101.1L39.3701 96.39L39.5001 96.46L40.3401 101.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6897 101.24L40.5897 101.3L39.7197 96.59L39.8397 96.66L40.6897 101.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0301 101.44L40.9301 101.5L40.0601 96.7799L40.1901 96.8599L41.0301 101.44Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 101.63L41.2699 101.7L40.3999 96.9799L40.5099 97.0399L40.5299 97.0499L41.3799 101.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.72 101.83L41.62 101.9L40.75 97.1799L40.87 97.2499L41.72 101.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0598 102.03L41.9598 102.1L41.0898 97.3799L41.1498 97.41L41.2198 97.4499L42.0598 102.03Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4099 102.23L42.3099 102.29L41.4399 97.58L41.5599 97.65L42.4099 102.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7498 102.43L42.6498 102.49L41.7798 97.77L41.9098 97.85L42.7498 102.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0999 102.63L42.9999 102.69L42.1299 97.9799L42.2499 98.0499L43.0999 102.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1697 101.36V101.96L42.4697 98.1699L42.5997 98.2499L43.1697 101.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1698 99.6899V100.29L42.8198 98.3799L42.8898 98.4199L42.9398 98.4499L43.1698 99.6899Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1699 102.34V102.44L42.7799 102.49L42.6299 102.4L43.1699 102.34Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1697 101.89V102L42.1497 102.12L41.9897 102.03L43.1697 101.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1699 101.46V101.57L41.5099 101.76L41.3599 101.67L43.1699 101.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17 101.02V101.13L40.88 101.39L40.73 101.3L43.17 101.02Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1698 100.58V100.69L40.2498 101.03L40.0898 100.93L43.1698 100.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17 100.14V100.25L39.62 100.66L39.46 100.57L43.17 100.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1699 99.7V99.81L39.1099 100.28L39.1399 100.17L43.1699 99.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17 99.2599V99.3699L38.96 99.8599V99.7499L43.17 99.2599Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17 98.8199V98.9299L38.96 99.4199V99.3099L43.17 98.8199Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.05 98.51L38.96 98.98V98.87L42.89 98.42L43.05 98.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.41 98.14L38.96 98.54V98.43L42.26 98.05L42.41 98.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.78 97.77L38.96 98.1V97.99L41.62 97.68L41.78 97.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.15 97.41L38.96 97.66V97.5499L40.99 97.3199L41.15 97.41Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.51 97.04L38.96 97.22V97.11L40.35 96.95L40.51 97.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.88 96.68L38.96 96.78V96.67L39.72 96.59L39.88 96.68Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.25 96.31L38.96 96.35V96.23L39.09 96.22L39.25 96.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9399 98.18L43.1399 102.79L47.6699 105.66L47.8699 105.53V100.78L43.1399 98.05L42.9399 98.18ZM43.3699 98.45L47.6499 100.92V105.13L43.3699 102.66V98.45Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9399 102.93L47.6699 105.66V100.91L42.9399 98.18V102.93ZM43.1699 98.58L47.4499 101.05V105.26L43.1699 102.79V98.58Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8799 100.78L47.6799 100.91L42.9399 98.18L43.1399 98.05L47.8799 100.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.59 102.91L43.55 102.93L43.49 102.97L43.47 102.88L43.23 101.61V101.01L43.59 102.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93 103.11L43.9 103.13L43.83 103.17L43.81 103.08L43.23 99.94V99.33L43.93 103.11Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1701 103.37L43.3101 98.66L43.3701 98.69L43.4301 98.73L44.2801 103.31L44.1701 103.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6199 103.51L44.5199 103.57L43.6499 98.86L43.7699 98.93L44.6199 103.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.96 103.71L44.86 103.77L44 99.0599L44.12 99.1299L44.96 103.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3098 103.91L45.2098 103.97L44.3398 99.25L44.4598 99.33L45.3098 103.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6502 104.1L45.5502 104.17L44.6802 99.45L44.7902 99.51L44.8102 99.52L45.6502 104.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9998 104.3L45.8998 104.37L45.0298 99.65L45.1498 99.72L45.9998 104.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3401 104.5L46.2401 104.56L45.3701 99.85L45.4301 99.88L45.5001 99.92L46.3401 104.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6902 104.7L46.5902 104.76L45.7202 100.05L45.8402 100.12L46.6902 104.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0301 104.9L46.9301 104.96L46.0601 100.24L46.1901 100.32L47.0301 104.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3802 105.1L47.2802 105.16L46.4102 100.45L46.5302 100.52L47.3802 105.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45 103.83V104.43L46.75 100.64L46.87 100.72L47.45 103.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4501 102.16V102.76L47.1001 100.84L47.1701 100.89L47.2201 100.92L47.4501 102.16Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4499 104.8V104.91L47.0599 104.96L46.8999 104.87L47.4499 104.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45 104.36V104.47L46.43 104.59L46.27 104.5L47.45 104.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4501 103.93V104.04L45.7901 104.23L45.6401 104.14L47.4501 103.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45 103.49V103.6L45.16 103.86L45 103.77L47.45 103.49Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4501 103.05V103.16L44.5301 103.49L44.3701 103.4L47.4501 103.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4497 102.61V102.72L43.8897 103.13L43.7397 103.04L47.4497 102.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4499 102.17V102.28L43.3799 102.75L43.4099 102.64L47.4499 102.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45 101.73V101.84L43.23 102.33V102.22L47.45 101.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45 101.29V101.4L43.23 101.89V101.78L47.45 101.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.33 100.98L43.23 101.45V101.34L47.17 100.89L47.33 100.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.69 100.61L43.23 101.01V100.9L46.53 100.52H46.54L46.69 100.61Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06 100.24L43.23 100.57V100.46L45.9 100.15L46.06 100.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.43 99.88L43.23 100.13V100.02L45.26 99.79H45.27L45.43 99.88Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.79 99.51L43.23 99.69V99.58L44.63 99.42L44.79 99.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.16 99.15L43.23 99.25V99.14L44 99.06L44.16 99.15Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.52 98.78L43.23 98.82V98.7L43.37 98.69L43.52 98.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2202 100.65L47.4202 105.26L51.9502 108.13L52.1502 108V103.25L47.4202 100.52L47.2202 100.65ZM47.6502 100.92L51.9302 103.39V107.6L47.6502 105.13V100.92Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2202 105.39L51.9502 108.12V103.37L47.2202 100.64V105.39ZM47.4502 101.04L51.7302 103.51V107.72L47.4502 105.25V101.04Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1502 103.25L51.9502 103.38L47.2202 100.65L47.4202 100.52L52.1502 103.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8603 105.38L47.8303 105.4L47.7603 105.44L47.7503 105.35L47.5103 104.08V103.48L47.8603 105.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2103 105.58L48.1703 105.6L48.1103 105.64L48.0903 105.55L47.5103 102.41V101.8L48.2103 105.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4501 105.84L47.5801 101.13L47.6401 101.16L47.7101 101.2L48.5501 105.78L48.4501 105.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9002 105.98L48.8002 106.04L47.9302 101.33L48.0502 101.4L48.9002 105.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.24 106.18L49.14 106.24L48.27 101.53H48.28L48.4 101.6L49.24 106.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5901 106.38L49.4901 106.44L48.6201 101.72L48.7401 101.8L49.5901 106.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9305 106.57L49.8305 106.64L48.9604 101.92L49.0704 101.98L49.0905 101.99L49.9305 106.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2801 106.77L50.1801 106.84L49.3101 102.12L49.4301 102.19L50.2801 106.77Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6204 106.97L50.5204 107.03L49.6504 102.32L49.7004 102.35H49.7104L49.7704 102.39L50.6204 106.97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9602 107.17L50.8602 107.23L49.9902 102.52L50.1202 102.59L50.9602 107.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3103 107.37L51.2103 107.43L50.3403 102.71L50.4603 102.79L51.3103 107.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6502 107.57L51.5502 107.63L50.6802 102.92L50.8102 102.99L51.6502 107.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7303 106.3V106.9L51.0303 103.11L51.1503 103.19L51.7303 106.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7301 104.63V105.23L51.3701 103.31L51.4501 103.36L51.5001 103.39L51.7301 104.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7302 107.27V107.38L51.3402 107.43L51.1802 107.34L51.7302 107.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7303 106.83V106.94L50.7003 107.06L50.5503 106.97L51.7303 106.83Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7304 106.4V106.51L50.0704 106.7L49.9204 106.61L51.7304 106.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7303 105.96V106.07L49.4403 106.33L49.2803 106.24L51.7303 105.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7304 105.52V105.63L48.8104 105.96L48.6504 105.87L51.7304 105.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.73 105.08V105.19L48.17 105.6L48.02 105.51L51.73 105.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7302 104.64V104.75L47.6602 105.22L47.6902 105.11L51.7302 104.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7303 104.2V104.31L47.5103 104.8V104.69L51.7303 104.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7303 103.76V103.87L47.5103 104.36V104.25L51.7303 103.76Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6003 103.45L47.5103 103.92V103.81L51.4503 103.36L51.6003 103.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9703 103.08L47.5103 103.48V103.37L50.8103 102.99L50.9703 103.08Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3403 102.71L47.5103 103.04V102.93L50.1803 102.62L50.3403 102.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7003 102.35L47.5103 102.6V102.49L49.5403 102.26L49.7003 102.35Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0703 101.98L47.5103 102.16V102.05L48.9103 101.89L49.0703 101.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4403 101.62L47.5103 101.72V101.61L48.2703 101.53H48.2803L48.4403 101.62Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8003 101.25L47.5103 101.29V101.17L47.6403 101.16L47.8003 101.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.73 103.26L51.93 107.87L56.46 110.74L56.66 110.61V105.86L51.93 103.13L51.73 103.26V103.26ZM52.16 103.53L56.44 106V110.21L52.16 107.74V103.53Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.73 108.01L56.46 110.74V105.99L51.73 103.26V108.01V108.01ZM51.96 103.66L56.24 106.13V110.34L51.96 107.87V103.66Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.66 105.86L56.46 106L51.73 103.26L51.93 103.13L56.66 105.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.37 107.99L52.34 108.01L52.27 108.05L52.25 107.96L52.02 106.69V106.09L52.37 107.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.72 108.19L52.68 108.21L52.61 108.25L52.6 108.16L52.02 105.02V104.42L52.72 108.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9598 108.45L52.0898 103.74L52.1498 103.77L52.2098 103.81L53.0598 108.39L52.9598 108.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4002 108.59L53.3002 108.65L52.4302 103.94L52.5602 104.01L53.4002 108.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7498 108.79L53.6498 108.85L52.7798 104.14L52.8998 104.21L53.7498 108.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0901 108.99L53.9901 109.05L53.1201 104.33L53.2501 104.41L54.0901 108.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4402 109.18L54.3402 109.25L53.4702 104.53L53.5702 104.59H53.5802L53.5902 104.6L54.4402 109.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7801 109.38L54.6801 109.45L53.8101 104.73L53.9401 104.8L54.7801 109.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1302 109.58L55.0302 109.65L54.1602 104.93L54.2102 104.96L54.2802 105L55.1302 109.58Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.47 109.78L55.37 109.84L54.5 105.13L54.63 105.2L55.47 109.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8198 109.98L55.7098 110.04L54.8398 105.33L54.9698 105.4L55.8198 109.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1599 110.18L56.0599 110.24L55.1899 105.53L55.3099 105.6L56.1599 110.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2298 108.91V109.51L55.5298 105.72L55.6598 105.8L56.2298 108.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2299 107.24V107.84L55.8799 105.93L55.9499 105.97L55.9999 106L56.2299 107.24Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2299 109.89V109.99L55.8499 110.04H55.8399L55.6899 109.95L56.2299 109.89Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2298 109.45V109.55L55.2098 109.67L55.0498 109.58L56.2298 109.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2299 109.01V109.12L54.5799 109.31L54.4199 109.22L56.2299 109.01Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23 108.57V108.68L53.95 108.94L53.79 108.85L56.23 108.57Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2299 108.13V108.24L53.3099 108.58L53.1499 108.48L56.2299 108.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23 107.69V107.8L52.68 108.21L52.52 108.12L56.23 107.69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2299 107.25V107.36L52.1699 107.83L52.1999 107.72L56.2299 107.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23 106.81V106.92L52.02 107.41V107.3L56.23 106.81Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23 106.37V106.48L52.02 106.97V106.86L56.23 106.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.11 106.06L52.02 106.53V106.42L55.95 105.97L56.11 106.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.48 105.69L52.02 106.09V105.98L55.32 105.6L55.48 105.69Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.84 105.33L52.02 105.65V105.54L54.68 105.24L54.84 105.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.21 104.96L52.02 105.21V105.1L54.05 104.87L54.21 104.96Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57 104.59L52.02 104.77V104.66L53.42 104.5L53.57 104.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.94 104.23L52.02 104.33V104.22L52.78 104.14L52.94 104.23Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.31 103.86L52.02 103.9V103.79L52.15 103.77L52.31 103.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 105.73L56.2 110.34L60.73 113.21L60.93 113.08V108.33L56.2 105.6L56 105.73ZM56.43 106L60.71 108.47V112.68L56.43 110.21V106Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 110.48L60.73 113.21V108.46L56 105.73V110.48ZM56.23 106.13L60.51 108.6V112.81L56.23 110.34V106.13Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.94 108.33L60.74 108.46L56 105.73L56.2 105.6L60.94 108.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6498 110.46L56.6098 110.48L56.5498 110.52L56.5298 110.43L56.2998 109.16V108.56L56.6498 110.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9898 110.66L56.9598 110.68L56.8898 110.72L56.8798 110.63L56.2998 107.49V106.89L56.9898 110.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2396 110.92L56.3696 106.21L56.4296 106.24L56.4896 106.28L57.3396 110.86L57.2396 110.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.68 111.06L57.58 111.12L56.71 106.41L56.84 106.48L57.68 111.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0296 111.26L57.9296 111.32L57.0596 106.61L57.1796 106.68L58.0296 111.26Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3699 111.46L58.2699 111.52L57.3999 106.8L57.5299 106.88L58.3699 111.46Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7197 111.65L58.6097 111.72L57.7397 107L57.8497 107.06L57.8697 107.07L58.7197 111.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0598 111.85L58.9598 111.92L58.0898 107.2L58.2098 107.27L59.0598 111.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3997 112.05L59.2997 112.12L58.4297 107.4L58.4897 107.43L58.5597 107.47L59.3997 112.05Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7498 112.25L59.6498 112.31L58.7798 107.6L58.8998 107.67L59.7498 112.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0896 112.45L59.9896 112.51L59.1196 107.79L59.2496 107.87L60.0896 112.45Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4397 112.65L60.3397 112.71L59.4697 108L59.5897 108.07L60.4397 112.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5096 111.38V111.98L59.8096 108.19L59.9396 108.27L60.5096 111.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5097 109.71V110.31L60.1597 108.4L60.2297 108.44L60.2797 108.47L60.5097 109.71Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5097 112.36V112.46L60.1197 112.51L59.9697 112.42L60.5097 112.36Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5096 111.91V112.02L59.4896 112.14L59.3296 112.05L60.5096 111.91Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5097 111.48V111.59L58.8497 111.78L58.6997 111.69L60.5097 111.48Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5098 111.04V111.15L58.2198 111.41L58.0698 111.32L60.5098 111.04Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5097 110.6V110.71L57.5897 111.05L57.4297 110.95L60.5097 110.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5098 110.16V110.27L56.9498 110.68L56.7998 110.59L60.5098 110.16Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5097 109.72V109.83L56.4497 110.3L56.4797 110.19L60.5097 109.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5098 109.28V109.39L56.2998 109.88V109.77L60.5098 109.28Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5098 108.84V108.95L56.2998 109.44V109.33L60.5098 108.84Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3898 108.53L56.2998 109V108.89L60.2298 108.44L60.3898 108.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7498 108.16L56.2998 108.56V108.45L59.5998 108.07L59.7498 108.16Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1198 107.79L56.2998 108.12V108.01L58.9598 107.7L59.1198 107.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4898 107.43L56.2998 107.68V107.57L58.3298 107.34L58.4898 107.43Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8498 107.06L56.2998 107.24V107.13L57.6898 106.97L57.8498 107.06Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2198 106.7L56.2998 106.8V106.69L57.0598 106.61L57.2198 106.7Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5898 106.33L56.2998 106.37V106.25L56.4298 106.24L56.5898 106.33Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2798 108.2L60.4798 112.81L65.0098 115.68L65.2098 115.55V110.8L60.4798 108.07L60.2798 108.2ZM60.7098 108.47L64.9898 110.94V115.15L60.7098 112.68V108.47V108.47Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2798 112.95L65.0098 115.68V110.93L60.2798 108.2V112.95ZM60.5098 108.6L64.7898 111.07V115.28L60.5098 112.81V108.6V108.6Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2198 110.8L65.0198 110.93L60.2798 108.2L60.4798 108.07L65.2198 110.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9298 112.93L60.8898 112.95L60.8298 112.99L60.8098 112.9L60.5698 111.63V111.03L60.9298 112.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2698 113.13L61.2398 113.15L61.1698 113.19L61.1498 113.1L60.5698 109.96V109.35L61.2698 113.13Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5099 113.39L60.6499 108.68L60.7099 108.71L60.7699 108.75L61.6199 113.33L61.5099 113.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9597 113.53L61.8597 113.59L60.9897 108.88L61.1097 108.95L61.9597 113.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2998 113.73L62.1998 113.79L61.3398 109.08L61.4598 109.15L62.2998 113.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6497 113.93L62.5497 113.99L61.6797 109.27L61.7997 109.35L62.6497 113.93Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.99 114.12L62.89 114.19L62.02 109.47L62.13 109.53L62.15 109.54L62.99 114.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3396 114.32L63.2396 114.39L62.3696 109.67L62.4896 109.74L63.3396 114.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.68 114.52L63.58 114.58L62.71 109.87L62.77 109.9L62.84 109.94L63.68 114.52Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0301 114.72L63.9301 114.78L63.0601 110.07L63.1801 110.14L64.0301 114.72Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3699 114.92L64.2699 114.98L63.3999 110.26L63.5299 110.34L64.3699 114.92Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.72 115.12L64.62 115.18L63.75 110.47L63.87 110.54L64.72 115.12Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7898 113.85V114.45L64.0898 110.66L64.2098 110.74L64.7898 113.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7897 112.18V112.78L64.4297 110.86L64.5097 110.91L64.5597 110.94L64.7897 112.18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7897 114.82V114.93L64.3997 114.98L64.2397 114.89L64.7897 114.82Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7899 114.38V114.49L63.7699 114.61L63.6099 114.52L64.7899 114.38Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.79 113.95V114.06L63.13 114.25L62.98 114.16L64.79 113.95Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7898 113.51V113.62L62.4998 113.88L62.3398 113.79L64.7898 113.51Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.79 113.07V113.18L61.87 113.51L61.71 113.42L64.79 113.07Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7896 112.63V112.74L61.2296 113.15L61.0796 113.06L64.7896 112.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7897 112.19V112.3L60.7197 112.77L60.7497 112.66L64.7897 112.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7898 111.75V111.86L60.5698 112.35V112.24L64.7898 111.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7898 111.31V111.42L60.5698 111.91V111.8L64.7898 111.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6698 111L60.5698 111.47V111.36L64.5098 110.91L64.6698 111Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0298 110.63L60.5698 111.03V110.92L63.8698 110.54H63.8798L64.0298 110.63Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3998 110.26L60.5698 110.59V110.48L63.2398 110.17L63.3998 110.26Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7698 109.9L60.5698 110.15V110.04L62.5998 109.81H62.6098L62.7698 109.9Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1298 109.53L60.5698 109.71V109.6L61.9698 109.44L62.1298 109.53Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4998 109.17L60.5698 109.27V109.16L61.3398 109.08L61.4998 109.17Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8598 108.8L60.5698 108.84V108.72L60.7098 108.71L60.8598 108.8Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5601 110.67L64.7601 115.28L69.2901 118.15L69.4901 118.02V113.27L64.7601 110.54L64.5601 110.67ZM64.9901 110.94L69.2701 113.41V117.62L64.9901 115.15V110.94Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5601 115.42L69.2901 118.15V113.4L64.5601 110.67V115.42ZM64.7901 111.07L69.0701 113.54V117.75L64.7901 115.28V111.07Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4901 113.27L69.2901 113.4L64.5601 110.67L64.7601 110.54L69.4901 113.27Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2001 115.4L65.1701 115.42L65.1001 115.46L65.0901 115.37L64.8501 114.1V113.5L65.2001 115.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5501 115.6L65.5101 115.62L65.4501 115.66L65.4301 115.57L64.8501 112.43V111.82L65.5501 115.6Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7899 115.86L64.9199 111.15L64.9799 111.18L65.0499 111.22L65.8899 115.8L65.7899 115.86Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.24 116L66.14 116.06L65.27 111.35L65.39 111.42L66.24 116Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5799 116.2L66.4799 116.26L65.6099 111.55H65.6199L65.7399 111.62L66.5799 116.2Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.93 116.4L66.83 116.46L65.96 111.74L66.08 111.82L66.93 116.4Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2703 116.59L67.1703 116.66L66.3003 111.94L66.4103 112L66.4303 112.01L67.2703 116.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6199 116.79L67.5199 116.86L66.6499 112.14L66.7699 112.21L67.6199 116.79Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9602 116.99L67.8602 117.05L66.9902 112.34L67.0402 112.37H67.0502L67.1102 112.41L67.9602 116.99Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3001 117.19L68.2001 117.25L67.3301 112.54L67.4601 112.61L68.3001 117.19Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6502 117.39L68.5502 117.45L67.6802 112.73L67.8002 112.81L68.6502 117.39Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.99 117.59L68.89 117.65L68.02 112.94L68.15 113.01L68.99 117.59Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0701 116.32V116.92L68.3701 113.13L68.4901 113.21L69.0701 116.32Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.07 114.65V115.25L68.71 113.33L68.79 113.38L68.84 113.41L69.07 114.65Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.07 117.29V117.4L68.68 117.45L68.52 117.36L69.07 117.29Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0701 116.85V116.96L68.0401 117.08L67.8901 116.99L69.0701 116.85Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.07 116.42V116.53L67.41 116.72L67.25 116.63L69.07 116.42Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0701 115.98V116.09L66.7801 116.35L66.6201 116.26L69.0701 115.98Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0702 115.54V115.65L66.1402 115.98L65.9902 115.89L69.0702 115.54Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0699 115.1V115.21L65.5099 115.62L65.3599 115.53L69.0699 115.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.07 114.66V114.77L65 115.24L65.03 115.13L69.07 114.66Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0701 114.22V114.33L64.8501 114.82V114.71L69.0701 114.22Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0701 113.78V113.89L64.8501 114.38V114.27L69.0701 113.78Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9401 113.47L64.8501 113.94V113.83L68.7901 113.38L68.9401 113.47Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3101 113.1L64.8501 113.5V113.39L68.1501 113.01L68.3101 113.1Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6801 112.73L64.8501 113.06V112.95L67.5201 112.64L67.6801 112.73Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0401 112.37L64.8501 112.62V112.51L66.8801 112.28L67.0401 112.37Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4101 112L64.8501 112.18V112.07L66.2501 111.91L66.4101 112Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7801 111.64L64.8501 111.74V111.63L65.6101 111.55H65.6201L65.7801 111.64Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1401 111.27L64.8501 111.31V111.19L64.9801 111.18L65.1401 111.27Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164881_183764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 124.07,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.70c032cf53dac2c1613f793a0902417a.svg";
export { ForwardRef as ReactComponent };